// 2017 Federal Child Support Guidelines — Complete Table Data
// Applies: November 22, 2017 – September 30, 2025
// All 12 provinces/territories (Quebec excluded — not applicable)
// Source: justice.gc.ca official simplified PDFs
// Extracted: April 2026
// Over-$150k rates: monthly % applied directly to excess income

// Alberta — 2017 Federal Child Support Guidelines Table
const T17_AB={
100000:[884, 1458, 1917, 2293],
100100:[885, 1459, 1919, 2295],
100200:[886, 1461, 1921, 2297],
100300:[887, 1462, 1922, 2299],
100400:[887, 1464, 1924, 2301],
100500:[888, 1465, 1926, 2304],
100600:[889, 1466, 1928, 2306],
100700:[890, 1468, 1929, 2308],
100800:[891, 1469, 1931, 2310],
100900:[892, 1470, 1933, 2312],
101000:[893, 1472, 1935, 2314],
101100:[894, 1473, 1937, 2316],
101200:[895, 1475, 1939, 2318],
101300:[896, 1476, 1940, 2320],
101400:[897, 1478, 1942, 2322],
101500:[897, 1479, 1944, 2325],
101600:[898, 1480, 1946, 2327],
101700:[899, 1482, 1948, 2329],
101800:[900, 1483, 1949, 2331],
101900:[901, 1485, 1951, 2333],
102000:[902, 1486, 1953, 2335],
102100:[903, 1487, 1955, 2337],
102200:[904, 1489, 1957, 2339],
102300:[905, 1490, 1958, 2341],
102400:[906, 1492, 1960, 2343],
102500:[906, 1493, 1962, 2346],
102600:[907, 1495, 1964, 2348],
102700:[908, 1496, 1966, 2350],
102800:[909, 1497, 1968, 2352],
102900:[910, 1499, 1969, 2354],
103000:[911, 1500, 1971, 2356],
103100:[912, 1501, 1973, 2358],
103200:[913, 1503, 1974, 2360],
103300:[914, 1504, 1976, 2362],
103400:[915, 1505, 1978, 2364],
103500:[916, 1507, 1980, 2367],
103600:[916, 1508, 1981, 2369],
103700:[917, 1509, 1983, 2371],
103800:[918, 1511, 1985, 2373],
103900:[919, 1512, 1987, 2375],
104000:[920, 1513, 1988, 2377],
104100:[921, 1514, 1990, 2379],
104200:[922, 1516, 1992, 2381],
104300:[923, 1517, 1993, 2383],
104400:[924, 1518, 1995, 2385],
104500:[925, 1520, 1997, 2388],
104600:[925, 1521, 1999, 2390],
104700:[926, 1522, 2000, 2392],
104800:[927, 1524, 2002, 2394],
104900:[928, 1525, 2004, 2396],
105000:[929, 1527, 2006, 2398],
105100:[930, 1528, 2008, 2400],
105200:[931, 1530, 2010, 2402],
105300:[932, 1531, 2011, 2404],
105400:[933, 1532, 2013, 2406],
105500:[934, 1534, 2015, 2409],
105600:[935, 1535, 2017, 2411],
105700:[935, 1537, 2019, 2413],
105800:[936, 1538, 2020, 2415],
105900:[937, 1539, 2022, 2417],
106000:[938, 1541, 2024, 2419],
106100:[939, 1542, 2026, 2421],
106200:[940, 1544, 2028, 2423],
106300:[941, 1545, 2029, 2425],
106400:[942, 1547, 2031, 2427],
106500:[943, 1548, 2033, 2430],
106600:[944, 1549, 2035, 2432],
106700:[945, 1551, 2037, 2434],
106800:[945, 1552, 2038, 2436],
106900:[946, 1553, 2040, 2438],
107000:[947, 1555, 2042, 2440],
107100:[948, 1556, 2044, 2442],
107200:[949, 1558, 2045, 2444],
107300:[950, 1559, 2047, 2446],
107400:[950, 1561, 2049, 2448],
107500:[951, 1562, 2051, 2451],
107600:[952, 1563, 2052, 2453],
107700:[953, 1565, 2054, 2455],
107800:[954, 1566, 2056, 2457],
107900:[955, 1568, 2058, 2459],
108000:[955, 1569, 2059, 2461],
108100:[956, 1570, 2061, 2463],
108200:[957, 1572, 2063, 2465],
108300:[958, 1573, 2064, 2467],
108400:[958, 1575, 2066, 2469],
108500:[959, 1576, 2068, 2472],
108600:[960, 1578, 2070, 2474],
108700:[961, 1579, 2071, 2476],
108800:[962, 1580, 2073, 2478],
108900:[963, 1582, 2075, 2480],
109000:[964, 1583, 2077, 2482],
109100:[965, 1584, 2079, 2484],
109200:[966, 1586, 2081, 2486],
109300:[967, 1587, 2082, 2488],
109400:[967, 1588, 2084, 2490],
109500:[968, 1590, 2086, 2493],
109600:[969, 1591, 2088, 2495],
109700:[970, 1592, 2089, 2497],
109800:[971, 1594, 2091, 2499],
109900:[972, 1595, 2093, 2501],
110000:[973, 1596, 2095, 2503],
110100:[974, 1597, 2097, 2505],
110200:[975, 1599, 2099, 2507],
110300:[976, 1600, 2100, 2509],
110400:[977, 1601, 2102, 2511],
110500:[977, 1603, 2104, 2514],
110600:[978, 1604, 2106, 2516],
110700:[979, 1605, 2108, 2518],
110800:[980, 1607, 2109, 2520],
110900:[981, 1608, 2111, 2522],
111000:[982, 1610, 2113, 2524],
111100:[983, 1611, 2115, 2526],
111200:[984, 1613, 2117, 2528],
111300:[985, 1614, 2118, 2530],
111400:[986, 1615, 2120, 2532],
111500:[986, 1617, 2122, 2535],
111600:[987, 1618, 2124, 2537],
111700:[988, 1620, 2126, 2539],
111800:[989, 1621, 2128, 2541],
111900:[990, 1622, 2129, 2543],
112000:[991, 1624, 2131, 2545],
112100:[992, 1625, 2133, 2547],
112200:[993, 1627, 2134, 2549],
112300:[994, 1628, 2136, 2551],
112400:[995, 1630, 2138, 2553],
112500:[996, 1631, 2140, 2556],
112600:[996, 1632, 2141, 2558],
112700:[997, 1634, 2143, 2560],
112800:[998, 1635, 2145, 2562],
112900:[999, 1637, 2147, 2564],
113000:[1000, 1638, 2148, 2566],
113100:[1001, 1639, 2150, 2568],
113200:[1002, 1641, 2152, 2570],
113300:[1003, 1642, 2153, 2572],
113400:[1004, 1644, 2155, 2574],
113500:[1005, 1645, 2157, 2577],
113600:[1005, 1646, 2159, 2579],
113700:[1006, 1648, 2160, 2581],
113800:[1007, 1649, 2162, 2583],
113900:[1008, 1651, 2164, 2585],
114000:[1009, 1652, 2166, 2587],
114100:[1010, 1653, 2168, 2589],
114200:[1011, 1655, 2170, 2591],
114300:[1012, 1656, 2171, 2593],
114400:[1013, 1658, 2173, 2595],
114500:[1014, 1659, 2175, 2598],
114600:[1015, 1661, 2177, 2600],
114700:[1015, 1662, 2179, 2602],
114800:[1016, 1663, 2180, 2604],
114900:[1017, 1665, 2182, 2606],
115000:[1018, 1666, 2184, 2608],
115100:[1019, 1667, 2186, 2610],
115200:[1020, 1669, 2188, 2612],
115300:[1021, 1670, 2189, 2614],
115400:[1022, 1671, 2191, 2616],
115500:[1023, 1673, 2193, 2618],
115600:[1024, 1674, 2195, 2621],
115700:[1025, 1675, 2197, 2623],
115800:[1025, 1677, 2198, 2625],
115900:[1026, 1678, 2200, 2627],
116000:[1027, 1679, 2202, 2629],
116100:[1028, 1680, 2204, 2631],
116200:[1029, 1682, 2205, 2633],
116300:[1030, 1683, 2207, 2635],
116400:[1030, 1684, 2209, 2637],
116500:[1031, 1686, 2211, 2639],
116600:[1032, 1687, 2212, 2642],
116700:[1033, 1689, 2214, 2644],
116800:[1034, 1690, 2216, 2646],
116900:[1035, 1691, 2218, 2648],
117000:[1035, 1693, 2219, 2650],
117100:[1036, 1694, 2221, 2652],
117200:[1037, 1696, 2223, 2654],
117300:[1038, 1697, 2224, 2656],
117400:[1038, 1699, 2226, 2658],
117500:[1039, 1700, 2228, 2660],
117600:[1040, 1701, 2230, 2663],
117700:[1041, 1703, 2231, 2665],
117800:[1042, 1704, 2233, 2667],
117900:[1043, 1705, 2235, 2669],
118000:[1044, 1707, 2237, 2671],
118100:[1045, 1708, 2239, 2673],
118200:[1046, 1710, 2241, 2675],
118300:[1047, 1711, 2242, 2677],
118400:[1047, 1713, 2244, 2679],
118500:[1048, 1714, 2246, 2681],
118600:[1049, 1715, 2248, 2684],
118700:[1050, 1717, 2249, 2686],
118800:[1051, 1718, 2251, 2688],
118900:[1052, 1720, 2253, 2690],
119000:[1053, 1721, 2255, 2692],
119100:[1054, 1722, 2257, 2694],
119200:[1055, 1724, 2259, 2696],
119300:[1056, 1725, 2260, 2698],
119400:[1057, 1727, 2262, 2700],
119500:[1057, 1728, 2264, 2702],
119600:[1058, 1729, 2266, 2705],
119700:[1059, 1731, 2268, 2707],
119800:[1060, 1732, 2269, 2709],
119900:[1061, 1734, 2271, 2711],
12000:[0, 0, 0, 0],
120000:[1062, 1735, 2273, 2713],
120100:[1063, 1736, 2275, 2715],
120200:[1064, 1738, 2277, 2717],
120300:[1065, 1739, 2278, 2719],
120400:[1066, 1741, 2280, 2721],
120500:[1066, 1742, 2282, 2723],
120600:[1067, 1744, 2284, 2726],
120700:[1068, 1745, 2286, 2728],
120800:[1069, 1746, 2288, 2730],
120900:[1070, 1748, 2289, 2732],
12100:[8, 9, 10, 10],
121000:[1071, 1749, 2291, 2734],
121100:[1072, 1750, 2293, 2736],
121200:[1073, 1752, 2294, 2738],
121300:[1074, 1753, 2296, 2740],
121400:[1075, 1754, 2298, 2742],
121500:[1076, 1756, 2300, 2744],
121600:[1076, 1757, 2301, 2747],
121700:[1077, 1758, 2303, 2749],
121800:[1078, 1760, 2305, 2751],
121900:[1079, 1761, 2307, 2753],
12200:[17, 18, 19, 21],
122000:[1080, 1762, 2308, 2755],
122100:[1081, 1763, 2310, 2757],
122200:[1082, 1765, 2312, 2759],
122300:[1083, 1766, 2313, 2761],
122400:[1084, 1767, 2315, 2763],
122500:[1085, 1769, 2317, 2765],
122600:[1085, 1770, 2319, 2768],
122700:[1086, 1772, 2320, 2770],
122800:[1087, 1773, 2322, 2772],
122900:[1088, 1774, 2324, 2774],
12300:[25, 27, 29, 31],
123000:[1089, 1776, 2326, 2776],
123100:[1090, 1777, 2328, 2778],
123200:[1091, 1779, 2330, 2780],
123300:[1092, 1780, 2331, 2782],
123400:[1093, 1782, 2333, 2784],
123500:[1094, 1783, 2335, 2786],
123600:[1095, 1784, 2337, 2789],
123700:[1095, 1786, 2339, 2791],
123800:[1096, 1787, 2340, 2793],
123900:[1097, 1788, 2342, 2795],
12400:[33, 36, 38, 41],
124000:[1098, 1790, 2344, 2797],
124100:[1099, 1791, 2346, 2799],
124200:[1100, 1793, 2348, 2801],
124300:[1101, 1794, 2349, 2803],
124400:[1102, 1796, 2351, 2805],
124500:[1103, 1797, 2353, 2807],
124600:[1104, 1798, 2355, 2810],
124700:[1105, 1800, 2357, 2812],
124800:[1105, 1801, 2358, 2814],
124900:[1106, 1803, 2360, 2816],
12500:[42, 45, 48, 52],
125000:[1107, 1804, 2362, 2818],
125100:[1108, 1805, 2364, 2820],
125200:[1109, 1807, 2365, 2822],
125300:[1110, 1808, 2367, 2824],
125400:[1110, 1809, 2369, 2826],
125500:[1111, 1811, 2371, 2828],
125600:[1112, 1812, 2372, 2830],
125700:[1113, 1813, 2374, 2832],
125800:[1114, 1815, 2376, 2834],
125900:[1115, 1816, 2378, 2836],
12600:[50, 53, 58, 62],
126000:[1115, 1817, 2379, 2838],
126100:[1116, 1818, 2381, 2840],
126200:[1117, 1820, 2382, 2842],
126300:[1118, 1821, 2384, 2844],
126400:[1119, 1823, 2386, 2846],
126500:[1119, 1824, 2388, 2848],
126600:[1120, 1825, 2389, 2850],
126700:[1121, 1827, 2391, 2852],
126800:[1122, 1828, 2393, 2854],
126900:[1123, 1829, 2394, 2856],
12700:[58, 62, 67, 72],
127000:[1124, 1831, 2396, 2859],
127100:[1125, 1832, 2398, 2861],
127200:[1126, 1834, 2399, 2863],
127300:[1126, 1835, 2401, 2865],
127400:[1127, 1836, 2403, 2867],
127500:[1128, 1838, 2404, 2869],
127600:[1129, 1839, 2406, 2871],
127700:[1130, 1840, 2408, 2873],
127800:[1131, 1842, 2409, 2875],
127900:[1131, 1843, 2411, 2877],
12800:[66, 71, 77, 82],
128000:[1132, 1844, 2413, 2879],
128100:[1133, 1845, 2415, 2881],
128200:[1134, 1847, 2417, 2883],
128300:[1135, 1848, 2418, 2885],
128400:[1135, 1849, 2420, 2887],
128500:[1136, 1850, 2422, 2889],
128600:[1137, 1852, 2424, 2891],
128700:[1138, 1853, 2425, 2894],
128800:[1139, 1854, 2427, 2896],
128900:[1140, 1856, 2429, 2898],
12900:[75, 80, 86, 93],
129000:[1141, 1857, 2431, 2900],
129100:[1142, 1858, 2433, 2902],
129200:[1143, 1860, 2434, 2904],
129300:[1144, 1861, 2436, 2906],
129400:[1145, 1862, 2438, 2908],
129500:[1146, 1864, 2440, 2910],
129600:[1146, 1865, 2441, 2912],
129700:[1147, 1866, 2443, 2914],
129800:[1148, 1868, 2445, 2916],
129900:[1149, 1869, 2447, 2918],
13000:[83, 89, 96, 103],
130000:[1150, 1871, 2448, 2920],
130100:[1151, 1872, 2450, 2922],
130200:[1152, 1874, 2451, 2924],
130300:[1153, 1875, 2453, 2926],
130400:[1153, 1876, 2455, 2928],
130500:[1154, 1878, 2457, 2930],
130600:[1155, 1879, 2458, 2932],
130700:[1156, 1880, 2460, 2934],
130800:[1157, 1882, 2462, 2936],
130900:[1158, 1883, 2463, 2938],
13100:[87, 93, 100, 107],
131000:[1158, 1884, 2465, 2940],
131100:[1159, 1885, 2467, 2942],
131200:[1160, 1887, 2468, 2944],
131300:[1161, 1888, 2470, 2946],
131400:[1162, 1890, 2472, 2948],
131500:[1162, 1891, 2473, 2950],
131600:[1163, 1892, 2475, 2952],
131700:[1164, 1894, 2477, 2955],
131800:[1165, 1895, 2479, 2957],
131900:[1166, 1896, 2480, 2959],
13200:[90, 97, 104, 112],
132000:[1167, 1898, 2482, 2961],
132100:[1168, 1899, 2484, 2963],
132200:[1169, 1901, 2485, 2965],
132300:[1169, 1902, 2487, 2967],
132400:[1170, 1903, 2489, 2969],
132500:[1171, 1905, 2490, 2971],
132600:[1172, 1906, 2492, 2973],
132700:[1173, 1907, 2494, 2975],
132800:[1174, 1909, 2495, 2977],
132900:[1174, 1910, 2497, 2979],
13300:[94, 101, 109, 116],
133000:[1175, 1911, 2499, 2981],
133100:[1176, 1912, 2501, 2983],
133200:[1177, 1914, 2503, 2985],
133300:[1178, 1915, 2504, 2987],
133400:[1178, 1916, 2506, 2989],
133500:[1179, 1917, 2508, 2991],
133600:[1180, 1919, 2510, 2993],
133700:[1181, 1920, 2511, 2995],
133800:[1182, 1921, 2513, 2997],
133900:[1183, 1923, 2515, 2999],
13400:[97, 104, 113, 121],
134000:[1184, 1924, 2517, 3001],
134100:[1185, 1925, 2519, 3003],
134200:[1186, 1927, 2520, 3005],
134300:[1187, 1928, 2522, 3007],
134400:[1188, 1929, 2524, 3009],
134500:[1188, 1931, 2526, 3011],
134600:[1189, 1932, 2527, 3013],
134700:[1190, 1934, 2529, 3015],
134800:[1191, 1935, 2531, 3018],
134900:[1192, 1936, 2533, 3020],
13500:[101, 108, 117, 125],
135000:[1193, 1938, 2534, 3022],
135100:[1194, 1939, 2536, 3024],
135200:[1195, 1941, 2537, 3026],
135300:[1196, 1942, 2539, 3028],
135400:[1196, 1943, 2541, 3030],
135500:[1197, 1945, 2543, 3032],
135600:[1198, 1946, 2544, 3034],
135700:[1199, 1947, 2546, 3036],
135800:[1200, 1949, 2548, 3038],
135900:[1201, 1950, 2549, 3040],
13600:[104, 112, 121, 130],
136000:[1201, 1951, 2551, 3042],
136100:[1202, 1952, 2553, 3044],
136200:[1203, 1954, 2554, 3046],
136300:[1204, 1955, 2556, 3048],
136400:[1204, 1957, 2558, 3050],
136500:[1205, 1958, 2559, 3052],
136600:[1206, 1959, 2561, 3054],
136700:[1207, 1961, 2563, 3056],
136800:[1208, 1962, 2564, 3058],
136900:[1209, 1963, 2566, 3060],
13700:[108, 116, 125, 134],
137000:[1210, 1965, 2568, 3062],
137100:[1211, 1966, 2570, 3064],
137200:[1212, 1968, 2572, 3066],
137300:[1212, 1969, 2573, 3068],
137400:[1213, 1970, 2575, 3070],
137500:[1214, 1972, 2577, 3072],
137600:[1215, 1973, 2579, 3074],
137700:[1216, 1974, 2580, 3076],
137800:[1216, 1976, 2582, 3079],
137900:[1217, 1977, 2584, 3081],
13800:[111, 120, 129, 139],
138000:[1218, 1978, 2586, 3083],
138100:[1219, 1979, 2588, 3085],
138200:[1220, 1981, 2589, 3087],
138300:[1221, 1982, 2591, 3089],
138400:[1221, 1983, 2593, 3091],
138500:[1222, 1985, 2595, 3093],
138600:[1223, 1986, 2596, 3095],
138700:[1224, 1987, 2598, 3097],
138800:[1225, 1988, 2600, 3099],
138900:[1226, 1990, 2602, 3101],
13900:[115, 124, 134, 143],
139000:[1227, 1991, 2603, 3103],
139100:[1228, 1992, 2605, 3105],
139200:[1229, 1994, 2606, 3107],
139300:[1230, 1995, 2608, 3109],
139400:[1231, 1996, 2610, 3111],
139500:[1231, 1998, 2612, 3113],
139600:[1232, 1999, 2613, 3115],
139700:[1233, 2001, 2615, 3117],
139800:[1234, 2002, 2617, 3119],
139900:[1235, 2003, 2618, 3121],
14000:[118, 128, 138, 148],
140000:[1236, 2005, 2620, 3123],
140100:[1237, 2006, 2622, 3125],
140200:[1238, 2008, 2623, 3127],
140300:[1238, 2009, 2625, 3129],
140400:[1239, 2010, 2627, 3131],
140500:[1240, 2012, 2628, 3133],
140600:[1241, 2013, 2630, 3135],
140700:[1242, 2014, 2632, 3137],
140800:[1243, 2016, 2634, 3139],
140900:[1243, 2017, 2635, 3141],
14100:[119, 132, 142, 152],
141000:[1244, 2018, 2637, 3143],
141100:[1245, 2019, 2639, 3145],
141200:[1246, 2021, 2640, 3147],
141300:[1246, 2022, 2642, 3149],
141400:[1247, 2023, 2643, 3151],
141500:[1248, 2025, 2645, 3153],
141600:[1249, 2026, 2647, 3155],
141700:[1250, 2027, 2648, 3157],
141800:[1250, 2029, 2650, 3159],
141900:[1251, 2030, 2652, 3161],
14200:[120, 135, 146, 156],
142000:[1252, 2031, 2653, 3163],
142100:[1253, 2032, 2655, 3165],
142200:[1254, 2033, 2656, 3167],
142300:[1254, 2035, 2658, 3169],
142400:[1255, 2036, 2660, 3171],
142500:[1256, 2037, 2661, 3173],
142600:[1257, 2038, 2663, 3175],
142700:[1257, 2040, 2665, 3177],
142800:[1258, 2041, 2666, 3179],
142900:[1259, 2042, 2668, 3181],
14300:[121, 139, 150, 160],
143000:[1260, 2043, 2670, 3182],
143100:[1261, 2044, 2672, 3184],
143200:[1262, 2046, 2673, 3186],
143300:[1263, 2047, 2675, 3188],
143400:[1263, 2048, 2677, 3190],
143500:[1264, 2049, 2678, 3192],
143600:[1265, 2051, 2680, 3193],
143700:[1266, 2052, 2682, 3195],
143800:[1267, 2053, 2683, 3197],
143900:[1268, 2054, 2685, 3199],
14400:[122, 142, 154, 164],
144000:[1269, 2056, 2686, 3201],
144100:[1270, 2057, 2688, 3203],
144200:[1271, 2059, 2689, 3205],
144300:[1272, 2060, 2691, 3207],
144400:[1272, 2061, 2692, 3209],
144500:[1273, 2062, 2694, 3211],
144600:[1274, 2064, 2696, 3213],
144700:[1275, 2065, 2697, 3215],
144800:[1276, 2066, 2699, 3217],
144900:[1277, 2068, 2700, 3219],
14500:[123, 146, 158, 169],
145000:[1277, 2069, 2702, 3221],
145100:[1278, 2070, 2704, 3223],
145200:[1279, 2072, 2705, 3225],
145300:[1279, 2073, 2707, 3227],
145400:[1280, 2074, 2709, 3229],
145500:[1281, 2076, 2710, 3231],
145600:[1282, 2077, 2712, 3233],
145700:[1283, 2078, 2714, 3235],
145800:[1284, 2080, 2715, 3236],
145900:[1284, 2081, 2717, 3238],
14600:[124, 150, 161, 173],
146000:[1285, 2082, 2719, 3240],
146100:[1286, 2083, 2721, 3242],
146200:[1287, 2084, 2722, 3244],
146300:[1287, 2086, 2724, 3246],
146400:[1288, 2087, 2726, 3248],
146500:[1289, 2088, 2727, 3249],
146600:[1290, 2089, 2729, 3251],
146700:[1291, 2091, 2730, 3253],
146800:[1291, 2092, 2732, 3255],
146900:[1292, 2093, 2734, 3257],
14700:[125, 153, 165, 177],
147000:[1293, 2094, 2735, 3259],
147100:[1294, 2095, 2737, 3261],
147200:[1295, 2097, 2738, 3263],
147300:[1295, 2098, 2740, 3265],
147400:[1296, 2099, 2741, 3267],
147500:[1297, 2100, 2743, 3269],
147600:[1298, 2102, 2745, 3271],
147700:[1298, 2103, 2746, 3273],
147800:[1299, 2104, 2748, 3275],
147900:[1300, 2105, 2749, 3277],
14800:[126, 157, 169, 181],
148000:[1301, 2107, 2751, 3279],
148100:[1302, 2108, 2753, 3281],
148200:[1303, 2110, 2754, 3283],
148300:[1304, 2111, 2756, 3285],
148400:[1304, 2112, 2758, 3287],
148500:[1305, 2113, 2759, 3289],
148600:[1306, 2115, 2761, 3291],
148700:[1307, 2116, 2763, 3292],
148800:[1308, 2117, 2764, 3294],
148900:[1309, 2119, 2766, 3296],
14900:[127, 160, 173, 185],
149000:[1310, 2120, 2768, 3298],
149100:[1311, 2121, 2770, 3300],
149200:[1312, 2123, 2771, 3302],
149300:[1313, 2124, 2773, 3304],
149400:[1313, 2125, 2774, 3306],
149500:[1314, 2127, 2776, 3307],
149600:[1315, 2128, 2778, 3309],
149700:[1316, 2129, 2779, 3311],
149800:[1317, 2131, 2781, 3313],
149900:[1318, 2132, 2783, 3315],
15000:[128, 164, 177, 189],
150000:[1318, 2133, 2784, 3317],
15100:[129, 168, 181, 193],
15200:[130, 171, 185, 197],
15300:[131, 175, 189, 202],
15400:[132, 178, 192, 206],
15500:[133, 182, 196, 210],
15600:[134, 186, 200, 214],
15700:[135, 189, 204, 218],
15800:[136, 193, 208, 222],
15900:[137, 196, 212, 227],
16000:[139, 200, 215, 231],
16100:[140, 204, 219, 235],
16200:[141, 207, 223, 239],
16300:[142, 211, 226, 243],
16400:[143, 214, 230, 247],
16500:[144, 218, 234, 251],
16600:[145, 221, 238, 255],
16700:[146, 225, 242, 259],
16800:[147, 228, 245, 263],
16900:[148, 232, 249, 267],
17000:[149, 235, 253, 271],
17100:[150, 238, 257, 275],
17200:[151, 242, 260, 279],
17300:[152, 245, 264, 283],
17400:[153, 249, 268, 287],
17500:[154, 252, 272, 291],
17600:[155, 256, 275, 295],
17700:[156, 259, 279, 299],
17800:[157, 262, 283, 303],
17900:[158, 266, 287, 307],
18000:[159, 269, 290, 311],
18100:[160, 272, 294, 315],
18200:[161, 276, 298, 319],
18300:[162, 279, 301, 323],
18400:[163, 283, 305, 327],
18500:[164, 286, 309, 331],
18600:[165, 290, 313, 335],
18700:[167, 293, 316, 339],
18800:[168, 297, 320, 343],
18900:[169, 300, 324, 347],
19000:[170, 304, 328, 351],
19100:[171, 306, 332, 355],
19200:[172, 309, 335, 359],
19300:[173, 311, 339, 363],
19400:[174, 314, 343, 367],
19500:[175, 316, 347, 372],
19600:[176, 318, 350, 376],
19700:[177, 321, 354, 380],
19800:[178, 323, 358, 384],
19900:[179, 325, 362, 388],
20000:[179, 328, 365, 392],
20100:[180, 329, 369, 396],
20200:[180, 331, 373, 401],
20300:[181, 332, 377, 405],
20400:[182, 333, 381, 409],
20500:[182, 334, 385, 414],
20600:[183, 336, 389, 418],
20700:[184, 337, 393, 422],
20800:[185, 338, 397, 427],
20900:[185, 339, 401, 431],
21000:[186, 341, 406, 435],
21100:[187, 342, 410, 439],
21200:[187, 343, 414, 444],
21300:[188, 345, 418, 448],
21400:[189, 346, 422, 453],
21500:[190, 347, 426, 457],
21600:[190, 348, 430, 461],
21700:[191, 349, 435, 466],
21800:[192, 351, 439, 470],
21900:[192, 352, 443, 474],
22000:[193, 353, 447, 479],
22100:[194, 354, 451, 483],
22200:[194, 356, 455, 488],
22300:[195, 357, 459, 492],
22400:[196, 358, 463, 497],
22500:[197, 359, 468, 501],
22600:[197, 361, 472, 505],
22700:[198, 362, 476, 510],
22800:[199, 363, 480, 514],
22900:[200, 364, 484, 519],
23000:[200, 366, 488, 523],
23100:[201, 367, 491, 527],
23200:[201, 368, 494, 532],
23300:[202, 370, 496, 536],
23400:[203, 371, 499, 540],
23500:[203, 372, 502, 545],
23600:[204, 373, 505, 549],
23700:[204, 374, 508, 553],
23800:[205, 376, 511, 558],
23900:[206, 377, 513, 562],
24000:[206, 378, 516, 566],
24100:[207, 379, 518, 570],
24200:[207, 381, 519, 575],
24300:[208, 382, 521, 579],
24400:[209, 383, 523, 584],
24500:[209, 384, 524, 588],
24600:[210, 386, 526, 592],
24700:[211, 387, 528, 597],
24800:[211, 388, 529, 601],
24900:[212, 389, 531, 605],
25000:[213, 391, 533, 610],
25100:[214, 392, 535, 614],
25200:[215, 394, 537, 619],
25300:[216, 395, 539, 623],
25400:[216, 397, 541, 628],
25500:[217, 398, 542, 632],
25600:[218, 399, 544, 636],
25700:[219, 401, 546, 641],
25800:[220, 402, 548, 645],
25900:[221, 404, 550, 650],
26000:[222, 405, 552, 654],
26100:[223, 407, 554, 658],
26200:[224, 408, 556, 662],
26300:[225, 410, 558, 667],
26400:[227, 412, 561, 671],
26500:[228, 414, 563, 675],
26600:[229, 415, 565, 679],
26700:[230, 417, 567, 684],
26800:[231, 419, 569, 688],
26900:[232, 420, 571, 692],
27000:[233, 422, 573, 696],
27100:[234, 424, 575, 698],
27200:[235, 425, 577, 701],
27300:[236, 427, 579, 703],
27400:[237, 428, 581, 706],
27500:[238, 430, 583, 708],
27600:[239, 432, 585, 710],
27700:[241, 433, 587, 713],
27800:[242, 435, 589, 715],
27900:[243, 437, 591, 718],
28000:[244, 438, 593, 720],
28100:[245, 439, 595, 722],
28200:[245, 440, 596, 724],
28300:[246, 442, 598, 726],
28400:[247, 443, 600, 728],
28500:[247, 444, 601, 731],
28600:[248, 445, 603, 733],
28700:[249, 446, 605, 735],
28800:[249, 447, 606, 737],
28900:[250, 449, 608, 739],
29000:[251, 450, 610, 741],
29100:[252, 451, 612, 743],
29200:[252, 453, 613, 745],
29300:[253, 454, 615, 747],
29400:[253, 455, 617, 749],
29500:[254, 456, 619, 751],
29600:[255, 458, 620, 753],
29700:[255, 459, 622, 755],
29800:[256, 460, 624, 757],
29900:[256, 461, 625, 759],
30000:[257, 463, 627, 761],
30100:[258, 464, 629, 763],
30200:[258, 465, 630, 765],
30300:[259, 467, 632, 767],
30400:[260, 468, 634, 769],
30500:[260, 469, 636, 771],
30600:[261, 470, 637, 774],
30700:[262, 472, 639, 776],
30800:[262, 473, 641, 778],
30900:[263, 474, 642, 780],
31000:[264, 475, 644, 782],
31100:[265, 476, 646, 784],
31200:[265, 477, 647, 786],
31300:[266, 479, 649, 788],
31400:[266, 480, 651, 790],
31500:[267, 481, 652, 792],
31600:[268, 482, 654, 794],
31700:[268, 484, 655, 796],
31800:[269, 485, 657, 798],
31900:[270, 486, 659, 800],
32000:[270, 487, 660, 802],
32100:[271, 488, 662, 804],
32200:[271, 489, 663, 806],
32300:[272, 491, 665, 808],
32400:[273, 492, 667, 810],
32500:[273, 493, 668, 812],
32600:[274, 494, 670, 814],
32700:[275, 495, 672, 817],
32800:[275, 497, 673, 819],
32900:[276, 498, 675, 821],
33000:[277, 499, 677, 823],
33100:[278, 500, 679, 825],
33200:[278, 501, 680, 827],
33300:[279, 503, 682, 829],
33400:[279, 504, 684, 831],
33500:[280, 505, 685, 833],
33600:[281, 506, 687, 835],
33700:[281, 507, 689, 837],
33800:[282, 508, 690, 839],
33900:[283, 510, 692, 841],
34000:[283, 511, 694, 843],
34100:[284, 512, 696, 845],
34200:[284, 514, 697, 847],
34300:[285, 515, 699, 849],
34400:[286, 516, 701, 851],
34500:[286, 517, 702, 853],
34600:[287, 519, 704, 855],
34700:[288, 520, 706, 857],
34800:[288, 521, 708, 859],
34900:[289, 522, 709, 861],
35000:[290, 524, 711, 864],
35100:[291, 525, 713, 866],
35200:[291, 526, 714, 868],
35300:[292, 528, 716, 870],
35400:[293, 529, 717, 872],
35500:[293, 530, 719, 874],
35600:[294, 531, 721, 876],
35700:[294, 533, 722, 878],
35800:[295, 534, 724, 880],
35900:[296, 535, 725, 882],
36000:[296, 536, 727, 884],
36100:[297, 537, 729, 886],
36200:[297, 538, 730, 888],
36300:[298, 539, 732, 890],
36400:[298, 541, 733, 892],
36500:[299, 542, 735, 893],
36600:[300, 543, 736, 895],
36700:[300, 544, 738, 897],
36800:[301, 545, 740, 899],
36900:[301, 546, 741, 901],
37000:[302, 547, 743, 903],
37100:[303, 548, 745, 905],
37200:[303, 549, 746, 907],
37300:[304, 550, 748, 909],
37400:[304, 552, 749, 911],
37500:[305, 553, 751, 912],
37600:[306, 554, 752, 914],
37700:[306, 555, 754, 916],
37800:[307, 556, 755, 918],
37900:[308, 557, 757, 920],
38000:[308, 558, 758, 922],
38100:[309, 559, 760, 924],
38200:[309, 560, 761, 926],
38300:[310, 561, 763, 928],
38400:[310, 562, 764, 930],
38500:[311, 564, 766, 931],
38600:[311, 565, 768, 933],
38700:[312, 566, 769, 935],
38800:[312, 567, 771, 937],
38900:[313, 568, 772, 939],
39000:[313, 569, 774, 941],
39100:[314, 570, 776, 943],
39200:[315, 572, 777, 945],
39300:[315, 573, 779, 947],
39400:[316, 574, 781, 949],
39500:[317, 575, 783, 951],
39600:[318, 577, 784, 953],
39700:[318, 578, 786, 955],
39800:[319, 579, 788, 957],
39900:[320, 581, 790, 959],
40000:[321, 582, 791, 961],
40100:[322, 583, 793, 963],
40200:[323, 585, 795, 965],
40300:[324, 586, 797, 968],
40400:[325, 588, 798, 970],
40500:[326, 589, 800, 972],
40600:[326, 591, 802, 974],
40700:[327, 592, 804, 976],
40800:[328, 593, 806, 978],
40900:[329, 595, 808, 981],
41000:[330, 596, 809, 983],
41100:[331, 597, 811, 985],
41200:[332, 599, 813, 987],
41300:[333, 600, 815, 989],
41400:[334, 602, 816, 992],
41500:[335, 603, 818, 994],
41600:[335, 604, 820, 996],
41700:[336, 606, 822, 998],
41800:[337, 607, 824, 1000],
41900:[338, 609, 826, 1002],
42000:[339, 610, 827, 1004],
42100:[340, 611, 829, 1006],
42200:[341, 613, 831, 1008],
42300:[342, 614, 833, 1010],
42400:[343, 616, 834, 1012],
42500:[344, 617, 836, 1015],
42600:[344, 618, 838, 1017],
42700:[345, 620, 840, 1019],
42800:[346, 621, 842, 1021],
42900:[347, 623, 844, 1023],
43000:[348, 624, 845, 1025],
43100:[349, 625, 847, 1027],
43200:[350, 627, 849, 1029],
43300:[351, 628, 851, 1032],
43400:[352, 630, 852, 1034],
43500:[353, 631, 854, 1036],
43600:[353, 632, 856, 1038],
43700:[354, 634, 858, 1040],
43800:[355, 635, 860, 1042],
43900:[356, 637, 862, 1045],
44000:[357, 638, 863, 1047],
44100:[358, 639, 865, 1049],
44200:[359, 641, 867, 1051],
44300:[360, 642, 869, 1054],
44400:[361, 644, 871, 1056],
44500:[362, 645, 873, 1058],
44600:[363, 647, 875, 1060],
44700:[364, 648, 876, 1063],
44800:[365, 650, 878, 1065],
44900:[366, 651, 880, 1067],
45000:[367, 653, 882, 1069],
45100:[368, 654, 884, 1071],
45200:[369, 656, 886, 1073],
45300:[370, 657, 887, 1076],
45400:[371, 659, 889, 1078],
45500:[372, 660, 891, 1080],
45600:[373, 661, 893, 1082],
45700:[374, 663, 895, 1084],
45800:[374, 664, 896, 1086],
45900:[375, 666, 898, 1089],
46000:[376, 667, 900, 1091],
46100:[377, 668, 902, 1093],
46200:[378, 670, 904, 1095],
46300:[379, 671, 905, 1097],
46400:[380, 673, 907, 1099],
46500:[381, 674, 909, 1102],
46600:[382, 675, 911, 1104],
46700:[382, 677, 912, 1106],
46800:[383, 678, 914, 1108],
46900:[384, 679, 916, 1110],
47000:[385, 681, 918, 1112],
47100:[386, 682, 920, 1114],
47200:[387, 684, 922, 1116],
47300:[388, 685, 923, 1118],
47400:[389, 687, 925, 1120],
47500:[390, 688, 927, 1122],
47600:[391, 689, 929, 1125],
47700:[391, 691, 931, 1127],
47800:[392, 692, 932, 1129],
47900:[393, 694, 934, 1131],
48000:[394, 695, 936, 1133],
48100:[395, 696, 938, 1135],
48200:[396, 698, 940, 1137],
48300:[397, 699, 941, 1139],
48400:[398, 701, 943, 1141],
48500:[399, 702, 945, 1143],
48600:[400, 703, 947, 1145],
48700:[401, 705, 949, 1148],
48800:[401, 706, 950, 1150],
48900:[402, 708, 952, 1152],
49000:[403, 709, 954, 1154],
49100:[404, 710, 956, 1156],
49200:[405, 712, 958, 1158],
49300:[406, 713, 959, 1160],
49400:[407, 715, 961, 1162],
49500:[408, 716, 963, 1164],
49600:[409, 717, 965, 1166],
49700:[410, 719, 967, 1168],
49800:[410, 720, 968, 1171],
49900:[411, 722, 970, 1173],
50000:[412, 723, 972, 1175],
50100:[413, 724, 974, 1177],
50200:[414, 726, 976, 1179],
50300:[415, 727, 977, 1181],
50400:[416, 729, 979, 1184],
50500:[417, 730, 981, 1186],
50600:[418, 732, 983, 1188],
50700:[419, 733, 985, 1190],
50800:[420, 734, 987, 1192],
50900:[420, 736, 988, 1194],
51000:[421, 737, 990, 1197],
51100:[422, 738, 992, 1199],
51200:[423, 740, 994, 1201],
51300:[424, 741, 995, 1203],
51400:[425, 743, 997, 1206],
51500:[426, 744, 999, 1208],
51600:[427, 746, 1001, 1210],
51700:[428, 747, 1003, 1212],
51800:[429, 748, 1005, 1214],
51900:[429, 750, 1006, 1216],
52000:[430, 751, 1008, 1218],
52100:[431, 752, 1010, 1220],
52200:[432, 754, 1012, 1222],
52300:[433, 755, 1013, 1225],
52400:[434, 757, 1015, 1227],
52500:[435, 758, 1017, 1229],
52600:[436, 759, 1019, 1231],
52700:[437, 761, 1021, 1233],
52800:[437, 762, 1022, 1235],
52900:[438, 764, 1024, 1238],
53000:[439, 765, 1026, 1240],
53100:[440, 766, 1028, 1242],
53200:[441, 768, 1030, 1244],
53300:[442, 769, 1032, 1246],
53400:[443, 771, 1033, 1248],
53500:[444, 772, 1035, 1251],
53600:[444, 773, 1037, 1253],
53700:[445, 775, 1039, 1255],
53800:[446, 776, 1041, 1257],
53900:[447, 777, 1043, 1259],
54000:[448, 779, 1045, 1261],
54100:[449, 780, 1047, 1263],
54200:[450, 782, 1049, 1265],
54300:[451, 783, 1051, 1267],
54400:[452, 785, 1052, 1270],
54500:[453, 786, 1054, 1272],
54600:[453, 788, 1056, 1274],
54700:[454, 789, 1058, 1276],
54800:[455, 791, 1060, 1278],
54900:[456, 792, 1062, 1280],
55000:[457, 794, 1063, 1283],
55100:[458, 796, 1065, 1285],
55200:[459, 797, 1067, 1288],
55300:[460, 799, 1069, 1290],
55400:[461, 800, 1071, 1292],
55500:[462, 802, 1073, 1294],
55600:[463, 803, 1074, 1297],
55700:[464, 805, 1076, 1299],
55800:[465, 806, 1078, 1301],
55900:[466, 808, 1080, 1304],
56000:[467, 809, 1082, 1306],
56100:[468, 811, 1084, 1308],
56200:[469, 812, 1086, 1311],
56300:[470, 814, 1088, 1313],
56400:[471, 815, 1090, 1315],
56500:[472, 817, 1092, 1317],
56600:[473, 818, 1094, 1320],
56700:[473, 820, 1096, 1322],
56800:[474, 821, 1098, 1324],
56900:[475, 823, 1100, 1327],
57000:[476, 824, 1102, 1329],
57100:[477, 826, 1104, 1331],
57200:[478, 827, 1106, 1334],
57300:[479, 829, 1108, 1336],
57400:[480, 830, 1110, 1338],
57500:[481, 832, 1112, 1341],
57600:[482, 833, 1114, 1343],
57700:[483, 835, 1116, 1345],
57800:[484, 836, 1118, 1348],
57900:[485, 838, 1120, 1350],
58000:[486, 839, 1121, 1352],
58100:[487, 841, 1123, 1354],
58200:[488, 842, 1125, 1356],
58300:[489, 844, 1127, 1359],
58400:[490, 845, 1129, 1361],
58500:[491, 847, 1131, 1363],
58600:[492, 848, 1132, 1365],
58700:[493, 850, 1134, 1368],
58800:[494, 851, 1136, 1370],
58900:[495, 853, 1138, 1372],
59000:[496, 854, 1140, 1374],
59100:[497, 856, 1142, 1376],
59200:[498, 857, 1144, 1379],
59300:[499, 859, 1146, 1381],
59400:[500, 860, 1148, 1383],
59500:[501, 862, 1149, 1385],
59600:[502, 863, 1151, 1388],
59700:[502, 865, 1153, 1390],
59800:[503, 866, 1155, 1392],
59900:[504, 868, 1157, 1394],
60000:[505, 869, 1159, 1397],
60100:[506, 871, 1161, 1399],
60200:[507, 872, 1163, 1402],
60300:[508, 874, 1165, 1404],
60400:[509, 875, 1167, 1406],
60500:[510, 877, 1169, 1408],
60600:[511, 878, 1171, 1411],
60700:[512, 880, 1173, 1413],
60800:[513, 881, 1175, 1415],
60900:[514, 883, 1177, 1417],
61000:[515, 884, 1179, 1420],
61100:[516, 886, 1181, 1422],
61200:[517, 887, 1183, 1425],
61300:[518, 889, 1185, 1427],
61400:[519, 890, 1187, 1429],
61500:[520, 892, 1189, 1431],
61600:[521, 893, 1191, 1434],
61700:[522, 895, 1192, 1436],
61800:[523, 896, 1194, 1438],
61900:[524, 898, 1196, 1441],
62000:[525, 899, 1198, 1443],
62100:[526, 901, 1200, 1445],
62200:[527, 902, 1202, 1448],
62300:[528, 904, 1204, 1450],
62400:[529, 905, 1206, 1452],
62500:[530, 907, 1207, 1455],
62600:[531, 908, 1209, 1457],
62700:[531, 910, 1211, 1459],
62800:[532, 911, 1213, 1461],
62900:[533, 913, 1215, 1464],
63000:[534, 914, 1217, 1466],
63100:[535, 916, 1219, 1468],
63200:[536, 917, 1221, 1471],
63300:[537, 919, 1223, 1473],
63400:[538, 920, 1225, 1475],
63500:[539, 922, 1227, 1478],
63600:[540, 923, 1229, 1480],
63700:[541, 925, 1231, 1482],
63800:[542, 926, 1233, 1485],
63900:[543, 928, 1235, 1487],
64000:[544, 929, 1237, 1489],
64100:[545, 931, 1239, 1491],
64200:[546, 932, 1241, 1493],
64300:[547, 934, 1243, 1496],
64400:[548, 935, 1245, 1498],
64500:[549, 937, 1247, 1500],
64600:[550, 938, 1249, 1502],
64700:[551, 940, 1251, 1505],
64800:[552, 941, 1252, 1507],
64900:[553, 943, 1254, 1509],
65000:[554, 944, 1256, 1511],
65100:[555, 946, 1258, 1513],
65200:[556, 947, 1260, 1516],
65300:[557, 949, 1262, 1518],
65400:[558, 950, 1264, 1520],
65500:[559, 952, 1266, 1522],
65600:[560, 953, 1267, 1525],
65700:[561, 955, 1269, 1527],
65800:[561, 956, 1271, 1529],
65900:[562, 958, 1273, 1531],
66000:[563, 959, 1275, 1534],
66100:[564, 961, 1277, 1536],
66200:[565, 962, 1279, 1539],
66300:[566, 964, 1281, 1541],
66400:[567, 965, 1283, 1543],
66500:[568, 967, 1285, 1545],
66600:[569, 968, 1287, 1548],
66700:[570, 970, 1289, 1550],
66800:[571, 971, 1291, 1552],
66900:[572, 973, 1293, 1555],
67000:[573, 974, 1295, 1557],
67100:[574, 976, 1297, 1559],
67200:[575, 977, 1299, 1562],
67300:[576, 979, 1301, 1564],
67400:[577, 980, 1303, 1566],
67500:[578, 982, 1305, 1569],
67600:[579, 983, 1307, 1571],
67700:[580, 985, 1309, 1573],
67800:[581, 986, 1311, 1575],
67900:[582, 988, 1312, 1578],
68000:[583, 989, 1314, 1580],
68100:[584, 991, 1316, 1582],
68200:[585, 992, 1318, 1585],
68300:[586, 994, 1320, 1587],
68400:[587, 995, 1322, 1589],
68500:[588, 997, 1324, 1592],
68600:[589, 998, 1325, 1594],
68700:[590, 1000, 1327, 1596],
68800:[590, 1001, 1329, 1599],
68900:[591, 1003, 1331, 1601],
69000:[592, 1004, 1333, 1603],
69100:[593, 1006, 1335, 1605],
69200:[594, 1007, 1337, 1607],
69300:[595, 1009, 1339, 1610],
69400:[596, 1010, 1341, 1612],
69500:[597, 1012, 1343, 1614],
69600:[598, 1013, 1345, 1616],
69700:[599, 1015, 1347, 1619],
69800:[600, 1016, 1349, 1621],
69900:[601, 1018, 1351, 1623],
70000:[602, 1019, 1353, 1625],
70100:[603, 1021, 1355, 1627],
70200:[604, 1022, 1357, 1630],
70300:[605, 1024, 1359, 1632],
70400:[606, 1025, 1361, 1634],
70500:[607, 1027, 1363, 1636],
70600:[608, 1028, 1365, 1639],
70700:[609, 1030, 1367, 1641],
70800:[610, 1031, 1369, 1643],
70900:[611, 1033, 1371, 1645],
71000:[612, 1034, 1372, 1648],
71100:[613, 1036, 1374, 1650],
71200:[614, 1037, 1376, 1653],
71300:[615, 1039, 1378, 1655],
71400:[616, 1040, 1380, 1657],
71500:[617, 1042, 1382, 1659],
71600:[618, 1043, 1384, 1662],
71700:[619, 1045, 1385, 1664],
71800:[620, 1046, 1387, 1666],
71900:[620, 1048, 1389, 1668],
72000:[621, 1049, 1391, 1671],
72100:[622, 1051, 1393, 1673],
72200:[623, 1052, 1395, 1676],
72300:[624, 1054, 1397, 1678],
72400:[625, 1055, 1399, 1680],
72500:[626, 1057, 1400, 1682],
72600:[627, 1058, 1402, 1685],
72700:[628, 1060, 1404, 1687],
72800:[629, 1061, 1406, 1689],
72900:[630, 1063, 1408, 1692],
73000:[631, 1064, 1410, 1694],
73100:[632, 1066, 1412, 1696],
73200:[633, 1067, 1414, 1699],
73300:[634, 1069, 1416, 1701],
73400:[635, 1070, 1418, 1703],
73500:[636, 1072, 1420, 1706],
73600:[637, 1073, 1422, 1708],
73700:[638, 1075, 1424, 1710],
73800:[639, 1076, 1426, 1712],
73900:[640, 1078, 1428, 1715],
74000:[641, 1079, 1430, 1717],
74100:[642, 1081, 1432, 1719],
74200:[643, 1082, 1434, 1722],
74300:[644, 1084, 1436, 1724],
74400:[645, 1085, 1438, 1726],
74500:[646, 1087, 1440, 1729],
74600:[647, 1088, 1442, 1731],
74700:[648, 1090, 1443, 1733],
74800:[649, 1091, 1445, 1736],
74900:[649, 1093, 1447, 1738],
75000:[650, 1094, 1449, 1740],
75100:[651, 1095, 1451, 1742],
75200:[652, 1097, 1453, 1744],
75300:[653, 1098, 1455, 1747],
75400:[654, 1100, 1457, 1749],
75500:[655, 1101, 1458, 1751],
75600:[656, 1103, 1460, 1753],
75700:[657, 1104, 1462, 1756],
75800:[658, 1106, 1464, 1758],
75900:[659, 1107, 1466, 1760],
76000:[660, 1109, 1468, 1762],
76100:[661, 1110, 1470, 1764],
76200:[662, 1112, 1472, 1767],
76300:[663, 1113, 1474, 1769],
76400:[664, 1115, 1476, 1771],
76500:[665, 1116, 1478, 1773],
76600:[666, 1118, 1480, 1776],
76700:[667, 1119, 1482, 1778],
76800:[668, 1121, 1484, 1780],
76900:[669, 1122, 1486, 1782],
77000:[670, 1124, 1488, 1785],
77100:[671, 1125, 1490, 1787],
77200:[672, 1127, 1492, 1790],
77300:[673, 1128, 1494, 1792],
77400:[674, 1130, 1496, 1794],
77500:[675, 1131, 1498, 1796],
77600:[676, 1133, 1500, 1799],
77700:[677, 1134, 1502, 1801],
77800:[678, 1136, 1503, 1803],
77900:[679, 1137, 1505, 1806],
78000:[679, 1139, 1507, 1808],
78100:[680, 1140, 1509, 1810],
78200:[681, 1142, 1511, 1813],
78300:[682, 1143, 1513, 1815],
78400:[683, 1145, 1515, 1817],
78500:[684, 1146, 1517, 1820],
78600:[685, 1148, 1518, 1822],
78700:[686, 1149, 1520, 1824],
78800:[687, 1151, 1522, 1826],
78900:[688, 1152, 1524, 1829],
79000:[689, 1154, 1526, 1831],
79100:[690, 1155, 1528, 1833],
79200:[691, 1157, 1530, 1836],
79300:[692, 1158, 1532, 1838],
79400:[693, 1160, 1534, 1840],
79500:[694, 1161, 1536, 1843],
79600:[694, 1163, 1538, 1845],
79700:[695, 1164, 1540, 1847],
79800:[696, 1166, 1542, 1850],
79900:[697, 1167, 1544, 1852],
80000:[698, 1169, 1546, 1854],
80100:[699, 1170, 1548, 1856],
80200:[700, 1172, 1550, 1858],
80300:[701, 1173, 1552, 1861],
80400:[702, 1175, 1554, 1863],
80500:[703, 1176, 1556, 1865],
80600:[704, 1178, 1558, 1867],
80700:[705, 1179, 1560, 1870],
80800:[706, 1181, 1562, 1872],
80900:[707, 1182, 1563, 1874],
81000:[708, 1184, 1565, 1876],
81100:[709, 1185, 1567, 1878],
81200:[710, 1187, 1569, 1881],
81300:[711, 1188, 1571, 1883],
81400:[712, 1190, 1573, 1885],
81500:[713, 1191, 1575, 1887],
81600:[714, 1193, 1576, 1890],
81700:[715, 1194, 1578, 1892],
81800:[716, 1196, 1580, 1894],
81900:[717, 1197, 1582, 1896],
82000:[718, 1199, 1584, 1899],
82100:[719, 1200, 1586, 1901],
82200:[720, 1202, 1588, 1904],
82300:[721, 1203, 1590, 1906],
82400:[722, 1205, 1592, 1908],
82500:[723, 1206, 1593, 1910],
82600:[724, 1208, 1595, 1913],
82700:[724, 1209, 1597, 1915],
82800:[725, 1211, 1599, 1917],
82900:[726, 1212, 1601, 1919],
83000:[727, 1214, 1603, 1922],
83100:[728, 1215, 1605, 1924],
83200:[729, 1217, 1607, 1927],
83300:[730, 1218, 1609, 1929],
83400:[731, 1220, 1611, 1931],
83500:[732, 1221, 1613, 1933],
83600:[733, 1223, 1615, 1936],
83700:[734, 1224, 1617, 1938],
83800:[735, 1226, 1619, 1940],
83900:[736, 1227, 1621, 1943],
84000:[737, 1229, 1623, 1945],
84100:[738, 1230, 1625, 1947],
84200:[739, 1232, 1627, 1950],
84300:[740, 1233, 1629, 1952],
84400:[741, 1235, 1631, 1954],
84500:[742, 1236, 1633, 1957],
84600:[743, 1238, 1635, 1959],
84700:[744, 1239, 1636, 1961],
84800:[745, 1241, 1638, 1964],
84900:[746, 1242, 1640, 1966],
85000:[747, 1244, 1642, 1968],
85100:[748, 1245, 1644, 1970],
85200:[749, 1247, 1646, 1972],
85300:[750, 1248, 1648, 1975],
85400:[751, 1250, 1650, 1977],
85500:[752, 1251, 1651, 1979],
85600:[753, 1253, 1653, 1981],
85700:[753, 1254, 1655, 1984],
85800:[754, 1256, 1657, 1986],
85900:[755, 1257, 1659, 1988],
86000:[756, 1259, 1661, 1990],
86100:[757, 1260, 1663, 1992],
86200:[758, 1262, 1665, 1995],
86300:[759, 1263, 1667, 1997],
86400:[760, 1265, 1669, 1999],
86500:[761, 1266, 1671, 2001],
86600:[762, 1268, 1673, 2004],
86700:[763, 1269, 1675, 2006],
86800:[764, 1271, 1677, 2008],
86900:[765, 1272, 1679, 2010],
87000:[766, 1274, 1681, 2013],
87100:[767, 1275, 1683, 2015],
87200:[768, 1277, 1685, 2018],
87300:[769, 1278, 1687, 2020],
87400:[770, 1280, 1689, 2022],
87500:[771, 1281, 1691, 2024],
87600:[772, 1283, 1693, 2027],
87700:[773, 1284, 1695, 2029],
87800:[774, 1286, 1696, 2031],
87900:[775, 1287, 1698, 2033],
88000:[776, 1289, 1700, 2036],
88100:[777, 1290, 1702, 2038],
88200:[778, 1292, 1704, 2041],
88300:[779, 1293, 1706, 2043],
88400:[780, 1295, 1708, 2045],
88500:[781, 1296, 1709, 2047],
88600:[782, 1298, 1711, 2050],
88700:[783, 1299, 1713, 2052],
88800:[783, 1301, 1715, 2054],
88900:[784, 1302, 1717, 2057],
89000:[785, 1304, 1719, 2059],
89100:[786, 1305, 1721, 2061],
89200:[787, 1307, 1723, 2064],
89300:[788, 1308, 1725, 2066],
89400:[789, 1310, 1727, 2068],
89500:[790, 1311, 1729, 2071],
89600:[791, 1313, 1731, 2073],
89700:[792, 1314, 1733, 2075],
89800:[793, 1316, 1735, 2077],
89900:[794, 1317, 1737, 2080],
90000:[795, 1319, 1739, 2082],
90100:[796, 1320, 1741, 2084],
90200:[797, 1322, 1743, 2086],
90300:[798, 1323, 1745, 2089],
90400:[799, 1325, 1746, 2091],
90500:[799, 1326, 1748, 2093],
90600:[800, 1328, 1750, 2095],
90700:[801, 1329, 1752, 2098],
90800:[802, 1331, 1754, 2100],
90900:[803, 1332, 1756, 2102],
91000:[804, 1334, 1757, 2104],
91100:[805, 1335, 1759, 2106],
91200:[806, 1337, 1761, 2108],
91300:[807, 1338, 1762, 2110],
91400:[807, 1340, 1764, 2112],
91500:[808, 1341, 1766, 2115],
91600:[809, 1343, 1768, 2117],
91700:[810, 1344, 1769, 2119],
91800:[811, 1345, 1771, 2121],
91900:[812, 1347, 1773, 2123],
92000:[813, 1348, 1775, 2125],
92100:[814, 1349, 1777, 2127],
92200:[815, 1351, 1779, 2129],
92300:[816, 1352, 1780, 2131],
92400:[817, 1353, 1782, 2133],
92500:[817, 1355, 1784, 2136],
92600:[818, 1356, 1786, 2138],
92700:[819, 1357, 1788, 2140],
92800:[820, 1359, 1789, 2142],
92900:[821, 1360, 1791, 2144],
93000:[822, 1361, 1793, 2146],
93100:[823, 1362, 1795, 2148],
93200:[824, 1364, 1797, 2150],
93300:[825, 1365, 1798, 2152],
93400:[826, 1366, 1800, 2154],
93500:[826, 1368, 1802, 2157],
93600:[827, 1369, 1804, 2159],
93700:[828, 1371, 1806, 2161],
93800:[829, 1372, 1808, 2163],
93900:[830, 1373, 1809, 2165],
94000:[831, 1375, 1811, 2167],
94100:[832, 1376, 1813, 2169],
94200:[833, 1378, 1814, 2171],
94300:[834, 1379, 1816, 2173],
94400:[835, 1381, 1818, 2175],
94500:[836, 1382, 1820, 2178],
94600:[836, 1383, 1821, 2180],
94700:[837, 1385, 1823, 2182],
94800:[838, 1386, 1825, 2184],
94900:[839, 1387, 1827, 2186],
95000:[840, 1389, 1828, 2188],
95100:[841, 1390, 1830, 2190],
95200:[842, 1392, 1832, 2192],
95300:[843, 1393, 1833, 2194],
95400:[844, 1395, 1835, 2196],
95500:[845, 1396, 1837, 2199],
95600:[845, 1397, 1839, 2201],
95700:[846, 1399, 1840, 2203],
95800:[847, 1400, 1842, 2205],
95900:[848, 1402, 1844, 2207],
96000:[849, 1403, 1846, 2209],
96100:[850, 1404, 1848, 2211],
96200:[851, 1406, 1850, 2213],
96300:[852, 1407, 1851, 2215],
96400:[853, 1409, 1853, 2217],
96500:[854, 1410, 1855, 2220],
96600:[855, 1411, 1857, 2222],
96700:[855, 1413, 1859, 2224],
96800:[856, 1414, 1860, 2226],
96900:[857, 1416, 1862, 2228],
97000:[858, 1417, 1864, 2230],
97100:[859, 1418, 1866, 2232],
97200:[860, 1420, 1868, 2234],
97300:[861, 1421, 1869, 2236],
97400:[862, 1423, 1871, 2238],
97500:[863, 1424, 1873, 2241],
97600:[864, 1426, 1875, 2243],
97700:[865, 1427, 1877, 2245],
97800:[865, 1428, 1878, 2247],
97900:[866, 1430, 1880, 2249],
98000:[867, 1431, 1882, 2251],
98100:[868, 1432, 1884, 2253],
98200:[869, 1434, 1885, 2255],
98300:[870, 1435, 1887, 2257],
98400:[870, 1436, 1889, 2259],
98500:[871, 1438, 1891, 2262],
98600:[872, 1439, 1892, 2264],
98700:[873, 1440, 1894, 2266],
98800:[874, 1442, 1896, 2268],
98900:[875, 1443, 1898, 2270],
99000:[875, 1444, 1899, 2272],
99100:[876, 1445, 1901, 2274],
99200:[877, 1447, 1903, 2276],
99300:[878, 1448, 1904, 2278],
99400:[878, 1449, 1906, 2280],
99500:[879, 1451, 1908, 2283],
99600:[880, 1452, 1910, 2285],
99700:[881, 1454, 1911, 2287],
99800:[882, 1455, 1913, 2289],
99900:[883, 1456, 1915, 2291],
};
const OR17_AB=[0.84, 1.32, 1.62, 1.88];

// British Columbia — 2017 Federal Child Support Guidelines Table
const T17_BC={
100000:[946, 1522, 1982, 2359],
100100:[947, 1523, 1984, 2361],
100200:[948, 1525, 1985, 2363],
100300:[949, 1526, 1987, 2365],
100400:[950, 1527, 1989, 2367],
100500:[950, 1529, 1991, 2369],
100600:[951, 1530, 1992, 2371],
100700:[952, 1531, 1994, 2373],
100800:[953, 1533, 1996, 2375],
100900:[954, 1534, 1997, 2377],
101000:[955, 1535, 1999, 2379],
101100:[956, 1536, 2001, 2381],
101200:[957, 1538, 2002, 2383],
101300:[958, 1539, 2004, 2385],
101400:[958, 1540, 2006, 2387],
101500:[959, 1542, 2007, 2389],
101600:[960, 1543, 2009, 2391],
101700:[961, 1544, 2011, 2393],
101800:[962, 1545, 2013, 2395],
101900:[963, 1547, 2014, 2397],
102000:[963, 1548, 2016, 2399],
102100:[964, 1549, 2018, 2401],
102200:[965, 1551, 2019, 2403],
102300:[966, 1552, 2021, 2405],
102400:[967, 1554, 2023, 2407],
102500:[967, 1555, 2024, 2409],
102600:[968, 1556, 2026, 2411],
102700:[969, 1558, 2028, 2413],
102800:[970, 1559, 2029, 2415],
102900:[971, 1560, 2031, 2417],
103000:[972, 1562, 2033, 2419],
103100:[973, 1563, 2035, 2421],
103200:[974, 1565, 2037, 2423],
103300:[974, 1566, 2038, 2425],
103400:[975, 1567, 2040, 2427],
103500:[976, 1569, 2042, 2429],
103600:[977, 1570, 2044, 2431],
103700:[978, 1571, 2045, 2433],
103800:[979, 1573, 2047, 2435],
103900:[979, 1574, 2049, 2438],
104000:[980, 1575, 2051, 2440],
104100:[981, 1576, 2053, 2442],
104200:[982, 1578, 2054, 2444],
104300:[983, 1579, 2056, 2446],
104400:[983, 1580, 2058, 2448],
104500:[984, 1582, 2060, 2450],
104600:[985, 1583, 2061, 2452],
104700:[986, 1584, 2063, 2454],
104800:[987, 1585, 2065, 2456],
104900:[988, 1587, 2067, 2458],
105000:[989, 1588, 2068, 2460],
105100:[990, 1589, 2070, 2462],
105200:[991, 1591, 2071, 2464],
105300:[991, 1592, 2073, 2466],
105400:[992, 1594, 2075, 2468],
105500:[993, 1595, 2077, 2470],
105600:[994, 1596, 2078, 2472],
105700:[995, 1598, 2080, 2474],
105800:[995, 1599, 2082, 2476],
105900:[996, 1600, 2084, 2478],
106000:[997, 1602, 2085, 2480],
106100:[998, 1603, 2087, 2482],
106200:[999, 1605, 2088, 2484],
106300:[1000, 1606, 2090, 2486],
106400:[1000, 1607, 2092, 2488],
106500:[1001, 1609, 2094, 2490],
106600:[1002, 1610, 2095, 2492],
106700:[1003, 1611, 2097, 2494],
106800:[1004, 1613, 2099, 2496],
106900:[1005, 1614, 2100, 2498],
107000:[1006, 1615, 2102, 2500],
107100:[1007, 1616, 2104, 2502],
107200:[1008, 1617, 2105, 2504],
107300:[1008, 1619, 2107, 2506],
107400:[1009, 1620, 2109, 2508],
107500:[1010, 1621, 2110, 2510],
107600:[1011, 1622, 2112, 2512],
107700:[1012, 1624, 2113, 2514],
107800:[1012, 1625, 2115, 2516],
107900:[1013, 1626, 2117, 2518],
108000:[1014, 1627, 2118, 2520],
108100:[1015, 1628, 2120, 2522],
108200:[1016, 1630, 2121, 2524],
108300:[1016, 1631, 2123, 2526],
108400:[1017, 1632, 2125, 2528],
108500:[1018, 1633, 2126, 2530],
108600:[1019, 1635, 2128, 2532],
108700:[1019, 1636, 2130, 2534],
108800:[1020, 1637, 2132, 2536],
108900:[1021, 1638, 2133, 2538],
109000:[1022, 1640, 2135, 2539],
109100:[1023, 1641, 2137, 2541],
109200:[1024, 1643, 2138, 2543],
109300:[1025, 1644, 2140, 2545],
109400:[1025, 1645, 2142, 2547],
109500:[1026, 1646, 2143, 2548],
109600:[1027, 1648, 2145, 2550],
109700:[1028, 1649, 2146, 2552],
109800:[1029, 1650, 2148, 2554],
109900:[1030, 1651, 2150, 2556],
110000:[1031, 1653, 2151, 2558],
110100:[1032, 1654, 2153, 2560],
110200:[1033, 1656, 2154, 2562],
110300:[1034, 1657, 2156, 2564],
110400:[1034, 1658, 2158, 2566],
110500:[1035, 1659, 2159, 2568],
110600:[1036, 1661, 2161, 2570],
110700:[1037, 1662, 2163, 2572],
110800:[1038, 1663, 2165, 2574],
110900:[1039, 1665, 2166, 2576],
111000:[1039, 1666, 2168, 2578],
111100:[1040, 1667, 2170, 2580],
111200:[1041, 1669, 2171, 2582],
111300:[1041, 1670, 2173, 2584],
111400:[1042, 1671, 2175, 2586],
111500:[1043, 1673, 2176, 2588],
111600:[1044, 1674, 2178, 2589],
111700:[1045, 1675, 2180, 2591],
111800:[1046, 1676, 2181, 2593],
111900:[1046, 1678, 2183, 2595],
112000:[1047, 1679, 2184, 2597],
112100:[1048, 1680, 2186, 2599],
112200:[1049, 1682, 2187, 2601],
112300:[1049, 1683, 2189, 2603],
112400:[1050, 1684, 2190, 2605],
112500:[1051, 1686, 2192, 2607],
112600:[1052, 1687, 2194, 2609],
112700:[1053, 1688, 2195, 2611],
112800:[1053, 1690, 2197, 2613],
112900:[1054, 1691, 2198, 2615],
113000:[1055, 1692, 2200, 2617],
113100:[1056, 1693, 2202, 2619],
113200:[1057, 1694, 2203, 2621],
113300:[1058, 1696, 2205, 2623],
113400:[1058, 1697, 2207, 2625],
113500:[1059, 1698, 2208, 2627],
113600:[1060, 1699, 2210, 2628],
113700:[1061, 1701, 2212, 2630],
113800:[1062, 1702, 2213, 2632],
113900:[1063, 1703, 2215, 2634],
114000:[1064, 1704, 2217, 2636],
114100:[1065, 1705, 2219, 2638],
114200:[1066, 1707, 2220, 2640],
114300:[1067, 1708, 2222, 2642],
114400:[1067, 1709, 2223, 2644],
114500:[1068, 1710, 2225, 2646],
114600:[1069, 1712, 2227, 2648],
114700:[1070, 1713, 2228, 2650],
114800:[1071, 1714, 2230, 2652],
114900:[1072, 1715, 2231, 2654],
115000:[1072, 1717, 2233, 2656],
115100:[1073, 1718, 2235, 2658],
115200:[1074, 1720, 2236, 2660],
115300:[1074, 1721, 2238, 2662],
115400:[1075, 1722, 2240, 2664],
115500:[1076, 1723, 2241, 2666],
115600:[1077, 1725, 2243, 2668],
115700:[1078, 1726, 2245, 2669],
115800:[1079, 1727, 2246, 2671],
115900:[1079, 1729, 2248, 2673],
116000:[1080, 1730, 2250, 2675],
116100:[1081, 1731, 2252, 2677],
116200:[1082, 1733, 2253, 2679],
116300:[1082, 1734, 2255, 2681],
116400:[1083, 1735, 2256, 2683],
116500:[1084, 1737, 2258, 2685],
116600:[1085, 1738, 2260, 2687],
116700:[1086, 1739, 2261, 2689],
116800:[1086, 1740, 2263, 2691],
116900:[1087, 1742, 2265, 2693],
117000:[1088, 1743, 2266, 2695],
117100:[1089, 1744, 2268, 2697],
117200:[1090, 1746, 2269, 2699],
117300:[1091, 1747, 2271, 2701],
117400:[1091, 1748, 2273, 2703],
117500:[1092, 1750, 2274, 2705],
117600:[1093, 1751, 2276, 2707],
117700:[1094, 1752, 2278, 2708],
117800:[1095, 1754, 2279, 2710],
117900:[1096, 1755, 2281, 2712],
118000:[1097, 1756, 2283, 2714],
118100:[1098, 1757, 2285, 2716],
118200:[1099, 1758, 2286, 2718],
118300:[1100, 1760, 2288, 2720],
118400:[1100, 1761, 2289, 2722],
118500:[1101, 1762, 2291, 2724],
118600:[1102, 1763, 2293, 2726],
118700:[1103, 1765, 2294, 2728],
118800:[1104, 1766, 2296, 2730],
118900:[1105, 1767, 2298, 2732],
119000:[1105, 1768, 2299, 2734],
119100:[1106, 1769, 2301, 2736],
119200:[1107, 1771, 2302, 2738],
119300:[1107, 1772, 2304, 2740],
119400:[1108, 1773, 2306, 2742],
119500:[1109, 1774, 2307, 2744],
119600:[1110, 1776, 2309, 2746],
119700:[1111, 1777, 2311, 2748],
119800:[1112, 1778, 2312, 2749],
119900:[1112, 1779, 2314, 2751],
12000:[0, 0, 0, 0],
120000:[1113, 1781, 2316, 2753],
120100:[1114, 1782, 2318, 2755],
120200:[1115, 1784, 2319, 2757],
120300:[1115, 1785, 2321, 2759],
120400:[1116, 1786, 2322, 2761],
120500:[1117, 1787, 2324, 2763],
120600:[1118, 1789, 2326, 2765],
120700:[1119, 1790, 2327, 2767],
120800:[1119, 1791, 2329, 2769],
120900:[1120, 1793, 2331, 2771],
12100:[4, 11, 12, 13],
121000:[1121, 1794, 2332, 2773],
121100:[1122, 1795, 2334, 2775],
121200:[1123, 1797, 2335, 2777],
121300:[1123, 1798, 2337, 2779],
121400:[1124, 1799, 2339, 2781],
121500:[1125, 1800, 2340, 2783],
121600:[1126, 1802, 2342, 2785],
121700:[1126, 1803, 2344, 2787],
121800:[1127, 1804, 2345, 2789],
121900:[1128, 1806, 2347, 2790],
12200:[8, 22, 24, 25],
122000:[1129, 1807, 2349, 2792],
122100:[1130, 1808, 2351, 2794],
122200:[1131, 1810, 2352, 2796],
122300:[1132, 1811, 2354, 2798],
122400:[1132, 1812, 2356, 2800],
122500:[1133, 1814, 2357, 2802],
122600:[1134, 1815, 2359, 2804],
122700:[1135, 1816, 2360, 2806],
122800:[1136, 1818, 2362, 2808],
122900:[1137, 1819, 2364, 2810],
12300:[12, 33, 36, 38],
123000:[1138, 1820, 2365, 2812],
123100:[1139, 1821, 2367, 2814],
123200:[1140, 1822, 2368, 2816],
123300:[1140, 1824, 2370, 2818],
123400:[1141, 1825, 2372, 2820],
123500:[1142, 1826, 2373, 2822],
123600:[1143, 1827, 2375, 2824],
123700:[1144, 1829, 2377, 2826],
123800:[1145, 1830, 2378, 2828],
123900:[1145, 1831, 2380, 2829],
12400:[16, 44, 48, 51],
124000:[1146, 1832, 2382, 2831],
124100:[1147, 1833, 2384, 2833],
124200:[1148, 1835, 2385, 2835],
124300:[1148, 1836, 2387, 2837],
124400:[1149, 1837, 2389, 2839],
124500:[1150, 1838, 2390, 2840],
124600:[1151, 1840, 2392, 2842],
124700:[1152, 1841, 2393, 2844],
124800:[1152, 1842, 2395, 2846],
124900:[1153, 1843, 2397, 2848],
12500:[20, 55, 60, 64],
125000:[1154, 1845, 2398, 2850],
125100:[1155, 1846, 2400, 2852],
125200:[1156, 1848, 2401, 2854],
125300:[1156, 1849, 2403, 2856],
125400:[1157, 1850, 2405, 2858],
125500:[1158, 1851, 2406, 2860],
125600:[1159, 1853, 2408, 2862],
125700:[1159, 1854, 2410, 2864],
125800:[1160, 1855, 2411, 2866],
125900:[1161, 1856, 2413, 2868],
12600:[23, 66, 71, 76],
126000:[1162, 1858, 2415, 2870],
126100:[1163, 1859, 2417, 2872],
126200:[1164, 1861, 2418, 2874],
126300:[1165, 1862, 2420, 2876],
126400:[1165, 1863, 2422, 2878],
126500:[1166, 1864, 2423, 2880],
126600:[1167, 1866, 2425, 2881],
126700:[1168, 1867, 2426, 2883],
126800:[1169, 1868, 2428, 2885],
126900:[1170, 1870, 2430, 2887],
12700:[27, 77, 83, 89],
127000:[1171, 1871, 2431, 2889],
127100:[1172, 1872, 2433, 2891],
127200:[1173, 1874, 2434, 2893],
127300:[1174, 1875, 2436, 2895],
127400:[1174, 1876, 2438, 2897],
127500:[1175, 1878, 2439, 2899],
127600:[1176, 1879, 2441, 2901],
127700:[1177, 1880, 2443, 2903],
127800:[1178, 1881, 2445, 2905],
127900:[1179, 1883, 2446, 2907],
12800:[31, 88, 95, 102],
128000:[1179, 1884, 2448, 2909],
128100:[1180, 1885, 2450, 2911],
128200:[1181, 1887, 2451, 2913],
128300:[1181, 1888, 2453, 2915],
128400:[1182, 1889, 2455, 2917],
128500:[1183, 1891, 2456, 2919],
128600:[1184, 1892, 2458, 2920],
128700:[1185, 1893, 2460, 2922],
128800:[1186, 1895, 2461, 2924],
128900:[1186, 1896, 2463, 2926],
12900:[35, 99, 107, 114],
129000:[1187, 1897, 2464, 2928],
129100:[1188, 1898, 2466, 2930],
129200:[1189, 1899, 2467, 2932],
129300:[1189, 1901, 2469, 2934],
129400:[1190, 1902, 2470, 2936],
129500:[1191, 1903, 2472, 2938],
129600:[1192, 1904, 2474, 2940],
129700:[1193, 1906, 2475, 2942],
129800:[1193, 1907, 2477, 2944],
129900:[1194, 1908, 2478, 2946],
13000:[39, 110, 119, 127],
130000:[1195, 1909, 2480, 2948],
130100:[1196, 1910, 2482, 2950],
130200:[1197, 1912, 2483, 2952],
130300:[1198, 1913, 2485, 2954],
130400:[1198, 1914, 2487, 2956],
130500:[1199, 1915, 2488, 2958],
130600:[1200, 1917, 2490, 2960],
130700:[1201, 1918, 2492, 2961],
130800:[1202, 1919, 2493, 2963],
130900:[1203, 1920, 2495, 2965],
13100:[41, 114, 123, 131],
131000:[1204, 1922, 2497, 2967],
131100:[1205, 1923, 2499, 2969],
131200:[1206, 1925, 2500, 2971],
131300:[1207, 1926, 2502, 2973],
131400:[1207, 1927, 2503, 2975],
131500:[1208, 1928, 2505, 2977],
131600:[1209, 1930, 2507, 2979],
131700:[1210, 1931, 2508, 2981],
131800:[1211, 1932, 2510, 2983],
131900:[1212, 1934, 2511, 2985],
13200:[43, 118, 127, 136],
132000:[1212, 1935, 2513, 2987],
132100:[1213, 1936, 2515, 2989],
132200:[1214, 1938, 2516, 2991],
132300:[1214, 1939, 2518, 2993],
132400:[1215, 1940, 2520, 2995],
132500:[1216, 1942, 2521, 2997],
132600:[1217, 1943, 2523, 2999],
132700:[1218, 1944, 2525, 3000],
132800:[1219, 1945, 2526, 3002],
132900:[1219, 1947, 2528, 3004],
13300:[44, 121, 131, 140],
133000:[1220, 1948, 2530, 3006],
133100:[1221, 1949, 2532, 3008],
133200:[1222, 1951, 2533, 3010],
133300:[1222, 1952, 2535, 3012],
133400:[1223, 1953, 2536, 3014],
133500:[1224, 1955, 2538, 3016],
133600:[1225, 1956, 2540, 3018],
133700:[1226, 1957, 2541, 3020],
133800:[1226, 1959, 2543, 3022],
133900:[1227, 1960, 2544, 3024],
13400:[46, 125, 135, 144],
134000:[1228, 1961, 2546, 3026],
134100:[1229, 1962, 2548, 3028],
134200:[1230, 1963, 2549, 3030],
134300:[1231, 1965, 2551, 3032],
134400:[1231, 1966, 2553, 3034],
134500:[1232, 1967, 2554, 3036],
134600:[1233, 1968, 2556, 3038],
134700:[1234, 1970, 2558, 3040],
134800:[1235, 1971, 2559, 3041],
134900:[1236, 1972, 2561, 3043],
13500:[48, 129, 140, 149],
135000:[1237, 1973, 2563, 3045],
135100:[1238, 1974, 2565, 3047],
135200:[1239, 1976, 2566, 3049],
135300:[1240, 1977, 2568, 3051],
135400:[1240, 1978, 2569, 3053],
135500:[1241, 1979, 2571, 3055],
135600:[1242, 1981, 2573, 3057],
135700:[1243, 1982, 2574, 3059],
135800:[1244, 1983, 2576, 3061],
135900:[1245, 1984, 2578, 3063],
13600:[50, 133, 144, 153],
136000:[1245, 1986, 2579, 3065],
136100:[1246, 1987, 2581, 3067],
136200:[1247, 1989, 2582, 3069],
136300:[1247, 1990, 2584, 3071],
136400:[1248, 1991, 2586, 3073],
136500:[1249, 1992, 2587, 3075],
136600:[1250, 1994, 2589, 3077],
136700:[1251, 1995, 2591, 3079],
136800:[1252, 1996, 2592, 3080],
136900:[1252, 1998, 2594, 3082],
13700:[51, 136, 148, 157],
137000:[1253, 1999, 2596, 3084],
137100:[1254, 2000, 2598, 3086],
137200:[1255, 2002, 2599, 3088],
137300:[1255, 2003, 2601, 3090],
137400:[1256, 2004, 2602, 3092],
137500:[1257, 2006, 2604, 3094],
137600:[1258, 2007, 2606, 3096],
137700:[1259, 2008, 2607, 3098],
137800:[1259, 2009, 2609, 3100],
137900:[1260, 2011, 2611, 3102],
13800:[53, 140, 152, 162],
138000:[1261, 2012, 2612, 3104],
138100:[1262, 2013, 2614, 3106],
138200:[1263, 2015, 2615, 3108],
138300:[1263, 2016, 2617, 3110],
138400:[1264, 2017, 2619, 3112],
138500:[1265, 2019, 2620, 3114],
138600:[1266, 2020, 2622, 3116],
138700:[1266, 2021, 2624, 3118],
138800:[1267, 2023, 2625, 3120],
138900:[1268, 2024, 2627, 3121],
13900:[55, 144, 156, 166],
139000:[1269, 2025, 2629, 3123],
139100:[1270, 2026, 2631, 3125],
139200:[1271, 2027, 2632, 3127],
139300:[1272, 2029, 2634, 3129],
139400:[1272, 2030, 2636, 3131],
139500:[1273, 2031, 2637, 3132],
139600:[1274, 2032, 2639, 3134],
139700:[1275, 2034, 2640, 3136],
139800:[1276, 2035, 2642, 3138],
139900:[1277, 2036, 2644, 3140],
14000:[57, 148, 160, 171],
140000:[1278, 2037, 2645, 3142],
140100:[1279, 2038, 2647, 3144],
140200:[1280, 2040, 2648, 3146],
140300:[1280, 2041, 2650, 3148],
140400:[1281, 2042, 2651, 3149],
140500:[1282, 2043, 2653, 3151],
140600:[1283, 2045, 2654, 3153],
140700:[1284, 2046, 2656, 3155],
140800:[1285, 2047, 2658, 3157],
140900:[1285, 2048, 2659, 3159],
14100:[59, 151, 164, 175],
141000:[1286, 2050, 2661, 3161],
141100:[1287, 2051, 2663, 3163],
141200:[1288, 2052, 2664, 3165],
141300:[1288, 2054, 2666, 3167],
141400:[1289, 2055, 2667, 3168],
141500:[1290, 2056, 2669, 3170],
141600:[1291, 2057, 2670, 3172],
141700:[1292, 2058, 2672, 3174],
141800:[1293, 2060, 2674, 3176],
141900:[1293, 2061, 2675, 3178],
14200:[61, 155, 168, 179],
142000:[1294, 2062, 2677, 3180],
142100:[1295, 2063, 2679, 3182],
142200:[1295, 2064, 2680, 3184],
142300:[1296, 2066, 2682, 3185],
142400:[1297, 2067, 2683, 3187],
142500:[1298, 2068, 2685, 3189],
142600:[1298, 2069, 2686, 3191],
142700:[1299, 2070, 2688, 3193],
142800:[1300, 2072, 2689, 3195],
142900:[1301, 2073, 2691, 3196],
14300:[62, 158, 171, 183],
143000:[1301, 2074, 2692, 3198],
143100:[1302, 2075, 2694, 3200],
143200:[1303, 2076, 2695, 3202],
143300:[1303, 2078, 2697, 3204],
143400:[1304, 2079, 2698, 3205],
143500:[1305, 2080, 2700, 3207],
143600:[1306, 2081, 2701, 3209],
143700:[1306, 2082, 2703, 3211],
143800:[1307, 2083, 2704, 3213],
143900:[1308, 2085, 2706, 3215],
14400:[64, 162, 175, 187],
144000:[1309, 2086, 2708, 3217],
144100:[1310, 2087, 2710, 3219],
144200:[1311, 2089, 2711, 3221],
144300:[1311, 2090, 2713, 3222],
144400:[1312, 2091, 2714, 3224],
144500:[1313, 2092, 2716, 3226],
144600:[1314, 2094, 2718, 3228],
144700:[1314, 2095, 2719, 3230],
144800:[1315, 2096, 2721, 3232],
144900:[1316, 2097, 2722, 3233],
14500:[66, 165, 179, 191],
145000:[1317, 2099, 2724, 3235],
145100:[1318, 2100, 2726, 3237],
145200:[1319, 2101, 2727, 3239],
145300:[1319, 2103, 2729, 3241],
145400:[1320, 2104, 2730, 3242],
145500:[1321, 2105, 2732, 3244],
145600:[1322, 2106, 2733, 3246],
145700:[1323, 2108, 2735, 3248],
145800:[1323, 2109, 2736, 3250],
145900:[1324, 2110, 2738, 3252],
14600:[68, 169, 183, 195],
146000:[1325, 2111, 2739, 3254],
146100:[1326, 2112, 2741, 3256],
146200:[1327, 2113, 2742, 3258],
146300:[1327, 2115, 2744, 3259],
146400:[1328, 2116, 2745, 3261],
146500:[1329, 2117, 2747, 3263],
146600:[1330, 2118, 2748, 3265],
146700:[1331, 2120, 2750, 3267],
146800:[1332, 2121, 2751, 3269],
146900:[1332, 2122, 2753, 3270],
14700:[69, 172, 187, 200],
147000:[1333, 2123, 2755, 3272],
147100:[1334, 2124, 2757, 3274],
147200:[1334, 2125, 2758, 3276],
147300:[1335, 2127, 2760, 3278],
147400:[1336, 2128, 2761, 3279],
147500:[1337, 2129, 2763, 3281],
147600:[1337, 2130, 2765, 3283],
147700:[1338, 2132, 2766, 3285],
147800:[1339, 2133, 2768, 3287],
147900:[1340, 2134, 2769, 3289],
14800:[71, 176, 191, 204],
148000:[1340, 2135, 2771, 3291],
148100:[1341, 2136, 2773, 3293],
148200:[1342, 2137, 2774, 3295],
148300:[1342, 2139, 2776, 3296],
148400:[1343, 2140, 2777, 3298],
148500:[1344, 2141, 2779, 3300],
148600:[1345, 2142, 2780, 3302],
148700:[1345, 2143, 2782, 3304],
148800:[1346, 2145, 2783, 3306],
148900:[1347, 2146, 2785, 3307],
14900:[73, 179, 194, 208],
149000:[1348, 2147, 2786, 3309],
149100:[1349, 2148, 2788, 3311],
149200:[1350, 2149, 2789, 3313],
149300:[1350, 2151, 2791, 3315],
149400:[1351, 2152, 2792, 3317],
149500:[1352, 2153, 2794, 3318],
149600:[1353, 2154, 2795, 3320],
149700:[1353, 2155, 2797, 3322],
149800:[1354, 2156, 2799, 3324],
149900:[1355, 2158, 2800, 3326],
15000:[75, 183, 198, 212],
150000:[1356, 2159, 2802, 3328],
15100:[77, 186, 202, 216],
15200:[79, 190, 205, 220],
15300:[80, 193, 209, 224],
15400:[82, 196, 213, 228],
15500:[84, 200, 216, 232],
15600:[86, 203, 220, 236],
15700:[88, 207, 224, 240],
15800:[89, 210, 227, 243],
15900:[91, 213, 231, 247],
16000:[93, 217, 234, 251],
16100:[95, 220, 238, 255],
16200:[97, 224, 241, 259],
16300:[98, 227, 245, 262],
16400:[100, 230, 248, 266],
16500:[102, 233, 252, 270],
16600:[104, 237, 256, 274],
16700:[106, 240, 259, 278],
16800:[107, 243, 263, 282],
16900:[109, 246, 266, 285],
17000:[111, 250, 270, 289],
17100:[113, 253, 274, 293],
17200:[115, 257, 277, 297],
17300:[116, 260, 281, 300],
17400:[118, 263, 284, 304],
17500:[120, 266, 288, 308],
17600:[122, 270, 291, 312],
17700:[124, 273, 295, 316],
17800:[125, 276, 298, 320],
17900:[127, 279, 302, 323],
18000:[129, 283, 305, 327],
18100:[131, 286, 309, 331],
18200:[133, 290, 312, 335],
18300:[134, 293, 316, 338],
18400:[136, 296, 319, 342],
18500:[138, 299, 323, 346],
18600:[140, 303, 327, 350],
18700:[142, 306, 330, 354],
18800:[144, 309, 334, 358],
18900:[145, 313, 337, 361],
19000:[147, 316, 341, 365],
19100:[149, 317, 345, 369],
19200:[151, 318, 348, 372],
19300:[153, 318, 352, 376],
19400:[154, 319, 355, 380],
19500:[156, 320, 359, 383],
19600:[158, 321, 362, 387],
19700:[160, 322, 366, 391],
19800:[162, 322, 369, 395],
19900:[164, 323, 373, 398],
20000:[165, 324, 376, 402],
20100:[166, 325, 380, 406],
20200:[167, 326, 384, 410],
20300:[169, 327, 388, 414],
20400:[170, 329, 391, 418],
20500:[171, 330, 395, 422],
20600:[172, 331, 399, 426],
20700:[174, 332, 403, 430],
20800:[175, 333, 407, 435],
20900:[176, 334, 411, 439],
21000:[177, 335, 414, 443],
21100:[178, 336, 418, 447],
21200:[179, 338, 422, 452],
21300:[179, 339, 426, 456],
21400:[180, 340, 430, 461],
21500:[181, 342, 435, 465],
21600:[182, 343, 439, 470],
21700:[182, 344, 443, 474],
21800:[183, 346, 447, 479],
21900:[184, 347, 451, 483],
22000:[185, 348, 455, 488],
22100:[186, 349, 459, 492],
22200:[187, 351, 463, 497],
22300:[187, 352, 467, 501],
22400:[188, 354, 471, 506],
22500:[189, 355, 475, 510],
22600:[190, 356, 479, 515],
22700:[190, 358, 484, 519],
22800:[191, 359, 488, 523],
22900:[192, 361, 492, 528],
23000:[193, 362, 496, 532],
23100:[194, 363, 498, 536],
23200:[195, 365, 500, 541],
23300:[195, 366, 501, 545],
23400:[196, 367, 503, 550],
23500:[197, 369, 505, 554],
23600:[198, 370, 507, 558],
23700:[199, 371, 508, 563],
23800:[199, 373, 510, 567],
23900:[200, 374, 512, 571],
24000:[201, 375, 514, 576],
24100:[202, 376, 516, 580],
24200:[203, 378, 518, 585],
24300:[203, 379, 520, 589],
24400:[204, 381, 521, 594],
24500:[205, 382, 523, 598],
24600:[206, 383, 525, 603],
24700:[207, 385, 527, 607],
24800:[207, 386, 529, 612],
24900:[208, 387, 531, 616],
25000:[209, 389, 533, 621],
25100:[210, 391, 535, 625],
25200:[211, 392, 537, 630],
25300:[213, 394, 539, 634],
25400:[214, 396, 541, 639],
25500:[215, 398, 544, 643],
25600:[216, 399, 546, 648],
25700:[217, 401, 548, 652],
25800:[218, 403, 550, 656],
25900:[220, 404, 552, 661],
26000:[221, 406, 554, 665],
26100:[223, 408, 556, 669],
26200:[224, 410, 559, 673],
26300:[226, 412, 561, 676],
26400:[227, 414, 564, 680],
26500:[229, 416, 566, 684],
26600:[230, 418, 569, 688],
26700:[232, 420, 571, 692],
26800:[234, 422, 574, 695],
26900:[235, 425, 576, 699],
27000:[237, 427, 579, 703],
27100:[239, 429, 581, 706],
27200:[240, 431, 584, 708],
27300:[242, 433, 586, 711],
27400:[243, 435, 589, 714],
27500:[245, 437, 591, 716],
27600:[247, 439, 594, 719],
27700:[248, 441, 596, 722],
27800:[250, 443, 598, 725],
27900:[251, 445, 601, 727],
28000:[253, 447, 603, 730],
28100:[255, 449, 605, 733],
28200:[256, 451, 608, 736],
28300:[258, 453, 610, 738],
28400:[259, 455, 613, 741],
28500:[261, 457, 615, 744],
28600:[262, 459, 617, 747],
28700:[264, 462, 620, 749],
28800:[265, 464, 622, 752],
28900:[267, 466, 625, 755],
29000:[268, 468, 627, 758],
29100:[269, 470, 629, 760],
29200:[270, 471, 631, 763],
29300:[271, 473, 633, 765],
29400:[272, 475, 635, 768],
29500:[273, 476, 637, 770],
29600:[275, 478, 639, 772],
29700:[276, 479, 641, 775],
29800:[277, 481, 644, 777],
29900:[278, 483, 646, 780],
30000:[279, 484, 648, 782],
30100:[280, 486, 650, 784],
30200:[281, 487, 652, 787],
30300:[282, 489, 654, 789],
30400:[283, 490, 656, 791],
30500:[284, 492, 658, 794],
30600:[285, 493, 660, 796],
30700:[286, 495, 662, 798],
30800:[287, 496, 664, 800],
30900:[288, 498, 666, 803],
31000:[289, 499, 668, 805],
31100:[290, 501, 670, 807],
31200:[291, 502, 672, 810],
31300:[292, 504, 674, 812],
31400:[293, 505, 676, 814],
31500:[294, 507, 678, 817],
31600:[295, 508, 680, 819],
31700:[296, 510, 682, 822],
31800:[297, 512, 684, 824],
31900:[298, 513, 686, 826],
32000:[299, 515, 688, 829],
32100:[300, 517, 690, 831],
32200:[301, 518, 692, 834],
32300:[302, 520, 694, 836],
32400:[303, 521, 696, 839],
32500:[304, 523, 698, 841],
32600:[305, 525, 700, 843],
32700:[306, 526, 702, 846],
32800:[307, 528, 704, 848],
32900:[308, 530, 706, 851],
33000:[309, 531, 708, 853],
33100:[310, 533, 710, 855],
33200:[311, 534, 712, 858],
33300:[312, 536, 714, 860],
33400:[313, 537, 716, 863],
33500:[314, 539, 718, 865],
33600:[315, 540, 720, 867],
33700:[316, 542, 722, 870],
33800:[317, 543, 724, 872],
33900:[318, 545, 726, 874],
34000:[319, 546, 728, 877],
34100:[320, 548, 730, 879],
34200:[321, 549, 732, 882],
34300:[322, 551, 734, 884],
34400:[323, 552, 736, 887],
34500:[324, 554, 738, 889],
34600:[325, 555, 740, 891],
34700:[326, 557, 742, 894],
34800:[327, 558, 744, 896],
34900:[328, 560, 746, 899],
35000:[329, 562, 748, 901],
35100:[330, 563, 750, 903],
35200:[331, 565, 752, 906],
35300:[332, 566, 754, 908],
35400:[333, 568, 756, 910],
35500:[334, 569, 758, 913],
35600:[335, 571, 760, 915],
35700:[336, 572, 762, 917],
35800:[337, 574, 764, 920],
35900:[338, 575, 766, 922],
36000:[339, 577, 768, 924],
36100:[340, 578, 770, 926],
36200:[341, 580, 772, 928],
36300:[342, 581, 774, 931],
36400:[343, 583, 776, 933],
36500:[343, 584, 777, 935],
36600:[344, 586, 779, 937],
36700:[345, 587, 781, 939],
36800:[346, 589, 783, 942],
36900:[347, 590, 785, 944],
37000:[348, 592, 787, 946],
37100:[349, 594, 789, 948],
37200:[350, 595, 791, 950],
37300:[351, 597, 793, 953],
37400:[352, 598, 795, 955],
37500:[353, 600, 797, 957],
37600:[354, 601, 799, 959],
37700:[355, 603, 800, 961],
37800:[356, 604, 802, 963],
37900:[357, 606, 804, 966],
38000:[358, 607, 806, 968],
38100:[359, 608, 808, 970],
38200:[360, 610, 810, 972],
38300:[361, 611, 812, 975],
38400:[362, 613, 813, 977],
38500:[363, 614, 815, 979],
38600:[363, 616, 817, 981],
38700:[364, 617, 819, 983],
38800:[365, 619, 821, 985],
38900:[366, 620, 823, 988],
39000:[367, 621, 824, 990],
39100:[368, 622, 826, 992],
39200:[369, 624, 828, 994],
39300:[370, 625, 830, 997],
39400:[371, 627, 832, 999],
39500:[371, 628, 833, 1001],
39600:[372, 629, 835, 1003],
39700:[373, 631, 837, 1005],
39800:[374, 632, 839, 1007],
39900:[375, 634, 841, 1010],
40000:[376, 635, 843, 1012],
40100:[377, 636, 845, 1014],
40200:[378, 638, 847, 1016],
40300:[379, 639, 849, 1019],
40400:[380, 641, 850, 1021],
40500:[381, 642, 852, 1023],
40600:[382, 644, 854, 1025],
40700:[383, 645, 856, 1027],
40800:[384, 647, 858, 1029],
40900:[385, 648, 860, 1032],
41000:[386, 650, 861, 1034],
41100:[387, 651, 863, 1036],
41200:[388, 653, 865, 1038],
41300:[389, 654, 867, 1041],
41400:[390, 656, 869, 1043],
41500:[391, 657, 870, 1045],
41600:[392, 658, 872, 1047],
41700:[393, 660, 874, 1049],
41800:[393, 661, 876, 1052],
41900:[394, 663, 878, 1054],
42000:[395, 664, 880, 1056],
42100:[396, 665, 882, 1058],
42200:[397, 667, 884, 1060],
42300:[398, 668, 885, 1063],
42400:[399, 670, 887, 1065],
42500:[400, 671, 889, 1067],
42600:[400, 673, 891, 1069],
42700:[401, 674, 893, 1071],
42800:[402, 676, 895, 1074],
42900:[403, 677, 896, 1076],
43000:[404, 679, 898, 1078],
43100:[405, 680, 900, 1080],
43200:[406, 682, 902, 1082],
43300:[407, 683, 904, 1085],
43400:[408, 685, 905, 1087],
43500:[409, 686, 907, 1089],
43600:[410, 688, 909, 1091],
43700:[411, 689, 911, 1093],
43800:[412, 690, 913, 1096],
43900:[413, 692, 915, 1098],
44000:[414, 693, 917, 1100],
44100:[415, 695, 919, 1102],
44200:[416, 696, 921, 1105],
44300:[417, 698, 923, 1107],
44400:[418, 699, 925, 1109],
44500:[419, 701, 927, 1111],
44600:[420, 702, 929, 1114],
44700:[421, 704, 931, 1116],
44800:[422, 706, 933, 1118],
44900:[422, 707, 935, 1121],
45000:[423, 709, 937, 1123],
45100:[424, 710, 939, 1125],
45200:[425, 712, 941, 1128],
45300:[426, 713, 943, 1130],
45400:[427, 715, 945, 1132],
45500:[428, 716, 947, 1134],
45600:[429, 718, 949, 1137],
45700:[430, 719, 950, 1139],
45800:[431, 721, 952, 1141],
45900:[432, 722, 954, 1143],
46000:[433, 723, 956, 1146],
46100:[434, 724, 958, 1148],
46200:[435, 726, 960, 1150],
46300:[436, 727, 962, 1152],
46400:[437, 729, 963, 1155],
46500:[438, 730, 965, 1157],
46600:[438, 732, 967, 1159],
46700:[439, 733, 969, 1161],
46800:[440, 735, 971, 1163],
46900:[441, 736, 973, 1165],
47000:[442, 738, 974, 1167],
47100:[443, 739, 976, 1169],
47200:[444, 741, 978, 1171],
47300:[445, 742, 979, 1173],
47400:[446, 744, 981, 1176],
47500:[446, 745, 983, 1178],
47600:[447, 747, 985, 1180],
47700:[448, 748, 987, 1182],
47800:[449, 749, 988, 1184],
47900:[450, 751, 990, 1186],
48000:[451, 752, 992, 1189],
48100:[452, 753, 994, 1191],
48200:[453, 755, 996, 1193],
48300:[454, 756, 998, 1196],
48400:[455, 758, 999, 1198],
48500:[456, 759, 1001, 1200],
48600:[457, 760, 1003, 1202],
48700:[458, 762, 1005, 1204],
48800:[459, 763, 1007, 1206],
48900:[460, 765, 1009, 1209],
49000:[461, 766, 1011, 1211],
49100:[462, 767, 1013, 1213],
49200:[463, 769, 1015, 1215],
49300:[464, 770, 1016, 1218],
49400:[465, 772, 1018, 1220],
49500:[466, 773, 1020, 1222],
49600:[467, 775, 1022, 1224],
49700:[468, 776, 1024, 1226],
49800:[469, 778, 1025, 1229],
49900:[470, 779, 1027, 1231],
50000:[470, 781, 1029, 1233],
50100:[471, 782, 1031, 1235],
50200:[472, 784, 1033, 1237],
50300:[473, 785, 1035, 1240],
50400:[474, 787, 1036, 1242],
50500:[475, 788, 1038, 1244],
50600:[476, 790, 1040, 1246],
50700:[476, 791, 1042, 1249],
50800:[477, 793, 1044, 1251],
50900:[478, 794, 1046, 1253],
51000:[479, 795, 1048, 1255],
51100:[480, 796, 1050, 1257],
51200:[481, 798, 1052, 1259],
51300:[482, 799, 1054, 1262],
51400:[483, 801, 1056, 1264],
51500:[483, 802, 1058, 1266],
51600:[484, 804, 1060, 1268],
51700:[485, 805, 1061, 1271],
51800:[486, 807, 1063, 1273],
51900:[487, 808, 1065, 1275],
52000:[488, 810, 1067, 1277],
52100:[489, 811, 1069, 1279],
52200:[490, 813, 1071, 1281],
52300:[491, 814, 1073, 1284],
52400:[492, 816, 1075, 1286],
52500:[493, 817, 1077, 1288],
52600:[494, 819, 1079, 1290],
52700:[495, 820, 1081, 1292],
52800:[496, 821, 1082, 1295],
52900:[497, 823, 1084, 1297],
53000:[498, 824, 1086, 1299],
53100:[499, 825, 1088, 1301],
53200:[500, 827, 1090, 1303],
53300:[501, 828, 1092, 1306],
53400:[502, 830, 1093, 1308],
53500:[503, 831, 1095, 1310],
53600:[503, 833, 1097, 1312],
53700:[504, 834, 1099, 1314],
53800:[505, 836, 1101, 1316],
53900:[506, 837, 1103, 1319],
54000:[507, 839, 1104, 1321],
54100:[508, 841, 1106, 1323],
54200:[509, 842, 1108, 1326],
54300:[510, 844, 1110, 1328],
54400:[511, 845, 1111, 1330],
54500:[512, 847, 1113, 1332],
54600:[513, 848, 1115, 1335],
54700:[514, 850, 1117, 1337],
54800:[515, 851, 1119, 1339],
54900:[516, 853, 1121, 1341],
55000:[517, 854, 1123, 1344],
55100:[518, 856, 1125, 1346],
55200:[519, 857, 1127, 1349],
55300:[520, 859, 1129, 1351],
55400:[521, 860, 1131, 1353],
55500:[522, 862, 1133, 1356],
55600:[523, 863, 1135, 1358],
55700:[524, 865, 1137, 1360],
55800:[525, 866, 1139, 1362],
55900:[526, 868, 1141, 1365],
56000:[527, 869, 1143, 1367],
56100:[528, 871, 1145, 1369],
56200:[529, 872, 1147, 1372],
56300:[530, 874, 1149, 1374],
56400:[531, 875, 1151, 1376],
56500:[532, 877, 1153, 1379],
56600:[533, 878, 1155, 1381],
56700:[534, 880, 1157, 1383],
56800:[535, 882, 1159, 1386],
56900:[536, 883, 1161, 1388],
57000:[537, 885, 1163, 1391],
57100:[538, 887, 1165, 1393],
57200:[539, 888, 1167, 1396],
57300:[540, 890, 1169, 1398],
57400:[541, 891, 1171, 1401],
57500:[542, 893, 1173, 1403],
57600:[543, 894, 1175, 1405],
57700:[544, 896, 1177, 1408],
57800:[545, 897, 1179, 1410],
57900:[546, 899, 1181, 1413],
58000:[547, 900, 1183, 1415],
58100:[548, 902, 1185, 1417],
58200:[549, 903, 1187, 1420],
58300:[550, 905, 1189, 1422],
58400:[551, 906, 1191, 1424],
58500:[552, 908, 1193, 1427],
58600:[553, 909, 1195, 1429],
58700:[554, 911, 1197, 1431],
58800:[555, 913, 1199, 1434],
58900:[556, 914, 1201, 1436],
59000:[557, 916, 1203, 1438],
59100:[558, 918, 1205, 1440],
59200:[559, 919, 1207, 1443],
59300:[560, 921, 1209, 1445],
59400:[561, 922, 1211, 1448],
59500:[562, 924, 1213, 1450],
59600:[563, 925, 1215, 1452],
59700:[564, 927, 1217, 1455],
59800:[565, 928, 1219, 1457],
59900:[566, 930, 1221, 1459],
60000:[567, 931, 1223, 1462],
60100:[568, 933, 1225, 1464],
60200:[569, 934, 1227, 1467],
60300:[570, 936, 1229, 1469],
60400:[571, 937, 1231, 1471],
60500:[572, 939, 1233, 1474],
60600:[573, 940, 1235, 1476],
60700:[574, 942, 1237, 1478],
60800:[575, 944, 1239, 1481],
60900:[576, 945, 1241, 1483],
61000:[577, 947, 1243, 1485],
61100:[578, 949, 1245, 1487],
61200:[579, 950, 1247, 1490],
61300:[580, 952, 1249, 1492],
61400:[581, 953, 1251, 1494],
61500:[582, 955, 1253, 1497],
61600:[583, 956, 1255, 1499],
61700:[584, 958, 1257, 1502],
61800:[585, 959, 1259, 1504],
61900:[586, 961, 1261, 1506],
62000:[587, 962, 1263, 1509],
62100:[588, 964, 1265, 1511],
62200:[589, 965, 1267, 1514],
62300:[590, 967, 1269, 1516],
62400:[591, 968, 1271, 1518],
62500:[592, 970, 1273, 1521],
62600:[593, 971, 1275, 1523],
62700:[594, 973, 1277, 1525],
62800:[595, 975, 1279, 1527],
62900:[596, 976, 1281, 1530],
63000:[597, 978, 1283, 1532],
63100:[598, 980, 1285, 1534],
63200:[599, 981, 1287, 1537],
63300:[600, 983, 1289, 1539],
63400:[601, 984, 1291, 1541],
63500:[602, 986, 1293, 1544],
63600:[603, 987, 1295, 1546],
63700:[604, 989, 1297, 1548],
63800:[605, 990, 1299, 1551],
63900:[606, 992, 1301, 1553],
64000:[607, 993, 1303, 1556],
64100:[608, 995, 1305, 1558],
64200:[609, 996, 1307, 1561],
64300:[610, 998, 1309, 1563],
64400:[611, 999, 1311, 1566],
64500:[612, 1001, 1313, 1568],
64600:[613, 1002, 1315, 1570],
64700:[614, 1004, 1317, 1573],
64800:[615, 1006, 1319, 1575],
64900:[616, 1007, 1321, 1578],
65000:[616, 1009, 1323, 1580],
65100:[617, 1011, 1325, 1582],
65200:[618, 1012, 1327, 1585],
65300:[619, 1014, 1329, 1587],
65400:[620, 1015, 1331, 1589],
65500:[621, 1017, 1333, 1592],
65600:[622, 1018, 1335, 1594],
65700:[623, 1020, 1337, 1596],
65800:[624, 1021, 1339, 1599],
65900:[625, 1023, 1341, 1601],
66000:[626, 1024, 1343, 1603],
66100:[627, 1026, 1345, 1605],
66200:[628, 1027, 1347, 1608],
66300:[629, 1029, 1349, 1610],
66400:[630, 1030, 1351, 1613],
66500:[631, 1032, 1353, 1615],
66600:[632, 1033, 1355, 1617],
66700:[633, 1035, 1357, 1620],
66800:[634, 1037, 1359, 1622],
66900:[635, 1038, 1361, 1624],
67000:[636, 1040, 1363, 1627],
67100:[637, 1042, 1365, 1629],
67200:[638, 1043, 1367, 1632],
67300:[639, 1045, 1369, 1634],
67400:[640, 1046, 1371, 1636],
67500:[641, 1048, 1373, 1639],
67600:[642, 1049, 1375, 1641],
67700:[643, 1051, 1377, 1643],
67800:[644, 1052, 1379, 1646],
67900:[645, 1054, 1381, 1648],
68000:[646, 1055, 1383, 1650],
68100:[647, 1057, 1385, 1652],
68200:[648, 1058, 1387, 1655],
68300:[649, 1060, 1389, 1657],
68400:[650, 1061, 1391, 1659],
68500:[651, 1063, 1393, 1662],
68600:[652, 1064, 1395, 1664],
68700:[653, 1066, 1397, 1667],
68800:[654, 1067, 1399, 1669],
68900:[655, 1069, 1401, 1671],
69000:[656, 1071, 1403, 1674],
69100:[657, 1073, 1405, 1676],
69200:[658, 1074, 1407, 1679],
69300:[659, 1076, 1409, 1681],
69400:[660, 1077, 1411, 1683],
69500:[661, 1079, 1413, 1686],
69600:[662, 1080, 1415, 1688],
69700:[663, 1082, 1417, 1690],
69800:[664, 1083, 1419, 1692],
69900:[665, 1085, 1421, 1695],
70000:[666, 1086, 1422, 1697],
70100:[667, 1088, 1424, 1699],
70200:[668, 1089, 1426, 1702],
70300:[669, 1091, 1428, 1704],
70400:[670, 1092, 1430, 1706],
70500:[671, 1094, 1432, 1709],
70600:[672, 1095, 1434, 1711],
70700:[673, 1097, 1436, 1713],
70800:[674, 1098, 1438, 1716],
70900:[675, 1100, 1440, 1718],
71000:[676, 1102, 1442, 1721],
71100:[677, 1104, 1444, 1723],
71200:[678, 1105, 1446, 1726],
71300:[679, 1107, 1448, 1728],
71400:[680, 1108, 1450, 1731],
71500:[681, 1110, 1452, 1733],
71600:[682, 1111, 1454, 1735],
71700:[683, 1113, 1456, 1738],
71800:[684, 1114, 1458, 1740],
71900:[685, 1116, 1460, 1743],
72000:[686, 1117, 1462, 1745],
72100:[687, 1119, 1464, 1747],
72200:[688, 1120, 1466, 1750],
72300:[689, 1122, 1468, 1752],
72400:[690, 1123, 1470, 1754],
72500:[691, 1125, 1472, 1757],
72600:[692, 1126, 1474, 1759],
72700:[693, 1128, 1476, 1761],
72800:[694, 1129, 1478, 1764],
72900:[695, 1131, 1480, 1766],
73000:[696, 1133, 1482, 1768],
73100:[697, 1135, 1484, 1770],
73200:[698, 1136, 1486, 1773],
73300:[699, 1138, 1488, 1775],
73400:[700, 1139, 1490, 1778],
73500:[701, 1141, 1492, 1780],
73600:[702, 1142, 1494, 1782],
73700:[703, 1144, 1496, 1785],
73800:[704, 1145, 1498, 1787],
73900:[705, 1147, 1500, 1789],
74000:[706, 1148, 1502, 1792],
74100:[707, 1150, 1504, 1794],
74200:[708, 1151, 1506, 1797],
74300:[709, 1153, 1508, 1799],
74400:[710, 1154, 1510, 1801],
74500:[711, 1156, 1512, 1804],
74600:[712, 1157, 1514, 1806],
74700:[713, 1159, 1516, 1808],
74800:[714, 1160, 1518, 1811],
74900:[715, 1162, 1520, 1813],
75000:[716, 1164, 1522, 1815],
75100:[717, 1166, 1524, 1817],
75200:[718, 1167, 1526, 1820],
75300:[719, 1169, 1528, 1822],
75400:[720, 1170, 1530, 1824],
75500:[721, 1172, 1532, 1827],
75600:[722, 1173, 1534, 1829],
75700:[723, 1175, 1536, 1832],
75800:[724, 1176, 1538, 1834],
75900:[725, 1178, 1540, 1836],
76000:[726, 1179, 1542, 1839],
76100:[727, 1181, 1544, 1841],
76200:[728, 1182, 1546, 1844],
76300:[729, 1184, 1548, 1846],
76400:[730, 1185, 1550, 1848],
76500:[731, 1187, 1552, 1851],
76600:[732, 1188, 1554, 1853],
76700:[733, 1190, 1556, 1855],
76800:[734, 1191, 1558, 1857],
76900:[735, 1193, 1560, 1860],
77000:[736, 1195, 1562, 1862],
77100:[737, 1197, 1564, 1864],
77200:[738, 1198, 1566, 1867],
77300:[739, 1200, 1568, 1869],
77400:[740, 1201, 1570, 1871],
77500:[741, 1203, 1572, 1874],
77600:[742, 1204, 1574, 1876],
77700:[743, 1206, 1576, 1878],
77800:[744, 1207, 1577, 1880],
77900:[745, 1209, 1579, 1883],
78000:[746, 1210, 1581, 1885],
78100:[747, 1211, 1583, 1887],
78200:[748, 1213, 1585, 1889],
78300:[749, 1214, 1587, 1892],
78400:[750, 1216, 1589, 1894],
78500:[751, 1217, 1591, 1896],
78600:[752, 1219, 1593, 1898],
78700:[753, 1220, 1594, 1901],
78800:[754, 1222, 1596, 1903],
78900:[755, 1223, 1598, 1905],
79000:[755, 1224, 1600, 1907],
79100:[756, 1225, 1602, 1909],
79200:[757, 1227, 1604, 1912],
79300:[758, 1228, 1606, 1914],
79400:[759, 1230, 1608, 1916],
79500:[760, 1231, 1610, 1918],
79600:[761, 1233, 1611, 1921],
79700:[762, 1234, 1613, 1923],
79800:[763, 1236, 1615, 1925],
79900:[764, 1237, 1617, 1927],
80000:[765, 1239, 1619, 1930],
80100:[766, 1240, 1621, 1932],
80200:[767, 1242, 1623, 1935],
80300:[768, 1243, 1625, 1937],
80400:[769, 1245, 1627, 1939],
80500:[770, 1246, 1628, 1942],
80600:[771, 1248, 1630, 1944],
80700:[772, 1249, 1632, 1946],
80800:[772, 1251, 1634, 1948],
80900:[773, 1252, 1636, 1951],
81000:[774, 1254, 1638, 1953],
81100:[775, 1255, 1640, 1955],
81200:[776, 1257, 1642, 1957],
81300:[777, 1258, 1644, 1960],
81400:[778, 1260, 1645, 1962],
81500:[779, 1261, 1647, 1964],
81600:[780, 1263, 1649, 1966],
81700:[781, 1264, 1651, 1969],
81800:[782, 1266, 1653, 1971],
81900:[783, 1267, 1655, 1973],
82000:[784, 1269, 1657, 1975],
82100:[785, 1270, 1659, 1977],
82200:[786, 1272, 1661, 1980],
82300:[787, 1273, 1663, 1982],
82400:[788, 1275, 1665, 1984],
82500:[789, 1276, 1667, 1986],
82600:[789, 1278, 1669, 1989],
82700:[790, 1279, 1671, 1991],
82800:[791, 1281, 1673, 1993],
82900:[792, 1282, 1675, 1996],
83000:[793, 1284, 1677, 1998],
83100:[794, 1285, 1679, 2000],
83200:[795, 1287, 1681, 2002],
83300:[796, 1288, 1683, 2005],
83400:[797, 1290, 1685, 2007],
83500:[798, 1291, 1687, 2009],
83600:[799, 1293, 1689, 2011],
83700:[800, 1294, 1691, 2014],
83800:[801, 1296, 1692, 2016],
83900:[802, 1297, 1694, 2018],
84000:[803, 1299, 1696, 2020],
84100:[804, 1300, 1698, 2022],
84200:[805, 1302, 1700, 2025],
84300:[806, 1303, 1702, 2027],
84400:[807, 1305, 1704, 2029],
84500:[808, 1306, 1706, 2031],
84600:[809, 1308, 1708, 2034],
84700:[810, 1309, 1709, 2036],
84800:[811, 1311, 1711, 2038],
84900:[812, 1312, 1713, 2040],
85000:[813, 1314, 1715, 2043],
85100:[814, 1316, 1717, 2045],
85200:[815, 1317, 1719, 2048],
85300:[816, 1319, 1721, 2050],
85400:[817, 1320, 1723, 2052],
85500:[818, 1322, 1725, 2054],
85600:[819, 1323, 1726, 2057],
85700:[820, 1325, 1728, 2059],
85800:[821, 1326, 1730, 2061],
85900:[821, 1328, 1732, 2064],
86000:[822, 1329, 1734, 2066],
86100:[823, 1331, 1736, 2068],
86200:[824, 1332, 1738, 2070],
86300:[825, 1334, 1740, 2073],
86400:[826, 1335, 1742, 2075],
86500:[827, 1337, 1743, 2077],
86600:[828, 1338, 1745, 2079],
86700:[829, 1340, 1747, 2082],
86800:[830, 1341, 1749, 2084],
86900:[831, 1343, 1751, 2086],
87000:[832, 1344, 1753, 2088],
87100:[833, 1346, 1755, 2090],
87200:[834, 1347, 1757, 2093],
87300:[835, 1349, 1759, 2095],
87400:[836, 1350, 1760, 2097],
87500:[837, 1352, 1762, 2099],
87600:[838, 1353, 1764, 2102],
87700:[838, 1355, 1766, 2104],
87800:[839, 1356, 1768, 2106],
87900:[840, 1358, 1770, 2108],
88000:[841, 1359, 1772, 2111],
88100:[842, 1360, 1774, 2113],
88200:[843, 1362, 1776, 2115],
88300:[844, 1363, 1778, 2118],
88400:[845, 1365, 1779, 2120],
88500:[846, 1366, 1781, 2122],
88600:[847, 1368, 1783, 2124],
88700:[848, 1369, 1785, 2126],
88800:[849, 1371, 1787, 2129],
88900:[850, 1372, 1789, 2131],
89000:[851, 1373, 1791, 2133],
89100:[852, 1374, 1793, 2135],
89200:[853, 1376, 1795, 2137],
89300:[854, 1377, 1797, 2140],
89400:[855, 1379, 1799, 2142],
89500:[856, 1380, 1800, 2144],
89600:[857, 1382, 1802, 2146],
89700:[858, 1383, 1804, 2148],
89800:[859, 1385, 1806, 2151],
89900:[859, 1386, 1808, 2153],
90000:[860, 1388, 1810, 2155],
90100:[861, 1389, 1812, 2157],
90200:[862, 1391, 1814, 2159],
90300:[863, 1392, 1815, 2161],
90400:[864, 1394, 1817, 2163],
90500:[865, 1395, 1819, 2165],
90600:[865, 1397, 1821, 2168],
90700:[866, 1398, 1823, 2170],
90800:[867, 1400, 1825, 2172],
90900:[868, 1401, 1826, 2174],
91000:[869, 1402, 1828, 2176],
91100:[870, 1403, 1830, 2178],
91200:[871, 1405, 1831, 2180],
91300:[872, 1406, 1833, 2182],
91400:[873, 1407, 1835, 2184],
91500:[874, 1409, 1837, 2186],
91600:[874, 1410, 1838, 2188],
91700:[875, 1411, 1840, 2190],
91800:[876, 1413, 1842, 2193],
91900:[877, 1414, 1844, 2195],
92000:[878, 1415, 1845, 2197],
92100:[879, 1416, 1847, 2199],
92200:[880, 1418, 1848, 2201],
92300:[881, 1419, 1850, 2203],
92400:[881, 1420, 1852, 2205],
92500:[882, 1422, 1854, 2207],
92600:[883, 1423, 1855, 2209],
92700:[884, 1424, 1857, 2211],
92800:[885, 1425, 1859, 2213],
92900:[886, 1427, 1860, 2215],
93000:[886, 1428, 1862, 2217],
93100:[887, 1429, 1864, 2219],
93200:[888, 1431, 1865, 2221],
93300:[889, 1432, 1867, 2223],
93400:[890, 1434, 1869, 2225],
93500:[890, 1435, 1871, 2227],
93600:[891, 1436, 1872, 2229],
93700:[892, 1438, 1874, 2231],
93800:[893, 1439, 1876, 2233],
93900:[894, 1440, 1877, 2235],
94000:[895, 1442, 1879, 2237],
94100:[896, 1443, 1881, 2239],
94200:[897, 1445, 1882, 2241],
94300:[898, 1446, 1884, 2243],
94400:[898, 1447, 1886, 2245],
94500:[899, 1449, 1887, 2247],
94600:[900, 1450, 1889, 2249],
94700:[901, 1451, 1891, 2251],
94800:[902, 1453, 1893, 2253],
94900:[903, 1454, 1894, 2255],
95000:[903, 1455, 1896, 2257],
95100:[904, 1456, 1898, 2259],
95200:[905, 1458, 1899, 2261],
95300:[906, 1459, 1901, 2263],
95400:[907, 1460, 1903, 2265],
95500:[907, 1462, 1904, 2267],
95600:[908, 1463, 1906, 2269],
95700:[909, 1464, 1908, 2271],
95800:[910, 1465, 1909, 2274],
95900:[911, 1467, 1911, 2276],
96000:[912, 1468, 1913, 2278],
96100:[913, 1469, 1915, 2280],
96200:[914, 1471, 1917, 2282],
96300:[914, 1472, 1918, 2284],
96400:[915, 1474, 1920, 2286],
96500:[916, 1475, 1922, 2288],
96600:[917, 1476, 1924, 2290],
96700:[918, 1478, 1925, 2292],
96800:[919, 1479, 1927, 2294],
96900:[919, 1480, 1929, 2296],
97000:[920, 1482, 1931, 2298],
97100:[921, 1483, 1933, 2300],
97200:[922, 1485, 1934, 2302],
97300:[923, 1486, 1936, 2304],
97400:[923, 1487, 1938, 2306],
97500:[924, 1489, 1940, 2308],
97600:[925, 1490, 1941, 2310],
97700:[926, 1491, 1943, 2312],
97800:[927, 1493, 1945, 2314],
97900:[928, 1494, 1947, 2316],
98000:[929, 1495, 1948, 2318],
98100:[930, 1496, 1950, 2320],
98200:[931, 1498, 1951, 2322],
98300:[932, 1499, 1953, 2324],
98400:[933, 1500, 1955, 2326],
98500:[934, 1502, 1957, 2328],
98600:[934, 1503, 1958, 2330],
98700:[935, 1504, 1960, 2332],
98800:[936, 1505, 1962, 2334],
98900:[937, 1507, 1964, 2336],
99000:[938, 1508, 1965, 2338],
99100:[939, 1509, 1967, 2340],
99200:[940, 1511, 1968, 2342],
99300:[941, 1512, 1970, 2344],
99400:[941, 1514, 1972, 2346],
99500:[942, 1515, 1974, 2348],
99600:[943, 1516, 1975, 2350],
99700:[944, 1518, 1977, 2352],
99800:[945, 1519, 1979, 2354],
99900:[946, 1520, 1980, 2357],
};
const OR17_BC=[0.78, 1.18, 1.56, 1.88];

// Manitoba — 2017 Federal Child Support Guidelines Table
const T17_MB={
100000:[851, 1387, 1814, 2157],
100100:[852, 1388, 1816, 2159],
100200:[853, 1389, 1817, 2161],
100300:[853, 1391, 1819, 2163],
100400:[854, 1392, 1820, 2165],
100500:[855, 1393, 1822, 2166],
100600:[856, 1394, 1824, 2168],
100700:[856, 1395, 1825, 2170],
100800:[857, 1396, 1827, 2172],
100900:[858, 1398, 1828, 2174],
101000:[859, 1399, 1830, 2176],
101100:[860, 1400, 1832, 2178],
101200:[861, 1402, 1833, 2180],
101300:[861, 1403, 1835, 2182],
101400:[862, 1404, 1836, 2184],
101500:[863, 1405, 1838, 2185],
101600:[864, 1407, 1840, 2187],
101700:[864, 1408, 1841, 2189],
101800:[865, 1409, 1843, 2191],
101900:[866, 1410, 1844, 2193],
102000:[867, 1412, 1846, 2195],
102100:[868, 1413, 1848, 2197],
102200:[869, 1414, 1849, 2199],
102300:[869, 1416, 1851, 2201],
102400:[870, 1417, 1852, 2203],
102500:[871, 1418, 1854, 2205],
102600:[872, 1419, 1856, 2206],
102700:[872, 1421, 1857, 2208],
102800:[873, 1422, 1859, 2210],
102900:[874, 1423, 1861, 2212],
103000:[875, 1424, 1862, 2214],
103100:[876, 1425, 1864, 2216],
103200:[877, 1426, 1865, 2218],
103300:[877, 1428, 1867, 2220],
103400:[878, 1429, 1868, 2222],
103500:[879, 1430, 1870, 2224],
103600:[880, 1431, 1872, 2226],
103700:[881, 1432, 1873, 2228],
103800:[881, 1434, 1875, 2229],
103900:[882, 1435, 1877, 2231],
104000:[883, 1436, 1878, 2233],
104100:[884, 1437, 1880, 2235],
104200:[885, 1438, 1881, 2237],
104300:[885, 1440, 1883, 2239],
104400:[886, 1441, 1884, 2240],
104500:[887, 1442, 1886, 2242],
104600:[888, 1443, 1888, 2244],
104700:[889, 1444, 1889, 2246],
104800:[889, 1445, 1891, 2248],
104900:[890, 1447, 1893, 2250],
105000:[891, 1448, 1894, 2251],
105100:[892, 1449, 1896, 2253],
105200:[893, 1451, 1897, 2255],
105300:[893, 1452, 1899, 2257],
105400:[894, 1453, 1900, 2258],
105500:[895, 1454, 1902, 2260],
105600:[896, 1456, 1904, 2262],
105700:[897, 1457, 1905, 2264],
105800:[898, 1458, 1907, 2266],
105900:[898, 1459, 1909, 2268],
106000:[899, 1461, 1910, 2270],
106100:[900, 1462, 1912, 2272],
106200:[901, 1463, 1913, 2274],
106300:[902, 1465, 1915, 2276],
106400:[902, 1466, 1916, 2278],
106500:[903, 1467, 1918, 2279],
106600:[904, 1468, 1920, 2281],
106700:[905, 1470, 1921, 2283],
106800:[906, 1471, 1923, 2285],
106900:[907, 1472, 1925, 2287],
107000:[907, 1473, 1926, 2289],
107100:[908, 1474, 1928, 2291],
107200:[908, 1475, 1929, 2293],
107300:[909, 1477, 1931, 2295],
107400:[910, 1478, 1932, 2297],
107500:[911, 1479, 1934, 2298],
107600:[911, 1480, 1936, 2300],
107700:[912, 1482, 1937, 2302],
107800:[913, 1483, 1939, 2304],
107900:[914, 1484, 1941, 2306],
108000:[914, 1485, 1942, 2308],
108100:[915, 1486, 1944, 2310],
108200:[916, 1487, 1945, 2312],
108300:[916, 1489, 1947, 2314],
108400:[917, 1490, 1948, 2316],
108500:[918, 1491, 1950, 2318],
108600:[919, 1492, 1951, 2319],
108700:[919, 1493, 1953, 2321],
108800:[920, 1495, 1954, 2323],
108900:[921, 1496, 1956, 2325],
109000:[922, 1497, 1957, 2327],
109100:[923, 1498, 1959, 2329],
109200:[924, 1500, 1960, 2331],
109300:[924, 1501, 1962, 2333],
109400:[925, 1502, 1963, 2334],
109500:[926, 1503, 1965, 2336],
109600:[927, 1505, 1966, 2338],
109700:[927, 1506, 1968, 2340],
109800:[928, 1507, 1970, 2342],
109900:[929, 1508, 1971, 2344],
110000:[930, 1510, 1973, 2345],
110100:[931, 1511, 1975, 2347],
110200:[932, 1512, 1976, 2349],
110300:[932, 1514, 1978, 2351],
110400:[933, 1515, 1979, 2352],
110500:[934, 1516, 1981, 2354],
110600:[935, 1517, 1983, 2356],
110700:[936, 1519, 1984, 2358],
110800:[936, 1520, 1986, 2360],
110900:[937, 1521, 1987, 2362],
111000:[938, 1522, 1989, 2364],
111100:[939, 1523, 1991, 2366],
111200:[940, 1524, 1992, 2368],
111300:[940, 1526, 1994, 2370],
111400:[941, 1527, 1995, 2371],
111500:[942, 1528, 1997, 2373],
111600:[943, 1529, 1998, 2375],
111700:[944, 1531, 2000, 2377],
111800:[944, 1532, 2001, 2379],
111900:[945, 1533, 2003, 2381],
112000:[946, 1534, 2004, 2383],
112100:[947, 1535, 2006, 2385],
112200:[948, 1536, 2007, 2387],
112300:[948, 1538, 2009, 2389],
112400:[949, 1539, 2010, 2391],
112500:[950, 1540, 2012, 2392],
112600:[951, 1541, 2013, 2394],
112700:[952, 1542, 2015, 2396],
112800:[953, 1544, 2016, 2398],
112900:[953, 1545, 2018, 2400],
113000:[954, 1546, 2020, 2402],
113100:[955, 1547, 2022, 2404],
113200:[956, 1548, 2023, 2406],
113300:[956, 1550, 2025, 2408],
113400:[957, 1551, 2026, 2410],
113500:[958, 1552, 2028, 2412],
113600:[959, 1553, 2029, 2413],
113700:[960, 1554, 2031, 2415],
113800:[961, 1555, 2033, 2417],
113900:[961, 1557, 2034, 2419],
114000:[962, 1558, 2036, 2421],
114100:[963, 1559, 2038, 2423],
114200:[963, 1561, 2039, 2425],
114300:[964, 1562, 2041, 2427],
114400:[965, 1563, 2042, 2429],
114500:[966, 1564, 2044, 2431],
114600:[966, 1566, 2046, 2433],
114700:[967, 1567, 2047, 2434],
114800:[968, 1568, 2049, 2436],
114900:[969, 1569, 2050, 2438],
115000:[969, 1571, 2052, 2440],
115100:[970, 1572, 2054, 2442],
115200:[971, 1573, 2055, 2444],
115300:[971, 1575, 2057, 2446],
115400:[972, 1576, 2058, 2447],
115500:[973, 1577, 2060, 2449],
115600:[974, 1578, 2061, 2451],
115700:[974, 1580, 2063, 2453],
115800:[975, 1581, 2064, 2455],
115900:[976, 1582, 2066, 2457],
116000:[977, 1583, 2067, 2458],
116100:[978, 1584, 2069, 2460],
116200:[979, 1585, 2070, 2462],
116300:[979, 1587, 2072, 2464],
116400:[980, 1588, 2073, 2465],
116500:[981, 1589, 2075, 2467],
116600:[982, 1590, 2076, 2469],
116700:[982, 1591, 2078, 2471],
116800:[983, 1593, 2080, 2473],
116900:[984, 1594, 2081, 2475],
117000:[985, 1595, 2083, 2477],
117100:[986, 1596, 2085, 2479],
117200:[987, 1597, 2086, 2481],
117300:[987, 1599, 2088, 2483],
117400:[988, 1600, 2089, 2484],
117500:[989, 1601, 2091, 2486],
117600:[990, 1602, 2093, 2488],
117700:[991, 1603, 2094, 2490],
117800:[991, 1605, 2096, 2492],
117900:[992, 1606, 2097, 2494],
118000:[993, 1607, 2099, 2496],
118100:[994, 1608, 2101, 2498],
118200:[995, 1610, 2102, 2500],
118300:[995, 1611, 2104, 2502],
118400:[996, 1612, 2105, 2504],
118500:[997, 1613, 2107, 2505],
118600:[998, 1615, 2109, 2507],
118700:[999, 1616, 2110, 2509],
118800:[999, 1617, 2112, 2511],
118900:[1000, 1618, 2114, 2513],
119000:[1001, 1620, 2115, 2515],
119100:[1002, 1621, 2117, 2517],
119200:[1003, 1622, 2118, 2519],
119300:[1003, 1624, 2120, 2521],
119400:[1004, 1625, 2121, 2523],
119500:[1005, 1626, 2123, 2525],
119600:[1006, 1627, 2124, 2526],
119700:[1007, 1629, 2126, 2528],
119800:[1008, 1630, 2127, 2530],
119900:[1008, 1631, 2129, 2532],
12000:[0, 0, 0, 0],
120000:[1009, 1632, 2130, 2534],
120100:[1010, 1633, 2132, 2536],
120200:[1011, 1634, 2133, 2538],
120300:[1011, 1636, 2135, 2540],
120400:[1012, 1637, 2136, 2542],
120500:[1013, 1638, 2138, 2544],
120600:[1014, 1639, 2139, 2546],
120700:[1015, 1641, 2141, 2547],
120800:[1016, 1642, 2143, 2549],
120900:[1016, 1643, 2144, 2551],
12100:[7, 7, 8, 8],
121000:[1017, 1644, 2146, 2553],
121100:[1018, 1645, 2148, 2555],
121200:[1018, 1646, 2149, 2557],
121300:[1019, 1648, 2151, 2559],
121400:[1020, 1649, 2152, 2560],
121500:[1021, 1650, 2154, 2562],
121600:[1021, 1651, 2156, 2564],
121700:[1022, 1652, 2157, 2566],
121800:[1023, 1654, 2159, 2568],
121900:[1024, 1655, 2160, 2570],
12200:[13, 14, 15, 16],
122000:[1024, 1656, 2162, 2571],
122100:[1025, 1657, 2164, 2573],
122200:[1026, 1658, 2165, 2575],
122300:[1026, 1660, 2167, 2577],
122400:[1027, 1661, 2168, 2578],
122500:[1028, 1662, 2170, 2580],
122600:[1029, 1663, 2171, 2582],
122700:[1029, 1664, 2173, 2584],
122800:[1030, 1665, 2174, 2586],
122900:[1031, 1667, 2176, 2588],
12300:[20, 21, 23, 24],
123000:[1032, 1668, 2177, 2590],
123100:[1033, 1669, 2179, 2592],
123200:[1034, 1671, 2180, 2594],
123300:[1034, 1672, 2182, 2596],
123400:[1035, 1673, 2183, 2598],
123500:[1036, 1674, 2185, 2599],
123600:[1037, 1676, 2186, 2601],
123700:[1037, 1677, 2188, 2603],
123800:[1038, 1678, 2189, 2605],
123900:[1039, 1679, 2191, 2607],
12400:[26, 28, 30, 32],
124000:[1040, 1681, 2193, 2609],
124100:[1041, 1682, 2195, 2611],
124200:[1042, 1683, 2196, 2613],
124300:[1042, 1685, 2198, 2615],
124400:[1043, 1686, 2199, 2617],
124500:[1044, 1687, 2201, 2618],
124600:[1045, 1688, 2203, 2620],
124700:[1045, 1690, 2204, 2622],
124800:[1046, 1691, 2206, 2624],
124900:[1047, 1692, 2207, 2626],
12500:[33, 35, 38, 41],
125000:[1048, 1693, 2209, 2628],
125100:[1049, 1694, 2211, 2630],
125200:[1050, 1695, 2212, 2632],
125300:[1050, 1697, 2214, 2634],
125400:[1051, 1698, 2215, 2636],
125500:[1052, 1699, 2217, 2638],
125600:[1053, 1700, 2219, 2639],
125700:[1054, 1701, 2220, 2641],
125800:[1054, 1703, 2222, 2643],
125900:[1055, 1704, 2224, 2645],
12600:[39, 42, 45, 49],
126000:[1056, 1705, 2225, 2647],
126100:[1057, 1706, 2227, 2649],
126200:[1058, 1707, 2228, 2651],
126300:[1058, 1709, 2230, 2653],
126400:[1059, 1710, 2231, 2655],
126500:[1060, 1711, 2233, 2657],
126600:[1061, 1712, 2234, 2659],
126700:[1062, 1713, 2236, 2661],
126800:[1062, 1714, 2237, 2662],
126900:[1063, 1716, 2239, 2664],
12700:[46, 49, 53, 57],
127000:[1064, 1717, 2240, 2666],
127100:[1065, 1718, 2242, 2668],
127200:[1066, 1720, 2243, 2670],
127300:[1066, 1721, 2245, 2672],
127400:[1067, 1722, 2246, 2673],
127500:[1068, 1723, 2248, 2675],
127600:[1069, 1725, 2249, 2677],
127700:[1070, 1726, 2251, 2679],
127800:[1071, 1727, 2253, 2681],
127900:[1071, 1728, 2254, 2683],
12800:[52, 56, 60, 65],
128000:[1072, 1730, 2256, 2684],
128100:[1073, 1731, 2258, 2686],
128200:[1073, 1732, 2259, 2688],
128300:[1074, 1734, 2261, 2690],
128400:[1075, 1735, 2262, 2691],
128500:[1076, 1736, 2264, 2693],
128600:[1076, 1737, 2266, 2695],
128700:[1077, 1739, 2267, 2697],
128800:[1078, 1740, 2269, 2699],
128900:[1079, 1741, 2270, 2701],
12900:[59, 63, 68, 73],
129000:[1079, 1742, 2272, 2703],
129100:[1080, 1743, 2274, 2705],
129200:[1081, 1744, 2275, 2707],
129300:[1081, 1746, 2277, 2709],
129400:[1082, 1747, 2278, 2711],
129500:[1083, 1748, 2280, 2712],
129600:[1084, 1749, 2281, 2714],
129700:[1084, 1751, 2283, 2716],
129800:[1085, 1752, 2284, 2718],
129900:[1086, 1753, 2286, 2720],
13000:[65, 70, 75, 81],
130000:[1087, 1754, 2287, 2722],
130100:[1088, 1755, 2289, 2724],
130200:[1089, 1756, 2290, 2726],
130300:[1089, 1758, 2292, 2728],
130400:[1090, 1759, 2293, 2730],
130500:[1091, 1760, 2295, 2731],
130600:[1092, 1761, 2296, 2733],
130700:[1092, 1762, 2298, 2735],
130800:[1093, 1764, 2299, 2737],
130900:[1094, 1765, 2301, 2739],
13100:[68, 73, 78, 85],
131000:[1095, 1766, 2303, 2741],
131100:[1096, 1767, 2305, 2743],
131200:[1097, 1769, 2306, 2745],
131300:[1097, 1770, 2308, 2747],
131400:[1098, 1771, 2309, 2749],
131500:[1099, 1772, 2311, 2751],
131600:[1100, 1774, 2312, 2752],
131700:[1100, 1775, 2314, 2754],
131800:[1101, 1776, 2316, 2756],
131900:[1102, 1777, 2317, 2758],
13200:[71, 76, 82, 88],
132000:[1103, 1779, 2319, 2760],
132100:[1104, 1780, 2321, 2762],
132200:[1105, 1781, 2322, 2764],
132300:[1105, 1783, 2324, 2765],
132400:[1106, 1784, 2325, 2767],
132500:[1107, 1785, 2327, 2769],
132600:[1108, 1786, 2329, 2771],
132700:[1109, 1788, 2330, 2773],
132800:[1109, 1789, 2332, 2775],
132900:[1110, 1790, 2333, 2776],
13300:[74, 80, 85, 92],
133000:[1111, 1791, 2335, 2778],
133100:[1112, 1792, 2337, 2780],
133200:[1113, 1793, 2338, 2782],
133300:[1113, 1795, 2340, 2784],
133400:[1114, 1796, 2341, 2785],
133500:[1115, 1797, 2343, 2787],
133600:[1116, 1798, 2344, 2789],
133700:[1117, 1800, 2346, 2791],
133800:[1117, 1801, 2347, 2793],
133900:[1118, 1802, 2349, 2795],
13400:[77, 83, 89, 96],
134000:[1119, 1803, 2350, 2797],
134100:[1120, 1804, 2352, 2799],
134200:[1121, 1805, 2353, 2801],
134300:[1121, 1807, 2355, 2803],
134400:[1122, 1808, 2356, 2804],
134500:[1123, 1809, 2358, 2806],
134600:[1124, 1810, 2359, 2808],
134700:[1125, 1811, 2361, 2810],
134800:[1126, 1813, 2363, 2812],
134900:[1126, 1814, 2364, 2814],
13500:[80, 86, 92, 100],
135000:[1127, 1815, 2366, 2816],
135100:[1128, 1816, 2368, 2818],
135200:[1128, 1817, 2369, 2820],
135300:[1129, 1819, 2371, 2822],
135400:[1130, 1820, 2372, 2824],
135500:[1131, 1821, 2374, 2825],
135600:[1131, 1822, 2376, 2827],
135700:[1132, 1823, 2377, 2829],
135800:[1133, 1824, 2379, 2831],
135900:[1134, 1826, 2380, 2833],
13600:[83, 89, 96, 103],
136000:[1134, 1827, 2382, 2835],
136100:[1135, 1828, 2384, 2837],
136200:[1136, 1830, 2385, 2839],
136300:[1136, 1831, 2387, 2841],
136400:[1137, 1832, 2388, 2843],
136500:[1138, 1833, 2390, 2845],
136600:[1139, 1835, 2392, 2846],
136700:[1139, 1836, 2393, 2848],
136800:[1140, 1837, 2395, 2850],
136900:[1141, 1838, 2397, 2852],
13700:[86, 92, 99, 107],
137000:[1142, 1840, 2398, 2854],
137100:[1143, 1841, 2400, 2856],
137200:[1144, 1842, 2401, 2858],
137300:[1144, 1844, 2403, 2860],
137400:[1145, 1845, 2404, 2862],
137500:[1146, 1846, 2406, 2864],
137600:[1147, 1847, 2407, 2866],
137700:[1147, 1849, 2409, 2867],
137800:[1148, 1850, 2410, 2869],
137900:[1149, 1851, 2412, 2871],
13800:[88, 96, 103, 111],
138000:[1150, 1852, 2413, 2873],
138100:[1151, 1853, 2415, 2875],
138200:[1152, 1854, 2416, 2877],
138300:[1152, 1856, 2418, 2879],
138400:[1153, 1857, 2419, 2880],
138500:[1154, 1858, 2421, 2882],
138600:[1155, 1859, 2422, 2884],
138700:[1155, 1860, 2424, 2886],
138800:[1156, 1862, 2426, 2888],
138900:[1157, 1863, 2427, 2890],
13900:[91, 99, 106, 114],
139000:[1158, 1864, 2429, 2891],
139100:[1159, 1865, 2431, 2893],
139200:[1160, 1866, 2432, 2895],
139300:[1160, 1868, 2434, 2897],
139400:[1161, 1869, 2435, 2899],
139500:[1162, 1870, 2437, 2900],
139600:[1163, 1871, 2439, 2902],
139700:[1164, 1872, 2440, 2904],
139800:[1164, 1873, 2442, 2906],
139900:[1165, 1875, 2443, 2908],
14000:[94, 102, 110, 118],
140000:[1166, 1876, 2445, 2910],
140100:[1167, 1877, 2447, 2912],
140200:[1168, 1878, 2448, 2914],
140300:[1168, 1879, 2450, 2915],
140400:[1169, 1881, 2451, 2917],
140500:[1170, 1882, 2453, 2919],
140600:[1171, 1883, 2454, 2921],
140700:[1172, 1884, 2456, 2923],
140800:[1172, 1885, 2457, 2925],
140900:[1173, 1886, 2459, 2926],
14100:[94, 105, 113, 121],
141000:[1174, 1888, 2460, 2928],
141100:[1175, 1889, 2462, 2930],
141200:[1175, 1890, 2463, 2931],
141300:[1176, 1892, 2465, 2933],
141400:[1177, 1893, 2466, 2935],
141500:[1178, 1894, 2468, 2937],
141600:[1178, 1895, 2469, 2938],
141700:[1179, 1896, 2471, 2940],
141800:[1180, 1897, 2472, 2942],
141900:[1181, 1899, 2474, 2944],
14200:[95, 108, 116, 125],
142000:[1181, 1900, 2475, 2945],
142100:[1182, 1901, 2477, 2947],
142200:[1182, 1902, 2478, 2949],
142300:[1183, 1903, 2480, 2950],
142400:[1184, 1904, 2481, 2952],
142500:[1185, 1906, 2483, 2954],
142600:[1185, 1907, 2484, 2956],
142700:[1186, 1908, 2486, 2957],
142800:[1187, 1909, 2487, 2959],
142900:[1187, 1910, 2489, 2961],
14300:[95, 111, 120, 128],
143000:[1188, 1911, 2490, 2963],
143100:[1189, 1912, 2492, 2965],
143200:[1190, 1913, 2493, 2966],
143300:[1190, 1914, 2495, 2968],
143400:[1191, 1916, 2496, 2970],
143500:[1192, 1917, 2498, 2972],
143600:[1193, 1918, 2499, 2973],
143700:[1193, 1919, 2501, 2975],
143800:[1194, 1920, 2502, 2977],
143900:[1195, 1921, 2504, 2978],
14400:[95, 114, 123, 132],
144000:[1196, 1923, 2505, 2980],
144100:[1197, 1924, 2506, 2982],
144200:[1197, 1925, 2508, 2984],
144300:[1198, 1927, 2509, 2985],
144400:[1199, 1928, 2511, 2987],
144500:[1200, 1929, 2512, 2989],
144600:[1200, 1930, 2514, 2991],
144700:[1201, 1931, 2515, 2992],
144800:[1202, 1933, 2517, 2994],
144900:[1202, 1934, 2518, 2996],
14500:[96, 117, 126, 135],
145000:[1203, 1935, 2519, 2998],
145100:[1204, 1936, 2520, 3000],
145200:[1205, 1937, 2522, 3002],
145300:[1205, 1938, 2523, 3003],
145400:[1206, 1940, 2525, 3005],
145500:[1207, 1941, 2526, 3007],
145600:[1208, 1942, 2528, 3009],
145700:[1208, 1943, 2529, 3011],
145800:[1209, 1944, 2531, 3012],
145900:[1210, 1945, 2532, 3014],
14600:[96, 120, 129, 138],
146000:[1211, 1946, 2534, 3016],
146100:[1212, 1947, 2535, 3018],
146200:[1212, 1948, 2537, 3019],
146300:[1213, 1950, 2538, 3021],
146400:[1214, 1951, 2540, 3023],
146500:[1215, 1952, 2541, 3025],
146600:[1215, 1953, 2543, 3026],
146700:[1216, 1954, 2544, 3028],
146800:[1217, 1956, 2546, 3030],
146900:[1218, 1957, 2547, 3032],
14700:[97, 123, 132, 142],
147000:[1218, 1958, 2549, 3033],
147100:[1219, 1959, 2550, 3035],
147200:[1220, 1960, 2552, 3037],
147300:[1220, 1961, 2553, 3038],
147400:[1221, 1963, 2555, 3040],
147500:[1222, 1964, 2556, 3042],
147600:[1223, 1965, 2558, 3044],
147700:[1223, 1966, 2559, 3045],
147800:[1224, 1967, 2561, 3047],
147900:[1225, 1968, 2562, 3049],
14800:[97, 126, 136, 145],
148000:[1226, 1969, 2564, 3051],
148100:[1227, 1970, 2565, 3053],
148200:[1227, 1971, 2567, 3054],
148300:[1228, 1973, 2568, 3056],
148400:[1229, 1974, 2570, 3058],
148500:[1230, 1975, 2571, 3060],
148600:[1230, 1976, 2573, 3061],
148700:[1231, 1977, 2574, 3063],
148800:[1232, 1978, 2576, 3065],
148900:[1233, 1980, 2577, 3066],
14900:[97, 129, 139, 149],
149000:[1233, 1981, 2579, 3068],
149100:[1234, 1982, 2580, 3070],
149200:[1235, 1983, 2582, 3072],
149300:[1235, 1984, 2583, 3073],
149400:[1236, 1985, 2585, 3075],
149500:[1237, 1987, 2586, 3077],
149600:[1238, 1988, 2588, 3079],
149700:[1239, 1989, 2589, 3080],
149800:[1239, 1990, 2591, 3082],
149900:[1240, 1991, 2592, 3084],
15000:[98, 132, 142, 152],
150000:[1241, 1992, 2594, 3086],
15100:[98, 135, 145, 155],
15200:[99, 138, 148, 159],
15300:[99, 141, 151, 162],
15400:[100, 144, 155, 166],
15500:[100, 147, 158, 169],
15600:[101, 150, 161, 173],
15700:[101, 153, 164, 176],
15800:[102, 156, 167, 179],
15900:[102, 158, 170, 183],
16000:[103, 161, 173, 186],
16100:[103, 164, 176, 189],
16200:[104, 167, 179, 192],
16300:[104, 169, 182, 196],
16400:[105, 172, 185, 199],
16500:[105, 175, 188, 202],
16600:[106, 178, 191, 205],
16700:[106, 181, 195, 209],
16800:[107, 183, 198, 212],
16900:[107, 186, 201, 215],
17000:[107, 189, 204, 218],
17100:[107, 192, 207, 221],
17200:[108, 195, 210, 225],
17300:[108, 197, 213, 228],
17400:[109, 200, 216, 231],
17500:[109, 203, 219, 234],
17600:[110, 206, 222, 238],
17700:[110, 208, 225, 241],
17800:[110, 211, 228, 244],
17900:[111, 214, 231, 247],
18000:[111, 217, 234, 251],
18100:[111, 220, 237, 255],
18200:[112, 224, 241, 258],
18300:[112, 227, 244, 262],
18400:[113, 230, 248, 266],
18500:[113, 233, 251, 270],
18600:[114, 237, 255, 273],
18700:[114, 240, 258, 277],
18800:[114, 243, 262, 281],
18900:[115, 246, 265, 284],
19000:[115, 250, 269, 288],
19100:[116, 252, 273, 292],
19200:[116, 253, 277, 296],
19300:[117, 255, 281, 301],
19400:[117, 257, 285, 305],
19500:[118, 259, 289, 309],
19600:[118, 260, 293, 313],
19700:[119, 262, 296, 317],
19800:[120, 264, 300, 322],
19900:[120, 266, 304, 326],
20000:[121, 267, 308, 330],
20100:[122, 268, 312, 334],
20200:[122, 269, 316, 339],
20300:[123, 271, 320, 343],
20400:[124, 272, 324, 347],
20500:[124, 273, 328, 351],
20600:[125, 274, 332, 356],
20700:[126, 275, 336, 360],
20800:[126, 277, 340, 364],
20900:[127, 278, 344, 368],
21000:[128, 279, 348, 373],
21100:[129, 280, 352, 377],
21200:[129, 281, 356, 381],
21300:[130, 283, 360, 386],
21400:[131, 284, 364, 390],
21500:[132, 285, 368, 394],
21600:[132, 286, 372, 398],
21700:[133, 287, 376, 402],
21800:[134, 289, 380, 407],
21900:[135, 290, 384, 411],
22000:[135, 291, 388, 415],
22100:[136, 292, 392, 419],
22200:[137, 293, 396, 424],
22300:[138, 295, 400, 428],
22400:[139, 296, 404, 432],
22500:[140, 297, 408, 436],
22600:[141, 298, 412, 441],
22700:[142, 299, 416, 445],
22800:[143, 301, 420, 449],
22900:[144, 302, 424, 453],
23000:[145, 303, 428, 458],
23100:[146, 304, 430, 462],
23200:[147, 305, 432, 467],
23300:[148, 307, 435, 471],
23400:[149, 308, 437, 475],
23500:[150, 309, 439, 479],
23600:[151, 310, 441, 484],
23700:[153, 311, 444, 488],
23800:[154, 313, 446, 492],
23900:[155, 314, 448, 497],
24000:[156, 315, 450, 501],
24100:[157, 316, 452, 505],
24200:[158, 318, 453, 510],
24300:[159, 319, 455, 514],
24400:[160, 321, 457, 518],
24500:[161, 322, 458, 523],
24600:[162, 324, 460, 527],
24700:[163, 325, 462, 532],
24800:[164, 327, 464, 536],
24900:[165, 328, 465, 540],
25000:[166, 330, 467, 545],
25100:[167, 332, 469, 549],
25200:[169, 333, 471, 554],
25300:[170, 335, 472, 558],
25400:[171, 337, 474, 562],
25500:[172, 339, 476, 567],
25600:[174, 340, 478, 571],
25700:[175, 342, 480, 575],
25800:[176, 344, 481, 580],
25900:[177, 345, 483, 584],
26000:[179, 347, 485, 588],
26100:[181, 349, 487, 592],
26200:[182, 351, 489, 596],
26300:[184, 353, 491, 600],
26400:[185, 355, 493, 604],
26500:[187, 357, 495, 608],
26600:[188, 359, 498, 612],
26700:[190, 361, 500, 615],
26800:[191, 363, 502, 619],
26900:[193, 365, 504, 623],
27000:[194, 367, 506, 627],
27100:[196, 369, 508, 629],
27200:[197, 371, 511, 632],
27300:[199, 373, 513, 634],
27400:[200, 375, 516, 637],
27500:[202, 377, 518, 639],
27600:[204, 379, 520, 642],
27700:[205, 381, 523, 644],
27800:[207, 383, 525, 646],
27900:[208, 385, 528, 649],
28000:[210, 387, 530, 651],
28100:[211, 389, 532, 653],
28200:[213, 391, 534, 656],
28300:[214, 393, 537, 658],
28400:[215, 394, 539, 660],
28500:[217, 396, 541, 663],
28600:[218, 398, 543, 665],
28700:[219, 400, 546, 667],
28800:[221, 402, 548, 669],
28900:[222, 404, 550, 672],
29000:[223, 406, 552, 674],
29100:[224, 408, 554, 676],
29200:[225, 409, 556, 678],
29300:[226, 411, 558, 680],
29400:[227, 412, 560, 682],
29500:[228, 414, 562, 684],
29600:[229, 415, 564, 686],
29700:[230, 417, 566, 688],
29800:[231, 418, 567, 690],
29900:[232, 420, 569, 692],
30000:[233, 421, 571, 694],
30100:[234, 423, 573, 696],
30200:[235, 424, 575, 699],
30300:[236, 426, 577, 701],
30400:[237, 427, 579, 703],
30500:[238, 429, 581, 706],
30600:[239, 431, 583, 708],
30700:[240, 432, 585, 711],
30800:[241, 434, 587, 713],
30900:[242, 435, 589, 715],
31000:[243, 437, 591, 718],
31100:[244, 439, 593, 720],
31200:[245, 440, 595, 722],
31300:[246, 442, 597, 725],
31400:[247, 443, 599, 727],
31500:[248, 445, 600, 729],
31600:[249, 446, 602, 731],
31700:[250, 448, 604, 734],
31800:[251, 449, 606, 736],
31900:[252, 451, 608, 738],
32000:[253, 452, 610, 740],
32100:[254, 454, 612, 742],
32200:[255, 455, 614, 745],
32300:[256, 457, 616, 747],
32400:[257, 458, 618, 749],
32500:[258, 460, 620, 751],
32600:[259, 461, 622, 754],
32700:[260, 463, 624, 756],
32800:[261, 464, 626, 758],
32900:[262, 466, 628, 761],
33000:[263, 467, 630, 763],
33100:[264, 469, 632, 765],
33200:[265, 470, 634, 767],
33300:[266, 472, 636, 770],
33400:[267, 473, 638, 772],
33500:[268, 475, 640, 774],
33600:[269, 476, 642, 776],
33700:[270, 478, 644, 779],
33800:[271, 479, 646, 781],
33900:[272, 481, 647, 783],
34000:[274, 482, 649, 785],
34100:[275, 484, 651, 787],
34200:[276, 485, 653, 790],
34300:[277, 487, 655, 792],
34400:[278, 488, 657, 794],
34500:[279, 490, 659, 796],
34600:[280, 491, 661, 799],
34700:[281, 493, 662, 801],
34800:[282, 494, 664, 803],
34900:[283, 496, 666, 805],
35000:[284, 497, 668, 808],
35100:[285, 498, 670, 810],
35200:[286, 500, 672, 812],
35300:[287, 501, 674, 815],
35400:[288, 503, 676, 817],
35500:[289, 504, 678, 819],
35600:[290, 506, 679, 821],
35700:[291, 507, 681, 824],
35800:[292, 509, 683, 826],
35900:[293, 510, 685, 828],
36000:[293, 512, 687, 830],
36100:[294, 513, 689, 832],
36200:[295, 515, 691, 834],
36300:[296, 516, 692, 836],
36400:[297, 518, 694, 838],
36500:[298, 519, 696, 841],
36600:[299, 520, 698, 843],
36700:[300, 522, 700, 845],
36800:[301, 523, 702, 847],
36900:[302, 525, 703, 849],
37000:[303, 526, 705, 851],
37100:[304, 527, 707, 853],
37200:[305, 529, 708, 855],
37300:[306, 530, 710, 857],
37400:[307, 532, 712, 859],
37500:[308, 533, 714, 862],
37600:[309, 534, 715, 864],
37700:[310, 536, 717, 866],
37800:[310, 537, 719, 868],
37900:[311, 539, 721, 870],
38000:[312, 540, 722, 872],
38100:[313, 541, 724, 874],
38200:[314, 543, 726, 876],
38300:[315, 544, 727, 878],
38400:[316, 546, 729, 881],
38500:[317, 547, 731, 883],
38600:[317, 548, 733, 885],
38700:[318, 550, 734, 887],
38800:[319, 551, 736, 889],
38900:[320, 553, 738, 891],
39000:[321, 554, 740, 893],
39100:[322, 555, 742, 895],
39200:[323, 557, 744, 897],
39300:[324, 558, 745, 899],
39400:[324, 560, 747, 901],
39500:[325, 561, 749, 903],
39600:[326, 562, 751, 905],
39700:[327, 564, 752, 907],
39800:[328, 565, 754, 909],
39900:[329, 567, 756, 911],
40000:[330, 568, 758, 913],
40100:[331, 569, 760, 915],
40200:[332, 571, 762, 917],
40300:[333, 572, 763, 919],
40400:[333, 574, 765, 921],
40500:[334, 575, 767, 923],
40600:[335, 576, 769, 925],
40700:[336, 578, 771, 927],
40800:[337, 579, 772, 929],
40900:[338, 581, 774, 931],
41000:[339, 582, 776, 934],
41100:[340, 583, 778, 936],
41200:[341, 585, 780, 938],
41300:[342, 586, 781, 940],
41400:[343, 588, 783, 942],
41500:[343, 589, 785, 944],
41600:[344, 590, 787, 946],
41700:[345, 592, 789, 948],
41800:[346, 593, 790, 950],
41900:[347, 594, 792, 953],
42000:[348, 596, 794, 955],
42100:[349, 597, 796, 957],
42200:[350, 599, 798, 959],
42300:[351, 600, 799, 961],
42400:[352, 602, 801, 963],
42500:[352, 603, 803, 965],
42600:[353, 604, 805, 967],
42700:[354, 606, 807, 969],
42800:[355, 607, 809, 972],
42900:[356, 609, 810, 974],
43000:[357, 610, 812, 976],
43100:[358, 611, 814, 978],
43200:[359, 613, 815, 980],
43300:[360, 614, 817, 982],
43400:[361, 616, 819, 984],
43500:[361, 617, 821, 986],
43600:[362, 619, 822, 988],
43700:[363, 620, 824, 991],
43800:[364, 621, 826, 993],
43900:[365, 623, 828, 995],
44000:[366, 624, 829, 997],
44100:[367, 625, 831, 999],
44200:[368, 627, 833, 1002],
44300:[369, 628, 835, 1004],
44400:[370, 630, 836, 1006],
44500:[371, 631, 838, 1008],
44600:[372, 633, 840, 1011],
44700:[373, 634, 842, 1013],
44800:[374, 635, 844, 1015],
44900:[375, 637, 846, 1017],
45000:[376, 638, 848, 1020],
45100:[377, 639, 850, 1022],
45200:[378, 641, 852, 1024],
45300:[379, 642, 853, 1026],
45400:[380, 644, 855, 1029],
45500:[381, 645, 857, 1031],
45600:[382, 646, 859, 1033],
45700:[382, 648, 860, 1035],
45800:[383, 649, 862, 1037],
45900:[384, 650, 864, 1039],
46000:[385, 652, 866, 1041],
46100:[386, 653, 868, 1043],
46200:[387, 655, 869, 1045],
46300:[387, 656, 871, 1047],
46400:[388, 658, 873, 1049],
46500:[389, 659, 874, 1052],
46600:[390, 660, 876, 1054],
46700:[391, 662, 878, 1056],
46800:[392, 663, 880, 1058],
46900:[392, 664, 881, 1060],
47000:[393, 666, 883, 1062],
47100:[394, 667, 885, 1064],
47200:[395, 669, 887, 1066],
47300:[396, 670, 888, 1068],
47400:[396, 671, 890, 1070],
47500:[397, 673, 892, 1072],
47600:[398, 674, 894, 1074],
47700:[399, 675, 895, 1076],
47800:[400, 677, 897, 1078],
47900:[401, 678, 899, 1080],
48000:[402, 679, 901, 1082],
48100:[403, 680, 903, 1084],
48200:[404, 682, 904, 1086],
48300:[405, 683, 906, 1088],
48400:[406, 684, 908, 1090],
48500:[406, 686, 910, 1092],
48600:[407, 687, 911, 1095],
48700:[408, 688, 913, 1097],
48800:[409, 690, 915, 1099],
48900:[410, 691, 916, 1101],
49000:[411, 693, 918, 1103],
49100:[412, 694, 920, 1105],
49200:[413, 696, 922, 1107],
49300:[414, 697, 923, 1109],
49400:[414, 699, 925, 1111],
49500:[415, 700, 927, 1113],
49600:[416, 701, 929, 1115],
49700:[417, 703, 930, 1117],
49800:[418, 704, 932, 1119],
49900:[419, 706, 934, 1121],
50000:[419, 707, 936, 1123],
50100:[420, 708, 938, 1125],
50200:[421, 710, 939, 1127],
50300:[422, 711, 941, 1129],
50400:[423, 712, 943, 1131],
50500:[423, 714, 945, 1133],
50600:[424, 715, 946, 1136],
50700:[425, 716, 948, 1138],
50800:[426, 718, 950, 1140],
50900:[427, 719, 952, 1142],
51000:[428, 720, 953, 1144],
51100:[429, 721, 955, 1146],
51200:[430, 723, 957, 1148],
51300:[431, 724, 958, 1150],
51400:[432, 725, 960, 1153],
51500:[433, 727, 962, 1155],
51600:[434, 728, 964, 1157],
51700:[434, 730, 965, 1159],
51800:[435, 731, 967, 1161],
51900:[436, 732, 969, 1163],
52000:[437, 734, 971, 1165],
52100:[438, 735, 973, 1167],
52200:[439, 737, 975, 1169],
52300:[440, 738, 976, 1171],
52400:[440, 739, 978, 1174],
52500:[441, 741, 980, 1176],
52600:[442, 742, 982, 1178],
52700:[443, 744, 984, 1180],
52800:[444, 745, 985, 1182],
52900:[445, 746, 987, 1184],
53000:[445, 748, 989, 1186],
53100:[446, 749, 991, 1188],
53200:[447, 751, 993, 1190],
53300:[448, 752, 994, 1192],
53400:[448, 753, 996, 1194],
53500:[449, 755, 998, 1196],
53600:[450, 756, 1000, 1198],
53700:[451, 758, 1002, 1200],
53800:[452, 759, 1004, 1202],
53900:[453, 760, 1005, 1204],
54000:[454, 762, 1007, 1206],
54100:[455, 763, 1009, 1208],
54200:[456, 765, 1010, 1210],
54300:[457, 766, 1012, 1212],
54400:[458, 768, 1014, 1215],
54500:[458, 769, 1016, 1217],
54600:[459, 770, 1017, 1219],
54700:[460, 772, 1019, 1221],
54800:[461, 773, 1021, 1223],
54900:[462, 774, 1023, 1225],
55000:[463, 776, 1024, 1228],
55100:[464, 777, 1026, 1230],
55200:[465, 779, 1028, 1232],
55300:[466, 780, 1030, 1235],
55400:[467, 782, 1031, 1237],
55500:[468, 783, 1033, 1239],
55600:[468, 785, 1035, 1241],
55700:[469, 786, 1037, 1244],
55800:[470, 788, 1039, 1246],
55900:[471, 789, 1041, 1248],
56000:[472, 791, 1043, 1250],
56100:[473, 793, 1045, 1252],
56200:[474, 794, 1047, 1254],
56300:[475, 796, 1049, 1257],
56400:[476, 797, 1051, 1259],
56500:[476, 799, 1052, 1261],
56600:[477, 800, 1054, 1263],
56700:[478, 802, 1056, 1266],
56800:[479, 803, 1058, 1268],
56900:[480, 805, 1060, 1270],
57000:[481, 806, 1062, 1272],
57100:[482, 807, 1064, 1274],
57200:[483, 809, 1066, 1276],
57300:[484, 810, 1068, 1279],
57400:[485, 812, 1070, 1281],
57500:[486, 813, 1071, 1283],
57600:[487, 815, 1073, 1285],
57700:[488, 816, 1075, 1288],
57800:[489, 817, 1077, 1290],
57900:[490, 819, 1079, 1292],
58000:[491, 820, 1081, 1294],
58100:[492, 821, 1083, 1296],
58200:[493, 823, 1085, 1298],
58300:[494, 824, 1087, 1301],
58400:[495, 826, 1089, 1303],
58500:[496, 827, 1091, 1305],
58600:[497, 829, 1092, 1307],
58700:[498, 830, 1094, 1309],
58800:[498, 832, 1096, 1312],
58900:[499, 833, 1098, 1314],
59000:[500, 835, 1100, 1316],
59100:[501, 836, 1102, 1318],
59200:[502, 838, 1104, 1320],
59300:[503, 839, 1105, 1323],
59400:[504, 841, 1107, 1325],
59500:[505, 842, 1109, 1327],
59600:[505, 844, 1111, 1329],
59700:[506, 845, 1113, 1331],
59800:[507, 847, 1115, 1333],
59900:[508, 848, 1116, 1336],
60000:[509, 850, 1118, 1338],
60100:[510, 852, 1120, 1340],
60200:[511, 853, 1122, 1342],
60300:[512, 855, 1124, 1345],
60400:[513, 856, 1125, 1347],
60500:[513, 858, 1127, 1349],
60600:[514, 859, 1129, 1351],
60700:[515, 861, 1131, 1353],
60800:[516, 862, 1133, 1355],
60900:[517, 864, 1135, 1358],
61000:[518, 865, 1137, 1360],
61100:[519, 866, 1139, 1362],
61200:[520, 868, 1141, 1365],
61300:[521, 869, 1143, 1367],
61400:[522, 871, 1144, 1369],
61500:[523, 872, 1146, 1371],
61600:[524, 874, 1148, 1374],
61700:[525, 875, 1150, 1376],
61800:[526, 877, 1152, 1378],
61900:[527, 878, 1154, 1380],
62000:[528, 879, 1156, 1383],
62100:[529, 880, 1158, 1385],
62200:[530, 882, 1160, 1387],
62300:[531, 883, 1162, 1390],
62400:[532, 885, 1164, 1392],
62500:[533, 886, 1165, 1394],
62600:[534, 888, 1167, 1396],
62700:[534, 889, 1169, 1399],
62800:[535, 891, 1171, 1401],
62900:[536, 892, 1173, 1403],
63000:[537, 894, 1175, 1405],
63100:[538, 896, 1177, 1407],
63200:[539, 897, 1179, 1409],
63300:[540, 899, 1181, 1412],
63400:[541, 900, 1183, 1414],
63500:[541, 902, 1185, 1416],
63600:[542, 903, 1186, 1418],
63700:[543, 905, 1188, 1421],
63800:[544, 906, 1190, 1423],
63900:[545, 908, 1192, 1425],
64000:[546, 909, 1194, 1427],
64100:[547, 910, 1196, 1429],
64200:[548, 912, 1198, 1431],
64300:[549, 913, 1200, 1434],
64400:[550, 915, 1202, 1436],
64500:[551, 916, 1204, 1438],
64600:[552, 918, 1206, 1440],
64700:[553, 919, 1207, 1442],
64800:[554, 920, 1209, 1445],
64900:[555, 922, 1211, 1447],
65000:[556, 923, 1213, 1449],
65100:[557, 924, 1215, 1451],
65200:[558, 926, 1217, 1453],
65300:[559, 927, 1219, 1456],
65400:[560, 929, 1220, 1458],
65500:[561, 930, 1222, 1460],
65600:[562, 932, 1224, 1462],
65700:[563, 933, 1226, 1464],
65800:[564, 935, 1228, 1467],
65900:[565, 936, 1230, 1469],
66000:[565, 938, 1231, 1471],
66100:[566, 939, 1233, 1473],
66200:[567, 941, 1235, 1475],
66300:[568, 942, 1237, 1478],
66400:[569, 944, 1238, 1480],
66500:[570, 945, 1240, 1482],
66600:[571, 947, 1242, 1484],
66700:[571, 948, 1244, 1486],
66800:[572, 950, 1246, 1488],
66900:[573, 951, 1248, 1491],
67000:[574, 953, 1250, 1493],
67100:[575, 954, 1252, 1495],
67200:[576, 956, 1254, 1497],
67300:[577, 957, 1255, 1499],
67400:[578, 959, 1257, 1501],
67500:[578, 960, 1259, 1503],
67600:[579, 961, 1261, 1505],
67700:[580, 963, 1262, 1507],
67800:[581, 964, 1264, 1509],
67900:[582, 966, 1266, 1512],
68000:[583, 967, 1268, 1514],
68100:[584, 968, 1270, 1516],
68200:[585, 970, 1271, 1518],
68300:[585, 971, 1273, 1520],
68400:[586, 972, 1275, 1522],
68500:[587, 974, 1277, 1524],
68600:[588, 975, 1278, 1527],
68700:[589, 976, 1280, 1529],
68800:[590, 978, 1282, 1531],
68900:[590, 979, 1284, 1533],
69000:[591, 980, 1285, 1535],
69100:[592, 981, 1287, 1537],
69200:[593, 983, 1289, 1539],
69300:[594, 984, 1290, 1541],
69400:[594, 985, 1292, 1543],
69500:[595, 987, 1294, 1545],
69600:[596, 988, 1296, 1547],
69700:[597, 990, 1297, 1549],
69800:[598, 991, 1299, 1551],
69900:[599, 992, 1301, 1553],
70000:[600, 994, 1303, 1555],
70100:[601, 995, 1305, 1557],
70200:[602, 997, 1306, 1559],
70300:[603, 998, 1308, 1561],
70400:[604, 1000, 1310, 1563],
70500:[605, 1001, 1312, 1565],
70600:[605, 1002, 1313, 1567],
70700:[606, 1004, 1315, 1569],
70800:[607, 1005, 1317, 1572],
70900:[608, 1007, 1319, 1574],
71000:[609, 1008, 1320, 1576],
71100:[610, 1009, 1322, 1578],
71200:[611, 1011, 1324, 1580],
71300:[612, 1012, 1325, 1582],
71400:[612, 1013, 1327, 1584],
71500:[613, 1015, 1329, 1587],
71600:[614, 1016, 1331, 1589],
71700:[615, 1017, 1332, 1591],
71800:[616, 1019, 1334, 1593],
71900:[617, 1020, 1336, 1595],
72000:[617, 1021, 1338, 1597],
72100:[618, 1022, 1340, 1599],
72200:[619, 1024, 1341, 1601],
72300:[620, 1025, 1343, 1603],
72400:[621, 1026, 1345, 1605],
72500:[621, 1028, 1347, 1607],
72600:[622, 1029, 1348, 1609],
72700:[623, 1030, 1350, 1611],
72800:[624, 1032, 1352, 1613],
72900:[625, 1033, 1354, 1615],
73000:[626, 1035, 1355, 1617],
73100:[627, 1036, 1357, 1619],
73200:[628, 1038, 1359, 1621],
73300:[628, 1039, 1360, 1623],
73400:[629, 1041, 1362, 1625],
73500:[630, 1042, 1364, 1627],
73600:[631, 1043, 1366, 1629],
73700:[632, 1045, 1367, 1632],
73800:[633, 1046, 1369, 1634],
73900:[633, 1047, 1371, 1636],
74000:[634, 1049, 1373, 1638],
74100:[635, 1050, 1375, 1640],
74200:[636, 1052, 1376, 1642],
74300:[637, 1053, 1378, 1644],
74400:[637, 1055, 1380, 1646],
74500:[638, 1056, 1382, 1648],
74600:[639, 1057, 1383, 1650],
74700:[640, 1059, 1385, 1652],
74800:[641, 1060, 1387, 1654],
74900:[642, 1062, 1388, 1656],
75000:[643, 1063, 1390, 1658],
75100:[644, 1064, 1392, 1660],
75200:[645, 1066, 1394, 1662],
75300:[646, 1067, 1395, 1664],
75400:[647, 1068, 1397, 1666],
75500:[647, 1070, 1399, 1668],
75600:[648, 1071, 1401, 1670],
75700:[649, 1072, 1402, 1672],
75800:[650, 1074, 1404, 1674],
75900:[651, 1075, 1406, 1676],
76000:[652, 1076, 1408, 1679],
76100:[653, 1077, 1410, 1681],
76200:[654, 1079, 1411, 1683],
76300:[654, 1080, 1413, 1685],
76400:[655, 1081, 1415, 1687],
76500:[656, 1083, 1417, 1689],
76600:[657, 1084, 1418, 1692],
76700:[658, 1086, 1420, 1694],
76800:[659, 1087, 1422, 1696],
76900:[659, 1088, 1423, 1698],
77000:[660, 1090, 1425, 1700],
77100:[661, 1091, 1427, 1702],
77200:[662, 1093, 1429, 1704],
77300:[663, 1094, 1430, 1706],
77400:[663, 1095, 1432, 1708],
77500:[664, 1097, 1434, 1710],
77600:[665, 1098, 1436, 1712],
77700:[666, 1099, 1437, 1714],
77800:[667, 1101, 1439, 1716],
77900:[668, 1102, 1441, 1718],
78000:[669, 1103, 1443, 1720],
78100:[670, 1104, 1445, 1722],
78200:[671, 1106, 1446, 1724],
78300:[672, 1107, 1448, 1726],
78400:[673, 1108, 1450, 1728],
78500:[674, 1110, 1452, 1730],
78600:[674, 1111, 1453, 1732],
78700:[675, 1113, 1455, 1734],
78800:[676, 1114, 1457, 1736],
78900:[677, 1115, 1458, 1739],
79000:[678, 1117, 1460, 1741],
79100:[679, 1118, 1462, 1743],
79200:[680, 1120, 1464, 1745],
79300:[681, 1121, 1465, 1747],
79400:[681, 1122, 1467, 1749],
79500:[682, 1124, 1469, 1751],
79600:[683, 1125, 1471, 1754],
79700:[684, 1126, 1472, 1756],
79800:[685, 1128, 1474, 1758],
79900:[686, 1129, 1476, 1760],
80000:[686, 1130, 1478, 1762],
80100:[687, 1131, 1480, 1764],
80200:[688, 1133, 1481, 1766],
80300:[689, 1134, 1483, 1768],
80400:[690, 1136, 1485, 1770],
80500:[690, 1137, 1487, 1772],
80600:[691, 1138, 1488, 1774],
80700:[692, 1140, 1490, 1776],
80800:[693, 1141, 1492, 1778],
80900:[694, 1142, 1493, 1780],
81000:[695, 1144, 1495, 1782],
81100:[696, 1145, 1497, 1784],
81200:[697, 1147, 1499, 1786],
81300:[697, 1148, 1500, 1788],
81400:[698, 1149, 1502, 1790],
81500:[699, 1151, 1504, 1792],
81600:[700, 1152, 1506, 1794],
81700:[701, 1153, 1507, 1797],
81800:[702, 1155, 1509, 1799],
81900:[702, 1156, 1511, 1801],
82000:[703, 1157, 1513, 1803],
82100:[704, 1158, 1515, 1805],
82200:[705, 1160, 1516, 1807],
82300:[706, 1161, 1518, 1809],
82400:[706, 1162, 1520, 1811],
82500:[707, 1164, 1522, 1814],
82600:[708, 1165, 1523, 1816],
82700:[709, 1166, 1525, 1818],
82800:[710, 1167, 1527, 1820],
82900:[711, 1169, 1528, 1822],
83000:[712, 1170, 1530, 1824],
83100:[713, 1171, 1532, 1826],
83200:[714, 1173, 1534, 1828],
83300:[715, 1174, 1535, 1830],
83400:[716, 1175, 1537, 1832],
83500:[716, 1177, 1539, 1834],
83600:[717, 1178, 1541, 1836],
83700:[718, 1180, 1542, 1838],
83800:[719, 1181, 1544, 1840],
83900:[720, 1182, 1546, 1842],
84000:[721, 1184, 1548, 1844],
84100:[722, 1185, 1550, 1846],
84200:[723, 1187, 1552, 1848],
84300:[723, 1188, 1553, 1850],
84400:[724, 1189, 1555, 1852],
84500:[725, 1191, 1557, 1854],
84600:[726, 1192, 1559, 1856],
84700:[727, 1193, 1561, 1859],
84800:[728, 1195, 1562, 1861],
84900:[728, 1196, 1564, 1863],
85000:[729, 1197, 1566, 1865],
85100:[730, 1198, 1568, 1867],
85200:[731, 1200, 1569, 1869],
85300:[732, 1201, 1571, 1871],
85400:[732, 1203, 1573, 1873],
85500:[733, 1204, 1575, 1875],
85600:[734, 1205, 1576, 1877],
85700:[735, 1207, 1578, 1879],
85800:[736, 1208, 1580, 1881],
85900:[737, 1209, 1582, 1883],
86000:[738, 1211, 1583, 1885],
86100:[739, 1212, 1585, 1887],
86200:[740, 1214, 1587, 1889],
86300:[741, 1215, 1588, 1891],
86400:[742, 1216, 1590, 1893],
86500:[743, 1218, 1592, 1895],
86600:[743, 1219, 1594, 1897],
86700:[744, 1220, 1596, 1899],
86800:[745, 1222, 1597, 1901],
86900:[746, 1223, 1599, 1904],
87000:[747, 1224, 1601, 1906],
87100:[748, 1225, 1603, 1908],
87200:[749, 1227, 1604, 1910],
87300:[750, 1228, 1606, 1912],
87400:[750, 1229, 1608, 1914],
87500:[751, 1230, 1610, 1916],
87600:[752, 1232, 1611, 1919],
87700:[753, 1233, 1613, 1921],
87800:[754, 1234, 1615, 1923],
87900:[755, 1236, 1617, 1925],
88000:[755, 1237, 1618, 1927],
88100:[756, 1238, 1620, 1929],
88200:[757, 1240, 1622, 1931],
88300:[758, 1241, 1623, 1933],
88400:[759, 1242, 1625, 1935],
88500:[759, 1244, 1627, 1937],
88600:[760, 1245, 1629, 1939],
88700:[761, 1246, 1631, 1941],
88800:[762, 1248, 1632, 1943],
88900:[763, 1249, 1634, 1945],
89000:[764, 1251, 1636, 1947],
89100:[765, 1252, 1638, 1949],
89200:[766, 1254, 1639, 1951],
89300:[766, 1255, 1641, 1953],
89400:[767, 1256, 1643, 1955],
89500:[768, 1258, 1645, 1957],
89600:[769, 1259, 1646, 1959],
89700:[770, 1260, 1648, 1961],
89800:[771, 1262, 1650, 1964],
89900:[771, 1263, 1652, 1966],
90000:[772, 1264, 1653, 1968],
90100:[773, 1265, 1655, 1970],
90200:[774, 1267, 1656, 1972],
90300:[775, 1268, 1658, 1974],
90400:[775, 1269, 1660, 1976],
90500:[776, 1270, 1661, 1978],
90600:[777, 1272, 1663, 1980],
90700:[778, 1273, 1665, 1982],
90800:[779, 1274, 1666, 1984],
90900:[780, 1275, 1668, 1986],
91000:[781, 1277, 1670, 1988],
91100:[782, 1278, 1672, 1990],
91200:[783, 1279, 1673, 1992],
91300:[783, 1281, 1675, 1994],
91400:[784, 1282, 1676, 1996],
91500:[785, 1283, 1678, 1998],
91600:[786, 1284, 1680, 2000],
91700:[787, 1285, 1681, 2001],
91800:[788, 1286, 1683, 2003],
91900:[788, 1288, 1684, 2005],
92000:[789, 1289, 1686, 2007],
92100:[790, 1290, 1688, 2009],
92200:[790, 1292, 1689, 2011],
92300:[791, 1293, 1691, 2013],
92400:[792, 1294, 1692, 2014],
92500:[793, 1295, 1694, 2016],
92600:[793, 1297, 1696, 2018],
92700:[794, 1298, 1697, 2020],
92800:[795, 1299, 1699, 2022],
92900:[796, 1300, 1700, 2024],
93000:[796, 1302, 1702, 2025],
93100:[797, 1303, 1704, 2027],
93200:[798, 1304, 1705, 2029],
93300:[798, 1306, 1707, 2031],
93400:[799, 1307, 1708, 2032],
93500:[800, 1308, 1710, 2034],
93600:[801, 1309, 1712, 2036],
93700:[801, 1311, 1713, 2038],
93800:[802, 1312, 1715, 2040],
93900:[803, 1313, 1716, 2042],
94000:[804, 1314, 1718, 2044],
94100:[805, 1315, 1720, 2046],
94200:[806, 1316, 1721, 2048],
94300:[806, 1318, 1723, 2050],
94400:[807, 1319, 1724, 2051],
94500:[808, 1320, 1726, 2053],
94600:[809, 1321, 1728, 2055],
94700:[809, 1323, 1729, 2057],
94800:[810, 1324, 1731, 2059],
94900:[811, 1325, 1732, 2061],
95000:[812, 1326, 1734, 2063],
95100:[813, 1327, 1736, 2065],
95200:[814, 1328, 1737, 2067],
95300:[814, 1330, 1739, 2069],
95400:[815, 1331, 1740, 2071],
95500:[816, 1332, 1742, 2072],
95600:[817, 1333, 1744, 2074],
95700:[817, 1334, 1745, 2076],
95800:[818, 1336, 1747, 2078],
95900:[819, 1337, 1748, 2080],
96000:[820, 1338, 1750, 2082],
96100:[821, 1339, 1752, 2084],
96200:[822, 1341, 1753, 2086],
96300:[822, 1342, 1755, 2088],
96400:[823, 1343, 1756, 2090],
96500:[824, 1344, 1758, 2092],
96600:[825, 1346, 1760, 2093],
96700:[826, 1347, 1761, 2095],
96800:[826, 1348, 1763, 2097],
96900:[827, 1349, 1764, 2099],
97000:[828, 1351, 1766, 2101],
97100:[829, 1352, 1768, 2103],
97200:[830, 1353, 1769, 2105],
97300:[830, 1355, 1771, 2107],
97400:[831, 1356, 1772, 2109],
97500:[832, 1357, 1774, 2111],
97600:[833, 1358, 1776, 2113],
97700:[834, 1360, 1777, 2114],
97800:[834, 1361, 1779, 2116],
97900:[835, 1362, 1780, 2118],
98000:[836, 1363, 1782, 2120],
98100:[837, 1364, 1784, 2122],
98200:[838, 1365, 1785, 2124],
98300:[838, 1367, 1787, 2126],
98400:[839, 1368, 1788, 2127],
98500:[840, 1369, 1790, 2129],
98600:[841, 1370, 1792, 2131],
98700:[842, 1372, 1793, 2133],
98800:[843, 1373, 1795, 2135],
98900:[843, 1374, 1796, 2137],
99000:[844, 1375, 1798, 2138],
99100:[845, 1376, 1800, 2140],
99200:[845, 1377, 1801, 2142],
99300:[846, 1379, 1803, 2144],
99400:[847, 1380, 1804, 2145],
99500:[848, 1381, 1806, 2147],
99600:[848, 1382, 1808, 2149],
99700:[849, 1383, 1809, 2151],
99800:[850, 1385, 1811, 2153],
99900:[851, 1386, 1812, 2155],
};
const OR17_MB=[0.78, 1.12, 1.5, 1.76];

// New Brunswick — 2017 Federal Child Support Guidelines Table
const T17_NB={
100000:[865, 1405, 1836, 2189],
100100:[866, 1406, 1838, 2191],
100200:[867, 1407, 1839, 2193],
100300:[867, 1409, 1841, 2195],
100400:[868, 1410, 1842, 2197],
100500:[869, 1411, 1844, 2199],
100600:[870, 1412, 1846, 2201],
100700:[870, 1414, 1847, 2202],
100800:[871, 1415, 1849, 2204],
100900:[872, 1416, 1851, 2206],
101000:[873, 1417, 1852, 2208],
101100:[874, 1418, 1854, 2210],
101200:[875, 1419, 1855, 2212],
101300:[875, 1421, 1857, 2214],
101400:[876, 1422, 1858, 2215],
101500:[877, 1423, 1860, 2217],
101600:[878, 1424, 1862, 2219],
101700:[878, 1425, 1863, 2221],
101800:[879, 1427, 1865, 2223],
101900:[880, 1428, 1867, 2225],
102000:[881, 1429, 1868, 2226],
102100:[882, 1430, 1870, 2228],
102200:[883, 1432, 1871, 2230],
102300:[883, 1433, 1873, 2232],
102400:[884, 1434, 1874, 2233],
102500:[885, 1435, 1876, 2235],
102600:[886, 1437, 1878, 2237],
102700:[886, 1438, 1879, 2239],
102800:[887, 1439, 1881, 2241],
102900:[888, 1440, 1883, 2243],
103000:[889, 1442, 1884, 2245],
103100:[890, 1443, 1886, 2247],
103200:[891, 1444, 1887, 2249],
103300:[891, 1446, 1889, 2251],
103400:[892, 1447, 1891, 2252],
103500:[893, 1448, 1892, 2254],
103600:[894, 1449, 1894, 2256],
103700:[894, 1451, 1895, 2258],
103800:[895, 1452, 1897, 2260],
103900:[896, 1453, 1899, 2262],
104000:[897, 1454, 1900, 2264],
104100:[898, 1455, 1902, 2266],
104200:[899, 1457, 1903, 2268],
104300:[899, 1458, 1905, 2270],
104400:[900, 1459, 1907, 2272],
104500:[901, 1460, 1908, 2273],
104600:[902, 1462, 1910, 2275],
104700:[902, 1463, 1911, 2277],
104800:[903, 1464, 1913, 2279],
104900:[904, 1466, 1915, 2281],
105000:[905, 1467, 1916, 2283],
105100:[906, 1468, 1918, 2285],
105200:[907, 1469, 1919, 2287],
105300:[907, 1471, 1921, 2289],
105400:[908, 1472, 1923, 2291],
105500:[909, 1473, 1924, 2292],
105600:[910, 1474, 1926, 2294],
105700:[910, 1476, 1927, 2296],
105800:[911, 1477, 1929, 2298],
105900:[912, 1478, 1931, 2300],
106000:[913, 1479, 1932, 2302],
106100:[914, 1480, 1934, 2304],
106200:[915, 1481, 1935, 2306],
106300:[915, 1483, 1937, 2308],
106400:[916, 1484, 1939, 2310],
106500:[917, 1485, 1940, 2312],
106600:[918, 1486, 1942, 2313],
106700:[918, 1487, 1943, 2315],
106800:[919, 1489, 1945, 2317],
106900:[920, 1490, 1947, 2319],
107000:[921, 1491, 1948, 2321],
107100:[922, 1492, 1950, 2323],
107200:[923, 1494, 1951, 2325],
107300:[923, 1495, 1953, 2327],
107400:[924, 1496, 1955, 2329],
107500:[925, 1497, 1956, 2331],
107600:[926, 1499, 1958, 2333],
107700:[926, 1500, 1959, 2334],
107800:[927, 1501, 1961, 2336],
107900:[928, 1502, 1963, 2338],
108000:[929, 1504, 1964, 2340],
108100:[930, 1505, 1966, 2342],
108200:[931, 1506, 1967, 2344],
108300:[931, 1508, 1969, 2346],
108400:[932, 1509, 1971, 2348],
108500:[933, 1510, 1972, 2350],
108600:[934, 1511, 1974, 2352],
108700:[934, 1513, 1976, 2354],
108800:[935, 1514, 1977, 2355],
108900:[936, 1515, 1979, 2357],
109000:[937, 1516, 1980, 2359],
109100:[938, 1517, 1982, 2361],
109200:[939, 1519, 1983, 2363],
109300:[939, 1520, 1985, 2365],
109400:[940, 1521, 1987, 2366],
109500:[941, 1522, 1988, 2368],
109600:[942, 1524, 1990, 2370],
109700:[942, 1525, 1992, 2372],
109800:[943, 1526, 1993, 2374],
109900:[944, 1527, 1995, 2376],
110000:[945, 1529, 1996, 2377],
110100:[946, 1530, 1998, 2379],
110200:[947, 1531, 1999, 2381],
110300:[947, 1533, 2001, 2383],
110400:[948, 1534, 2002, 2384],
110500:[949, 1535, 2004, 2386],
110600:[950, 1536, 2005, 2388],
110700:[950, 1538, 2007, 2390],
110800:[951, 1539, 2008, 2392],
110900:[952, 1540, 2010, 2394],
111000:[953, 1541, 2011, 2396],
111100:[954, 1542, 2013, 2398],
111200:[955, 1544, 2014, 2400],
111300:[955, 1545, 2016, 2402],
111400:[956, 1546, 2017, 2403],
111500:[957, 1547, 2019, 2405],
111600:[958, 1549, 2020, 2407],
111700:[958, 1550, 2022, 2409],
111800:[959, 1551, 2023, 2411],
111900:[960, 1553, 2025, 2413],
112000:[961, 1554, 2027, 2415],
112100:[962, 1555, 2029, 2417],
112200:[963, 1556, 2030, 2419],
112300:[963, 1558, 2032, 2421],
112400:[964, 1559, 2033, 2423],
112500:[965, 1560, 2035, 2424],
112600:[966, 1561, 2036, 2426],
112700:[966, 1563, 2038, 2428],
112800:[967, 1564, 2039, 2430],
112900:[968, 1565, 2041, 2432],
113000:[969, 1566, 2043, 2434],
113100:[970, 1567, 2045, 2436],
113200:[971, 1568, 2046, 2438],
113300:[971, 1570, 2048, 2440],
113400:[972, 1571, 2049, 2442],
113500:[973, 1572, 2051, 2443],
113600:[974, 1573, 2052, 2445],
113700:[975, 1574, 2054, 2447],
113800:[975, 1576, 2055, 2449],
113900:[976, 1577, 2057, 2451],
114000:[977, 1578, 2059, 2453],
114100:[978, 1579, 2061, 2455],
114200:[979, 1581, 2062, 2457],
114300:[979, 1582, 2064, 2459],
114400:[980, 1583, 2065, 2461],
114500:[981, 1584, 2067, 2463],
114600:[982, 1586, 2068, 2464],
114700:[983, 1587, 2070, 2466],
114800:[983, 1588, 2072, 2468],
114900:[984, 1589, 2073, 2470],
115000:[985, 1591, 2075, 2472],
115100:[986, 1592, 2077, 2474],
115200:[987, 1593, 2078, 2476],
115300:[987, 1595, 2080, 2478],
115400:[988, 1596, 2081, 2480],
115500:[989, 1597, 2083, 2482],
115600:[990, 1598, 2084, 2484],
115700:[991, 1600, 2086, 2485],
115800:[991, 1601, 2088, 2487],
115900:[992, 1602, 2089, 2489],
116000:[993, 1603, 2091, 2491],
116100:[994, 1604, 2093, 2493],
116200:[995, 1606, 2094, 2495],
116300:[995, 1607, 2096, 2497],
116400:[996, 1608, 2097, 2499],
116500:[997, 1609, 2099, 2501],
116600:[998, 1611, 2100, 2503],
116700:[999, 1612, 2102, 2505],
116800:[999, 1613, 2104, 2506],
116900:[1000, 1615, 2105, 2508],
117000:[1001, 1616, 2107, 2510],
117100:[1002, 1617, 2109, 2512],
117200:[1003, 1618, 2110, 2514],
117300:[1003, 1620, 2112, 2516],
117400:[1004, 1621, 2113, 2517],
117500:[1005, 1622, 2115, 2519],
117600:[1006, 1623, 2116, 2521],
117700:[1007, 1625, 2118, 2523],
117800:[1007, 1626, 2120, 2525],
117900:[1008, 1627, 2121, 2527],
118000:[1009, 1628, 2123, 2528],
118100:[1010, 1629, 2125, 2530],
118200:[1011, 1630, 2126, 2532],
118300:[1011, 1632, 2128, 2534],
118400:[1012, 1633, 2129, 2535],
118500:[1013, 1634, 2131, 2537],
118600:[1014, 1635, 2132, 2539],
118700:[1015, 1636, 2134, 2541],
118800:[1015, 1638, 2136, 2543],
118900:[1016, 1639, 2137, 2545],
119000:[1017, 1640, 2139, 2547],
119100:[1018, 1641, 2141, 2549],
119200:[1019, 1643, 2142, 2551],
119300:[1019, 1644, 2144, 2553],
119400:[1020, 1645, 2145, 2554],
119500:[1021, 1646, 2147, 2556],
119600:[1022, 1648, 2148, 2558],
119700:[1023, 1649, 2150, 2560],
119800:[1023, 1650, 2152, 2562],
119900:[1024, 1651, 2153, 2564],
12000:[0, 0, 0, 0],
120000:[1025, 1653, 2155, 2566],
120100:[1026, 1654, 2157, 2568],
120200:[1027, 1655, 2158, 2570],
120300:[1027, 1657, 2160, 2572],
120400:[1028, 1658, 2161, 2574],
120500:[1029, 1659, 2163, 2575],
120600:[1030, 1660, 2164, 2577],
120700:[1031, 1661, 2166, 2579],
120800:[1031, 1663, 2168, 2581],
120900:[1032, 1664, 2169, 2583],
12100:[7, 8, 9, 9],
121000:[1033, 1665, 2171, 2585],
121100:[1034, 1666, 2173, 2587],
121200:[1035, 1668, 2174, 2589],
121300:[1035, 1669, 2176, 2591],
121400:[1036, 1670, 2177, 2593],
121500:[1037, 1671, 2179, 2594],
121600:[1038, 1673, 2181, 2596],
121700:[1039, 1674, 2182, 2598],
121800:[1039, 1675, 2184, 2600],
121900:[1040, 1676, 2185, 2602],
12200:[15, 16, 17, 18],
122000:[1041, 1678, 2187, 2604],
122100:[1042, 1679, 2189, 2606],
122200:[1043, 1680, 2190, 2608],
122300:[1043, 1682, 2192, 2610],
122400:[1044, 1683, 2193, 2612],
122500:[1045, 1684, 2195, 2614],
122600:[1046, 1685, 2197, 2615],
122700:[1047, 1687, 2198, 2617],
122800:[1047, 1688, 2200, 2619],
122900:[1048, 1689, 2201, 2621],
12300:[22, 24, 26, 28],
123000:[1049, 1690, 2203, 2623],
123100:[1050, 1691, 2205, 2625],
123200:[1051, 1693, 2206, 2627],
123300:[1051, 1694, 2208, 2629],
123400:[1052, 1695, 2209, 2631],
123500:[1053, 1696, 2211, 2633],
123600:[1054, 1698, 2213, 2635],
123700:[1055, 1699, 2214, 2636],
123800:[1055, 1700, 2216, 2638],
123900:[1056, 1702, 2217, 2640],
12400:[30, 32, 34, 37],
124000:[1057, 1703, 2219, 2642],
124100:[1058, 1704, 2221, 2644],
124200:[1059, 1705, 2222, 2646],
124300:[1059, 1707, 2224, 2648],
124400:[1060, 1708, 2225, 2649],
124500:[1061, 1709, 2227, 2651],
124600:[1062, 1710, 2229, 2653],
124700:[1063, 1712, 2230, 2655],
124800:[1063, 1713, 2232, 2657],
124900:[1064, 1714, 2233, 2659],
12500:[37, 40, 43, 46],
125000:[1065, 1715, 2235, 2660],
125100:[1066, 1716, 2237, 2662],
125200:[1067, 1717, 2238, 2664],
125300:[1067, 1719, 2240, 2666],
125400:[1068, 1720, 2241, 2667],
125500:[1069, 1721, 2243, 2669],
125600:[1070, 1722, 2245, 2671],
125700:[1071, 1723, 2246, 2673],
125800:[1071, 1725, 2248, 2675],
125900:[1072, 1726, 2249, 2677],
12600:[44, 48, 52, 55],
126000:[1073, 1727, 2251, 2679],
126100:[1074, 1728, 2253, 2681],
126200:[1075, 1730, 2254, 2683],
126300:[1075, 1731, 2256, 2685],
126400:[1076, 1732, 2257, 2686],
126500:[1077, 1733, 2259, 2688],
126600:[1078, 1735, 2261, 2690],
126700:[1079, 1736, 2262, 2692],
126800:[1079, 1737, 2264, 2694],
126900:[1080, 1738, 2265, 2696],
12700:[52, 56, 60, 64],
127000:[1081, 1740, 2267, 2698],
127100:[1082, 1741, 2269, 2700],
127200:[1083, 1742, 2270, 2702],
127300:[1083, 1744, 2272, 2704],
127400:[1084, 1745, 2273, 2706],
127500:[1085, 1746, 2275, 2707],
127600:[1086, 1747, 2277, 2709],
127700:[1087, 1749, 2278, 2711],
127800:[1087, 1750, 2280, 2713],
127900:[1088, 1751, 2281, 2715],
12800:[59, 64, 69, 74],
128000:[1089, 1752, 2283, 2717],
128100:[1090, 1753, 2285, 2719],
128200:[1091, 1755, 2286, 2721],
128300:[1091, 1756, 2288, 2723],
128400:[1092, 1757, 2289, 2725],
128500:[1093, 1758, 2291, 2726],
128600:[1094, 1760, 2293, 2728],
128700:[1095, 1761, 2294, 2730],
128800:[1095, 1762, 2296, 2732],
128900:[1096, 1763, 2297, 2734],
12900:[67, 72, 77, 83],
129000:[1097, 1765, 2299, 2736],
129100:[1098, 1766, 2301, 2738],
129200:[1099, 1767, 2302, 2740],
129300:[1099, 1769, 2304, 2742],
129400:[1100, 1770, 2305, 2744],
129500:[1101, 1771, 2307, 2746],
129600:[1102, 1772, 2309, 2747],
129700:[1103, 1774, 2310, 2749],
129800:[1104, 1775, 2312, 2751],
129900:[1104, 1776, 2314, 2753],
13000:[74, 80, 86, 92],
130000:[1105, 1777, 2315, 2755],
130100:[1106, 1778, 2317, 2757],
130200:[1107, 1779, 2318, 2759],
130300:[1107, 1781, 2320, 2761],
130400:[1108, 1782, 2321, 2763],
130500:[1109, 1783, 2323, 2765],
130600:[1110, 1784, 2325, 2767],
130700:[1111, 1785, 2326, 2768],
130800:[1112, 1787, 2328, 2770],
130900:[1112, 1788, 2330, 2772],
13100:[78, 84, 90, 97],
131000:[1113, 1789, 2331, 2774],
131100:[1114, 1790, 2333, 2776],
131200:[1115, 1792, 2334, 2778],
131300:[1115, 1793, 2336, 2779],
131400:[1116, 1794, 2337, 2781],
131500:[1117, 1795, 2339, 2783],
131600:[1118, 1797, 2341, 2785],
131700:[1119, 1798, 2342, 2787],
131800:[1120, 1799, 2344, 2789],
131900:[1120, 1800, 2346, 2790],
13200:[81, 88, 94, 101],
132000:[1121, 1802, 2347, 2792],
132100:[1122, 1803, 2349, 2794],
132200:[1123, 1804, 2350, 2796],
132300:[1123, 1806, 2352, 2798],
132400:[1124, 1807, 2353, 2799],
132500:[1125, 1808, 2355, 2801],
132600:[1126, 1809, 2356, 2803],
132700:[1127, 1811, 2358, 2805],
132800:[1128, 1812, 2359, 2807],
132900:[1128, 1813, 2361, 2809],
13300:[85, 91, 99, 106],
133000:[1129, 1814, 2362, 2811],
133100:[1130, 1815, 2364, 2813],
133200:[1130, 1816, 2365, 2815],
133300:[1131, 1818, 2367, 2816],
133400:[1132, 1819, 2368, 2818],
133500:[1133, 1820, 2370, 2820],
133600:[1133, 1821, 2371, 2822],
133700:[1134, 1822, 2373, 2824],
133800:[1135, 1824, 2375, 2826],
133900:[1136, 1825, 2376, 2827],
13400:[88, 95, 103, 110],
134000:[1136, 1826, 2378, 2829],
134100:[1137, 1827, 2380, 2831],
134200:[1138, 1828, 2381, 2833],
134300:[1138, 1830, 2383, 2835],
134400:[1139, 1831, 2384, 2836],
134500:[1140, 1832, 2386, 2838],
134600:[1141, 1833, 2387, 2840],
134700:[1141, 1834, 2389, 2842],
134800:[1142, 1836, 2390, 2844],
134900:[1143, 1837, 2392, 2846],
13500:[92, 99, 107, 115],
135000:[1144, 1838, 2393, 2848],
135100:[1145, 1839, 2395, 2850],
135200:[1146, 1840, 2396, 2852],
135300:[1146, 1842, 2398, 2853],
135400:[1147, 1843, 2399, 2855],
135500:[1148, 1844, 2401, 2857],
135600:[1149, 1845, 2402, 2859],
135700:[1149, 1846, 2404, 2861],
135800:[1150, 1847, 2405, 2863],
135900:[1151, 1849, 2407, 2864],
13600:[95, 103, 111, 119],
136000:[1152, 1850, 2409, 2866],
136100:[1153, 1851, 2411, 2868],
136200:[1154, 1852, 2412, 2870],
136300:[1154, 1853, 2414, 2872],
136400:[1155, 1855, 2415, 2874],
136500:[1156, 1856, 2417, 2875],
136600:[1157, 1857, 2419, 2877],
136700:[1158, 1858, 2420, 2879],
136800:[1158, 1859, 2422, 2881],
136900:[1159, 1860, 2423, 2883],
13700:[99, 107, 116, 124],
137000:[1160, 1862, 2425, 2885],
137100:[1161, 1863, 2427, 2887],
137200:[1162, 1865, 2428, 2889],
137300:[1162, 1866, 2430, 2891],
137400:[1163, 1867, 2431, 2892],
137500:[1164, 1868, 2433, 2894],
137600:[1165, 1870, 2434, 2896],
137700:[1166, 1871, 2436, 2898],
137800:[1167, 1872, 2437, 2900],
137900:[1167, 1873, 2439, 2902],
13800:[102, 111, 120, 128],
138000:[1168, 1875, 2440, 2903],
138100:[1169, 1876, 2442, 2905],
138200:[1169, 1877, 2443, 2907],
138300:[1170, 1879, 2445, 2908],
138400:[1171, 1880, 2446, 2910],
138500:[1172, 1881, 2448, 2912],
138600:[1172, 1882, 2449, 2914],
138700:[1173, 1884, 2451, 2916],
138800:[1174, 1885, 2453, 2917],
138900:[1175, 1886, 2454, 2919],
13900:[106, 114, 124, 133],
139000:[1175, 1887, 2456, 2921],
139100:[1176, 1888, 2458, 2923],
139200:[1177, 1889, 2459, 2925],
139300:[1177, 1891, 2461, 2927],
139400:[1178, 1892, 2462, 2928],
139500:[1179, 1893, 2464, 2930],
139600:[1180, 1894, 2465, 2932],
139700:[1180, 1896, 2467, 2934],
139800:[1181, 1897, 2468, 2936],
139900:[1182, 1898, 2470, 2938],
14000:[109, 118, 128, 137],
140000:[1183, 1899, 2471, 2940],
140100:[1184, 1900, 2473, 2942],
140200:[1185, 1901, 2474, 2944],
140300:[1185, 1903, 2476, 2945],
140400:[1186, 1904, 2477, 2947],
140500:[1187, 1905, 2479, 2949],
140600:[1188, 1906, 2480, 2951],
140700:[1188, 1907, 2482, 2953],
140800:[1189, 1909, 2483, 2954],
140900:[1190, 1910, 2485, 2956],
14100:[110, 122, 132, 141],
141000:[1191, 1911, 2487, 2958],
141100:[1192, 1912, 2488, 2960],
141200:[1192, 1913, 2490, 2961],
141300:[1193, 1914, 2491, 2963],
141400:[1194, 1916, 2493, 2965],
141500:[1195, 1917, 2494, 2967],
141600:[1195, 1918, 2496, 2968],
141700:[1196, 1919, 2497, 2970],
141800:[1197, 1920, 2499, 2972],
141900:[1198, 1921, 2500, 2974],
14200:[111, 125, 136, 145],
142000:[1198, 1922, 2501, 2975],
142100:[1199, 1923, 2502, 2977],
142200:[1199, 1924, 2504, 2979],
142300:[1200, 1926, 2505, 2980],
142400:[1201, 1927, 2507, 2982],
142500:[1201, 1928, 2508, 2984],
142600:[1202, 1929, 2510, 2986],
142700:[1203, 1930, 2511, 2987],
142800:[1204, 1932, 2513, 2989],
142900:[1204, 1933, 2514, 2991],
14300:[112, 129, 140, 149],
143000:[1205, 1934, 2516, 2993],
143100:[1206, 1935, 2517, 2995],
143200:[1207, 1936, 2519, 2996],
143300:[1207, 1937, 2520, 2998],
143400:[1208, 1939, 2522, 3000],
143500:[1209, 1940, 2523, 3002],
143600:[1210, 1941, 2525, 3003],
143700:[1210, 1942, 2526, 3005],
143800:[1211, 1943, 2528, 3007],
143900:[1212, 1944, 2529, 3009],
14400:[113, 132, 143, 154],
144000:[1213, 1945, 2531, 3010],
144100:[1214, 1946, 2533, 3012],
144200:[1214, 1947, 2534, 3014],
144300:[1215, 1949, 2536, 3015],
144400:[1216, 1950, 2537, 3017],
144500:[1217, 1951, 2539, 3019],
144600:[1217, 1952, 2540, 3021],
144700:[1218, 1953, 2542, 3023],
144800:[1219, 1955, 2543, 3024],
144900:[1219, 1956, 2545, 3026],
14500:[114, 136, 147, 158],
145000:[1220, 1957, 2546, 3028],
145100:[1221, 1958, 2547, 3030],
145200:[1222, 1959, 2549, 3031],
145300:[1222, 1960, 2550, 3033],
145400:[1223, 1962, 2552, 3035],
145500:[1224, 1963, 2553, 3037],
145600:[1225, 1964, 2555, 3038],
145700:[1225, 1965, 2556, 3040],
145800:[1226, 1966, 2558, 3042],
145900:[1227, 1967, 2559, 3044],
14600:[115, 139, 151, 162],
146000:[1228, 1968, 2560, 3045],
146100:[1229, 1969, 2561, 3047],
146200:[1229, 1970, 2563, 3048],
146300:[1230, 1972, 2564, 3050],
146400:[1231, 1973, 2566, 3052],
146500:[1232, 1974, 2567, 3053],
146600:[1232, 1975, 2569, 3055],
146700:[1233, 1976, 2570, 3057],
146800:[1234, 1978, 2572, 3059],
146900:[1235, 1979, 2573, 3060],
14700:[116, 143, 155, 166],
147000:[1235, 1980, 2575, 3062],
147100:[1236, 1981, 2576, 3064],
147200:[1236, 1982, 2578, 3066],
147300:[1237, 1983, 2579, 3067],
147400:[1238, 1985, 2581, 3069],
147500:[1238, 1986, 2582, 3071],
147600:[1239, 1987, 2584, 3073],
147700:[1240, 1988, 2585, 3074],
147800:[1241, 1989, 2587, 3076],
147900:[1241, 1990, 2588, 3078],
14800:[117, 146, 159, 170],
148000:[1242, 1991, 2590, 3080],
148100:[1243, 1992, 2592, 3082],
148200:[1244, 1993, 2593, 3083],
148300:[1244, 1995, 2595, 3085],
148400:[1245, 1996, 2596, 3087],
148500:[1246, 1997, 2598, 3089],
148600:[1247, 1998, 2599, 3090],
148700:[1247, 1999, 2601, 3092],
148800:[1248, 2001, 2602, 3094],
148900:[1249, 2002, 2604, 3095],
14900:[118, 150, 163, 174],
149000:[1250, 2003, 2605, 3097],
149100:[1251, 2004, 2606, 3099],
149200:[1251, 2005, 2608, 3101],
149300:[1252, 2006, 2609, 3102],
149400:[1253, 2008, 2611, 3104],
149500:[1254, 2009, 2612, 3106],
149600:[1254, 2010, 2614, 3108],
149700:[1255, 2011, 2615, 3109],
149800:[1256, 2012, 2616, 3111],
149900:[1257, 2013, 2618, 3113],
15000:[119, 154, 166, 178],
150000:[1257, 2014, 2619, 3115],
15100:[120, 158, 170, 182],
15200:[121, 161, 174, 186],
15300:[122, 165, 178, 190],
15400:[123, 168, 182, 194],
15500:[124, 172, 185, 198],
15600:[125, 175, 189, 203],
15700:[126, 179, 193, 207],
15800:[127, 183, 197, 211],
15900:[128, 186, 201, 215],
16000:[128, 190, 205, 219],
16100:[129, 193, 209, 223],
16200:[130, 197, 212, 227],
16300:[131, 200, 216, 231],
16400:[132, 204, 220, 235],
16500:[133, 207, 224, 239],
16600:[134, 211, 227, 243],
16700:[135, 214, 231, 247],
16800:[135, 218, 235, 252],
16900:[136, 221, 239, 256],
17000:[137, 225, 242, 260],
17100:[138, 228, 245, 263],
17200:[139, 231, 248, 267],
17300:[140, 234, 251, 270],
17400:[141, 237, 254, 273],
17500:[142, 240, 257, 277],
17600:[142, 242, 260, 280],
17700:[143, 245, 263, 283],
17800:[144, 248, 267, 287],
17900:[145, 251, 270, 290],
18000:[146, 254, 273, 293],
18100:[147, 257, 276, 297],
18200:[148, 260, 280, 300],
18300:[149, 264, 283, 304],
18400:[150, 267, 287, 308],
18500:[150, 270, 290, 312],
18600:[151, 273, 294, 315],
18700:[152, 277, 297, 319],
18800:[153, 280, 301, 323],
18900:[154, 283, 304, 327],
19000:[155, 286, 308, 330],
19100:[156, 288, 312, 334],
19200:[156, 290, 316, 338],
19300:[157, 293, 320, 343],
19400:[157, 295, 324, 347],
19500:[158, 297, 328, 351],
19600:[158, 299, 332, 355],
19700:[159, 302, 336, 360],
19800:[159, 304, 340, 364],
19900:[160, 306, 343, 368],
20000:[160, 308, 347, 372],
20100:[161, 309, 351, 376],
20200:[161, 310, 355, 380],
20300:[162, 311, 359, 385],
20400:[162, 313, 363, 389],
20500:[163, 314, 367, 393],
20600:[164, 315, 371, 397],
20700:[164, 316, 374, 402],
20800:[165, 317, 378, 406],
20900:[165, 318, 382, 410],
21000:[166, 320, 386, 414],
21100:[167, 321, 390, 418],
21200:[167, 322, 394, 422],
21300:[168, 323, 398, 427],
21400:[168, 325, 402, 431],
21500:[169, 326, 406, 435],
21600:[169, 327, 409, 439],
21700:[170, 328, 413, 444],
21800:[170, 329, 417, 448],
21900:[171, 330, 421, 452],
22000:[171, 331, 425, 456],
22100:[172, 332, 429, 460],
22200:[172, 333, 433, 464],
22300:[173, 334, 437, 469],
22400:[173, 336, 441, 473],
22500:[174, 337, 444, 477],
22600:[175, 338, 448, 481],
22700:[175, 339, 452, 486],
22800:[176, 340, 456, 490],
22900:[176, 341, 460, 494],
23000:[177, 342, 464, 498],
23100:[178, 343, 467, 502],
23200:[178, 344, 469, 506],
23300:[179, 345, 472, 511],
23400:[179, 346, 474, 515],
23500:[180, 348, 477, 519],
23600:[180, 349, 479, 523],
23700:[181, 350, 482, 528],
23800:[181, 351, 485, 532],
23900:[182, 352, 487, 536],
24000:[182, 353, 490, 540],
24100:[183, 354, 492, 544],
24200:[183, 355, 493, 548],
24300:[184, 356, 495, 552],
24400:[184, 357, 496, 557],
24500:[185, 359, 498, 561],
24600:[186, 360, 499, 565],
24700:[186, 361, 501, 569],
24800:[187, 362, 502, 573],
24900:[187, 363, 504, 577],
25000:[188, 364, 505, 581],
25100:[189, 365, 507, 585],
25200:[189, 367, 508, 589],
25300:[190, 368, 510, 593],
25400:[191, 369, 512, 598],
25500:[192, 370, 513, 602],
25600:[192, 372, 515, 606],
25700:[193, 373, 517, 610],
25800:[194, 374, 518, 614],
25900:[195, 376, 520, 618],
26000:[195, 377, 522, 623],
26100:[196, 379, 524, 627],
26200:[197, 380, 526, 631],
26300:[198, 382, 528, 635],
26400:[199, 383, 530, 639],
26500:[200, 385, 532, 643],
26600:[201, 386, 533, 647],
26700:[202, 388, 535, 651],
26800:[203, 389, 537, 655],
26900:[204, 391, 539, 659],
27000:[205, 392, 541, 664],
27100:[206, 394, 543, 666],
27200:[207, 395, 545, 669],
27300:[208, 397, 547, 671],
27400:[209, 398, 549, 673],
27500:[210, 400, 551, 676],
27600:[211, 401, 553, 678],
27700:[212, 403, 555, 680],
27800:[213, 404, 557, 683],
27900:[214, 406, 559, 685],
28000:[215, 407, 561, 687],
28100:[216, 408, 563, 689],
28200:[217, 410, 565, 691],
28300:[218, 411, 566, 693],
28400:[218, 412, 568, 696],
28500:[219, 414, 570, 698],
28600:[220, 415, 572, 700],
28700:[221, 417, 574, 702],
28800:[222, 418, 575, 704],
28900:[223, 419, 577, 706],
29000:[224, 421, 579, 708],
29100:[225, 422, 581, 710],
29200:[226, 424, 583, 712],
29300:[227, 425, 584, 715],
29400:[228, 427, 586, 717],
29500:[229, 428, 588, 719],
29600:[230, 429, 590, 721],
29700:[231, 431, 592, 723],
29800:[231, 432, 594, 726],
29900:[232, 434, 595, 728],
30000:[233, 435, 597, 730],
30100:[234, 436, 599, 732],
30200:[235, 438, 601, 734],
30300:[236, 439, 603, 737],
30400:[237, 441, 604, 739],
30500:[238, 442, 606, 741],
30600:[238, 444, 608, 743],
30700:[239, 445, 610, 745],
30800:[240, 447, 612, 748],
30900:[241, 448, 614, 750],
31000:[242, 450, 616, 752],
31100:[243, 451, 618, 754],
31200:[244, 453, 620, 756],
31300:[245, 454, 622, 759],
31400:[246, 456, 624, 761],
31500:[247, 457, 625, 763],
31600:[248, 458, 627, 765],
31700:[249, 460, 629, 767],
31800:[250, 461, 631, 770],
31900:[251, 463, 633, 772],
32000:[252, 464, 635, 774],
32100:[253, 465, 637, 776],
32200:[254, 467, 639, 778],
32300:[255, 468, 640, 781],
32400:[256, 470, 642, 783],
32500:[257, 471, 644, 785],
32600:[258, 473, 646, 787],
32700:[259, 474, 648, 789],
32800:[259, 476, 650, 792],
32900:[260, 477, 651, 794],
33000:[261, 479, 653, 796],
33100:[262, 481, 655, 798],
33200:[263, 482, 657, 800],
33300:[264, 484, 659, 803],
33400:[265, 485, 660, 805],
33500:[266, 487, 662, 807],
33600:[266, 488, 664, 809],
33700:[267, 490, 666, 811],
33800:[268, 491, 668, 814],
33900:[269, 493, 670, 816],
34000:[270, 494, 672, 818],
34100:[271, 495, 674, 820],
34200:[272, 497, 676, 822],
34300:[273, 498, 678, 825],
34400:[274, 500, 680, 827],
34500:[275, 501, 681, 829],
34600:[276, 503, 683, 831],
34700:[277, 504, 685, 833],
34800:[278, 506, 687, 835],
34900:[279, 507, 689, 838],
35000:[280, 508, 691, 840],
35100:[281, 509, 693, 842],
35200:[282, 511, 695, 844],
35300:[283, 512, 696, 847],
35400:[284, 514, 698, 849],
35500:[285, 515, 700, 851],
35600:[286, 516, 702, 853],
35700:[287, 518, 704, 855],
35800:[287, 519, 706, 857],
35900:[288, 521, 707, 860],
36000:[289, 522, 709, 862],
36100:[290, 523, 711, 864],
36200:[291, 525, 712, 866],
36300:[291, 526, 714, 868],
36400:[292, 528, 716, 870],
36500:[293, 529, 718, 872],
36600:[294, 530, 719, 874],
36700:[295, 532, 721, 876],
36800:[296, 533, 723, 878],
36900:[296, 534, 724, 880],
37000:[297, 536, 726, 882],
37100:[298, 537, 728, 884],
37200:[299, 539, 730, 886],
37300:[300, 540, 732, 889],
37400:[301, 542, 734, 891],
37500:[302, 543, 735, 893],
37600:[303, 545, 737, 895],
37700:[304, 546, 739, 897],
37800:[305, 547, 741, 899],
37900:[306, 549, 743, 902],
38000:[307, 550, 745, 904],
38100:[308, 551, 747, 906],
38200:[309, 553, 749, 908],
38300:[310, 554, 751, 911],
38400:[311, 556, 753, 913],
38500:[312, 557, 755, 915],
38600:[313, 559, 757, 917],
38700:[314, 560, 759, 920],
38800:[315, 562, 761, 922],
38900:[316, 563, 762, 924],
39000:[317, 565, 764, 926],
39100:[318, 566, 766, 928],
39200:[319, 568, 768, 930],
39300:[320, 569, 770, 933],
39400:[321, 571, 771, 935],
39500:[322, 572, 773, 937],
39600:[323, 574, 775, 939],
39700:[324, 575, 777, 941],
39800:[325, 577, 779, 944],
39900:[326, 578, 781, 946],
40000:[327, 580, 782, 948],
40100:[328, 581, 784, 950],
40200:[329, 583, 786, 952],
40300:[330, 584, 788, 954],
40400:[331, 586, 789, 956],
40500:[332, 587, 791, 958],
40600:[333, 589, 793, 961],
40700:[334, 590, 795, 963],
40800:[335, 592, 797, 965],
40900:[336, 593, 799, 967],
41000:[337, 595, 801, 969],
41100:[338, 596, 803, 971],
41200:[339, 598, 804, 973],
41300:[340, 599, 806, 975],
41400:[341, 600, 808, 977],
41500:[342, 602, 810, 979],
41600:[342, 603, 811, 981],
41700:[343, 604, 813, 983],
41800:[344, 606, 815, 986],
41900:[345, 607, 817, 988],
42000:[346, 608, 818, 990],
42100:[347, 609, 820, 992],
42200:[348, 611, 822, 994],
42300:[349, 612, 823, 996],
42400:[350, 613, 825, 998],
42500:[351, 615, 827, 1000],
42600:[352, 616, 829, 1002],
42700:[353, 617, 830, 1004],
42800:[354, 619, 832, 1006],
42900:[355, 620, 834, 1008],
43000:[356, 622, 836, 1010],
43100:[357, 623, 838, 1012],
43200:[358, 625, 839, 1014],
43300:[359, 626, 841, 1016],
43400:[360, 627, 843, 1018],
43500:[361, 629, 845, 1020],
43600:[362, 630, 846, 1022],
43700:[363, 632, 848, 1025],
43800:[363, 633, 850, 1027],
43900:[364, 634, 852, 1029],
44000:[365, 636, 853, 1031],
44100:[366, 637, 855, 1033],
44200:[367, 639, 857, 1035],
44300:[368, 640, 859, 1038],
44400:[369, 642, 860, 1040],
44500:[370, 643, 862, 1042],
44600:[371, 645, 864, 1044],
44700:[372, 646, 866, 1046],
44800:[373, 648, 868, 1049],
44900:[374, 649, 870, 1051],
45000:[375, 651, 872, 1053],
45100:[376, 652, 874, 1055],
45200:[377, 654, 876, 1057],
45300:[378, 655, 877, 1059],
45400:[379, 657, 879, 1062],
45500:[380, 658, 881, 1064],
45600:[381, 659, 883, 1066],
45700:[382, 661, 885, 1068],
45800:[383, 662, 886, 1070],
45900:[384, 663, 888, 1072],
46000:[385, 665, 890, 1074],
46100:[386, 666, 892, 1076],
46200:[387, 668, 893, 1078],
46300:[388, 669, 895, 1080],
46400:[389, 670, 897, 1082],
46500:[390, 672, 899, 1084],
46600:[391, 673, 900, 1086],
46700:[392, 675, 902, 1088],
46800:[393, 676, 904, 1090],
46900:[393, 677, 905, 1092],
47000:[394, 679, 907, 1094],
47100:[395, 680, 909, 1096],
47200:[396, 682, 911, 1098],
47300:[397, 683, 912, 1100],
47400:[398, 685, 914, 1102],
47500:[399, 686, 916, 1104],
47600:[399, 687, 918, 1106],
47700:[400, 689, 919, 1108],
47800:[401, 690, 921, 1110],
47900:[402, 692, 923, 1112],
48000:[403, 693, 925, 1114],
48100:[404, 694, 927, 1116],
48200:[405, 696, 928, 1118],
48300:[406, 697, 930, 1120],
48400:[407, 699, 932, 1122],
48500:[408, 700, 934, 1124],
48600:[409, 702, 935, 1126],
48700:[410, 703, 937, 1128],
48800:[411, 704, 939, 1130],
48900:[412, 706, 941, 1132],
49000:[413, 707, 942, 1134],
49100:[414, 708, 944, 1136],
49200:[415, 710, 945, 1138],
49300:[416, 711, 947, 1140],
49400:[417, 712, 949, 1142],
49500:[418, 714, 951, 1144],
49600:[419, 715, 952, 1146],
49700:[420, 716, 954, 1148],
49800:[421, 718, 956, 1150],
49900:[422, 719, 957, 1153],
50000:[422, 720, 959, 1155],
50100:[423, 721, 961, 1157],
50200:[424, 723, 963, 1159],
50300:[425, 724, 964, 1161],
50400:[426, 725, 966, 1163],
50500:[427, 727, 968, 1165],
50600:[428, 728, 970, 1167],
50700:[428, 730, 971, 1169],
50800:[429, 731, 973, 1171],
50900:[430, 732, 975, 1173],
51000:[431, 734, 977, 1175],
51100:[432, 735, 979, 1177],
51200:[433, 737, 980, 1179],
51300:[434, 738, 982, 1181],
51400:[435, 739, 984, 1183],
51500:[436, 741, 986, 1185],
51600:[437, 742, 987, 1188],
51700:[438, 744, 989, 1190],
51800:[439, 745, 991, 1192],
51900:[440, 746, 993, 1194],
52000:[441, 748, 994, 1196],
52100:[442, 749, 996, 1198],
52200:[443, 751, 998, 1200],
52300:[444, 752, 999, 1202],
52400:[445, 753, 1001, 1204],
52500:[446, 755, 1003, 1207],
52600:[447, 756, 1005, 1209],
52700:[448, 758, 1006, 1211],
52800:[448, 759, 1008, 1213],
52900:[449, 760, 1010, 1215],
53000:[450, 762, 1012, 1217],
53100:[451, 763, 1014, 1219],
53200:[452, 765, 1016, 1221],
53300:[453, 766, 1017, 1223],
53400:[454, 768, 1019, 1225],
53500:[455, 769, 1021, 1227],
53600:[456, 771, 1023, 1229],
53700:[457, 772, 1024, 1231],
53800:[458, 774, 1026, 1233],
53900:[459, 775, 1028, 1235],
54000:[460, 777, 1030, 1237],
54100:[461, 778, 1032, 1239],
54200:[462, 780, 1034, 1241],
54300:[463, 781, 1035, 1243],
54400:[464, 783, 1037, 1245],
54500:[465, 784, 1039, 1247],
54600:[466, 786, 1041, 1249],
54700:[467, 787, 1043, 1251],
54800:[467, 789, 1044, 1253],
54900:[468, 790, 1046, 1256],
55000:[469, 791, 1048, 1258],
55100:[470, 793, 1050, 1260],
55200:[471, 794, 1052, 1262],
55300:[472, 796, 1054, 1265],
55400:[473, 797, 1056, 1267],
55500:[474, 799, 1058, 1269],
55600:[475, 800, 1059, 1271],
55700:[476, 802, 1061, 1273],
55800:[477, 803, 1063, 1275],
55900:[478, 805, 1065, 1278],
56000:[479, 806, 1067, 1280],
56100:[480, 808, 1069, 1282],
56200:[481, 809, 1071, 1284],
56300:[482, 811, 1072, 1287],
56400:[483, 812, 1074, 1289],
56500:[484, 814, 1076, 1291],
56600:[485, 815, 1078, 1293],
56700:[486, 817, 1080, 1295],
56800:[487, 818, 1082, 1297],
56900:[488, 820, 1083, 1300],
57000:[489, 821, 1085, 1302],
57100:[490, 822, 1087, 1304],
57200:[491, 824, 1089, 1306],
57300:[492, 825, 1091, 1309],
57400:[493, 827, 1092, 1311],
57500:[494, 828, 1094, 1313],
57600:[495, 830, 1096, 1315],
57700:[496, 831, 1098, 1317],
57800:[497, 833, 1100, 1319],
57900:[498, 834, 1102, 1322],
58000:[499, 835, 1104, 1324],
58100:[500, 836, 1106, 1326],
58200:[501, 838, 1108, 1328],
58300:[502, 839, 1110, 1331],
58400:[503, 841, 1111, 1333],
58500:[504, 842, 1113, 1335],
58600:[505, 844, 1115, 1337],
58700:[506, 845, 1117, 1339],
58800:[507, 847, 1119, 1341],
58900:[508, 848, 1121, 1344],
59000:[509, 850, 1123, 1346],
59100:[510, 851, 1125, 1348],
59200:[511, 853, 1127, 1350],
59300:[512, 854, 1129, 1352],
59400:[513, 856, 1130, 1354],
59500:[514, 857, 1132, 1357],
59600:[515, 859, 1134, 1359],
59700:[515, 860, 1136, 1361],
59800:[516, 861, 1138, 1363],
59900:[517, 863, 1140, 1365],
60000:[518, 864, 1141, 1367],
60100:[519, 865, 1143, 1369],
60200:[520, 867, 1145, 1371],
60300:[521, 868, 1147, 1373],
60400:[522, 870, 1148, 1375],
60500:[523, 871, 1150, 1377],
60600:[524, 873, 1152, 1380],
60700:[524, 874, 1154, 1382],
60800:[525, 875, 1156, 1384],
60900:[526, 877, 1158, 1386],
61000:[527, 878, 1159, 1388],
61100:[528, 879, 1161, 1390],
61200:[529, 881, 1163, 1392],
61300:[530, 882, 1165, 1395],
61400:[531, 884, 1166, 1397],
61500:[532, 885, 1168, 1399],
61600:[533, 887, 1170, 1401],
61700:[534, 888, 1172, 1403],
61800:[534, 889, 1174, 1405],
61900:[535, 891, 1176, 1408],
62000:[536, 892, 1177, 1410],
62100:[537, 893, 1179, 1412],
62200:[538, 895, 1180, 1414],
62300:[539, 896, 1182, 1416],
62400:[540, 898, 1184, 1419],
62500:[541, 899, 1186, 1421],
62600:[542, 901, 1187, 1423],
62700:[543, 902, 1189, 1425],
62800:[543, 903, 1191, 1427],
62900:[544, 905, 1193, 1429],
63000:[545, 906, 1194, 1431],
63100:[546, 907, 1196, 1433],
63200:[547, 909, 1198, 1435],
63300:[548, 910, 1199, 1437],
63400:[549, 912, 1201, 1439],
63500:[550, 913, 1203, 1442],
63600:[551, 915, 1205, 1444],
63700:[552, 916, 1206, 1446],
63800:[552, 917, 1208, 1448],
63900:[553, 919, 1210, 1450],
64000:[554, 920, 1212, 1452],
64100:[555, 921, 1214, 1454],
64200:[556, 923, 1216, 1456],
64300:[557, 924, 1217, 1458],
64400:[558, 926, 1219, 1460],
64500:[559, 927, 1221, 1463],
64600:[560, 929, 1223, 1465],
64700:[561, 930, 1224, 1467],
64800:[561, 931, 1226, 1469],
64900:[562, 933, 1228, 1471],
65000:[563, 934, 1230, 1473],
65100:[564, 935, 1232, 1475],
65200:[565, 937, 1234, 1477],
65300:[566, 938, 1235, 1479],
65400:[567, 940, 1237, 1481],
65500:[568, 941, 1239, 1483],
65600:[569, 943, 1241, 1485],
65700:[570, 944, 1242, 1488],
65800:[570, 946, 1244, 1490],
65900:[571, 947, 1246, 1492],
66000:[572, 948, 1248, 1494],
66100:[573, 949, 1250, 1496],
66200:[574, 951, 1252, 1498],
66300:[575, 952, 1253, 1500],
66400:[576, 954, 1255, 1503],
66500:[577, 955, 1257, 1505],
66600:[578, 957, 1259, 1507],
66700:[579, 958, 1260, 1509],
66800:[580, 960, 1262, 1511],
66900:[580, 961, 1264, 1513],
67000:[581, 962, 1266, 1516],
67100:[582, 963, 1268, 1518],
67200:[583, 965, 1270, 1520],
67300:[584, 966, 1271, 1522],
67400:[585, 968, 1273, 1525],
67500:[586, 969, 1275, 1527],
67600:[587, 971, 1277, 1529],
67700:[588, 972, 1278, 1531],
67800:[589, 974, 1280, 1533],
67900:[589, 975, 1282, 1535],
68000:[590, 976, 1284, 1537],
68100:[591, 977, 1286, 1539],
68200:[592, 979, 1288, 1541],
68300:[593, 980, 1289, 1543],
68400:[594, 982, 1291, 1545],
68500:[595, 983, 1293, 1548],
68600:[596, 985, 1295, 1550],
68700:[597, 986, 1296, 1552],
68800:[598, 988, 1298, 1554],
68900:[598, 989, 1300, 1556],
69000:[599, 990, 1302, 1558],
69100:[600, 991, 1304, 1560],
69200:[601, 993, 1306, 1562],
69300:[602, 994, 1307, 1564],
69400:[603, 995, 1309, 1566],
69500:[604, 997, 1311, 1568],
69600:[605, 998, 1313, 1571],
69700:[606, 999, 1314, 1573],
69800:[607, 1001, 1316, 1575],
69900:[607, 1002, 1318, 1577],
70000:[608, 1003, 1320, 1579],
70100:[609, 1004, 1322, 1581],
70200:[610, 1006, 1324, 1583],
70300:[611, 1007, 1325, 1585],
70400:[612, 1008, 1327, 1588],
70500:[613, 1010, 1329, 1590],
70600:[614, 1011, 1331, 1592],
70700:[615, 1012, 1332, 1594],
70800:[616, 1014, 1334, 1596],
70900:[617, 1015, 1336, 1598],
71000:[617, 1017, 1338, 1601],
71100:[618, 1018, 1340, 1603],
71200:[619, 1020, 1342, 1605],
71300:[620, 1021, 1343, 1607],
71400:[621, 1022, 1345, 1610],
71500:[622, 1024, 1347, 1612],
71600:[623, 1025, 1349, 1614],
71700:[624, 1026, 1350, 1616],
71800:[625, 1028, 1352, 1618],
71900:[626, 1029, 1354, 1620],
72000:[626, 1031, 1356, 1622],
72100:[627, 1032, 1358, 1624],
72200:[628, 1034, 1360, 1626],
72300:[629, 1035, 1361, 1628],
72400:[630, 1036, 1363, 1630],
72500:[631, 1038, 1365, 1633],
72600:[632, 1039, 1367, 1635],
72700:[633, 1040, 1368, 1637],
72800:[634, 1042, 1370, 1639],
72900:[635, 1043, 1372, 1641],
73000:[635, 1045, 1374, 1643],
73100:[636, 1046, 1376, 1645],
73200:[637, 1048, 1378, 1647],
73300:[638, 1049, 1379, 1649],
73400:[638, 1050, 1381, 1651],
73500:[639, 1052, 1383, 1653],
73600:[640, 1053, 1385, 1656],
73700:[641, 1055, 1387, 1658],
73800:[642, 1056, 1388, 1660],
73900:[643, 1057, 1390, 1662],
74000:[643, 1059, 1392, 1664],
74100:[644, 1060, 1394, 1666],
74200:[645, 1062, 1396, 1668],
74300:[646, 1063, 1397, 1671],
74400:[646, 1064, 1399, 1673],
74500:[647, 1066, 1401, 1675],
74600:[648, 1067, 1403, 1677],
74700:[649, 1069, 1405, 1679],
74800:[650, 1070, 1406, 1681],
74900:[651, 1071, 1408, 1684],
75000:[652, 1073, 1410, 1686],
75100:[653, 1074, 1412, 1688],
75200:[654, 1076, 1414, 1690],
75300:[655, 1077, 1415, 1692],
75400:[655, 1078, 1417, 1695],
75500:[656, 1080, 1419, 1697],
75600:[657, 1081, 1421, 1699],
75700:[658, 1083, 1423, 1701],
75800:[659, 1084, 1424, 1703],
75900:[660, 1085, 1426, 1705],
76000:[661, 1087, 1428, 1707],
76100:[662, 1088, 1430, 1709],
76200:[663, 1090, 1432, 1711],
76300:[664, 1091, 1433, 1713],
76400:[664, 1092, 1435, 1715],
76500:[665, 1094, 1437, 1718],
76600:[666, 1095, 1439, 1720],
76700:[667, 1097, 1441, 1722],
76800:[668, 1098, 1442, 1724],
76900:[669, 1099, 1444, 1726],
77000:[670, 1101, 1446, 1728],
77100:[671, 1102, 1448, 1730],
77200:[672, 1104, 1450, 1732],
77300:[673, 1105, 1451, 1734],
77400:[673, 1106, 1453, 1736],
77500:[674, 1108, 1455, 1738],
77600:[675, 1109, 1457, 1741],
77700:[676, 1111, 1459, 1743],
77800:[677, 1112, 1460, 1745],
77900:[678, 1113, 1462, 1747],
78000:[679, 1115, 1464, 1749],
78100:[680, 1116, 1466, 1751],
78200:[681, 1118, 1468, 1753],
78300:[682, 1119, 1469, 1755],
78400:[682, 1120, 1471, 1757],
78500:[683, 1122, 1473, 1759],
78600:[684, 1123, 1475, 1761],
78700:[685, 1125, 1477, 1764],
78800:[686, 1126, 1478, 1766],
78900:[687, 1127, 1480, 1768],
79000:[688, 1129, 1482, 1770],
79100:[689, 1130, 1484, 1772],
79200:[690, 1132, 1486, 1774],
79300:[691, 1133, 1487, 1776],
79400:[691, 1134, 1489, 1779],
79500:[692, 1136, 1491, 1781],
79600:[693, 1137, 1493, 1783],
79700:[694, 1139, 1495, 1785],
79800:[695, 1140, 1496, 1787],
79900:[696, 1141, 1498, 1789],
80000:[697, 1143, 1500, 1792],
80100:[698, 1144, 1502, 1794],
80200:[699, 1146, 1504, 1796],
80300:[700, 1147, 1505, 1798],
80400:[700, 1149, 1507, 1801],
80500:[701, 1150, 1509, 1803],
80600:[702, 1151, 1511, 1805],
80700:[703, 1153, 1513, 1807],
80800:[704, 1154, 1514, 1809],
80900:[705, 1155, 1516, 1811],
81000:[706, 1157, 1518, 1813],
81100:[707, 1158, 1520, 1815],
81200:[708, 1160, 1521, 1817],
81300:[709, 1161, 1523, 1819],
81400:[709, 1163, 1525, 1821],
81500:[710, 1164, 1527, 1824],
81600:[711, 1165, 1528, 1826],
81700:[712, 1167, 1530, 1828],
81800:[713, 1168, 1532, 1830],
81900:[714, 1169, 1533, 1832],
82000:[715, 1171, 1535, 1834],
82100:[716, 1172, 1537, 1836],
82200:[717, 1174, 1539, 1838],
82300:[718, 1175, 1540, 1840],
82400:[719, 1176, 1542, 1842],
82500:[719, 1178, 1544, 1844],
82600:[720, 1179, 1546, 1846],
82700:[721, 1180, 1547, 1848],
82800:[722, 1182, 1549, 1850],
82900:[723, 1183, 1551, 1852],
83000:[724, 1184, 1553, 1854],
83100:[725, 1185, 1555, 1856],
83200:[726, 1187, 1556, 1858],
83300:[727, 1188, 1558, 1860],
83400:[728, 1189, 1560, 1862],
83500:[729, 1191, 1562, 1864],
83600:[729, 1192, 1563, 1866],
83700:[730, 1194, 1565, 1868],
83800:[731, 1195, 1567, 1871],
83900:[732, 1196, 1568, 1873],
84000:[733, 1198, 1570, 1875],
84100:[734, 1199, 1572, 1877],
84200:[735, 1201, 1574, 1879],
84300:[736, 1202, 1575, 1881],
84400:[736, 1204, 1577, 1883],
84500:[737, 1205, 1579, 1886],
84600:[738, 1206, 1581, 1888],
84700:[739, 1208, 1582, 1890],
84800:[740, 1209, 1584, 1892],
84900:[741, 1211, 1586, 1894],
85000:[741, 1212, 1588, 1896],
85100:[742, 1213, 1590, 1898],
85200:[743, 1215, 1591, 1900],
85300:[744, 1216, 1593, 1902],
85400:[744, 1217, 1595, 1904],
85500:[745, 1219, 1597, 1906],
85600:[746, 1220, 1598, 1908],
85700:[747, 1221, 1600, 1910],
85800:[748, 1223, 1602, 1912],
85900:[749, 1224, 1603, 1914],
86000:[750, 1225, 1605, 1916],
86100:[751, 1226, 1607, 1918],
86200:[752, 1228, 1609, 1920],
86300:[753, 1229, 1610, 1922],
86400:[754, 1231, 1612, 1924],
86500:[754, 1232, 1614, 1926],
86600:[755, 1233, 1616, 1928],
86700:[756, 1235, 1617, 1930],
86800:[757, 1236, 1619, 1933],
86900:[758, 1237, 1621, 1935],
87000:[759, 1239, 1623, 1937],
87100:[760, 1240, 1625, 1939],
87200:[761, 1242, 1626, 1941],
87300:[762, 1243, 1628, 1943],
87400:[763, 1244, 1630, 1945],
87500:[764, 1246, 1632, 1947],
87600:[764, 1247, 1633, 1950],
87700:[765, 1248, 1635, 1952],
87800:[766, 1250, 1637, 1954],
87900:[767, 1251, 1638, 1956],
88000:[768, 1252, 1640, 1958],
88100:[769, 1253, 1642, 1960],
88200:[770, 1255, 1644, 1962],
88300:[771, 1256, 1645, 1964],
88400:[771, 1257, 1647, 1966],
88500:[772, 1259, 1649, 1968],
88600:[773, 1260, 1651, 1970],
88700:[774, 1261, 1652, 1972],
88800:[775, 1263, 1654, 1974],
88900:[776, 1264, 1656, 1976],
89000:[776, 1266, 1658, 1978],
89100:[777, 1267, 1660, 1980],
89200:[778, 1269, 1661, 1982],
89300:[779, 1270, 1663, 1984],
89400:[779, 1272, 1665, 1986],
89500:[780, 1273, 1667, 1988],
89600:[781, 1274, 1668, 1990],
89700:[782, 1276, 1670, 1992],
89800:[783, 1277, 1672, 1995],
89900:[784, 1279, 1673, 1997],
90000:[785, 1280, 1675, 1999],
90100:[786, 1281, 1677, 2001],
90200:[787, 1283, 1678, 2003],
90300:[788, 1284, 1680, 2005],
90400:[789, 1285, 1682, 2007],
90500:[789, 1287, 1683, 2009],
90600:[790, 1288, 1685, 2011],
90700:[791, 1289, 1687, 2013],
90800:[792, 1291, 1688, 2015],
90900:[793, 1292, 1690, 2017],
91000:[794, 1293, 1692, 2019],
91100:[795, 1294, 1694, 2021],
91200:[795, 1295, 1695, 2023],
91300:[796, 1297, 1697, 2025],
91400:[797, 1298, 1698, 2027],
91500:[798, 1299, 1700, 2029],
91600:[798, 1300, 1702, 2030],
91700:[799, 1302, 1703, 2032],
91800:[800, 1303, 1705, 2034],
91900:[801, 1304, 1706, 2036],
92000:[801, 1305, 1708, 2038],
92100:[802, 1306, 1710, 2040],
92200:[803, 1308, 1711, 2042],
92300:[803, 1309, 1713, 2044],
92400:[804, 1310, 1714, 2046],
92500:[805, 1311, 1716, 2048],
92600:[806, 1313, 1718, 2050],
92700:[806, 1314, 1719, 2051],
92800:[807, 1315, 1721, 2053],
92900:[808, 1317, 1722, 2055],
93000:[809, 1318, 1724, 2057],
93100:[810, 1319, 1726, 2059],
93200:[811, 1320, 1727, 2061],
93300:[811, 1322, 1729, 2063],
93400:[812, 1323, 1730, 2065],
93500:[813, 1324, 1732, 2067],
93600:[814, 1325, 1734, 2069],
93700:[814, 1327, 1735, 2071],
93800:[815, 1328, 1737, 2072],
93900:[816, 1329, 1738, 2074],
94000:[817, 1330, 1740, 2076],
94100:[818, 1331, 1742, 2078],
94200:[819, 1332, 1743, 2080],
94300:[819, 1334, 1745, 2082],
94400:[820, 1335, 1746, 2083],
94500:[821, 1336, 1748, 2085],
94600:[822, 1337, 1750, 2087],
94700:[822, 1338, 1751, 2089],
94800:[823, 1340, 1753, 2091],
94900:[824, 1341, 1754, 2093],
95000:[825, 1342, 1756, 2094],
95100:[826, 1343, 1758, 2096],
95200:[827, 1345, 1759, 2098],
95300:[827, 1346, 1761, 2100],
95400:[828, 1347, 1762, 2101],
95500:[829, 1348, 1764, 2103],
95600:[830, 1350, 1766, 2105],
95700:[830, 1351, 1767, 2107],
95800:[831, 1352, 1769, 2109],
95900:[832, 1353, 1770, 2111],
96000:[833, 1355, 1772, 2113],
96100:[834, 1356, 1774, 2115],
96200:[835, 1357, 1775, 2117],
96300:[835, 1359, 1777, 2119],
96400:[836, 1360, 1778, 2120],
96500:[837, 1361, 1780, 2122],
96600:[838, 1362, 1782, 2124],
96700:[838, 1364, 1783, 2126],
96800:[839, 1365, 1785, 2128],
96900:[840, 1366, 1786, 2130],
97000:[841, 1367, 1788, 2132],
97100:[842, 1368, 1790, 2134],
97200:[843, 1370, 1791, 2136],
97300:[843, 1371, 1793, 2138],
97400:[844, 1372, 1794, 2140],
97500:[845, 1373, 1796, 2141],
97600:[846, 1375, 1798, 2143],
97700:[846, 1376, 1799, 2145],
97800:[847, 1377, 1801, 2147],
97900:[848, 1378, 1802, 2149],
98000:[849, 1380, 1804, 2151],
98100:[850, 1381, 1806, 2153],
98200:[851, 1382, 1807, 2155],
98300:[851, 1384, 1809, 2157],
98400:[852, 1385, 1810, 2159],
98500:[853, 1386, 1812, 2161],
98600:[854, 1387, 1814, 2162],
98700:[854, 1389, 1815, 2164],
98800:[855, 1390, 1817, 2166],
98900:[856, 1391, 1818, 2168],
99000:[857, 1392, 1820, 2170],
99100:[858, 1393, 1822, 2172],
99200:[859, 1395, 1823, 2174],
99300:[859, 1396, 1825, 2176],
99400:[860, 1397, 1826, 2178],
99500:[861, 1398, 1828, 2180],
99600:[862, 1400, 1830, 2181],
99700:[862, 1401, 1831, 2183],
99800:[863, 1402, 1833, 2185],
99900:[864, 1404, 1835, 2187],
};
const OR17_NB=[0.72, 1.14, 1.44, 1.76];

// Newfoundland & Labrador — 2017 Federal Child Support Guidelines Table
const T17_NL={
100000:[880, 1422, 1855, 2210],
100100:[881, 1423, 1856, 2212],
100200:[881, 1424, 1858, 2214],
100300:[882, 1425, 1859, 2215],
100400:[883, 1427, 1861, 2217],
100500:[884, 1428, 1862, 2219],
100600:[884, 1429, 1864, 2221],
100700:[885, 1430, 1865, 2223],
100800:[886, 1431, 1867, 2224],
100900:[887, 1432, 1868, 2226],
101000:[887, 1433, 1870, 2228],
101100:[888, 1434, 1872, 2230],
101200:[889, 1436, 1873, 2232],
101300:[889, 1437, 1875, 2234],
101400:[890, 1438, 1877, 2236],
101500:[891, 1439, 1878, 2238],
101600:[892, 1441, 1880, 2240],
101700:[893, 1442, 1882, 2242],
101800:[893, 1443, 1883, 2244],
101900:[894, 1444, 1885, 2246],
102000:[895, 1446, 1887, 2248],
102100:[896, 1447, 1889, 2250],
102200:[897, 1449, 1890, 2252],
102300:[898, 1450, 1892, 2254],
102400:[898, 1451, 1893, 2256],
102500:[899, 1452, 1895, 2258],
102600:[900, 1454, 1897, 2260],
102700:[901, 1455, 1898, 2262],
102800:[902, 1456, 1900, 2264],
102900:[903, 1457, 1901, 2266],
103000:[904, 1459, 1903, 2267],
103100:[905, 1460, 1905, 2269],
103200:[906, 1462, 1906, 2271],
103300:[907, 1463, 1908, 2273],
103400:[907, 1464, 1910, 2275],
103500:[908, 1465, 1911, 2277],
103600:[909, 1467, 1913, 2279],
103700:[910, 1468, 1915, 2281],
103800:[911, 1469, 1916, 2283],
103900:[912, 1471, 1918, 2285],
104000:[912, 1472, 1920, 2287],
104100:[913, 1473, 1922, 2289],
104200:[914, 1475, 1923, 2291],
104300:[914, 1476, 1925, 2293],
104400:[915, 1477, 1926, 2295],
104500:[916, 1479, 1928, 2297],
104600:[917, 1480, 1930, 2299],
104700:[918, 1481, 1931, 2301],
104800:[919, 1482, 1933, 2303],
104900:[919, 1484, 1934, 2304],
105000:[920, 1485, 1936, 2306],
105100:[921, 1486, 1938, 2308],
105200:[922, 1488, 1939, 2310],
105300:[922, 1489, 1941, 2312],
105400:[923, 1490, 1943, 2314],
105500:[924, 1492, 1944, 2316],
105600:[925, 1493, 1946, 2318],
105700:[926, 1494, 1948, 2320],
105800:[926, 1496, 1949, 2322],
105900:[927, 1497, 1951, 2324],
106000:[928, 1498, 1953, 2326],
106100:[929, 1499, 1955, 2328],
106200:[930, 1500, 1956, 2330],
106300:[931, 1502, 1958, 2332],
106400:[931, 1503, 1960, 2334],
106500:[932, 1504, 1962, 2336],
106600:[933, 1505, 1963, 2338],
106700:[934, 1507, 1965, 2340],
106800:[935, 1508, 1967, 2342],
106900:[936, 1509, 1968, 2343],
107000:[937, 1510, 1970, 2345],
107100:[938, 1511, 1972, 2347],
107200:[939, 1513, 1973, 2349],
107300:[940, 1514, 1975, 2351],
107400:[940, 1515, 1977, 2353],
107500:[941, 1516, 1978, 2355],
107600:[942, 1518, 1980, 2357],
107700:[943, 1519, 1982, 2359],
107800:[944, 1520, 1983, 2361],
107900:[945, 1521, 1985, 2363],
108000:[945, 1523, 1986, 2365],
108100:[946, 1524, 1988, 2367],
108200:[947, 1526, 1989, 2369],
108300:[947, 1527, 1991, 2371],
108400:[948, 1528, 1993, 2373],
108500:[949, 1529, 1994, 2375],
108600:[950, 1531, 1996, 2377],
108700:[951, 1532, 1998, 2379],
108800:[952, 1533, 2000, 2380],
108900:[952, 1534, 2001, 2382],
109000:[953, 1536, 2003, 2384],
109100:[954, 1537, 2005, 2386],
109200:[955, 1539, 2006, 2388],
109300:[955, 1540, 2008, 2390],
109400:[956, 1541, 2010, 2392],
109500:[957, 1542, 2011, 2394],
109600:[958, 1544, 2013, 2396],
109700:[959, 1545, 2015, 2398],
109800:[959, 1546, 2016, 2400],
109900:[960, 1548, 2018, 2402],
110000:[961, 1549, 2019, 2404],
110100:[962, 1550, 2021, 2406],
110200:[963, 1552, 2022, 2408],
110300:[964, 1553, 2024, 2410],
110400:[964, 1554, 2026, 2412],
110500:[965, 1556, 2027, 2414],
110600:[966, 1557, 2029, 2416],
110700:[967, 1558, 2031, 2418],
110800:[968, 1559, 2033, 2419],
110900:[969, 1561, 2034, 2421],
111000:[970, 1562, 2036, 2423],
111100:[971, 1563, 2038, 2425],
111200:[972, 1565, 2039, 2427],
111300:[973, 1566, 2041, 2429],
111400:[973, 1567, 2043, 2431],
111500:[974, 1569, 2044, 2433],
111600:[975, 1570, 2046, 2435],
111700:[976, 1571, 2048, 2437],
111800:[977, 1573, 2049, 2439],
111900:[978, 1574, 2051, 2441],
112000:[978, 1575, 2052, 2443],
112100:[979, 1576, 2054, 2445],
112200:[980, 1578, 2055, 2447],
112300:[980, 1579, 2057, 2449],
112400:[981, 1580, 2059, 2451],
112500:[982, 1582, 2060, 2453],
112600:[983, 1583, 2062, 2455],
112700:[984, 1584, 2064, 2457],
112800:[984, 1586, 2066, 2458],
112900:[985, 1587, 2067, 2460],
113000:[986, 1588, 2069, 2462],
113100:[987, 1589, 2071, 2464],
113200:[988, 1590, 2072, 2466],
113300:[988, 1592, 2074, 2468],
113400:[989, 1593, 2076, 2470],
113500:[990, 1594, 2077, 2472],
113600:[991, 1595, 2079, 2474],
113700:[991, 1597, 2080, 2476],
113800:[992, 1598, 2082, 2478],
113900:[993, 1599, 2084, 2480],
114000:[994, 1600, 2085, 2482],
114100:[995, 1601, 2087, 2484],
114200:[996, 1603, 2088, 2486],
114300:[997, 1604, 2090, 2488],
114400:[997, 1605, 2092, 2490],
114500:[998, 1606, 2093, 2492],
114600:[999, 1608, 2095, 2494],
114700:[1000, 1609, 2097, 2495],
114800:[1001, 1610, 2099, 2497],
114900:[1002, 1611, 2100, 2499],
115000:[1003, 1613, 2102, 2501],
115100:[1004, 1614, 2104, 2503],
115200:[1005, 1616, 2105, 2505],
115300:[1005, 1617, 2107, 2507],
115400:[1006, 1618, 2109, 2509],
115500:[1007, 1619, 2110, 2511],
115600:[1008, 1621, 2112, 2513],
115700:[1009, 1622, 2113, 2515],
115800:[1010, 1623, 2115, 2517],
115900:[1010, 1625, 2117, 2519],
116000:[1011, 1626, 2118, 2521],
116100:[1012, 1627, 2120, 2523],
116200:[1013, 1629, 2121, 2525],
116300:[1013, 1630, 2123, 2527],
116400:[1014, 1631, 2125, 2529],
116500:[1015, 1632, 2126, 2531],
116600:[1016, 1634, 2128, 2533],
116700:[1017, 1635, 2130, 2534],
116800:[1017, 1636, 2131, 2536],
116900:[1018, 1638, 2133, 2538],
117000:[1019, 1639, 2135, 2540],
117100:[1020, 1640, 2137, 2542],
117200:[1021, 1642, 2138, 2544],
117300:[1021, 1643, 2140, 2546],
117400:[1022, 1644, 2142, 2548],
117500:[1023, 1646, 2143, 2550],
117600:[1024, 1647, 2145, 2552],
117700:[1024, 1648, 2146, 2554],
117800:[1025, 1649, 2148, 2556],
117900:[1026, 1651, 2150, 2558],
118000:[1027, 1652, 2151, 2560],
118100:[1028, 1653, 2153, 2562],
118200:[1029, 1655, 2154, 2564],
118300:[1030, 1656, 2156, 2566],
118400:[1030, 1657, 2158, 2568],
118500:[1031, 1659, 2159, 2570],
118600:[1032, 1660, 2161, 2572],
118700:[1033, 1661, 2163, 2573],
118800:[1034, 1663, 2164, 2575],
118900:[1035, 1664, 2166, 2577],
119000:[1036, 1665, 2168, 2579],
119100:[1037, 1666, 2170, 2581],
119200:[1038, 1667, 2171, 2583],
119300:[1038, 1669, 2173, 2585],
119400:[1039, 1670, 2175, 2587],
119500:[1040, 1671, 2176, 2589],
119600:[1041, 1672, 2178, 2591],
119700:[1042, 1674, 2179, 2593],
119800:[1043, 1675, 2181, 2595],
119900:[1043, 1676, 2183, 2597],
12000:[0, 0, 0, 0],
120000:[1044, 1677, 2184, 2599],
120100:[1045, 1678, 2186, 2601],
120200:[1046, 1680, 2187, 2603],
120300:[1046, 1681, 2189, 2605],
120400:[1047, 1682, 2191, 2607],
120500:[1048, 1683, 2192, 2609],
120600:[1049, 1685, 2194, 2611],
120700:[1050, 1686, 2196, 2612],
120800:[1050, 1687, 2197, 2614],
120900:[1051, 1688, 2199, 2616],
12100:[8, 8, 9, 9],
121000:[1052, 1690, 2201, 2618],
121100:[1053, 1691, 2203, 2620],
121200:[1054, 1693, 2204, 2622],
121300:[1054, 1694, 2206, 2624],
121400:[1055, 1695, 2208, 2626],
121500:[1056, 1696, 2209, 2628],
121600:[1057, 1698, 2211, 2630],
121700:[1057, 1699, 2212, 2632],
121800:[1058, 1700, 2214, 2634],
121900:[1059, 1701, 2216, 2636],
12200:[15, 16, 18, 19],
122000:[1060, 1703, 2217, 2638],
122100:[1061, 1704, 2219, 2640],
122200:[1062, 1706, 2220, 2642],
122300:[1063, 1707, 2222, 2644],
122400:[1063, 1708, 2224, 2646],
122500:[1064, 1709, 2225, 2648],
122600:[1065, 1711, 2227, 2649],
122700:[1066, 1712, 2229, 2651],
122800:[1067, 1713, 2230, 2653],
122900:[1068, 1715, 2232, 2655],
12300:[23, 25, 26, 28],
123000:[1069, 1716, 2234, 2657],
123100:[1070, 1717, 2236, 2659],
123200:[1071, 1719, 2237, 2661],
123300:[1071, 1720, 2239, 2663],
123400:[1072, 1721, 2241, 2665],
123500:[1073, 1723, 2242, 2667],
123600:[1074, 1724, 2244, 2669],
123700:[1075, 1725, 2245, 2671],
123800:[1076, 1726, 2247, 2673],
123900:[1076, 1728, 2249, 2675],
12400:[30, 33, 35, 38],
124000:[1077, 1729, 2250, 2677],
124100:[1078, 1730, 2252, 2679],
124200:[1079, 1732, 2253, 2681],
124300:[1079, 1733, 2255, 2683],
124400:[1080, 1734, 2257, 2685],
124500:[1081, 1736, 2258, 2687],
124600:[1082, 1737, 2260, 2688],
124700:[1083, 1738, 2262, 2690],
124800:[1083, 1740, 2263, 2692],
124900:[1084, 1741, 2265, 2694],
12500:[38, 41, 44, 47],
125000:[1085, 1742, 2267, 2696],
125100:[1086, 1743, 2269, 2698],
125200:[1087, 1744, 2270, 2700],
125300:[1087, 1745, 2272, 2701],
125400:[1088, 1747, 2273, 2703],
125500:[1089, 1748, 2275, 2705],
125600:[1090, 1749, 2276, 2707],
125700:[1090, 1750, 2278, 2708],
125800:[1091, 1751, 2279, 2710],
125900:[1092, 1752, 2281, 2712],
12600:[46, 49, 53, 56],
126000:[1093, 1753, 2282, 2714],
126100:[1094, 1754, 2284, 2716],
126200:[1095, 1756, 2285, 2718],
126300:[1095, 1757, 2287, 2720],
126400:[1096, 1758, 2289, 2722],
126500:[1097, 1759, 2290, 2723],
126600:[1098, 1761, 2292, 2725],
126700:[1099, 1762, 2293, 2727],
126800:[1100, 1763, 2295, 2729],
126900:[1100, 1764, 2297, 2731],
12700:[53, 57, 62, 66],
127000:[1101, 1766, 2298, 2733],
127100:[1102, 1767, 2300, 2735],
127200:[1103, 1768, 2301, 2737],
127300:[1103, 1770, 2303, 2739],
127400:[1104, 1771, 2304, 2741],
127500:[1105, 1772, 2306, 2742],
127600:[1106, 1773, 2308, 2744],
127700:[1107, 1775, 2309, 2746],
127800:[1108, 1776, 2311, 2748],
127900:[1108, 1777, 2312, 2750],
12800:[61, 66, 70, 75],
128000:[1109, 1778, 2314, 2752],
128100:[1110, 1779, 2316, 2754],
128200:[1111, 1781, 2317, 2756],
128300:[1111, 1782, 2319, 2758],
128400:[1112, 1783, 2320, 2759],
128500:[1113, 1784, 2322, 2761],
128600:[1114, 1786, 2324, 2763],
128700:[1115, 1787, 2325, 2765],
128800:[1115, 1788, 2327, 2767],
128900:[1116, 1789, 2328, 2769],
12900:[68, 74, 79, 85],
129000:[1117, 1791, 2330, 2771],
129100:[1118, 1792, 2332, 2773],
129200:[1119, 1794, 2333, 2775],
129300:[1119, 1795, 2335, 2777],
129400:[1120, 1796, 2336, 2779],
129500:[1121, 1798, 2338, 2781],
129600:[1122, 1799, 2339, 2783],
129700:[1123, 1800, 2341, 2785],
129800:[1123, 1801, 2343, 2787],
129900:[1124, 1803, 2344, 2789],
13000:[76, 82, 88, 94],
130000:[1125, 1804, 2346, 2791],
130100:[1126, 1805, 2348, 2793],
130200:[1127, 1806, 2349, 2795],
130300:[1127, 1808, 2351, 2797],
130400:[1128, 1809, 2353, 2799],
130500:[1129, 1810, 2354, 2801],
130600:[1130, 1811, 2356, 2803],
130700:[1131, 1813, 2358, 2805],
130800:[1131, 1814, 2359, 2807],
130900:[1132, 1815, 2361, 2809],
13100:[80, 86, 92, 98],
131000:[1133, 1816, 2363, 2810],
131100:[1134, 1817, 2365, 2812],
131200:[1135, 1819, 2366, 2814],
131300:[1135, 1820, 2368, 2816],
131400:[1136, 1821, 2370, 2818],
131500:[1137, 1822, 2371, 2820],
131600:[1138, 1824, 2373, 2822],
131700:[1139, 1825, 2375, 2824],
131800:[1139, 1826, 2376, 2826],
131900:[1140, 1828, 2378, 2827],
13200:[83, 90, 96, 103],
132000:[1141, 1829, 2379, 2829],
132100:[1142, 1830, 2381, 2831],
132200:[1143, 1831, 2382, 2833],
132300:[1143, 1833, 2384, 2835],
132400:[1144, 1834, 2386, 2837],
132500:[1145, 1835, 2387, 2839],
132600:[1146, 1836, 2389, 2841],
132700:[1146, 1838, 2390, 2842],
132800:[1147, 1839, 2392, 2844],
132900:[1148, 1840, 2394, 2846],
13300:[87, 94, 101, 107],
133000:[1149, 1841, 2395, 2848],
133100:[1150, 1842, 2397, 2850],
133200:[1151, 1844, 2398, 2852],
133300:[1151, 1845, 2400, 2854],
133400:[1152, 1846, 2401, 2856],
133500:[1153, 1847, 2403, 2858],
133600:[1154, 1849, 2405, 2860],
133700:[1154, 1850, 2406, 2861],
133800:[1155, 1851, 2408, 2863],
133900:[1156, 1852, 2409, 2865],
13400:[90, 98, 105, 112],
134000:[1157, 1854, 2411, 2867],
134100:[1158, 1855, 2413, 2869],
134200:[1159, 1856, 2414, 2871],
134300:[1159, 1858, 2416, 2873],
134400:[1160, 1859, 2417, 2875],
134500:[1161, 1860, 2419, 2877],
134600:[1162, 1861, 2421, 2878],
134700:[1162, 1862, 2422, 2880],
134800:[1163, 1864, 2424, 2882],
134900:[1164, 1865, 2425, 2884],
13500:[94, 102, 109, 116],
135000:[1165, 1866, 2427, 2886],
135100:[1166, 1867, 2429, 2888],
135200:[1167, 1869, 2430, 2890],
135300:[1168, 1870, 2432, 2892],
135400:[1168, 1871, 2433, 2894],
135500:[1169, 1872, 2435, 2895],
135600:[1170, 1874, 2436, 2897],
135700:[1171, 1875, 2438, 2899],
135800:[1172, 1876, 2440, 2901],
135900:[1173, 1877, 2441, 2903],
13600:[97, 105, 113, 121],
136000:[1174, 1879, 2443, 2905],
136100:[1175, 1880, 2445, 2907],
136200:[1176, 1882, 2446, 2909],
136300:[1177, 1883, 2448, 2911],
136400:[1177, 1884, 2450, 2913],
136500:[1178, 1885, 2451, 2914],
136600:[1179, 1887, 2453, 2916],
136700:[1180, 1888, 2455, 2918],
136800:[1181, 1889, 2456, 2920],
136900:[1182, 1891, 2458, 2922],
13700:[101, 109, 117, 125],
137000:[1182, 1892, 2460, 2924],
137100:[1183, 1893, 2462, 2926],
137200:[1184, 1894, 2463, 2928],
137300:[1185, 1896, 2465, 2930],
137400:[1185, 1897, 2467, 2931],
137500:[1186, 1898, 2468, 2933],
137600:[1187, 1899, 2470, 2935],
137700:[1188, 1901, 2472, 2937],
137800:[1189, 1902, 2473, 2939],
137900:[1190, 1903, 2475, 2941],
13800:[104, 113, 121, 130],
138000:[1190, 1904, 2476, 2943],
138100:[1191, 1905, 2478, 2945],
138200:[1192, 1907, 2479, 2947],
138300:[1192, 1908, 2481, 2949],
138400:[1193, 1909, 2483, 2950],
138500:[1194, 1910, 2484, 2952],
138600:[1195, 1912, 2486, 2954],
138700:[1196, 1913, 2487, 2956],
138800:[1197, 1914, 2489, 2958],
138900:[1197, 1916, 2491, 2960],
13900:[108, 117, 126, 134],
139000:[1198, 1917, 2492, 2962],
139100:[1199, 1918, 2494, 2964],
139200:[1200, 1919, 2495, 2966],
139300:[1200, 1921, 2497, 2968],
139400:[1201, 1922, 2498, 2970],
139500:[1202, 1923, 2500, 2972],
139600:[1203, 1924, 2502, 2974],
139700:[1204, 1926, 2503, 2976],
139800:[1205, 1927, 2505, 2978],
139900:[1205, 1928, 2506, 2980],
14000:[111, 121, 130, 139],
140000:[1206, 1929, 2508, 2982],
140100:[1207, 1930, 2510, 2984],
140200:[1208, 1932, 2511, 2986],
140300:[1208, 1933, 2513, 2988],
140400:[1209, 1934, 2514, 2989],
140500:[1210, 1935, 2516, 2991],
140600:[1211, 1937, 2518, 2993],
140700:[1212, 1938, 2519, 2995],
140800:[1212, 1939, 2521, 2997],
140900:[1213, 1940, 2522, 2999],
14100:[112, 125, 134, 143],
141000:[1214, 1942, 2524, 3000],
141100:[1215, 1943, 2526, 3002],
141200:[1215, 1944, 2527, 3004],
141300:[1216, 1945, 2529, 3005],
141400:[1217, 1947, 2530, 3007],
141500:[1218, 1948, 2532, 3009],
141600:[1218, 1949, 2533, 3011],
141700:[1219, 1950, 2535, 3013],
141800:[1220, 1951, 2536, 3014],
141900:[1221, 1952, 2538, 3016],
14200:[112, 128, 138, 147],
142000:[1221, 1953, 2539, 3018],
142100:[1222, 1954, 2540, 3020],
142200:[1223, 1955, 2542, 3022],
142300:[1223, 1956, 2543, 3023],
142400:[1224, 1958, 2545, 3025],
142500:[1225, 1959, 2546, 3027],
142600:[1226, 1960, 2548, 3029],
142700:[1226, 1961, 2549, 3030],
142800:[1227, 1962, 2551, 3032],
142900:[1228, 1963, 2552, 3034],
14300:[113, 132, 141, 152],
143000:[1229, 1965, 2554, 3036],
143100:[1230, 1966, 2556, 3038],
143200:[1231, 1967, 2557, 3040],
143300:[1231, 1968, 2559, 3041],
143400:[1232, 1970, 2560, 3043],
143500:[1233, 1971, 2562, 3045],
143600:[1234, 1972, 2563, 3047],
143700:[1235, 1973, 2565, 3048],
143800:[1235, 1974, 2566, 3050],
143900:[1236, 1975, 2568, 3052],
14400:[113, 135, 145, 156],
144000:[1237, 1977, 2570, 3054],
144100:[1238, 1978, 2572, 3056],
144200:[1238, 1979, 2573, 3058],
144300:[1239, 1981, 2575, 3060],
144400:[1240, 1982, 2576, 3061],
144500:[1241, 1983, 2578, 3063],
144600:[1241, 1984, 2579, 3065],
144700:[1242, 1985, 2581, 3067],
144800:[1243, 1986, 2582, 3069],
144900:[1244, 1988, 2584, 3071],
14500:[114, 139, 149, 160],
145000:[1244, 1989, 2585, 3073],
145100:[1245, 1990, 2586, 3075],
145200:[1246, 1991, 2588, 3077],
145300:[1246, 1993, 2589, 3079],
145400:[1247, 1994, 2591, 3080],
145500:[1248, 1995, 2592, 3082],
145600:[1249, 1996, 2594, 3084],
145700:[1249, 1997, 2595, 3086],
145800:[1250, 1998, 2597, 3088],
145900:[1251, 2000, 2598, 3090],
14600:[114, 142, 153, 164],
146000:[1252, 2001, 2600, 3091],
146100:[1253, 2002, 2602, 3093],
146200:[1254, 2003, 2603, 3095],
146300:[1254, 2005, 2605, 3096],
146400:[1255, 2006, 2606, 3098],
146500:[1256, 2007, 2608, 3100],
146600:[1257, 2008, 2609, 3102],
146700:[1258, 2009, 2611, 3104],
146800:[1258, 2010, 2612, 3106],
146900:[1259, 2012, 2614, 3107],
14700:[115, 146, 157, 168],
147000:[1260, 2013, 2616, 3109],
147100:[1261, 2014, 2618, 3111],
147200:[1261, 2015, 2619, 3113],
147300:[1262, 2017, 2621, 3114],
147400:[1263, 2018, 2622, 3116],
147500:[1264, 2019, 2624, 3118],
147600:[1264, 2020, 2625, 3120],
147700:[1265, 2021, 2627, 3122],
147800:[1266, 2023, 2628, 3124],
147900:[1267, 2024, 2630, 3125],
14800:[116, 149, 161, 172],
148000:[1267, 2025, 2631, 3127],
148100:[1268, 2026, 2632, 3129],
148200:[1269, 2027, 2634, 3131],
148300:[1269, 2029, 2635, 3132],
148400:[1270, 2030, 2637, 3134],
148500:[1271, 2031, 2638, 3136],
148600:[1272, 2032, 2640, 3138],
148700:[1272, 2033, 2641, 3140],
148800:[1273, 2035, 2643, 3141],
148900:[1274, 2036, 2644, 3143],
14900:[116, 153, 164, 177],
149000:[1275, 2037, 2646, 3145],
149100:[1276, 2038, 2648, 3147],
149200:[1277, 2039, 2649, 3149],
149300:[1277, 2041, 2651, 3150],
149400:[1278, 2042, 2652, 3152],
149500:[1279, 2043, 2654, 3154],
149600:[1280, 2044, 2655, 3156],
149700:[1281, 2045, 2657, 3158],
149800:[1281, 2047, 2658, 3159],
149900:[1282, 2048, 2660, 3161],
15000:[117, 156, 168, 181],
150000:[1283, 2049, 2662, 3163],
15100:[118, 159, 172, 185],
15200:[118, 163, 175, 189],
15300:[119, 166, 179, 193],
15400:[119, 169, 183, 196],
15500:[120, 173, 186, 200],
15600:[121, 176, 190, 204],
15700:[121, 179, 194, 208],
15800:[122, 183, 197, 212],
15900:[122, 186, 201, 216],
16000:[123, 190, 205, 219],
16100:[124, 193, 209, 223],
16200:[124, 197, 212, 227],
16300:[125, 200, 216, 231],
16400:[125, 204, 220, 235],
16500:[126, 207, 224, 239],
16600:[126, 211, 227, 243],
16700:[127, 214, 231, 247],
16800:[127, 218, 235, 252],
16900:[128, 221, 239, 256],
17000:[128, 225, 242, 260],
17100:[129, 229, 246, 264],
17200:[129, 232, 250, 268],
17300:[130, 236, 253, 272],
17400:[130, 239, 257, 276],
17500:[131, 243, 261, 280],
17600:[131, 246, 265, 284],
17700:[132, 250, 268, 288],
17800:[133, 253, 272, 292],
17900:[133, 257, 276, 296],
18000:[134, 260, 280, 300],
18100:[135, 264, 284, 304],
18200:[135, 268, 288, 309],
18300:[136, 271, 292, 313],
18400:[136, 275, 296, 318],
18500:[137, 279, 301, 322],
18600:[138, 283, 305, 327],
18700:[138, 287, 309, 331],
18800:[139, 291, 313, 335],
18900:[139, 294, 317, 340],
19000:[140, 298, 321, 344],
19100:[141, 300, 324, 347],
19200:[141, 301, 328, 351],
19300:[142, 303, 331, 354],
19400:[142, 305, 334, 358],
19500:[143, 306, 337, 361],
19600:[143, 308, 341, 365],
19700:[144, 310, 344, 368],
19800:[144, 311, 347, 372],
19900:[145, 313, 350, 375],
20000:[145, 315, 354, 379],
20100:[146, 315, 357, 382],
20200:[146, 316, 361, 386],
20300:[147, 316, 364, 389],
20400:[147, 317, 367, 393],
20500:[148, 317, 370, 396],
20600:[148, 318, 374, 400],
20700:[149, 318, 377, 403],
20800:[150, 319, 380, 407],
20900:[150, 319, 384, 410],
21000:[151, 320, 387, 414],
21100:[152, 320, 390, 417],
21200:[152, 321, 393, 421],
21300:[153, 321, 397, 424],
21400:[153, 322, 400, 428],
21500:[154, 322, 403, 431],
21600:[155, 323, 406, 435],
21700:[155, 323, 410, 438],
21800:[156, 324, 413, 442],
21900:[157, 324, 416, 445],
22000:[157, 325, 419, 449],
22100:[158, 325, 422, 453],
22200:[158, 326, 425, 456],
22300:[159, 326, 429, 460],
22400:[159, 327, 432, 463],
22500:[160, 327, 435, 467],
22600:[160, 328, 438, 470],
22700:[161, 328, 441, 474],
22800:[161, 329, 445, 477],
22900:[162, 329, 448, 481],
23000:[162, 330, 451, 484],
23100:[163, 331, 453, 488],
23200:[163, 332, 455, 491],
23300:[164, 332, 457, 495],
23400:[164, 333, 460, 499],
23500:[165, 334, 462, 503],
23600:[165, 335, 464, 506],
23700:[166, 336, 466, 510],
23800:[167, 336, 468, 514],
23900:[167, 337, 470, 518],
24000:[168, 338, 473, 521],
24100:[169, 339, 475, 525],
24200:[170, 341, 477, 530],
24300:[170, 342, 479, 534],
24400:[171, 343, 480, 539],
24500:[172, 345, 482, 543],
24600:[173, 346, 484, 548],
24700:[174, 347, 486, 552],
24800:[174, 349, 488, 557],
24900:[175, 350, 490, 561],
25000:[176, 351, 492, 566],
25100:[177, 352, 494, 570],
25200:[178, 354, 496, 575],
25300:[179, 355, 498, 579],
25400:[180, 357, 500, 584],
25500:[181, 358, 502, 588],
25600:[182, 360, 504, 593],
25700:[183, 361, 506, 597],
25800:[183, 363, 508, 602],
25900:[184, 364, 510, 606],
26000:[185, 366, 511, 611],
26100:[186, 368, 513, 615],
26200:[187, 370, 515, 620],
26300:[189, 371, 518, 624],
26400:[190, 373, 520, 629],
26500:[191, 375, 522, 633],
26600:[192, 377, 524, 638],
26700:[194, 379, 527, 642],
26800:[195, 380, 529, 646],
26900:[196, 382, 531, 651],
27000:[197, 384, 533, 655],
27100:[198, 386, 535, 658],
27200:[200, 387, 537, 660],
27300:[201, 389, 540, 663],
27400:[202, 391, 542, 665],
27500:[203, 393, 544, 668],
27600:[205, 394, 546, 670],
27700:[206, 396, 549, 673],
27800:[207, 398, 551, 675],
27900:[208, 400, 553, 678],
28000:[210, 401, 555, 680],
28100:[211, 403, 557, 682],
28200:[212, 404, 559, 685],
28300:[213, 406, 561, 687],
28400:[214, 407, 563, 690],
28500:[215, 409, 565, 692],
28600:[216, 410, 567, 694],
28700:[217, 412, 569, 697],
28800:[218, 414, 571, 699],
28900:[219, 415, 573, 702],
29000:[220, 417, 575, 704],
29100:[221, 418, 577, 706],
29200:[221, 420, 578, 708],
29300:[222, 421, 580, 710],
29400:[223, 422, 582, 713],
29500:[223, 423, 584, 715],
29600:[224, 425, 585, 717],
29700:[225, 426, 587, 719],
29800:[226, 427, 589, 721],
29900:[226, 429, 591, 723],
30000:[227, 430, 592, 725],
30100:[228, 431, 594, 727],
30200:[229, 433, 596, 729],
30300:[229, 434, 597, 732],
30400:[230, 435, 599, 734],
30500:[231, 436, 601, 736],
30600:[232, 438, 603, 738],
30700:[232, 439, 604, 740],
30800:[233, 440, 606, 742],
30900:[234, 441, 608, 745],
31000:[235, 443, 610, 747],
31100:[236, 444, 612, 749],
31200:[236, 446, 614, 751],
31300:[237, 447, 615, 753],
31400:[238, 448, 617, 755],
31500:[239, 449, 619, 758],
31600:[239, 451, 621, 760],
31700:[240, 452, 622, 762],
31800:[241, 453, 624, 764],
31900:[242, 454, 626, 766],
32000:[242, 456, 628, 768],
32100:[243, 458, 630, 771],
32200:[245, 460, 633, 773],
32300:[246, 462, 635, 776],
32400:[248, 464, 637, 779],
32500:[249, 466, 639, 781],
32600:[250, 468, 642, 784],
32700:[252, 470, 644, 787],
32800:[253, 472, 646, 789],
32900:[255, 474, 649, 792],
33000:[256, 476, 651, 795],
33100:[258, 478, 653, 798],
33200:[259, 480, 656, 800],
33300:[261, 482, 658, 803],
33400:[262, 484, 661, 806],
33500:[264, 486, 663, 809],
33600:[265, 488, 665, 811],
33700:[267, 490, 668, 814],
33800:[268, 492, 670, 817],
33900:[270, 494, 672, 819],
34000:[271, 496, 675, 822],
34100:[273, 498, 677, 825],
34200:[274, 500, 680, 828],
34300:[276, 502, 682, 830],
34400:[277, 504, 685, 833],
34500:[279, 506, 687, 836],
34600:[280, 508, 690, 839],
34700:[282, 510, 692, 841],
34800:[283, 512, 695, 844],
34900:[285, 514, 697, 847],
35000:[287, 516, 700, 850],
35100:[289, 518, 702, 853],
35200:[290, 520, 704, 855],
35300:[292, 522, 707, 858],
35400:[293, 523, 709, 860],
35500:[295, 525, 711, 863],
35600:[296, 527, 713, 865],
35700:[298, 529, 716, 868],
35800:[299, 531, 718, 870],
35900:[301, 533, 720, 873],
36000:[302, 535, 722, 875],
36100:[303, 537, 724, 877],
36200:[305, 539, 726, 880],
36300:[306, 541, 728, 882],
36400:[308, 542, 731, 885],
36500:[309, 544, 733, 887],
36600:[311, 546, 735, 890],
36700:[312, 548, 737, 892],
36800:[314, 550, 739, 895],
36900:[315, 552, 741, 897],
37000:[316, 554, 744, 900],
37100:[317, 556, 746, 902],
37200:[319, 558, 748, 905],
37300:[320, 560, 750, 907],
37400:[322, 561, 752, 910],
37500:[323, 563, 755, 912],
37600:[325, 565, 757, 915],
37700:[326, 567, 759, 917],
37800:[327, 569, 761, 920],
37900:[329, 571, 763, 922],
38000:[330, 572, 765, 924],
38100:[331, 574, 767, 926],
38200:[333, 576, 769, 929],
38300:[334, 577, 771, 931],
38400:[336, 579, 774, 934],
38500:[337, 581, 776, 936],
38600:[339, 583, 778, 939],
38700:[340, 585, 780, 941],
38800:[341, 587, 782, 943],
38900:[343, 588, 784, 946],
39000:[344, 590, 787, 948],
39100:[345, 592, 789, 950],
39200:[346, 593, 791, 952],
39300:[347, 595, 793, 955],
39400:[348, 596, 795, 957],
39500:[350, 598, 797, 959],
39600:[351, 599, 799, 961],
39700:[352, 601, 800, 963],
39800:[353, 602, 802, 966],
39900:[354, 604, 804, 968],
40000:[355, 605, 806, 970],
40100:[356, 606, 808, 972],
40200:[357, 608, 809, 974],
40300:[357, 609, 811, 976],
40400:[358, 610, 813, 978],
40500:[359, 612, 815, 980],
40600:[360, 613, 816, 982],
40700:[361, 615, 818, 984],
40800:[362, 616, 820, 986],
40900:[362, 617, 822, 988],
41000:[363, 619, 823, 990],
41100:[364, 620, 825, 992],
41200:[365, 622, 826, 994],
41300:[366, 623, 828, 996],
41400:[366, 624, 830, 998],
41500:[367, 626, 832, 1000],
41600:[368, 627, 833, 1002],
41700:[369, 628, 835, 1004],
41800:[370, 630, 837, 1006],
41900:[371, 631, 838, 1008],
42000:[372, 632, 840, 1010],
42100:[373, 633, 842, 1012],
42200:[374, 635, 843, 1014],
42300:[374, 636, 845, 1016],
42400:[375, 637, 847, 1018],
42500:[376, 639, 849, 1020],
42600:[377, 640, 850, 1022],
42700:[378, 641, 852, 1024],
42800:[379, 643, 854, 1026],
42900:[379, 644, 855, 1028],
43000:[380, 645, 857, 1030],
43100:[381, 646, 859, 1032],
43200:[382, 648, 860, 1034],
43300:[383, 649, 862, 1036],
43400:[383, 650, 864, 1038],
43500:[384, 651, 866, 1040],
43600:[385, 653, 867, 1042],
43700:[386, 654, 869, 1044],
43800:[387, 655, 871, 1046],
43900:[388, 657, 872, 1048],
44000:[389, 658, 874, 1050],
44100:[390, 659, 876, 1052],
44200:[391, 661, 878, 1054],
44300:[392, 662, 879, 1056],
44400:[393, 663, 881, 1059],
44500:[394, 665, 883, 1061],
44600:[394, 666, 885, 1063],
44700:[395, 668, 887, 1065],
44800:[396, 669, 888, 1067],
44900:[397, 670, 890, 1069],
45000:[398, 672, 892, 1072],
45100:[399, 673, 894, 1074],
45200:[400, 675, 895, 1076],
45300:[401, 676, 897, 1078],
45400:[402, 677, 899, 1080],
45500:[403, 679, 900, 1082],
45600:[403, 680, 902, 1084],
45700:[404, 681, 904, 1086],
45800:[405, 683, 905, 1088],
45900:[406, 684, 907, 1090],
46000:[407, 686, 909, 1092],
46100:[408, 687, 911, 1094],
46200:[409, 689, 912, 1096],
46300:[410, 690, 914, 1098],
46400:[410, 691, 916, 1100],
46500:[411, 693, 917, 1102],
46600:[412, 694, 919, 1104],
46700:[413, 695, 921, 1106],
46800:[414, 696, 922, 1108],
46900:[415, 698, 924, 1110],
47000:[415, 699, 926, 1112],
47100:[416, 700, 928, 1114],
47200:[417, 702, 929, 1116],
47300:[417, 703, 931, 1118],
47400:[418, 704, 933, 1120],
47500:[419, 705, 934, 1122],
47600:[420, 707, 936, 1124],
47700:[421, 708, 938, 1126],
47800:[421, 709, 939, 1128],
47900:[422, 711, 941, 1130],
48000:[423, 712, 943, 1132],
48100:[424, 713, 945, 1134],
48200:[425, 715, 946, 1136],
48300:[426, 716, 948, 1138],
48400:[426, 717, 950, 1140],
48500:[427, 718, 951, 1142],
48600:[428, 720, 953, 1144],
48700:[429, 721, 955, 1146],
48800:[430, 722, 956, 1148],
48900:[431, 724, 958, 1150],
49000:[432, 725, 960, 1152],
49100:[433, 726, 962, 1154],
49200:[434, 728, 963, 1156],
49300:[434, 729, 965, 1158],
49400:[435, 730, 967, 1160],
49500:[436, 731, 968, 1162],
49600:[437, 733, 970, 1164],
49700:[438, 734, 972, 1166],
49800:[438, 735, 974, 1168],
49900:[439, 736, 975, 1170],
50000:[440, 738, 977, 1172],
50100:[441, 739, 979, 1174],
50200:[442, 741, 980, 1176],
50300:[442, 742, 982, 1177],
50400:[443, 743, 983, 1179],
50500:[444, 744, 985, 1181],
50600:[445, 746, 987, 1183],
50700:[445, 747, 988, 1185],
50800:[446, 748, 990, 1186],
50900:[447, 749, 991, 1188],
51000:[448, 751, 993, 1190],
51100:[449, 752, 995, 1192],
51200:[450, 754, 996, 1194],
51300:[451, 755, 998, 1196],
51400:[452, 756, 1000, 1198],
51500:[452, 758, 1002, 1200],
51600:[453, 759, 1003, 1202],
51700:[454, 760, 1005, 1204],
51800:[455, 762, 1007, 1206],
51900:[456, 763, 1009, 1208],
52000:[457, 764, 1010, 1211],
52100:[458, 765, 1012, 1213],
52200:[459, 767, 1013, 1215],
52300:[459, 768, 1015, 1217],
52400:[460, 769, 1017, 1219],
52500:[461, 770, 1019, 1221],
52600:[462, 772, 1020, 1223],
52700:[463, 773, 1022, 1225],
52800:[464, 774, 1024, 1227],
52900:[464, 776, 1025, 1229],
53000:[465, 777, 1027, 1231],
53100:[466, 778, 1029, 1233],
53200:[467, 780, 1030, 1235],
53300:[468, 781, 1032, 1237],
53400:[468, 782, 1034, 1239],
53500:[469, 784, 1035, 1241],
53600:[470, 785, 1037, 1243],
53700:[471, 786, 1039, 1245],
53800:[472, 788, 1041, 1248],
53900:[473, 789, 1042, 1250],
54000:[474, 791, 1044, 1252],
54100:[475, 792, 1046, 1254],
54200:[476, 794, 1048, 1256],
54300:[477, 795, 1049, 1258],
54400:[478, 796, 1051, 1260],
54500:[478, 798, 1053, 1262],
54600:[479, 799, 1055, 1264],
54700:[480, 800, 1056, 1266],
54800:[481, 801, 1058, 1268],
54900:[482, 803, 1060, 1270],
55000:[483, 804, 1062, 1272],
55100:[484, 805, 1064, 1274],
55200:[485, 807, 1065, 1276],
55300:[485, 808, 1067, 1278],
55400:[486, 809, 1069, 1280],
55500:[487, 811, 1071, 1282],
55600:[488, 812, 1072, 1284],
55700:[489, 814, 1074, 1286],
55800:[490, 815, 1076, 1288],
55900:[490, 816, 1078, 1290],
56000:[491, 818, 1079, 1292],
56100:[492, 819, 1081, 1294],
56200:[493, 821, 1083, 1296],
56300:[494, 822, 1084, 1299],
56400:[495, 824, 1086, 1301],
56500:[495, 825, 1088, 1303],
56600:[496, 827, 1090, 1305],
56700:[497, 828, 1092, 1307],
56800:[498, 830, 1094, 1309],
56900:[499, 831, 1095, 1312],
57000:[500, 832, 1097, 1314],
57100:[501, 833, 1099, 1316],
57200:[502, 835, 1101, 1318],
57300:[503, 836, 1102, 1321],
57400:[504, 838, 1104, 1323],
57500:[505, 839, 1106, 1325],
57600:[506, 840, 1108, 1327],
57700:[507, 842, 1110, 1329],
57800:[508, 843, 1111, 1332],
57900:[509, 845, 1113, 1334],
58000:[510, 846, 1115, 1336],
58100:[511, 847, 1117, 1338],
58200:[512, 849, 1119, 1340],
58300:[513, 850, 1121, 1342],
58400:[514, 852, 1122, 1345],
58500:[515, 853, 1124, 1347],
58600:[516, 854, 1126, 1349],
58700:[517, 856, 1128, 1351],
58800:[518, 857, 1130, 1353],
58900:[519, 859, 1132, 1355],
59000:[519, 860, 1134, 1357],
59100:[520, 861, 1136, 1359],
59200:[521, 863, 1138, 1361],
59300:[522, 864, 1139, 1364],
59400:[523, 866, 1141, 1366],
59500:[524, 867, 1143, 1368],
59600:[525, 869, 1145, 1370],
59700:[526, 870, 1147, 1372],
59800:[526, 872, 1149, 1374],
59900:[527, 873, 1150, 1377],
60000:[528, 875, 1152, 1379],
60100:[529, 876, 1154, 1381],
60200:[530, 878, 1155, 1383],
60300:[530, 879, 1157, 1385],
60400:[531, 880, 1159, 1387],
60500:[532, 882, 1160, 1389],
60600:[533, 883, 1162, 1391],
60700:[534, 884, 1164, 1393],
60800:[535, 886, 1166, 1395],
60900:[535, 887, 1167, 1397],
61000:[536, 888, 1169, 1399],
61100:[537, 889, 1171, 1401],
61200:[538, 891, 1173, 1403],
61300:[539, 892, 1174, 1406],
61400:[540, 894, 1176, 1408],
61500:[541, 895, 1178, 1410],
61600:[542, 897, 1180, 1412],
61700:[543, 898, 1182, 1414],
61800:[544, 899, 1183, 1417],
61900:[545, 901, 1185, 1419],
62000:[546, 902, 1187, 1421],
62100:[547, 903, 1189, 1423],
62200:[548, 905, 1191, 1425],
62300:[549, 906, 1193, 1427],
62400:[550, 908, 1194, 1430],
62500:[551, 909, 1196, 1432],
62600:[552, 910, 1198, 1434],
62700:[553, 912, 1200, 1436],
62800:[554, 913, 1202, 1438],
62900:[555, 915, 1204, 1440],
63000:[555, 916, 1206, 1442],
63100:[556, 917, 1208, 1444],
63200:[557, 919, 1210, 1446],
63300:[558, 920, 1212, 1448],
63400:[559, 922, 1213, 1451],
63500:[560, 923, 1215, 1453],
63600:[561, 925, 1217, 1455],
63700:[562, 926, 1219, 1457],
63800:[562, 928, 1221, 1459],
63900:[563, 929, 1223, 1461],
64000:[564, 931, 1224, 1464],
64100:[565, 932, 1226, 1466],
64200:[566, 934, 1228, 1468],
64300:[567, 935, 1229, 1471],
64400:[568, 937, 1231, 1473],
64500:[569, 938, 1233, 1475],
64600:[569, 940, 1235, 1477],
64700:[570, 941, 1237, 1479],
64800:[571, 943, 1238, 1482],
64900:[572, 944, 1240, 1484],
65000:[573, 945, 1242, 1486],
65100:[574, 946, 1244, 1488],
65200:[575, 948, 1245, 1490],
65300:[575, 949, 1247, 1492],
65400:[576, 950, 1249, 1494],
65500:[577, 952, 1250, 1496],
65600:[578, 953, 1252, 1498],
65700:[579, 954, 1254, 1500],
65800:[579, 956, 1255, 1502],
65900:[580, 957, 1257, 1504],
66000:[581, 958, 1259, 1506],
66100:[582, 959, 1261, 1508],
66200:[583, 961, 1263, 1510],
66300:[584, 962, 1265, 1512],
66400:[585, 964, 1267, 1515],
66500:[586, 965, 1268, 1517],
66600:[587, 966, 1270, 1519],
66700:[588, 968, 1272, 1521],
66800:[589, 969, 1274, 1523],
66900:[590, 971, 1276, 1525],
67000:[591, 972, 1278, 1527],
67100:[592, 973, 1280, 1529],
67200:[593, 975, 1282, 1531],
67300:[594, 976, 1284, 1533],
67400:[595, 978, 1285, 1536],
67500:[596, 979, 1287, 1538],
67600:[597, 981, 1289, 1540],
67700:[598, 982, 1291, 1542],
67800:[598, 984, 1293, 1544],
67900:[599, 985, 1295, 1546],
68000:[600, 987, 1296, 1549],
68100:[601, 988, 1298, 1551],
68200:[602, 990, 1300, 1553],
68300:[603, 991, 1301, 1556],
68400:[604, 993, 1303, 1558],
68500:[605, 994, 1305, 1560],
68600:[606, 996, 1307, 1562],
68700:[606, 997, 1309, 1564],
68800:[607, 999, 1310, 1567],
68900:[608, 1000, 1312, 1569],
69000:[609, 1001, 1314, 1571],
69100:[610, 1002, 1316, 1573],
69200:[611, 1004, 1318, 1575],
69300:[612, 1005, 1320, 1577],
69400:[613, 1007, 1322, 1580],
69500:[614, 1008, 1323, 1582],
69600:[614, 1010, 1325, 1584],
69700:[615, 1011, 1327, 1586],
69800:[616, 1012, 1329, 1588],
69900:[617, 1014, 1331, 1590],
70000:[618, 1015, 1333, 1592],
70100:[619, 1016, 1335, 1594],
70200:[620, 1018, 1336, 1596],
70300:[621, 1019, 1338, 1598],
70400:[622, 1020, 1340, 1600],
70500:[622, 1021, 1341, 1602],
70600:[623, 1023, 1343, 1604],
70700:[624, 1024, 1345, 1606],
70800:[625, 1025, 1346, 1608],
70900:[626, 1027, 1348, 1610],
71000:[627, 1028, 1349, 1612],
71100:[628, 1029, 1351, 1614],
71200:[629, 1031, 1353, 1616],
71300:[630, 1032, 1354, 1618],
71400:[631, 1034, 1356, 1620],
71500:[632, 1035, 1358, 1622],
71600:[633, 1036, 1360, 1625],
71700:[634, 1038, 1361, 1627],
71800:[635, 1039, 1363, 1629],
71900:[636, 1041, 1365, 1631],
72000:[636, 1042, 1367, 1633],
72100:[637, 1043, 1369, 1635],
72200:[638, 1045, 1371, 1637],
72300:[639, 1046, 1372, 1639],
72400:[640, 1048, 1374, 1642],
72500:[641, 1049, 1376, 1644],
72600:[642, 1050, 1378, 1646],
72700:[643, 1052, 1379, 1648],
72800:[644, 1053, 1381, 1650],
72900:[645, 1055, 1383, 1652],
73000:[645, 1056, 1385, 1655],
73100:[646, 1057, 1387, 1657],
73200:[647, 1059, 1389, 1659],
73300:[648, 1060, 1390, 1661],
73400:[649, 1062, 1392, 1663],
73500:[650, 1063, 1394, 1666],
73600:[651, 1064, 1396, 1668],
73700:[652, 1066, 1397, 1670],
73800:[653, 1067, 1399, 1672],
73900:[654, 1068, 1401, 1674],
74000:[654, 1070, 1403, 1676],
74100:[655, 1071, 1405, 1678],
74200:[656, 1073, 1407, 1680],
74300:[657, 1074, 1408, 1682],
74400:[658, 1076, 1410, 1684],
74500:[659, 1077, 1412, 1686],
74600:[660, 1078, 1414, 1689],
74700:[661, 1080, 1415, 1691],
74800:[662, 1081, 1417, 1693],
74900:[662, 1082, 1419, 1695],
75000:[663, 1084, 1421, 1697],
75100:[664, 1085, 1423, 1699],
75200:[665, 1087, 1424, 1701],
75300:[666, 1088, 1426, 1703],
75400:[666, 1089, 1428, 1705],
75500:[667, 1090, 1429, 1707],
75600:[668, 1092, 1431, 1709],
75700:[669, 1093, 1433, 1711],
75800:[670, 1094, 1434, 1713],
75900:[671, 1096, 1436, 1715],
76000:[671, 1097, 1438, 1717],
76100:[672, 1098, 1440, 1719],
76200:[673, 1100, 1442, 1721],
76300:[674, 1101, 1443, 1723],
76400:[675, 1103, 1445, 1725],
76500:[676, 1104, 1447, 1727],
76600:[676, 1105, 1449, 1730],
76700:[677, 1107, 1451, 1732],
76800:[678, 1108, 1452, 1734],
76900:[679, 1109, 1454, 1736],
77000:[680, 1111, 1456, 1738],
77100:[681, 1112, 1458, 1740],
77200:[682, 1114, 1460, 1742],
77300:[683, 1115, 1461, 1744],
77400:[684, 1117, 1463, 1747],
77500:[685, 1118, 1465, 1749],
77600:[685, 1119, 1467, 1751],
77700:[686, 1121, 1468, 1753],
77800:[687, 1122, 1470, 1755],
77900:[688, 1123, 1472, 1757],
78000:[689, 1125, 1474, 1760],
78100:[690, 1126, 1476, 1762],
78200:[691, 1128, 1478, 1764],
78300:[692, 1129, 1479, 1766],
78400:[693, 1131, 1481, 1769],
78500:[694, 1132, 1483, 1771],
78600:[694, 1133, 1485, 1773],
78700:[695, 1135, 1486, 1775],
78800:[696, 1136, 1488, 1777],
78900:[697, 1137, 1490, 1779],
79000:[698, 1139, 1492, 1781],
79100:[699, 1140, 1494, 1783],
79200:[700, 1142, 1496, 1785],
79300:[701, 1143, 1497, 1787],
79400:[702, 1145, 1499, 1789],
79500:[703, 1146, 1501, 1791],
79600:[703, 1147, 1503, 1794],
79700:[704, 1149, 1504, 1796],
79800:[705, 1150, 1506, 1798],
79900:[706, 1151, 1508, 1800],
80000:[707, 1153, 1510, 1802],
80100:[708, 1154, 1512, 1804],
80200:[709, 1156, 1513, 1806],
80300:[709, 1157, 1515, 1808],
80400:[710, 1158, 1517, 1810],
80500:[711, 1159, 1518, 1812],
80600:[712, 1161, 1520, 1814],
80700:[713, 1162, 1522, 1816],
80800:[713, 1163, 1523, 1818],
80900:[714, 1164, 1525, 1820],
81000:[715, 1166, 1527, 1822],
81100:[716, 1167, 1529, 1824],
81200:[717, 1169, 1531, 1826],
81300:[718, 1170, 1532, 1828],
81400:[718, 1172, 1534, 1830],
81500:[719, 1173, 1536, 1832],
81600:[720, 1174, 1538, 1835],
81700:[721, 1176, 1540, 1837],
81800:[722, 1177, 1541, 1839],
81900:[723, 1178, 1543, 1841],
82000:[724, 1180, 1545, 1843],
82100:[725, 1181, 1547, 1845],
82200:[726, 1183, 1549, 1847],
82300:[727, 1184, 1550, 1849],
82400:[727, 1185, 1552, 1852],
82500:[728, 1187, 1554, 1854],
82600:[729, 1188, 1556, 1856],
82700:[730, 1190, 1558, 1858],
82800:[731, 1191, 1559, 1860],
82900:[732, 1192, 1561, 1862],
83000:[733, 1194, 1563, 1865],
83100:[734, 1195, 1565, 1867],
83200:[735, 1197, 1567, 1869],
83300:[736, 1198, 1568, 1871],
83400:[736, 1199, 1570, 1874],
83500:[737, 1201, 1572, 1876],
83600:[738, 1202, 1574, 1878],
83700:[739, 1204, 1576, 1880],
83800:[740, 1205, 1577, 1882],
83900:[741, 1206, 1579, 1884],
84000:[742, 1208, 1581, 1886],
84100:[743, 1209, 1583, 1888],
84200:[744, 1211, 1585, 1890],
84300:[745, 1212, 1586, 1892],
84400:[745, 1213, 1588, 1894],
84500:[746, 1215, 1590, 1896],
84600:[747, 1216, 1592, 1899],
84700:[748, 1218, 1594, 1901],
84800:[749, 1219, 1595, 1903],
84900:[750, 1220, 1597, 1905],
85000:[751, 1222, 1599, 1907],
85100:[752, 1223, 1601, 1909],
85200:[753, 1225, 1603, 1911],
85300:[754, 1226, 1604, 1913],
85400:[754, 1227, 1606, 1916],
85500:[755, 1229, 1608, 1918],
85600:[756, 1230, 1610, 1920],
85700:[757, 1232, 1612, 1922],
85800:[758, 1233, 1613, 1924],
85900:[759, 1234, 1615, 1926],
86000:[760, 1236, 1617, 1929],
86100:[761, 1237, 1619, 1931],
86200:[762, 1239, 1621, 1933],
86300:[763, 1240, 1622, 1935],
86400:[763, 1241, 1624, 1938],
86500:[764, 1243, 1626, 1940],
86600:[765, 1244, 1628, 1942],
86700:[766, 1246, 1629, 1944],
86800:[767, 1247, 1631, 1946],
86900:[768, 1248, 1633, 1948],
87000:[769, 1250, 1635, 1950],
87100:[770, 1251, 1637, 1952],
87200:[771, 1253, 1639, 1954],
87300:[772, 1254, 1640, 1956],
87400:[772, 1255, 1642, 1958],
87500:[773, 1257, 1644, 1960],
87600:[774, 1258, 1646, 1963],
87700:[775, 1260, 1647, 1965],
87800:[776, 1261, 1649, 1967],
87900:[777, 1262, 1651, 1969],
88000:[778, 1264, 1653, 1971],
88100:[779, 1265, 1655, 1973],
88200:[780, 1267, 1657, 1975],
88300:[781, 1268, 1658, 1978],
88400:[781, 1269, 1660, 1980],
88500:[782, 1271, 1662, 1982],
88600:[783, 1272, 1664, 1984],
88700:[784, 1273, 1665, 1986],
88800:[785, 1275, 1667, 1988],
88900:[786, 1276, 1669, 1991],
89000:[787, 1278, 1671, 1993],
89100:[788, 1279, 1673, 1995],
89200:[789, 1281, 1675, 1997],
89300:[790, 1282, 1676, 1999],
89400:[791, 1284, 1678, 2002],
89500:[792, 1285, 1680, 2004],
89600:[793, 1287, 1682, 2006],
89700:[794, 1288, 1683, 2008],
89800:[795, 1290, 1685, 2010],
89900:[796, 1291, 1687, 2012],
90000:[797, 1293, 1689, 2014],
90100:[798, 1294, 1691, 2016],
90200:[799, 1296, 1693, 2018],
90300:[800, 1297, 1694, 2020],
90400:[800, 1298, 1696, 2022],
90500:[801, 1300, 1698, 2024],
90600:[802, 1301, 1700, 2026],
90700:[803, 1302, 1701, 2028],
90800:[804, 1304, 1703, 2030],
90900:[805, 1305, 1705, 2032],
91000:[805, 1306, 1707, 2034],
91100:[806, 1307, 1709, 2036],
91200:[807, 1309, 1710, 2038],
91300:[807, 1310, 1712, 2040],
91400:[808, 1311, 1714, 2042],
91500:[809, 1312, 1715, 2044],
91600:[810, 1314, 1717, 2046],
91700:[810, 1315, 1718, 2048],
91800:[811, 1316, 1720, 2050],
91900:[812, 1318, 1722, 2052],
92000:[813, 1319, 1723, 2054],
92100:[814, 1320, 1725, 2056],
92200:[815, 1322, 1726, 2058],
92300:[816, 1323, 1728, 2060],
92400:[816, 1324, 1730, 2062],
92500:[817, 1326, 1731, 2064],
92600:[818, 1327, 1733, 2066],
92700:[819, 1328, 1735, 2068],
92800:[820, 1330, 1736, 2070],
92900:[821, 1331, 1738, 2072],
93000:[822, 1332, 1740, 2074],
93100:[823, 1333, 1742, 2076],
93200:[824, 1335, 1743, 2078],
93300:[824, 1336, 1745, 2080],
93400:[825, 1337, 1747, 2082],
93500:[826, 1339, 1748, 2084],
93600:[827, 1340, 1750, 2086],
93700:[828, 1341, 1751, 2088],
93800:[829, 1343, 1753, 2090],
93900:[829, 1344, 1755, 2092],
94000:[830, 1345, 1756, 2093],
94100:[831, 1346, 1758, 2095],
94200:[832, 1347, 1759, 2097],
94300:[832, 1349, 1761, 2099],
94400:[833, 1350, 1763, 2101],
94500:[834, 1351, 1764, 2103],
94600:[835, 1352, 1766, 2105],
94700:[836, 1354, 1768, 2107],
94800:[836, 1355, 1769, 2109],
94900:[837, 1356, 1771, 2111],
95000:[838, 1357, 1773, 2113],
95100:[839, 1358, 1775, 2115],
95200:[840, 1360, 1776, 2117],
95300:[840, 1361, 1778, 2119],
95400:[841, 1362, 1780, 2121],
95500:[842, 1363, 1781, 2123],
95600:[843, 1365, 1783, 2125],
95700:[843, 1366, 1784, 2127],
95800:[844, 1367, 1786, 2129],
95900:[845, 1368, 1788, 2130],
96000:[846, 1370, 1789, 2132],
96100:[847, 1371, 1791, 2134],
96200:[848, 1373, 1792, 2136],
96300:[849, 1374, 1794, 2138],
96400:[849, 1375, 1796, 2140],
96500:[850, 1376, 1797, 2142],
96600:[851, 1378, 1799, 2144],
96700:[852, 1379, 1801, 2146],
96800:[853, 1380, 1802, 2148],
96900:[854, 1381, 1804, 2150],
97000:[855, 1383, 1806, 2152],
97100:[856, 1384, 1808, 2154],
97200:[857, 1386, 1809, 2156],
97300:[857, 1387, 1811, 2158],
97400:[858, 1388, 1812, 2160],
97500:[859, 1389, 1814, 2162],
97600:[860, 1391, 1816, 2164],
97700:[861, 1392, 1817, 2166],
97800:[862, 1393, 1819, 2168],
97900:[862, 1395, 1821, 2169],
98000:[863, 1396, 1822, 2171],
98100:[864, 1397, 1824, 2173],
98200:[865, 1399, 1825, 2175],
98300:[865, 1400, 1827, 2177],
98400:[866, 1401, 1829, 2179],
98500:[867, 1403, 1830, 2181],
98600:[868, 1404, 1832, 2183],
98700:[869, 1405, 1834, 2185],
98800:[869, 1406, 1835, 2187],
98900:[870, 1408, 1837, 2189],
99000:[871, 1409, 1839, 2191],
99100:[872, 1410, 1841, 2193],
99200:[873, 1412, 1842, 2195],
99300:[874, 1413, 1844, 2197],
99400:[874, 1414, 1845, 2199],
99500:[875, 1416, 1847, 2201],
99600:[876, 1417, 1849, 2203],
99700:[877, 1418, 1850, 2205],
99800:[878, 1420, 1852, 2207],
99900:[879, 1421, 1854, 2208],
};
const OR17_NL=[0.8, 1.2, 1.56, 1.8];

// Nova Scotia — 2017 Federal Child Support Guidelines Table
const T17_NS={
100000:[853, 1383, 1808, 2156],
100100:[854, 1384, 1810, 2158],
100200:[855, 1386, 1811, 2160],
100300:[856, 1387, 1813, 2162],
100400:[856, 1388, 1814, 2163],
100500:[857, 1389, 1816, 2165],
100600:[858, 1391, 1818, 2167],
100700:[859, 1392, 1819, 2169],
100800:[860, 1393, 1821, 2171],
100900:[861, 1394, 1822, 2173],
101000:[861, 1396, 1824, 2174],
101100:[862, 1397, 1826, 2176],
101200:[862, 1398, 1827, 2178],
101300:[863, 1400, 1829, 2180],
101400:[864, 1401, 1830, 2182],
101500:[865, 1402, 1832, 2183],
101600:[865, 1403, 1833, 2185],
101700:[866, 1405, 1835, 2187],
101800:[867, 1406, 1836, 2189],
101900:[868, 1407, 1838, 2191],
102000:[868, 1408, 1839, 2193],
102100:[869, 1409, 1841, 2195],
102200:[870, 1410, 1842, 2197],
102300:[870, 1412, 1844, 2199],
102400:[871, 1413, 1845, 2200],
102500:[872, 1414, 1847, 2202],
102600:[873, 1415, 1848, 2204],
102700:[873, 1416, 1850, 2206],
102800:[874, 1418, 1851, 2208],
102900:[875, 1419, 1853, 2210],
103000:[876, 1420, 1855, 2211],
103100:[877, 1421, 1857, 2213],
103200:[878, 1422, 1858, 2215],
103300:[878, 1424, 1860, 2217],
103400:[879, 1425, 1861, 2219],
103500:[880, 1426, 1863, 2220],
103600:[881, 1427, 1864, 2222],
103700:[881, 1428, 1866, 2224],
103800:[882, 1430, 1868, 2226],
103900:[883, 1431, 1869, 2228],
104000:[884, 1432, 1871, 2230],
104100:[885, 1433, 1873, 2232],
104200:[886, 1434, 1874, 2234],
104300:[886, 1436, 1876, 2235],
104400:[887, 1437, 1877, 2237],
104500:[888, 1438, 1879, 2239],
104600:[889, 1439, 1881, 2241],
104700:[890, 1440, 1882, 2243],
104800:[890, 1441, 1884, 2245],
104900:[891, 1443, 1886, 2246],
105000:[892, 1444, 1887, 2248],
105100:[893, 1445, 1889, 2250],
105200:[894, 1447, 1890, 2252],
105300:[894, 1448, 1892, 2254],
105400:[895, 1449, 1893, 2255],
105500:[896, 1450, 1895, 2257],
105600:[897, 1452, 1896, 2259],
105700:[898, 1453, 1898, 2261],
105800:[898, 1454, 1899, 2263],
105900:[899, 1455, 1901, 2265],
106000:[900, 1457, 1902, 2267],
106100:[901, 1458, 1904, 2269],
106200:[902, 1459, 1905, 2271],
106300:[902, 1461, 1907, 2272],
106400:[903, 1462, 1908, 2274],
106500:[904, 1463, 1910, 2276],
106600:[905, 1464, 1911, 2278],
106700:[906, 1466, 1913, 2280],
106800:[907, 1467, 1915, 2282],
106900:[907, 1468, 1916, 2283],
107000:[908, 1469, 1918, 2285],
107100:[909, 1470, 1920, 2287],
107200:[909, 1471, 1921, 2289],
107300:[910, 1473, 1923, 2291],
107400:[911, 1474, 1924, 2292],
107500:[912, 1475, 1926, 2294],
107600:[912, 1476, 1928, 2296],
107700:[913, 1477, 1929, 2298],
107800:[914, 1479, 1931, 2300],
107900:[915, 1480, 1932, 2302],
108000:[915, 1481, 1934, 2304],
108100:[916, 1482, 1936, 2306],
108200:[917, 1483, 1937, 2308],
108300:[917, 1485, 1939, 2309],
108400:[918, 1486, 1940, 2311],
108500:[919, 1487, 1942, 2313],
108600:[920, 1488, 1943, 2315],
108700:[920, 1489, 1945, 2317],
108800:[921, 1491, 1946, 2318],
108900:[922, 1492, 1948, 2320],
109000:[923, 1493, 1949, 2322],
109100:[924, 1494, 1951, 2324],
109200:[925, 1496, 1952, 2326],
109300:[925, 1497, 1954, 2328],
109400:[926, 1498, 1955, 2329],
109500:[927, 1499, 1957, 2331],
109600:[928, 1501, 1958, 2333],
109700:[928, 1502, 1960, 2335],
109800:[929, 1503, 1962, 2337],
109900:[930, 1504, 1963, 2339],
110000:[931, 1506, 1965, 2341],
110100:[932, 1507, 1967, 2343],
110200:[933, 1508, 1968, 2345],
110300:[933, 1510, 1970, 2347],
110400:[934, 1511, 1971, 2349],
110500:[935, 1512, 1973, 2350],
110600:[936, 1513, 1975, 2352],
110700:[937, 1515, 1976, 2354],
110800:[937, 1516, 1978, 2356],
110900:[938, 1517, 1979, 2358],
111000:[939, 1518, 1981, 2360],
111100:[940, 1519, 1983, 2362],
111200:[941, 1520, 1984, 2364],
111300:[941, 1522, 1986, 2366],
111400:[942, 1523, 1987, 2367],
111500:[943, 1524, 1989, 2369],
111600:[944, 1525, 1990, 2371],
111700:[945, 1527, 1992, 2373],
111800:[945, 1528, 1993, 2375],
111900:[946, 1529, 1995, 2377],
112000:[947, 1530, 1996, 2378],
112100:[948, 1531, 1998, 2380],
112200:[949, 1532, 1999, 2382],
112300:[949, 1534, 2001, 2384],
112400:[950, 1535, 2002, 2386],
112500:[951, 1536, 2004, 2387],
112600:[952, 1537, 2005, 2389],
112700:[953, 1538, 2007, 2391],
112800:[954, 1540, 2008, 2393],
112900:[954, 1541, 2010, 2395],
113000:[955, 1542, 2012, 2397],
113100:[956, 1543, 2014, 2399],
113200:[957, 1544, 2015, 2401],
113300:[957, 1546, 2017, 2403],
113400:[958, 1547, 2018, 2404],
113500:[959, 1548, 2020, 2406],
113600:[960, 1549, 2022, 2408],
113700:[961, 1550, 2023, 2410],
113800:[962, 1551, 2025, 2412],
113900:[962, 1553, 2026, 2414],
114000:[963, 1554, 2028, 2415],
114100:[964, 1555, 2030, 2417],
114200:[964, 1557, 2031, 2419],
114300:[965, 1558, 2033, 2421],
114400:[966, 1559, 2034, 2423],
114500:[967, 1560, 2036, 2424],
114600:[967, 1562, 2038, 2426],
114700:[968, 1563, 2039, 2428],
114800:[969, 1564, 2041, 2430],
114900:[970, 1565, 2043, 2432],
115000:[970, 1567, 2044, 2434],
115100:[971, 1568, 2046, 2436],
115200:[972, 1569, 2047, 2438],
115300:[972, 1571, 2049, 2439],
115400:[973, 1572, 2050, 2441],
115500:[974, 1573, 2052, 2443],
115600:[975, 1574, 2053, 2445],
115700:[975, 1576, 2055, 2447],
115800:[976, 1577, 2056, 2449],
115900:[977, 1578, 2058, 2450],
116000:[978, 1579, 2059, 2452],
116100:[979, 1580, 2061, 2454],
116200:[980, 1581, 2062, 2456],
116300:[980, 1583, 2064, 2458],
116400:[981, 1584, 2065, 2459],
116500:[982, 1585, 2067, 2461],
116600:[983, 1586, 2068, 2463],
116700:[983, 1588, 2070, 2465],
116800:[984, 1589, 2072, 2467],
116900:[985, 1590, 2073, 2469],
117000:[986, 1591, 2075, 2471],
117100:[987, 1592, 2077, 2473],
117200:[988, 1593, 2078, 2475],
117300:[988, 1595, 2080, 2476],
117400:[989, 1596, 2081, 2478],
117500:[990, 1597, 2083, 2480],
117600:[991, 1598, 2085, 2482],
117700:[992, 1599, 2086, 2484],
117800:[992, 1601, 2088, 2486],
117900:[993, 1602, 2089, 2487],
118000:[994, 1603, 2091, 2489],
118100:[995, 1604, 2093, 2491],
118200:[996, 1605, 2094, 2493],
118300:[996, 1607, 2096, 2495],
118400:[997, 1608, 2097, 2496],
118500:[998, 1609, 2099, 2498],
118600:[999, 1610, 2100, 2500],
118700:[1000, 1611, 2102, 2502],
118800:[1000, 1612, 2103, 2504],
118900:[1001, 1614, 2105, 2506],
119000:[1002, 1615, 2106, 2508],
119100:[1003, 1616, 2108, 2510],
119200:[1004, 1618, 2109, 2512],
119300:[1004, 1619, 2111, 2513],
119400:[1005, 1620, 2112, 2515],
119500:[1006, 1621, 2114, 2517],
119600:[1007, 1623, 2115, 2519],
119700:[1008, 1624, 2117, 2521],
119800:[1009, 1625, 2119, 2522],
119900:[1009, 1626, 2120, 2524],
12000:[0, 0, 0, 0],
120000:[1010, 1628, 2122, 2526],
120100:[1011, 1629, 2124, 2528],
120200:[1011, 1630, 2125, 2530],
120300:[1012, 1632, 2127, 2532],
120400:[1013, 1633, 2128, 2533],
120500:[1014, 1634, 2130, 2535],
120600:[1014, 1635, 2132, 2537],
120700:[1015, 1637, 2133, 2539],
120800:[1016, 1638, 2135, 2541],
120900:[1017, 1639, 2136, 2543],
12100:[4, 9, 10, 11],
121000:[1017, 1640, 2138, 2545],
121100:[1018, 1641, 2140, 2547],
121200:[1019, 1642, 2141, 2549],
121300:[1019, 1644, 2143, 2551],
121400:[1020, 1645, 2144, 2553],
121500:[1021, 1646, 2146, 2554],
121600:[1022, 1647, 2147, 2556],
121700:[1022, 1649, 2149, 2558],
121800:[1023, 1650, 2150, 2560],
121900:[1024, 1651, 2152, 2562],
12200:[7, 18, 20, 21],
122000:[1025, 1652, 2153, 2564],
122100:[1026, 1653, 2155, 2566],
122200:[1027, 1654, 2156, 2568],
122300:[1027, 1656, 2158, 2570],
122400:[1028, 1657, 2159, 2571],
122500:[1029, 1658, 2161, 2573],
122600:[1030, 1659, 2162, 2575],
122700:[1030, 1660, 2164, 2577],
122800:[1031, 1662, 2165, 2579],
122900:[1032, 1663, 2167, 2581],
12300:[11, 28, 30, 32],
123000:[1033, 1664, 2169, 2582],
123100:[1034, 1665, 2171, 2584],
123200:[1035, 1666, 2172, 2586],
123300:[1035, 1668, 2174, 2588],
123400:[1036, 1669, 2175, 2590],
123500:[1037, 1670, 2177, 2591],
123600:[1038, 1671, 2179, 2593],
123700:[1038, 1672, 2180, 2595],
123800:[1039, 1673, 2182, 2597],
123900:[1040, 1675, 2183, 2599],
12400:[14, 37, 40, 42],
124000:[1041, 1676, 2185, 2601],
124100:[1042, 1677, 2187, 2603],
124200:[1043, 1679, 2188, 2605],
124300:[1043, 1680, 2190, 2606],
124400:[1044, 1681, 2191, 2608],
124500:[1045, 1682, 2193, 2610],
124600:[1046, 1684, 2194, 2612],
124700:[1047, 1685, 2196, 2614],
124800:[1047, 1686, 2197, 2616],
124900:[1048, 1687, 2199, 2617],
12500:[18, 46, 50, 53],
125000:[1049, 1689, 2200, 2619],
125100:[1050, 1690, 2202, 2621],
125200:[1051, 1691, 2203, 2623],
125300:[1051, 1693, 2205, 2625],
125400:[1052, 1694, 2206, 2627],
125500:[1053, 1695, 2208, 2628],
125600:[1054, 1696, 2209, 2630],
125700:[1055, 1698, 2211, 2632],
125800:[1056, 1699, 2212, 2634],
125900:[1056, 1700, 2214, 2636],
12600:[21, 55, 59, 64],
126000:[1057, 1701, 2216, 2638],
126100:[1058, 1702, 2218, 2640],
126200:[1059, 1703, 2219, 2642],
126300:[1059, 1705, 2221, 2643],
126400:[1060, 1706, 2222, 2645],
126500:[1061, 1707, 2224, 2647],
126600:[1062, 1708, 2226, 2649],
126700:[1063, 1710, 2227, 2651],
126800:[1064, 1711, 2229, 2653],
126900:[1064, 1712, 2230, 2654],
12700:[25, 64, 69, 74],
127000:[1065, 1713, 2232, 2656],
127100:[1066, 1714, 2234, 2658],
127200:[1066, 1715, 2235, 2660],
127300:[1067, 1717, 2237, 2662],
127400:[1068, 1718, 2238, 2663],
127500:[1069, 1719, 2240, 2665],
127600:[1069, 1720, 2242, 2667],
127700:[1070, 1721, 2243, 2669],
127800:[1071, 1723, 2245, 2671],
127900:[1072, 1724, 2247, 2673],
12800:[28, 74, 79, 85],
128000:[1072, 1725, 2248, 2675],
128100:[1073, 1726, 2250, 2677],
128200:[1074, 1727, 2251, 2679],
128300:[1074, 1729, 2253, 2680],
128400:[1075, 1730, 2254, 2682],
128500:[1076, 1731, 2256, 2684],
128600:[1077, 1732, 2257, 2686],
128700:[1077, 1733, 2259, 2688],
128800:[1078, 1734, 2260, 2689],
128900:[1079, 1736, 2262, 2691],
12900:[32, 83, 89, 95],
129000:[1080, 1737, 2263, 2693],
129100:[1081, 1738, 2265, 2695],
129200:[1082, 1740, 2266, 2697],
129300:[1082, 1741, 2268, 2699],
129400:[1083, 1742, 2269, 2700],
129500:[1084, 1743, 2271, 2702],
129600:[1085, 1745, 2272, 2704],
129700:[1085, 1746, 2274, 2706],
129800:[1086, 1747, 2276, 2708],
129900:[1087, 1748, 2277, 2710],
13000:[35, 92, 99, 106],
130000:[1088, 1750, 2279, 2712],
130100:[1089, 1751, 2281, 2714],
130200:[1090, 1752, 2282, 2716],
130300:[1090, 1754, 2284, 2718],
130400:[1091, 1755, 2285, 2720],
130500:[1092, 1756, 2287, 2722],
130600:[1093, 1757, 2289, 2723],
130700:[1094, 1759, 2290, 2725],
130800:[1094, 1760, 2292, 2727],
130900:[1095, 1761, 2293, 2729],
13100:[37, 95, 103, 110],
131000:[1096, 1762, 2295, 2731],
131100:[1097, 1763, 2297, 2733],
131200:[1098, 1764, 2298, 2735],
131300:[1098, 1766, 2300, 2737],
131400:[1099, 1767, 2301, 2738],
131500:[1100, 1768, 2303, 2740],
131600:[1101, 1769, 2304, 2742],
131700:[1102, 1770, 2306, 2744],
131800:[1102, 1772, 2307, 2746],
131900:[1103, 1773, 2309, 2748],
13200:[38, 99, 106, 114],
132000:[1104, 1774, 2310, 2749],
132100:[1105, 1775, 2312, 2751],
132200:[1106, 1776, 2313, 2753],
132300:[1106, 1778, 2315, 2755],
132400:[1107, 1779, 2316, 2757],
132500:[1108, 1780, 2318, 2758],
132600:[1109, 1781, 2319, 2760],
132700:[1110, 1782, 2321, 2762],
132800:[1111, 1784, 2323, 2764],
132900:[1111, 1785, 2324, 2766],
13300:[40, 102, 110, 118],
133000:[1112, 1786, 2326, 2768],
133100:[1113, 1787, 2328, 2770],
133200:[1113, 1788, 2329, 2772],
133300:[1114, 1790, 2331, 2774],
133400:[1115, 1791, 2332, 2775],
133500:[1116, 1792, 2334, 2777],
133600:[1116, 1793, 2336, 2779],
133700:[1117, 1794, 2337, 2781],
133800:[1118, 1795, 2339, 2783],
133900:[1119, 1797, 2340, 2785],
13400:[42, 106, 114, 122],
134000:[1119, 1798, 2342, 2786],
134100:[1120, 1799, 2344, 2788],
134200:[1121, 1801, 2345, 2790],
134300:[1121, 1802, 2347, 2792],
134400:[1122, 1803, 2348, 2794],
134500:[1123, 1804, 2350, 2795],
134600:[1124, 1806, 2351, 2797],
134700:[1124, 1807, 2353, 2799],
134800:[1125, 1808, 2354, 2801],
134900:[1126, 1809, 2356, 2803],
13500:[43, 109, 118, 126],
135000:[1127, 1811, 2357, 2805],
135100:[1128, 1812, 2359, 2807],
135200:[1129, 1813, 2360, 2809],
135300:[1129, 1815, 2362, 2810],
135400:[1130, 1816, 2363, 2812],
135500:[1131, 1817, 2365, 2814],
135600:[1132, 1818, 2366, 2816],
135700:[1132, 1820, 2368, 2818],
135800:[1133, 1821, 2369, 2820],
135900:[1134, 1822, 2371, 2821],
13600:[45, 113, 121, 130],
136000:[1135, 1823, 2373, 2823],
136100:[1136, 1824, 2375, 2825],
136200:[1137, 1825, 2376, 2827],
136300:[1137, 1827, 2378, 2829],
136400:[1138, 1828, 2379, 2830],
136500:[1139, 1829, 2381, 2832],
136600:[1140, 1830, 2383, 2834],
136700:[1140, 1831, 2384, 2836],
136800:[1141, 1833, 2386, 2838],
136900:[1142, 1834, 2387, 2840],
13700:[47, 116, 125, 133],
137000:[1143, 1835, 2389, 2842],
137100:[1144, 1836, 2391, 2844],
137200:[1145, 1837, 2392, 2846],
137300:[1145, 1839, 2394, 2847],
137400:[1146, 1840, 2395, 2849],
137500:[1147, 1841, 2397, 2851],
137600:[1148, 1842, 2398, 2853],
137700:[1149, 1843, 2400, 2855],
137800:[1149, 1845, 2401, 2857],
137900:[1150, 1846, 2403, 2858],
13800:[48, 119, 129, 137],
138000:[1151, 1847, 2404, 2860],
138100:[1152, 1848, 2406, 2862],
138200:[1153, 1850, 2407, 2864],
138300:[1153, 1851, 2409, 2866],
138400:[1154, 1852, 2410, 2867],
138500:[1155, 1853, 2412, 2869],
138600:[1156, 1855, 2413, 2871],
138700:[1157, 1856, 2415, 2873],
138800:[1158, 1857, 2416, 2875],
138900:[1158, 1858, 2418, 2877],
13900:[50, 123, 133, 141],
139000:[1159, 1860, 2420, 2879],
139100:[1160, 1861, 2422, 2881],
139200:[1161, 1862, 2423, 2883],
139300:[1161, 1864, 2425, 2884],
139400:[1162, 1865, 2426, 2886],
139500:[1163, 1866, 2428, 2888],
139600:[1164, 1867, 2429, 2890],
139700:[1165, 1869, 2431, 2892],
139800:[1166, 1870, 2433, 2893],
139900:[1166, 1871, 2434, 2895],
14000:[52, 126, 136, 145],
140000:[1167, 1872, 2436, 2897],
140100:[1168, 1873, 2438, 2899],
140200:[1168, 1874, 2439, 2901],
140300:[1169, 1876, 2441, 2902],
140400:[1170, 1877, 2442, 2904],
140500:[1171, 1878, 2444, 2906],
140600:[1171, 1879, 2445, 2908],
140700:[1172, 1881, 2447, 2909],
140800:[1173, 1882, 2448, 2911],
140900:[1174, 1883, 2450, 2913],
14100:[54, 129, 139, 149],
141000:[1174, 1884, 2451, 2915],
141100:[1175, 1885, 2452, 2917],
141200:[1176, 1886, 2454, 2919],
141300:[1176, 1887, 2455, 2920],
141400:[1177, 1889, 2457, 2922],
141500:[1178, 1890, 2458, 2924],
141600:[1179, 1891, 2460, 2926],
141700:[1179, 1892, 2461, 2927],
141800:[1180, 1893, 2463, 2929],
141900:[1181, 1894, 2464, 2931],
14200:[55, 132, 143, 152],
142000:[1182, 1895, 2466, 2933],
142100:[1183, 1896, 2468, 2935],
142200:[1183, 1897, 2469, 2937],
142300:[1184, 1899, 2471, 2938],
142400:[1185, 1900, 2472, 2940],
142500:[1186, 1901, 2474, 2942],
142600:[1186, 1902, 2475, 2944],
142700:[1187, 1903, 2477, 2946],
142800:[1188, 1905, 2478, 2947],
142900:[1189, 1906, 2480, 2949],
14300:[57, 135, 146, 156],
143000:[1189, 1907, 2481, 2951],
143100:[1190, 1908, 2483, 2953],
143200:[1190, 1909, 2484, 2954],
143300:[1191, 1910, 2486, 2956],
143400:[1192, 1912, 2487, 2958],
143500:[1192, 1913, 2489, 2960],
143600:[1193, 1914, 2490, 2961],
143700:[1194, 1915, 2492, 2963],
143800:[1195, 1916, 2493, 2965],
143900:[1195, 1917, 2495, 2967],
14400:[59, 138, 149, 160],
144000:[1196, 1918, 2496, 2968],
144100:[1197, 1919, 2498, 2970],
144200:[1198, 1920, 2499, 2972],
144300:[1198, 1922, 2501, 2973],
144400:[1199, 1923, 2502, 2975],
144500:[1200, 1924, 2504, 2977],
144600:[1201, 1925, 2505, 2979],
144700:[1201, 1926, 2507, 2981],
144800:[1202, 1927, 2508, 2982],
144900:[1203, 1929, 2510, 2984],
14500:[60, 142, 153, 163],
145000:[1204, 1930, 2511, 2986],
145100:[1205, 1931, 2512, 2988],
145200:[1205, 1932, 2514, 2989],
145300:[1206, 1933, 2515, 2991],
145400:[1207, 1934, 2517, 2993],
145500:[1208, 1936, 2518, 2995],
145600:[1208, 1937, 2520, 2996],
145700:[1209, 1938, 2521, 2998],
145800:[1210, 1939, 2523, 3000],
145900:[1210, 1940, 2524, 3002],
14600:[62, 145, 156, 167],
146000:[1211, 1941, 2525, 3003],
146100:[1212, 1942, 2526, 3005],
146200:[1213, 1943, 2528, 3007],
146300:[1213, 1944, 2529, 3008],
146400:[1214, 1946, 2531, 3010],
146500:[1215, 1947, 2532, 3012],
146600:[1216, 1948, 2534, 3014],
146700:[1216, 1949, 2535, 3015],
146800:[1217, 1950, 2537, 3017],
146900:[1218, 1951, 2538, 3019],
14700:[64, 148, 159, 171],
147000:[1219, 1953, 2540, 3021],
147100:[1220, 1954, 2541, 3023],
147200:[1220, 1955, 2543, 3024],
147300:[1221, 1956, 2544, 3026],
147400:[1222, 1957, 2546, 3028],
147500:[1223, 1959, 2547, 3030],
147600:[1223, 1960, 2549, 3031],
147700:[1224, 1961, 2550, 3033],
147800:[1225, 1962, 2552, 3035],
147900:[1226, 1963, 2553, 3036],
14800:[65, 151, 163, 174],
148000:[1226, 1964, 2555, 3038],
148100:[1227, 1965, 2556, 3040],
148200:[1228, 1966, 2558, 3042],
148300:[1228, 1967, 2559, 3043],
148400:[1229, 1969, 2561, 3045],
148500:[1230, 1970, 2562, 3047],
148600:[1231, 1971, 2564, 3049],
148700:[1231, 1972, 2565, 3050],
148800:[1232, 1973, 2567, 3052],
148900:[1233, 1974, 2568, 3054],
14900:[67, 154, 166, 178],
149000:[1234, 1976, 2570, 3056],
149100:[1235, 1977, 2572, 3058],
149200:[1235, 1978, 2573, 3059],
149300:[1236, 1980, 2575, 3061],
149400:[1237, 1981, 2576, 3063],
149500:[1238, 1982, 2578, 3065],
149600:[1238, 1983, 2579, 3066],
149700:[1239, 1984, 2581, 3068],
149800:[1240, 1986, 2582, 3070],
149900:[1241, 1987, 2584, 3071],
15000:[69, 157, 169, 182],
150000:[1241, 1988, 2585, 3073],
15100:[71, 160, 172, 185],
15200:[72, 163, 175, 189],
15300:[74, 166, 178, 192],
15400:[76, 168, 181, 195],
15500:[77, 171, 184, 199],
15600:[79, 174, 187, 202],
15700:[81, 177, 190, 205],
15800:[82, 180, 193, 209],
15900:[84, 183, 196, 212],
16000:[86, 186, 200, 215],
16100:[88, 189, 203, 218],
16200:[89, 192, 206, 221],
16300:[91, 194, 209, 225],
16400:[93, 197, 212, 228],
16500:[94, 200, 215, 231],
16600:[96, 203, 218, 234],
16700:[98, 206, 221, 238],
16800:[100, 208, 224, 241],
16900:[101, 211, 227, 244],
17000:[103, 214, 230, 247],
17100:[105, 217, 233, 250],
17200:[106, 219, 236, 253],
17300:[108, 222, 239, 257],
17400:[110, 225, 242, 260],
17500:[112, 228, 245, 263],
17600:[113, 230, 248, 266],
17700:[115, 233, 251, 270],
17800:[117, 236, 254, 273],
17900:[118, 238, 257, 276],
18000:[120, 241, 260, 279],
18100:[121, 244, 263, 283],
18200:[123, 247, 267, 286],
18300:[124, 250, 270, 290],
18400:[126, 254, 274, 294],
18500:[127, 257, 277, 297],
18600:[129, 260, 280, 301],
18700:[130, 263, 284, 305],
18800:[131, 266, 287, 308],
18900:[133, 269, 291, 312],
19000:[134, 273, 294, 315],
19100:[134, 275, 298, 319],
19200:[135, 276, 302, 323],
19300:[135, 278, 305, 327],
19400:[136, 279, 309, 331],
19500:[136, 281, 313, 336],
19600:[137, 282, 317, 340],
19700:[137, 284, 321, 344],
19800:[138, 285, 325, 348],
19900:[138, 287, 328, 352],
20000:[139, 288, 332, 356],
20100:[139, 289, 336, 360],
20200:[140, 290, 340, 364],
20300:[140, 291, 344, 368],
20400:[141, 292, 347, 372],
20500:[141, 293, 351, 376],
20600:[142, 294, 355, 381],
20700:[142, 295, 359, 385],
20800:[143, 296, 363, 389],
20900:[143, 297, 367, 393],
21000:[144, 298, 371, 397],
21100:[145, 299, 375, 401],
21200:[146, 301, 379, 406],
21300:[147, 302, 383, 410],
21400:[148, 303, 387, 415],
21500:[149, 304, 392, 419],
21600:[150, 306, 396, 424],
21700:[151, 307, 400, 428],
21800:[152, 308, 404, 433],
21900:[153, 310, 408, 437],
22000:[154, 311, 412, 442],
22100:[155, 312, 416, 446],
22200:[156, 314, 420, 451],
22300:[158, 315, 425, 455],
22400:[159, 317, 429, 460],
22500:[160, 318, 433, 464],
22600:[161, 320, 437, 469],
22700:[162, 321, 441, 473],
22800:[163, 323, 445, 477],
22900:[165, 324, 450, 482],
23000:[166, 326, 454, 486],
23100:[167, 328, 456, 490],
23200:[168, 329, 458, 495],
23300:[170, 331, 460, 499],
23400:[171, 333, 463, 504],
23500:[172, 335, 465, 508],
23600:[173, 336, 467, 512],
23700:[174, 338, 469, 517],
23800:[176, 340, 471, 521],
23900:[177, 342, 473, 525],
24000:[178, 343, 475, 530],
24100:[179, 345, 477, 534],
24200:[180, 346, 479, 539],
24300:[182, 348, 481, 543],
24400:[183, 350, 483, 548],
24500:[184, 352, 486, 552],
24600:[185, 353, 488, 557],
24700:[186, 355, 490, 561],
24800:[188, 357, 492, 566],
24900:[189, 358, 494, 570],
25000:[190, 360, 496, 575],
25100:[191, 362, 498, 579],
25200:[193, 364, 501, 584],
25300:[194, 366, 503, 588],
25400:[195, 368, 505, 593],
25500:[196, 369, 507, 597],
25600:[198, 371, 510, 601],
25700:[199, 373, 512, 606],
25800:[200, 375, 514, 610],
25900:[202, 377, 517, 615],
26000:[203, 379, 519, 619],
26100:[205, 381, 522, 623],
26200:[206, 383, 524, 628],
26300:[208, 385, 527, 632],
26400:[210, 388, 529, 636],
26500:[211, 390, 532, 640],
26600:[213, 392, 534, 645],
26700:[215, 394, 537, 649],
26800:[216, 396, 539, 653],
26900:[218, 398, 542, 657],
27000:[220, 400, 544, 662],
27100:[221, 402, 546, 665],
27200:[223, 404, 549, 668],
27300:[224, 407, 551, 670],
27400:[226, 409, 554, 673],
27500:[227, 411, 556, 676],
27600:[229, 413, 559, 679],
27700:[230, 415, 561, 682],
27800:[232, 417, 564, 685],
27900:[233, 420, 566, 687],
28000:[235, 422, 569, 690],
28100:[236, 424, 571, 693],
28200:[238, 426, 574, 695],
28300:[239, 428, 576, 698],
28400:[240, 430, 578, 701],
28500:[241, 432, 581, 703],
28600:[243, 434, 583, 706],
28700:[244, 436, 586, 709],
28800:[245, 437, 588, 712],
28900:[246, 439, 590, 714],
29000:[248, 441, 593, 717],
29100:[249, 443, 595, 719],
29200:[250, 444, 597, 722],
29300:[251, 446, 599, 724],
29400:[252, 448, 601, 727],
29500:[253, 449, 603, 729],
29600:[254, 451, 605, 731],
29700:[255, 453, 607, 734],
29800:[256, 454, 609, 736],
29900:[257, 456, 611, 739],
30000:[258, 458, 613, 741],
30100:[259, 459, 615, 743],
30200:[260, 461, 617, 745],
30300:[260, 462, 618, 747],
30400:[261, 463, 620, 750],
30500:[262, 465, 622, 752],
30600:[263, 466, 624, 754],
30700:[264, 467, 625, 756],
30800:[265, 469, 627, 758],
30900:[265, 470, 629, 760],
31000:[266, 471, 631, 762],
31100:[267, 472, 633, 764],
31200:[268, 474, 635, 766],
31300:[268, 475, 636, 768],
31400:[269, 476, 638, 770],
31500:[270, 478, 640, 772],
31600:[271, 479, 642, 774],
31700:[272, 480, 643, 776],
31800:[272, 481, 645, 778],
31900:[273, 483, 647, 780],
32000:[274, 484, 649, 782],
32100:[275, 485, 651, 784],
32200:[276, 487, 653, 786],
32300:[277, 488, 654, 788],
32400:[277, 489, 656, 790],
32500:[278, 491, 658, 792],
32600:[279, 492, 660, 794],
32700:[280, 493, 661, 796],
32800:[281, 495, 663, 798],
32900:[282, 496, 665, 801],
33000:[283, 497, 667, 803],
33100:[284, 498, 669, 805],
33200:[285, 500, 671, 807],
33300:[286, 501, 672, 809],
33400:[286, 502, 674, 811],
33500:[287, 504, 676, 813],
33600:[288, 505, 678, 815],
33700:[289, 506, 679, 817],
33800:[290, 508, 681, 820],
33900:[291, 509, 683, 822],
34000:[291, 510, 685, 824],
34100:[292, 511, 687, 826],
34200:[293, 513, 688, 828],
34300:[293, 514, 690, 830],
34400:[294, 515, 692, 832],
34500:[295, 517, 693, 834],
34600:[296, 518, 695, 836],
34700:[297, 519, 696, 839],
34800:[297, 521, 698, 841],
34900:[298, 522, 700, 843],
35000:[299, 523, 701, 845],
35100:[300, 524, 703, 847],
35200:[301, 526, 705, 849],
35300:[302, 527, 706, 852],
35400:[302, 528, 708, 854],
35500:[303, 530, 710, 856],
35600:[304, 531, 712, 858],
35700:[305, 532, 713, 860],
35800:[306, 534, 715, 862],
35900:[307, 535, 717, 865],
36000:[308, 536, 719, 867],
36100:[309, 537, 721, 869],
36200:[310, 539, 722, 871],
36300:[310, 540, 724, 873],
36400:[311, 541, 725, 875],
36500:[312, 542, 727, 877],
36600:[313, 544, 729, 880],
36700:[314, 545, 730, 882],
36800:[314, 546, 732, 884],
36900:[315, 547, 734, 886],
37000:[316, 549, 735, 888],
37100:[317, 550, 737, 890],
37200:[318, 552, 738, 892],
37300:[319, 553, 740, 894],
37400:[319, 554, 742, 896],
37500:[320, 555, 743, 898],
37600:[321, 557, 745, 900],
37700:[322, 558, 747, 901],
37800:[323, 559, 748, 903],
37900:[324, 561, 750, 905],
38000:[325, 562, 752, 907],
38100:[326, 563, 754, 909],
38200:[327, 565, 755, 911],
38300:[328, 566, 757, 913],
38400:[328, 567, 759, 915],
38500:[329, 568, 760, 917],
38600:[330, 570, 762, 919],
38700:[331, 571, 764, 921],
38800:[332, 572, 766, 923],
38900:[333, 574, 767, 925],
39000:[333, 575, 769, 927],
39100:[334, 576, 771, 929],
39200:[335, 578, 772, 931],
39300:[335, 579, 774, 933],
39400:[336, 580, 776, 935],
39500:[337, 581, 777, 937],
39600:[338, 583, 779, 939],
39700:[339, 584, 780, 941],
39800:[339, 585, 782, 943],
39900:[340, 587, 784, 945],
40000:[341, 588, 785, 947],
40100:[342, 589, 787, 949],
40200:[343, 591, 788, 951],
40300:[344, 592, 790, 953],
40400:[344, 593, 792, 955],
40500:[345, 595, 793, 957],
40600:[346, 596, 795, 959],
40700:[347, 597, 797, 960],
40800:[348, 598, 798, 962],
40900:[349, 600, 800, 964],
41000:[350, 601, 802, 966],
41100:[351, 602, 804, 968],
41200:[352, 604, 805, 970],
41300:[353, 605, 807, 972],
41400:[353, 606, 809, 974],
41500:[354, 608, 811, 976],
41600:[355, 609, 812, 978],
41700:[356, 610, 814, 980],
41800:[357, 611, 816, 982],
41900:[358, 613, 817, 984],
42000:[358, 614, 819, 986],
42100:[359, 615, 821, 988],
42200:[360, 617, 822, 990],
42300:[360, 618, 824, 992],
42400:[361, 619, 826, 994],
42500:[362, 621, 827, 996],
42600:[363, 622, 829, 998],
42700:[364, 623, 831, 1000],
42800:[364, 625, 832, 1002],
42900:[365, 626, 834, 1004],
43000:[366, 627, 835, 1006],
43100:[367, 628, 837, 1008],
43200:[368, 630, 838, 1010],
43300:[369, 631, 840, 1012],
43400:[370, 632, 842, 1014],
43500:[370, 634, 843, 1016],
43600:[371, 635, 845, 1018],
43700:[372, 636, 847, 1020],
43800:[373, 638, 848, 1022],
43900:[374, 639, 850, 1024],
44000:[375, 640, 852, 1026],
44100:[376, 641, 854, 1028],
44200:[377, 643, 856, 1030],
44300:[378, 644, 857, 1032],
44400:[378, 646, 859, 1035],
44500:[379, 647, 861, 1037],
44600:[380, 649, 863, 1039],
44700:[381, 650, 865, 1041],
44800:[382, 651, 866, 1043],
44900:[383, 653, 868, 1045],
45000:[383, 654, 870, 1047],
45100:[384, 655, 872, 1049],
45200:[385, 657, 873, 1051],
45300:[386, 658, 875, 1053],
45400:[386, 659, 877, 1055],
45500:[387, 661, 879, 1057],
45600:[388, 662, 880, 1059],
45700:[389, 663, 882, 1061],
45800:[390, 665, 884, 1063],
45900:[391, 666, 886, 1065],
46000:[392, 667, 887, 1067],
46100:[393, 668, 889, 1069],
46200:[394, 670, 890, 1071],
46300:[394, 671, 892, 1073],
46400:[395, 672, 894, 1075],
46500:[396, 674, 895, 1077],
46600:[397, 675, 897, 1079],
46700:[398, 676, 898, 1081],
46800:[398, 678, 900, 1083],
46900:[399, 679, 902, 1085],
47000:[400, 680, 903, 1086],
47100:[401, 681, 905, 1088],
47200:[402, 682, 906, 1090],
47300:[402, 684, 908, 1092],
47400:[403, 685, 910, 1094],
47500:[404, 686, 911, 1096],
47600:[405, 687, 913, 1097],
47700:[405, 689, 915, 1099],
47800:[406, 690, 917, 1101],
47900:[407, 691, 918, 1103],
48000:[408, 692, 920, 1105],
48100:[409, 693, 922, 1107],
48200:[410, 695, 923, 1109],
48300:[411, 696, 925, 1111],
48400:[411, 697, 927, 1113],
48500:[412, 698, 928, 1115],
48600:[413, 700, 930, 1117],
48700:[414, 701, 931, 1119],
48800:[415, 702, 933, 1121],
48900:[416, 703, 935, 1123],
49000:[417, 705, 936, 1125],
49100:[418, 706, 938, 1127],
49200:[419, 708, 939, 1129],
49300:[420, 709, 941, 1131],
49400:[420, 710, 943, 1133],
49500:[421, 711, 944, 1135],
49600:[422, 713, 946, 1136],
49700:[423, 714, 948, 1138],
49800:[424, 715, 950, 1140],
49900:[425, 717, 951, 1142],
50000:[425, 718, 953, 1144],
50100:[426, 719, 955, 1146],
50200:[427, 721, 956, 1148],
50300:[427, 722, 958, 1150],
50400:[428, 723, 960, 1152],
50500:[429, 724, 961, 1154],
50600:[430, 726, 963, 1156],
50700:[431, 727, 965, 1158],
50800:[431, 728, 966, 1160],
50900:[432, 730, 968, 1162],
51000:[433, 731, 969, 1164],
51100:[434, 732, 971, 1166],
51200:[435, 734, 972, 1168],
51300:[436, 735, 974, 1170],
51400:[437, 736, 976, 1172],
51500:[437, 738, 977, 1174],
51600:[438, 739, 979, 1176],
51700:[439, 740, 981, 1178],
51800:[440, 741, 983, 1180],
51900:[441, 743, 984, 1182],
52000:[442, 744, 986, 1184],
52100:[443, 745, 988, 1186],
52200:[444, 747, 989, 1188],
52300:[445, 748, 991, 1190],
52400:[445, 749, 993, 1192],
52500:[446, 750, 994, 1194],
52600:[447, 752, 996, 1196],
52700:[448, 753, 998, 1198],
52800:[449, 754, 1000, 1200],
52900:[450, 756, 1001, 1202],
53000:[450, 757, 1003, 1204],
53100:[451, 758, 1005, 1206],
53200:[452, 760, 1006, 1208],
53300:[452, 761, 1008, 1210],
53400:[453, 762, 1010, 1212],
53500:[454, 763, 1012, 1214],
53600:[455, 765, 1013, 1216],
53700:[456, 766, 1015, 1218],
53800:[456, 767, 1017, 1220],
53900:[457, 769, 1018, 1222],
54000:[458, 770, 1020, 1224],
54100:[459, 771, 1022, 1226],
54200:[460, 773, 1023, 1228],
54300:[461, 774, 1025, 1230],
54400:[461, 775, 1027, 1232],
54500:[462, 777, 1029, 1234],
54600:[463, 778, 1030, 1236],
54700:[464, 780, 1032, 1238],
54800:[465, 781, 1034, 1240],
54900:[466, 782, 1036, 1242],
55000:[467, 784, 1037, 1244],
55100:[468, 785, 1039, 1246],
55200:[469, 787, 1041, 1248],
55300:[470, 788, 1042, 1250],
55400:[471, 789, 1044, 1252],
55500:[472, 791, 1046, 1255],
55600:[472, 792, 1048, 1257],
55700:[473, 793, 1050, 1259],
55800:[474, 795, 1052, 1261],
55900:[475, 796, 1053, 1263],
56000:[476, 797, 1055, 1265],
56100:[477, 798, 1057, 1267],
56200:[478, 800, 1059, 1269],
56300:[479, 801, 1060, 1271],
56400:[480, 802, 1062, 1273],
56500:[481, 804, 1064, 1275],
56600:[481, 805, 1066, 1278],
56700:[482, 806, 1068, 1280],
56800:[483, 808, 1070, 1282],
56900:[484, 809, 1071, 1284],
57000:[485, 811, 1073, 1286],
57100:[486, 812, 1075, 1288],
57200:[487, 814, 1077, 1290],
57300:[488, 815, 1079, 1293],
57400:[489, 816, 1080, 1295],
57500:[490, 818, 1082, 1297],
57600:[490, 819, 1084, 1299],
57700:[491, 821, 1086, 1301],
57800:[492, 822, 1088, 1303],
57900:[493, 823, 1090, 1306],
58000:[494, 825, 1091, 1308],
58100:[495, 826, 1093, 1310],
58200:[496, 828, 1094, 1312],
58300:[497, 829, 1096, 1314],
58400:[498, 830, 1098, 1317],
58500:[499, 832, 1100, 1319],
58600:[499, 833, 1101, 1321],
58700:[500, 835, 1103, 1323],
58800:[501, 836, 1105, 1325],
58900:[502, 837, 1107, 1327],
59000:[503, 839, 1108, 1329],
59100:[504, 840, 1110, 1331],
59200:[505, 842, 1112, 1333],
59300:[506, 843, 1113, 1335],
59400:[507, 844, 1115, 1337],
59500:[508, 846, 1117, 1339],
59600:[508, 847, 1119, 1341],
59700:[509, 849, 1120, 1343],
59800:[510, 850, 1122, 1345],
59900:[511, 851, 1124, 1347],
60000:[512, 853, 1126, 1349],
60100:[513, 854, 1128, 1351],
60200:[514, 856, 1129, 1353],
60300:[515, 857, 1131, 1355],
60400:[515, 859, 1133, 1357],
60500:[516, 860, 1134, 1359],
60600:[517, 861, 1136, 1361],
60700:[518, 863, 1138, 1363],
60800:[519, 864, 1140, 1365],
60900:[520, 866, 1141, 1368],
61000:[520, 867, 1143, 1370],
61100:[521, 868, 1145, 1372],
61200:[522, 870, 1147, 1374],
61300:[523, 871, 1148, 1376],
61400:[523, 872, 1150, 1378],
61500:[524, 874, 1152, 1380],
61600:[525, 875, 1154, 1383],
61700:[526, 876, 1155, 1385],
61800:[527, 878, 1157, 1387],
61900:[528, 879, 1159, 1389],
62000:[529, 880, 1161, 1391],
62100:[530, 881, 1163, 1393],
62200:[531, 883, 1164, 1395],
62300:[532, 884, 1166, 1397],
62400:[533, 886, 1168, 1399],
62500:[533, 887, 1170, 1401],
62600:[534, 888, 1171, 1403],
62700:[535, 890, 1173, 1405],
62800:[536, 891, 1175, 1407],
62900:[537, 893, 1176, 1409],
63000:[538, 894, 1178, 1411],
63100:[539, 895, 1180, 1413],
63200:[540, 897, 1182, 1415],
63300:[541, 898, 1183, 1417],
63400:[542, 899, 1185, 1419],
63500:[543, 901, 1187, 1421],
63600:[544, 902, 1189, 1423],
63700:[544, 903, 1190, 1425],
63800:[545, 905, 1192, 1428],
63900:[546, 906, 1194, 1430],
64000:[547, 907, 1196, 1432],
64100:[548, 908, 1198, 1434],
64200:[549, 910, 1199, 1436],
64300:[550, 911, 1201, 1438],
64400:[550, 913, 1203, 1440],
64500:[551, 914, 1205, 1443],
64600:[552, 915, 1206, 1445],
64700:[553, 917, 1208, 1447],
64800:[554, 918, 1210, 1449],
64900:[555, 919, 1211, 1451],
65000:[555, 921, 1213, 1453],
65100:[556, 922, 1215, 1455],
65200:[557, 924, 1217, 1457],
65300:[558, 925, 1218, 1459],
65400:[558, 926, 1220, 1461],
65500:[559, 928, 1222, 1463],
65600:[560, 929, 1224, 1465],
65700:[561, 930, 1225, 1467],
65800:[562, 932, 1227, 1469],
65900:[563, 933, 1229, 1471],
66000:[564, 934, 1231, 1473],
66100:[565, 935, 1233, 1475],
66200:[566, 937, 1234, 1477],
66300:[567, 938, 1236, 1479],
66400:[568, 939, 1238, 1481],
66500:[569, 941, 1240, 1483],
66600:[569, 942, 1241, 1485],
66700:[570, 944, 1243, 1488],
66800:[571, 945, 1245, 1490],
66900:[572, 946, 1247, 1492],
67000:[573, 948, 1248, 1494],
67100:[574, 949, 1250, 1496],
67200:[575, 951, 1252, 1498],
67300:[575, 952, 1253, 1500],
67400:[576, 954, 1255, 1502],
67500:[577, 955, 1257, 1504],
67600:[578, 956, 1259, 1506],
67700:[579, 958, 1260, 1508],
67800:[580, 959, 1262, 1510],
67900:[580, 961, 1264, 1512],
68000:[581, 962, 1266, 1514],
68100:[582, 963, 1268, 1516],
68200:[583, 965, 1269, 1518],
68300:[584, 966, 1271, 1520],
68400:[584, 967, 1273, 1522],
68500:[585, 969, 1275, 1524],
68600:[586, 970, 1276, 1526],
68700:[587, 971, 1278, 1528],
68800:[588, 973, 1280, 1530],
68900:[589, 974, 1282, 1533],
69000:[590, 975, 1283, 1535],
69100:[591, 976, 1285, 1537],
69200:[592, 978, 1287, 1539],
69300:[593, 979, 1288, 1541],
69400:[594, 981, 1290, 1543],
69500:[594, 982, 1292, 1545],
69600:[595, 983, 1294, 1548],
69700:[596, 985, 1296, 1550],
69800:[597, 986, 1297, 1552],
69900:[598, 987, 1299, 1554],
70000:[599, 989, 1301, 1556],
70100:[600, 990, 1303, 1558],
70200:[601, 992, 1304, 1560],
70300:[602, 993, 1306, 1562],
70400:[603, 994, 1308, 1564],
70500:[604, 996, 1310, 1566],
70600:[604, 997, 1311, 1568],
70700:[605, 998, 1313, 1570],
70800:[606, 1000, 1315, 1572],
70900:[607, 1001, 1317, 1574],
71000:[608, 1002, 1318, 1576],
71100:[609, 1003, 1320, 1578],
71200:[610, 1005, 1321, 1580],
71300:[611, 1006, 1323, 1582],
71400:[611, 1007, 1325, 1584],
71500:[612, 1009, 1327, 1586],
71600:[613, 1010, 1328, 1588],
71700:[614, 1012, 1330, 1590],
71800:[615, 1013, 1332, 1593],
71900:[616, 1014, 1333, 1595],
72000:[616, 1016, 1335, 1597],
72100:[617, 1017, 1337, 1599],
72200:[618, 1019, 1339, 1601],
72300:[619, 1020, 1340, 1603],
72400:[619, 1021, 1342, 1605],
72500:[620, 1023, 1344, 1608],
72600:[621, 1024, 1346, 1610],
72700:[622, 1025, 1347, 1612],
72800:[623, 1027, 1349, 1614],
72900:[624, 1028, 1351, 1616],
73000:[625, 1029, 1353, 1618],
73100:[626, 1030, 1355, 1620],
73200:[627, 1032, 1356, 1622],
73300:[628, 1033, 1358, 1624],
73400:[629, 1034, 1360, 1626],
73500:[629, 1036, 1362, 1628],
73600:[630, 1037, 1363, 1630],
73700:[631, 1039, 1365, 1632],
73800:[632, 1040, 1367, 1634],
73900:[633, 1041, 1368, 1636],
74000:[634, 1043, 1370, 1638],
74100:[635, 1044, 1372, 1640],
74200:[636, 1046, 1374, 1642],
74300:[637, 1047, 1375, 1644],
74400:[638, 1049, 1377, 1646],
74500:[639, 1050, 1379, 1648],
74600:[640, 1051, 1381, 1650],
74700:[640, 1053, 1382, 1653],
74800:[641, 1054, 1384, 1655],
74900:[642, 1056, 1386, 1657],
75000:[643, 1057, 1388, 1659],
75100:[644, 1058, 1390, 1661],
75200:[645, 1060, 1391, 1663],
75300:[646, 1061, 1393, 1665],
75400:[646, 1062, 1395, 1667],
75500:[647, 1064, 1397, 1669],
75600:[648, 1065, 1398, 1671],
75700:[649, 1066, 1400, 1673],
75800:[650, 1068, 1402, 1675],
75900:[651, 1069, 1403, 1677],
76000:[651, 1070, 1405, 1679],
76100:[652, 1071, 1407, 1681],
76200:[653, 1073, 1409, 1683],
76300:[654, 1074, 1410, 1685],
76400:[655, 1076, 1412, 1687],
76500:[655, 1077, 1414, 1689],
76600:[656, 1078, 1416, 1691],
76700:[657, 1080, 1417, 1693],
76800:[658, 1081, 1419, 1695],
76900:[659, 1082, 1421, 1698],
77000:[660, 1084, 1423, 1700],
77100:[661, 1085, 1425, 1702],
77200:[662, 1087, 1426, 1704],
77300:[663, 1088, 1428, 1706],
77400:[664, 1089, 1430, 1708],
77500:[665, 1091, 1432, 1710],
77600:[665, 1092, 1433, 1713],
77700:[666, 1093, 1435, 1715],
77800:[667, 1095, 1437, 1717],
77900:[668, 1096, 1439, 1719],
78000:[669, 1097, 1440, 1721],
78100:[670, 1098, 1442, 1723],
78200:[671, 1100, 1444, 1725],
78300:[671, 1101, 1445, 1727],
78400:[672, 1102, 1447, 1729],
78500:[673, 1104, 1449, 1731],
78600:[674, 1105, 1451, 1733],
78700:[675, 1107, 1452, 1735],
78800:[676, 1108, 1454, 1737],
78900:[676, 1109, 1456, 1739],
79000:[677, 1111, 1458, 1741],
79100:[678, 1112, 1460, 1743],
79200:[679, 1114, 1461, 1745],
79300:[680, 1115, 1463, 1747],
79400:[680, 1116, 1465, 1749],
79500:[681, 1118, 1467, 1751],
79600:[682, 1119, 1468, 1753],
79700:[683, 1120, 1470, 1755],
79800:[684, 1122, 1472, 1758],
79900:[685, 1123, 1474, 1760],
80000:[686, 1124, 1475, 1762],
80100:[687, 1125, 1477, 1764],
80200:[688, 1127, 1479, 1766],
80300:[689, 1128, 1480, 1768],
80400:[690, 1129, 1482, 1770],
80500:[690, 1131, 1484, 1773],
80600:[691, 1132, 1486, 1775],
80700:[692, 1133, 1488, 1777],
80800:[693, 1135, 1489, 1779],
80900:[694, 1136, 1491, 1781],
81000:[695, 1138, 1493, 1783],
81100:[696, 1139, 1495, 1785],
81200:[697, 1141, 1496, 1787],
81300:[698, 1142, 1498, 1789],
81400:[699, 1144, 1500, 1791],
81500:[700, 1145, 1502, 1793],
81600:[700, 1146, 1503, 1795],
81700:[701, 1148, 1505, 1797],
81800:[702, 1149, 1507, 1799],
81900:[703, 1151, 1509, 1801],
82000:[704, 1152, 1510, 1803],
82100:[705, 1153, 1512, 1805],
82200:[706, 1155, 1513, 1807],
82300:[707, 1156, 1515, 1809],
82400:[707, 1157, 1517, 1811],
82500:[708, 1159, 1519, 1813],
82600:[709, 1160, 1520, 1815],
82700:[710, 1161, 1522, 1818],
82800:[711, 1163, 1524, 1820],
82900:[712, 1164, 1525, 1822],
83000:[712, 1165, 1527, 1824],
83100:[713, 1166, 1529, 1826],
83200:[714, 1168, 1531, 1828],
83300:[715, 1169, 1532, 1830],
83400:[715, 1171, 1534, 1832],
83500:[716, 1172, 1536, 1834],
83600:[717, 1173, 1538, 1836],
83700:[718, 1175, 1539, 1838],
83800:[719, 1176, 1541, 1840],
83900:[720, 1177, 1543, 1842],
84000:[721, 1179, 1545, 1844],
84100:[722, 1180, 1547, 1846],
84200:[723, 1182, 1548, 1848],
84300:[724, 1183, 1550, 1850],
84400:[725, 1184, 1552, 1852],
84500:[725, 1186, 1554, 1854],
84600:[726, 1187, 1555, 1856],
84700:[727, 1188, 1557, 1858],
84800:[728, 1190, 1559, 1860],
84900:[729, 1191, 1560, 1862],
85000:[730, 1192, 1562, 1865],
85100:[731, 1193, 1564, 1867],
85200:[732, 1195, 1566, 1869],
85300:[733, 1196, 1567, 1871],
85400:[734, 1197, 1569, 1873],
85500:[735, 1199, 1571, 1875],
85600:[736, 1200, 1573, 1878],
85700:[736, 1202, 1574, 1880],
85800:[737, 1203, 1576, 1882],
85900:[738, 1204, 1578, 1884],
86000:[739, 1206, 1580, 1886],
86100:[740, 1207, 1582, 1888],
86200:[741, 1209, 1583, 1890],
86300:[742, 1210, 1585, 1892],
86400:[742, 1211, 1587, 1894],
86500:[743, 1213, 1589, 1896],
86600:[744, 1214, 1590, 1898],
86700:[745, 1215, 1592, 1900],
86800:[746, 1216, 1594, 1902],
86900:[747, 1218, 1595, 1904],
87000:[747, 1219, 1597, 1906],
87100:[748, 1220, 1599, 1908],
87200:[749, 1222, 1601, 1910],
87300:[750, 1223, 1602, 1912],
87400:[751, 1224, 1604, 1914],
87500:[751, 1226, 1606, 1916],
87600:[752, 1227, 1608, 1918],
87700:[753, 1228, 1609, 1920],
87800:[754, 1230, 1611, 1923],
87900:[755, 1231, 1613, 1925],
88000:[756, 1233, 1615, 1927],
88100:[757, 1234, 1617, 1929],
88200:[758, 1236, 1618, 1931],
88300:[759, 1237, 1620, 1933],
88400:[760, 1239, 1622, 1935],
88500:[761, 1240, 1624, 1938],
88600:[761, 1241, 1625, 1940],
88700:[762, 1243, 1627, 1942],
88800:[763, 1244, 1629, 1944],
88900:[764, 1246, 1631, 1946],
89000:[765, 1247, 1632, 1948],
89100:[766, 1248, 1634, 1950],
89200:[767, 1250, 1636, 1952],
89300:[767, 1251, 1637, 1954],
89400:[768, 1252, 1639, 1956],
89500:[769, 1254, 1641, 1958],
89600:[770, 1255, 1643, 1960],
89700:[771, 1256, 1645, 1962],
89800:[772, 1258, 1646, 1964],
89900:[772, 1259, 1648, 1966],
90000:[773, 1260, 1650, 1968],
90100:[774, 1261, 1652, 1970],
90200:[775, 1263, 1653, 1972],
90300:[776, 1264, 1655, 1974],
90400:[776, 1265, 1657, 1976],
90500:[777, 1266, 1658, 1978],
90600:[778, 1268, 1660, 1980],
90700:[779, 1269, 1661, 1982],
90800:[780, 1270, 1663, 1984],
90900:[781, 1272, 1665, 1986],
91000:[782, 1273, 1666, 1988],
91100:[783, 1274, 1668, 1990],
91200:[784, 1276, 1669, 1992],
91300:[784, 1277, 1671, 1994],
91400:[785, 1278, 1672, 1996],
91500:[786, 1279, 1674, 1997],
91600:[787, 1281, 1675, 1999],
91700:[788, 1282, 1677, 2001],
91800:[789, 1283, 1679, 2003],
91900:[789, 1284, 1680, 2005],
92000:[790, 1286, 1682, 2007],
92100:[791, 1287, 1684, 2009],
92200:[792, 1288, 1685, 2011],
92300:[792, 1290, 1687, 2013],
92400:[793, 1291, 1688, 2015],
92500:[794, 1292, 1690, 2017],
92600:[795, 1293, 1691, 2018],
92700:[796, 1295, 1693, 2020],
92800:[797, 1296, 1695, 2022],
92900:[797, 1297, 1696, 2024],
93000:[798, 1298, 1698, 2026],
93100:[799, 1299, 1700, 2028],
93200:[800, 1300, 1701, 2030],
93300:[800, 1302, 1703, 2031],
93400:[801, 1303, 1704, 2033],
93500:[802, 1304, 1706, 2035],
93600:[803, 1305, 1707, 2037],
93700:[804, 1306, 1709, 2039],
93800:[805, 1308, 1711, 2041],
93900:[805, 1309, 1712, 2042],
94000:[806, 1310, 1714, 2044],
94100:[807, 1311, 1716, 2046],
94200:[807, 1312, 1717, 2048],
94300:[808, 1314, 1719, 2050],
94400:[809, 1315, 1720, 2052],
94500:[810, 1316, 1722, 2053],
94600:[810, 1317, 1724, 2055],
94700:[811, 1318, 1725, 2057],
94800:[812, 1319, 1727, 2059],
94900:[813, 1321, 1728, 2061],
95000:[813, 1322, 1730, 2063],
95100:[814, 1323, 1732, 2065],
95200:[815, 1325, 1733, 2067],
95300:[815, 1326, 1735, 2068],
95400:[816, 1327, 1736, 2070],
95500:[817, 1328, 1738, 2072],
95600:[818, 1330, 1739, 2074],
95700:[818, 1331, 1741, 2076],
95800:[819, 1332, 1742, 2078],
95900:[820, 1333, 1744, 2079],
96000:[821, 1335, 1745, 2081],
96100:[822, 1336, 1747, 2083],
96200:[823, 1337, 1748, 2085],
96300:[823, 1339, 1750, 2087],
96400:[824, 1340, 1751, 2088],
96500:[825, 1341, 1753, 2090],
96600:[826, 1342, 1754, 2092],
96700:[826, 1344, 1756, 2094],
96800:[827, 1345, 1758, 2096],
96900:[828, 1346, 1759, 2098],
97000:[829, 1347, 1761, 2100],
97100:[830, 1348, 1763, 2102],
97200:[831, 1349, 1764, 2104],
97300:[831, 1351, 1766, 2105],
97400:[832, 1352, 1767, 2107],
97500:[833, 1353, 1769, 2109],
97600:[834, 1354, 1771, 2111],
97700:[835, 1356, 1772, 2113],
97800:[835, 1357, 1774, 2114],
97900:[836, 1358, 1775, 2116],
98000:[837, 1359, 1777, 2118],
98100:[838, 1360, 1779, 2120],
98200:[839, 1361, 1780, 2122],
98300:[839, 1363, 1782, 2124],
98400:[840, 1364, 1783, 2125],
98500:[841, 1365, 1785, 2127],
98600:[842, 1366, 1786, 2129],
98700:[843, 1367, 1788, 2131],
98800:[843, 1369, 1789, 2133],
98900:[844, 1370, 1791, 2135],
99000:[845, 1371, 1792, 2137],
99100:[846, 1372, 1794, 2139],
99200:[847, 1373, 1795, 2141],
99300:[847, 1375, 1797, 2143],
99400:[848, 1376, 1798, 2145],
99500:[849, 1377, 1800, 2147],
99600:[850, 1378, 1801, 2148],
99700:[851, 1379, 1803, 2150],
99800:[852, 1380, 1804, 2152],
99900:[852, 1382, 1806, 2154],
};
const OR17_NS=[0.74, 1.2, 1.5, 1.7];

// Northwest Territories — 2017 Federal Child Support Guidelines Table
const T17_NT={
100000:[942, 1525, 1991, 2372],
100100:[943, 1526, 1993, 2374],
100200:[944, 1528, 1994, 2376],
100300:[945, 1529, 1996, 2378],
100400:[945, 1530, 1998, 2380],
100500:[946, 1531, 1999, 2382],
100600:[947, 1533, 2001, 2384],
100700:[948, 1534, 2003, 2386],
100800:[949, 1535, 2005, 2388],
100900:[950, 1537, 2006, 2390],
101000:[951, 1538, 2008, 2393],
101100:[952, 1539, 2010, 2395],
101200:[953, 1541, 2011, 2397],
101300:[954, 1542, 2013, 2399],
101400:[955, 1543, 2015, 2401],
101500:[956, 1545, 2016, 2403],
101600:[956, 1546, 2018, 2405],
101700:[957, 1548, 2020, 2407],
101800:[958, 1549, 2021, 2409],
101900:[959, 1550, 2023, 2411],
102000:[960, 1552, 2025, 2413],
102100:[961, 1553, 2027, 2415],
102200:[962, 1555, 2029, 2417],
102300:[963, 1556, 2030, 2419],
102400:[963, 1557, 2032, 2421],
102500:[964, 1559, 2034, 2423],
102600:[965, 1560, 2036, 2425],
102700:[966, 1561, 2037, 2427],
102800:[967, 1563, 2039, 2429],
102900:[968, 1564, 2041, 2431],
103000:[968, 1565, 2043, 2433],
103100:[969, 1566, 2045, 2435],
103200:[970, 1568, 2046, 2437],
103300:[971, 1569, 2048, 2439],
103400:[972, 1570, 2050, 2441],
103500:[972, 1571, 2052, 2443],
103600:[973, 1573, 2053, 2445],
103700:[974, 1574, 2055, 2447],
103800:[975, 1575, 2057, 2450],
103900:[976, 1577, 2059, 2452],
104000:[977, 1578, 2060, 2454],
104100:[978, 1579, 2062, 2456],
104200:[979, 1581, 2063, 2458],
104300:[979, 1582, 2065, 2460],
104400:[980, 1583, 2067, 2462],
104500:[981, 1585, 2069, 2464],
104600:[982, 1586, 2070, 2466],
104700:[983, 1588, 2072, 2468],
104800:[984, 1589, 2074, 2470],
104900:[984, 1590, 2076, 2472],
105000:[985, 1592, 2077, 2474],
105100:[986, 1593, 2079, 2476],
105200:[987, 1595, 2080, 2478],
105300:[988, 1596, 2082, 2480],
105400:[988, 1597, 2084, 2482],
105500:[989, 1599, 2086, 2484],
105600:[990, 1600, 2087, 2486],
105700:[991, 1601, 2089, 2488],
105800:[992, 1603, 2091, 2490],
105900:[993, 1604, 2092, 2492],
106000:[994, 1605, 2094, 2494],
106100:[995, 1606, 2096, 2496],
106200:[996, 1608, 2097, 2498],
106300:[996, 1609, 2099, 2500],
106400:[997, 1610, 2101, 2502],
106500:[998, 1611, 2102, 2504],
106600:[999, 1613, 2104, 2506],
106700:[1000, 1614, 2106, 2508],
106800:[1000, 1615, 2108, 2510],
106900:[1001, 1617, 2109, 2512],
107000:[1002, 1618, 2111, 2514],
107100:[1003, 1619, 2113, 2516],
107200:[1004, 1621, 2114, 2518],
107300:[1005, 1622, 2116, 2520],
107400:[1005, 1623, 2118, 2522],
107500:[1006, 1625, 2119, 2524],
107600:[1007, 1626, 2121, 2526],
107700:[1008, 1627, 2123, 2528],
107800:[1009, 1629, 2124, 2530],
107900:[1010, 1630, 2126, 2532],
108000:[1011, 1632, 2128, 2535],
108100:[1012, 1633, 2130, 2537],
108200:[1013, 1635, 2132, 2539],
108300:[1014, 1636, 2133, 2541],
108400:[1015, 1637, 2135, 2543],
108500:[1015, 1639, 2137, 2545],
108600:[1016, 1640, 2139, 2547],
108700:[1017, 1641, 2140, 2549],
108800:[1018, 1643, 2142, 2551],
108900:[1019, 1644, 2144, 2553],
109000:[1020, 1645, 2146, 2555],
109100:[1021, 1646, 2148, 2557],
109200:[1022, 1648, 2149, 2559],
109300:[1023, 1649, 2151, 2561],
109400:[1023, 1651, 2153, 2563],
109500:[1024, 1652, 2155, 2565],
109600:[1025, 1653, 2156, 2567],
109700:[1026, 1655, 2158, 2569],
109800:[1027, 1656, 2160, 2571],
109900:[1028, 1657, 2162, 2573],
110000:[1028, 1659, 2163, 2575],
110100:[1029, 1660, 2165, 2577],
110200:[1030, 1662, 2166, 2579],
110300:[1031, 1663, 2168, 2581],
110400:[1032, 1664, 2170, 2583],
110500:[1032, 1666, 2172, 2585],
110600:[1033, 1667, 2173, 2587],
110700:[1034, 1668, 2175, 2589],
110800:[1035, 1670, 2177, 2592],
110900:[1036, 1671, 2179, 2594],
111000:[1037, 1672, 2180, 2596],
111100:[1038, 1673, 2182, 2598],
111200:[1039, 1675, 2183, 2600],
111300:[1039, 1676, 2185, 2602],
111400:[1040, 1677, 2187, 2604],
111500:[1041, 1679, 2189, 2606],
111600:[1042, 1680, 2190, 2608],
111700:[1043, 1681, 2192, 2610],
111800:[1044, 1683, 2194, 2612],
111900:[1044, 1684, 2195, 2614],
112000:[1045, 1685, 2197, 2616],
112100:[1046, 1686, 2199, 2618],
112200:[1047, 1688, 2200, 2620],
112300:[1048, 1689, 2202, 2622],
112400:[1048, 1691, 2204, 2624],
112500:[1049, 1692, 2205, 2626],
112600:[1050, 1693, 2207, 2628],
112700:[1051, 1695, 2209, 2630],
112800:[1052, 1696, 2211, 2632],
112900:[1053, 1697, 2212, 2634],
113000:[1054, 1699, 2214, 2636],
113100:[1055, 1700, 2216, 2638],
113200:[1056, 1702, 2217, 2640],
113300:[1057, 1703, 2219, 2642],
113400:[1058, 1704, 2221, 2644],
113500:[1059, 1706, 2222, 2646],
113600:[1059, 1707, 2224, 2648],
113700:[1060, 1708, 2226, 2650],
113800:[1061, 1710, 2227, 2652],
113900:[1062, 1711, 2229, 2654],
114000:[1063, 1712, 2231, 2656],
114100:[1064, 1713, 2233, 2658],
114200:[1065, 1715, 2235, 2660],
114300:[1066, 1716, 2236, 2662],
114400:[1066, 1717, 2238, 2664],
114500:[1067, 1719, 2240, 2666],
114600:[1068, 1720, 2242, 2668],
114700:[1069, 1721, 2243, 2670],
114800:[1070, 1722, 2245, 2672],
114900:[1071, 1724, 2247, 2674],
115000:[1071, 1725, 2249, 2677],
115100:[1072, 1726, 2251, 2679],
115200:[1073, 1728, 2252, 2681],
115300:[1074, 1729, 2254, 2683],
115400:[1075, 1730, 2256, 2685],
115500:[1075, 1732, 2258, 2687],
115600:[1076, 1733, 2259, 2689],
115700:[1077, 1735, 2261, 2691],
115800:[1078, 1736, 2263, 2693],
115900:[1079, 1737, 2265, 2695],
116000:[1080, 1739, 2266, 2697],
116100:[1081, 1740, 2268, 2699],
116200:[1082, 1742, 2269, 2701],
116300:[1082, 1743, 2271, 2703],
116400:[1083, 1744, 2273, 2705],
116500:[1084, 1746, 2275, 2707],
116600:[1085, 1747, 2276, 2709],
116700:[1086, 1748, 2278, 2711],
116800:[1087, 1750, 2280, 2713],
116900:[1087, 1751, 2282, 2715],
117000:[1088, 1752, 2283, 2717],
117100:[1089, 1753, 2285, 2719],
117200:[1090, 1755, 2286, 2721],
117300:[1091, 1756, 2288, 2723],
117400:[1091, 1757, 2290, 2725],
117500:[1092, 1759, 2292, 2727],
117600:[1093, 1760, 2293, 2729],
117700:[1094, 1761, 2295, 2731],
117800:[1095, 1762, 2297, 2734],
117900:[1096, 1764, 2298, 2736],
118000:[1097, 1765, 2300, 2738],
118100:[1098, 1766, 2302, 2740],
118200:[1099, 1768, 2303, 2742],
118300:[1099, 1769, 2305, 2744],
118400:[1100, 1770, 2307, 2746],
118500:[1101, 1772, 2308, 2748],
118600:[1102, 1773, 2310, 2750],
118700:[1103, 1775, 2312, 2752],
118800:[1103, 1776, 2314, 2754],
118900:[1104, 1777, 2315, 2756],
119000:[1105, 1779, 2317, 2758],
119100:[1106, 1780, 2319, 2760],
119200:[1107, 1782, 2320, 2762],
119300:[1108, 1783, 2322, 2764],
119400:[1108, 1784, 2324, 2766],
119500:[1109, 1786, 2325, 2768],
119600:[1110, 1787, 2327, 2770],
119700:[1111, 1788, 2329, 2772],
119800:[1112, 1790, 2330, 2774],
119900:[1113, 1791, 2332, 2776],
12000:[0, 0, 0, 0],
120000:[1114, 1792, 2334, 2778],
120100:[1115, 1793, 2336, 2780],
120200:[1116, 1795, 2338, 2782],
120300:[1117, 1796, 2339, 2784],
120400:[1118, 1797, 2341, 2786],
120500:[1118, 1798, 2343, 2788],
120600:[1119, 1800, 2345, 2790],
120700:[1120, 1801, 2346, 2792],
120800:[1121, 1802, 2348, 2794],
120900:[1122, 1804, 2350, 2796],
12100:[4, 10, 11, 11],
121000:[1123, 1805, 2352, 2798],
121100:[1124, 1806, 2354, 2800],
121200:[1125, 1808, 2355, 2802],
121300:[1126, 1809, 2357, 2804],
121400:[1126, 1810, 2359, 2806],
121500:[1127, 1812, 2361, 2808],
121600:[1128, 1813, 2362, 2810],
121700:[1129, 1815, 2364, 2812],
121800:[1130, 1816, 2366, 2814],
121900:[1131, 1817, 2368, 2816],
12200:[9, 20, 21, 23],
122000:[1131, 1819, 2369, 2819],
122100:[1132, 1820, 2371, 2821],
122200:[1133, 1822, 2372, 2823],
122300:[1134, 1823, 2374, 2825],
122400:[1135, 1824, 2376, 2827],
122500:[1135, 1826, 2378, 2829],
122600:[1136, 1827, 2379, 2831],
122700:[1137, 1828, 2381, 2833],
122800:[1138, 1830, 2383, 2835],
122900:[1139, 1831, 2385, 2837],
12300:[13, 30, 32, 34],
123000:[1140, 1832, 2386, 2839],
123100:[1141, 1833, 2388, 2841],
123200:[1142, 1835, 2389, 2843],
123300:[1142, 1836, 2391, 2845],
123400:[1143, 1837, 2393, 2847],
123500:[1144, 1838, 2395, 2849],
123600:[1145, 1840, 2396, 2851],
123700:[1146, 1841, 2398, 2853],
123800:[1147, 1842, 2400, 2855],
123900:[1147, 1844, 2401, 2857],
12400:[18, 40, 42, 46],
124000:[1148, 1845, 2403, 2859],
124100:[1149, 1846, 2405, 2861],
124200:[1150, 1848, 2406, 2863],
124300:[1151, 1849, 2408, 2865],
124400:[1151, 1850, 2410, 2867],
124500:[1152, 1852, 2411, 2869],
124600:[1153, 1853, 2413, 2871],
124700:[1154, 1854, 2415, 2873],
124800:[1155, 1856, 2417, 2876],
124900:[1156, 1857, 2418, 2878],
12500:[22, 50, 53, 57],
125000:[1157, 1859, 2420, 2880],
125100:[1158, 1860, 2422, 2882],
125200:[1159, 1862, 2423, 2884],
125300:[1160, 1863, 2425, 2886],
125400:[1161, 1864, 2427, 2888],
125500:[1162, 1866, 2428, 2890],
125600:[1162, 1867, 2430, 2892],
125700:[1163, 1868, 2432, 2894],
125800:[1164, 1870, 2433, 2896],
125900:[1165, 1871, 2435, 2898],
12600:[26, 59, 64, 68],
126000:[1166, 1872, 2437, 2900],
126100:[1167, 1873, 2439, 2902],
126200:[1168, 1875, 2441, 2904],
126300:[1169, 1876, 2442, 2906],
126400:[1169, 1878, 2444, 2908],
126500:[1170, 1879, 2446, 2910],
126600:[1171, 1880, 2448, 2912],
126700:[1172, 1882, 2449, 2914],
126800:[1173, 1883, 2451, 2916],
126900:[1174, 1884, 2453, 2918],
12700:[31, 69, 74, 80],
127000:[1174, 1886, 2455, 2920],
127100:[1175, 1887, 2457, 2922],
127200:[1176, 1889, 2458, 2924],
127300:[1177, 1890, 2460, 2926],
127400:[1178, 1891, 2462, 2928],
127500:[1178, 1893, 2464, 2930],
127600:[1179, 1894, 2465, 2932],
127700:[1180, 1895, 2467, 2935],
127800:[1181, 1897, 2469, 2937],
127900:[1182, 1898, 2471, 2939],
12800:[35, 79, 85, 91],
128000:[1183, 1899, 2472, 2941],
128100:[1184, 1900, 2474, 2943],
128200:[1185, 1902, 2475, 2945],
128300:[1185, 1903, 2477, 2947],
128400:[1186, 1904, 2479, 2949],
128500:[1187, 1906, 2481, 2951],
128600:[1188, 1907, 2482, 2953],
128700:[1189, 1908, 2484, 2955],
128800:[1190, 1910, 2486, 2957],
128900:[1190, 1911, 2488, 2959],
12900:[40, 89, 95, 103],
129000:[1191, 1912, 2489, 2961],
129100:[1192, 1913, 2491, 2963],
129200:[1193, 1915, 2492, 2965],
129300:[1194, 1916, 2494, 2967],
129400:[1194, 1918, 2496, 2969],
129500:[1195, 1919, 2498, 2971],
129600:[1196, 1920, 2499, 2973],
129700:[1197, 1922, 2501, 2975],
129800:[1198, 1923, 2503, 2977],
129900:[1199, 1924, 2504, 2979],
13000:[44, 99, 106, 114],
130000:[1200, 1926, 2506, 2981],
130100:[1201, 1927, 2508, 2983],
130200:[1202, 1929, 2509, 2985],
130300:[1202, 1930, 2511, 2987],
130400:[1203, 1931, 2513, 2989],
130500:[1204, 1933, 2514, 2991],
130600:[1205, 1934, 2516, 2993],
130700:[1206, 1935, 2518, 2995],
130800:[1206, 1937, 2520, 2997],
130900:[1207, 1938, 2521, 2999],
13100:[46, 103, 110, 119],
131000:[1208, 1939, 2523, 3001],
131100:[1209, 1940, 2525, 3003],
131200:[1210, 1942, 2526, 3005],
131300:[1211, 1943, 2528, 3007],
131400:[1211, 1944, 2530, 3009],
131500:[1212, 1946, 2531, 3011],
131600:[1213, 1947, 2533, 3013],
131700:[1214, 1948, 2535, 3015],
131800:[1215, 1949, 2536, 3018],
131900:[1216, 1951, 2538, 3020],
13200:[48, 107, 114, 123],
132000:[1217, 1952, 2540, 3022],
132100:[1218, 1953, 2542, 3024],
132200:[1219, 1955, 2544, 3026],
132300:[1220, 1956, 2545, 3028],
132400:[1221, 1957, 2547, 3030],
132500:[1221, 1959, 2549, 3032],
132600:[1222, 1960, 2551, 3034],
132700:[1223, 1962, 2552, 3036],
132800:[1224, 1963, 2554, 3038],
132900:[1225, 1964, 2556, 3040],
13300:[50, 110, 119, 128],
133000:[1226, 1966, 2558, 3042],
133100:[1227, 1967, 2560, 3044],
133200:[1228, 1969, 2561, 3046],
133300:[1229, 1970, 2563, 3048],
133400:[1229, 1971, 2565, 3050],
133500:[1230, 1973, 2566, 3052],
133600:[1231, 1974, 2568, 3054],
133700:[1232, 1975, 2569, 3056],
133800:[1233, 1977, 2571, 3058],
133900:[1234, 1978, 2573, 3060],
13400:[52, 114, 123, 132],
134000:[1234, 1979, 2574, 3062],
134100:[1235, 1980, 2576, 3064],
134200:[1236, 1982, 2577, 3066],
134300:[1236, 1983, 2579, 3068],
134400:[1237, 1984, 2581, 3070],
134500:[1238, 1986, 2582, 3072],
134600:[1239, 1987, 2584, 3074],
134700:[1240, 1988, 2586, 3076],
134800:[1240, 1990, 2587, 3078],
134900:[1241, 1991, 2589, 3080],
13500:[54, 118, 127, 137],
135000:[1242, 1992, 2591, 3082],
135100:[1243, 1993, 2593, 3084],
135200:[1244, 1995, 2594, 3086],
135300:[1245, 1996, 2596, 3088],
135400:[1245, 1997, 2598, 3090],
135500:[1246, 1999, 2599, 3092],
135600:[1247, 2000, 2601, 3094],
135700:[1248, 2001, 2603, 3096],
135800:[1249, 2003, 2605, 3098],
135900:[1250, 2004, 2606, 3100],
13600:[56, 122, 131, 141],
136000:[1251, 2005, 2608, 3101],
136100:[1252, 2006, 2610, 3103],
136200:[1253, 2008, 2611, 3105],
136300:[1253, 2009, 2613, 3107],
136400:[1254, 2010, 2615, 3109],
136500:[1255, 2012, 2616, 3111],
136600:[1256, 2013, 2618, 3113],
136700:[1257, 2014, 2619, 3115],
136800:[1258, 2016, 2621, 3117],
136900:[1258, 2017, 2623, 3119],
13700:[58, 126, 135, 146],
137000:[1259, 2018, 2624, 3121],
137100:[1260, 2019, 2626, 3123],
137200:[1261, 2021, 2627, 3125],
137300:[1261, 2022, 2629, 3127],
137400:[1262, 2023, 2631, 3129],
137500:[1263, 2025, 2632, 3131],
137600:[1264, 2026, 2634, 3133],
137700:[1265, 2027, 2636, 3135],
137800:[1265, 2029, 2637, 3137],
137900:[1266, 2030, 2639, 3139],
13800:[60, 130, 139, 150],
138000:[1267, 2031, 2641, 3141],
138100:[1268, 2032, 2643, 3143],
138200:[1269, 2033, 2644, 3145],
138300:[1270, 2035, 2646, 3147],
138400:[1270, 2036, 2648, 3149],
138500:[1271, 2037, 2649, 3151],
138600:[1272, 2038, 2651, 3153],
138700:[1273, 2040, 2653, 3155],
138800:[1274, 2041, 2655, 3157],
138900:[1275, 2042, 2656, 3158],
13900:[62, 133, 144, 155],
139000:[1276, 2043, 2658, 3160],
139100:[1277, 2044, 2660, 3162],
139200:[1278, 2046, 2661, 3164],
139300:[1278, 2047, 2663, 3166],
139400:[1279, 2048, 2665, 3168],
139500:[1280, 2049, 2666, 3170],
139600:[1281, 2051, 2668, 3172],
139700:[1282, 2052, 2669, 3174],
139800:[1283, 2053, 2671, 3176],
139900:[1283, 2054, 2673, 3178],
14000:[64, 137, 148, 159],
140000:[1284, 2056, 2674, 3180],
140100:[1285, 2057, 2676, 3182],
140200:[1286, 2059, 2677, 3184],
140300:[1286, 2060, 2679, 3186],
140400:[1287, 2061, 2681, 3188],
140500:[1288, 2062, 2682, 3190],
140600:[1289, 2064, 2684, 3191],
140700:[1290, 2065, 2686, 3193],
140800:[1290, 2066, 2687, 3195],
140900:[1291, 2067, 2689, 3197],
14100:[66, 141, 152, 163],
141000:[1292, 2069, 2691, 3199],
141100:[1293, 2070, 2693, 3201],
141200:[1294, 2071, 2694, 3203],
141300:[1294, 2073, 2696, 3205],
141400:[1295, 2074, 2697, 3207],
141500:[1296, 2075, 2699, 3208],
141600:[1297, 2076, 2700, 3210],
141700:[1298, 2077, 2702, 3212],
141800:[1298, 2079, 2703, 3214],
141900:[1299, 2080, 2705, 3216],
14200:[68, 144, 156, 167],
142000:[1300, 2081, 2706, 3218],
142100:[1301, 2082, 2708, 3220],
142200:[1302, 2084, 2709, 3222],
142300:[1302, 2085, 2711, 3223],
142400:[1303, 2086, 2712, 3225],
142500:[1304, 2087, 2714, 3227],
142600:[1305, 2089, 2715, 3229],
142700:[1306, 2090, 2717, 3231],
142800:[1306, 2091, 2719, 3233],
142900:[1307, 2092, 2720, 3234],
14300:[70, 148, 159, 171],
143000:[1308, 2094, 2722, 3236],
143100:[1309, 2095, 2724, 3238],
143200:[1310, 2096, 2725, 3240],
143300:[1310, 2098, 2727, 3242],
143400:[1311, 2099, 2728, 3243],
143500:[1312, 2100, 2730, 3245],
143600:[1313, 2101, 2732, 3247],
143700:[1314, 2103, 2733, 3249],
143800:[1314, 2104, 2735, 3251],
143900:[1315, 2105, 2736, 3253],
14400:[72, 151, 163, 176],
144000:[1316, 2106, 2738, 3255],
144100:[1317, 2107, 2740, 3257],
144200:[1318, 2108, 2741, 3259],
144300:[1318, 2110, 2743, 3261],
144400:[1319, 2111, 2744, 3263],
144500:[1320, 2112, 2746, 3264],
144600:[1321, 2113, 2748, 3266],
144700:[1322, 2114, 2749, 3268],
144800:[1323, 2116, 2751, 3270],
144900:[1323, 2117, 2752, 3272],
14500:[74, 155, 167, 180],
145000:[1324, 2118, 2754, 3274],
145100:[1325, 2119, 2756, 3276],
145200:[1326, 2121, 2757, 3278],
145300:[1326, 2122, 2759, 3280],
145400:[1327, 2123, 2760, 3282],
145500:[1328, 2124, 2762, 3284],
145600:[1329, 2126, 2764, 3286],
145700:[1330, 2127, 2765, 3287],
145800:[1331, 2128, 2767, 3289],
145900:[1331, 2130, 2769, 3291],
14600:[76, 158, 171, 184],
146000:[1332, 2131, 2770, 3293],
146100:[1333, 2132, 2772, 3295],
146200:[1334, 2133, 2773, 3297],
146300:[1335, 2135, 2775, 3299],
146400:[1335, 2136, 2776, 3300],
146500:[1336, 2137, 2778, 3302],
146600:[1337, 2138, 2779, 3304],
146700:[1338, 2140, 2781, 3306],
146800:[1339, 2141, 2782, 3308],
146900:[1340, 2142, 2784, 3310],
14700:[78, 162, 175, 188],
147000:[1340, 2143, 2785, 3311],
147100:[1341, 2144, 2787, 3313],
147200:[1341, 2145, 2788, 3315],
147300:[1342, 2147, 2790, 3317],
147400:[1343, 2148, 2791, 3319],
147500:[1344, 2149, 2793, 3320],
147600:[1344, 2150, 2794, 3322],
147700:[1345, 2152, 2796, 3324],
147800:[1346, 2153, 2797, 3326],
147900:[1347, 2154, 2799, 3328],
14800:[80, 165, 178, 192],
148000:[1347, 2155, 2801, 3330],
148100:[1348, 2156, 2803, 3332],
148200:[1349, 2157, 2804, 3334],
148300:[1349, 2159, 2806, 3336],
148400:[1350, 2160, 2807, 3338],
148500:[1351, 2161, 2809, 3340],
148600:[1352, 2162, 2810, 3341],
148700:[1352, 2163, 2812, 3343],
148800:[1353, 2165, 2814, 3345],
148900:[1354, 2166, 2815, 3347],
14900:[82, 169, 182, 196],
149000:[1355, 2167, 2817, 3349],
149100:[1356, 2168, 2819, 3351],
149200:[1357, 2170, 2820, 3353],
149300:[1357, 2171, 2822, 3355],
149400:[1358, 2172, 2823, 3356],
149500:[1359, 2173, 2825, 3358],
149600:[1360, 2175, 2827, 3360],
149700:[1360, 2176, 2828, 3362],
149800:[1361, 2177, 2830, 3364],
149900:[1362, 2178, 2831, 3366],
15000:[84, 173, 186, 200],
150000:[1363, 2180, 2833, 3367],
15100:[86, 176, 190, 204],
15200:[88, 180, 193, 208],
15300:[90, 183, 197, 212],
15400:[92, 187, 200, 215],
15500:[94, 190, 204, 219],
15600:[96, 193, 207, 223],
15700:[98, 197, 211, 227],
15800:[100, 200, 215, 231],
15900:[102, 204, 218, 235],
16000:[104, 207, 222, 238],
16100:[106, 210, 226, 242],
16200:[108, 213, 229, 246],
16300:[110, 217, 233, 249],
16400:[112, 220, 236, 253],
16500:[114, 223, 240, 257],
16600:[116, 226, 243, 261],
16700:[118, 230, 247, 264],
16800:[120, 233, 250, 268],
16900:[122, 236, 254, 272],
17000:[124, 239, 258, 276],
17100:[126, 242, 261, 280],
17200:[128, 246, 265, 283],
17300:[130, 249, 268, 287],
17400:[132, 252, 272, 291],
17500:[134, 255, 275, 295],
17600:[136, 259, 279, 298],
17700:[138, 262, 282, 302],
17800:[140, 265, 286, 306],
17900:[142, 269, 289, 309],
18000:[144, 272, 292, 313],
18100:[146, 276, 296, 317],
18200:[147, 279, 300, 321],
18300:[149, 283, 304, 325],
18400:[151, 286, 308, 330],
18500:[152, 290, 312, 334],
18600:[154, 293, 316, 338],
18700:[156, 297, 320, 342],
18800:[158, 300, 324, 346],
18900:[159, 304, 328, 350],
19000:[161, 307, 332, 355],
19100:[162, 308, 336, 360],
19200:[163, 310, 341, 364],
19300:[164, 311, 345, 369],
19400:[165, 313, 349, 374],
19500:[166, 314, 354, 378],
19600:[167, 316, 358, 383],
19700:[168, 317, 362, 388],
19800:[168, 319, 367, 392],
19900:[169, 320, 371, 397],
20000:[170, 321, 375, 402],
20100:[171, 322, 379, 407],
20200:[172, 324, 384, 411],
20300:[173, 325, 388, 416],
20400:[173, 327, 392, 421],
20500:[174, 328, 397, 425],
20600:[175, 330, 401, 430],
20700:[176, 331, 406, 435],
20800:[177, 333, 410, 440],
20900:[178, 334, 414, 444],
21000:[178, 336, 419, 449],
21100:[179, 337, 423, 454],
21200:[180, 339, 428, 458],
21300:[181, 340, 432, 463],
21400:[181, 342, 437, 468],
21500:[182, 343, 441, 473],
21600:[183, 345, 445, 477],
21700:[184, 346, 450, 482],
21800:[185, 348, 454, 487],
21900:[186, 349, 459, 491],
22000:[187, 351, 463, 496],
22100:[188, 353, 467, 501],
22200:[189, 354, 471, 505],
22300:[190, 356, 475, 510],
22400:[191, 357, 479, 515],
22500:[191, 359, 483, 520],
22600:[192, 360, 487, 524],
22700:[193, 362, 490, 529],
22800:[194, 363, 494, 534],
22900:[195, 365, 498, 538],
23000:[196, 366, 502, 543],
23100:[197, 368, 504, 548],
23200:[198, 369, 506, 552],
23300:[199, 371, 508, 557],
23400:[200, 372, 510, 562],
23500:[200, 374, 512, 566],
23600:[201, 375, 514, 571],
23700:[202, 377, 516, 575],
23800:[203, 378, 518, 580],
23900:[204, 380, 519, 585],
24000:[205, 381, 521, 589],
24100:[206, 382, 523, 594],
24200:[207, 384, 525, 598],
24300:[208, 385, 527, 603],
24400:[209, 387, 529, 608],
24500:[210, 388, 531, 612],
24600:[210, 390, 533, 617],
24700:[211, 391, 535, 622],
24800:[212, 393, 537, 626],
24900:[213, 394, 539, 631],
25000:[214, 395, 541, 636],
25100:[215, 397, 543, 641],
25200:[216, 398, 545, 645],
25300:[217, 400, 547, 650],
25400:[218, 402, 550, 655],
25500:[219, 403, 552, 659],
25600:[220, 405, 554, 664],
25700:[221, 407, 556, 669],
25800:[222, 408, 558, 673],
25900:[223, 410, 560, 678],
26000:[224, 412, 562, 683],
26100:[225, 414, 564, 686],
26200:[227, 416, 567, 689],
26300:[228, 418, 569, 691],
26400:[230, 420, 571, 694],
26500:[231, 422, 574, 697],
26600:[232, 424, 576, 700],
26700:[234, 426, 578, 702],
26800:[235, 428, 581, 705],
26900:[236, 429, 583, 708],
27000:[238, 431, 585, 711],
27100:[239, 433, 587, 714],
27200:[241, 435, 590, 716],
27300:[242, 437, 592, 719],
27400:[244, 439, 594, 722],
27500:[245, 441, 597, 724],
27600:[246, 443, 599, 727],
27700:[248, 445, 601, 730],
27800:[249, 446, 603, 732],
27900:[251, 448, 606, 735],
28000:[252, 450, 608, 738],
28100:[253, 452, 610, 741],
28200:[254, 453, 612, 743],
28300:[255, 455, 614, 746],
28400:[257, 457, 617, 748],
28500:[258, 459, 619, 751],
28600:[259, 460, 621, 753],
28700:[260, 462, 623, 756],
28800:[261, 464, 625, 759],
28900:[262, 465, 627, 761],
29000:[263, 467, 630, 764],
29100:[264, 468, 632, 766],
29200:[265, 470, 634, 769],
29300:[266, 471, 636, 771],
29400:[267, 473, 638, 773],
29500:[267, 474, 639, 776],
29600:[268, 475, 641, 778],
29700:[269, 477, 643, 780],
29800:[270, 478, 645, 783],
29900:[271, 480, 647, 785],
30000:[272, 481, 649, 787],
30100:[273, 483, 651, 789],
30200:[274, 484, 653, 792],
30300:[275, 486, 655, 794],
30400:[276, 488, 657, 797],
30500:[277, 489, 659, 799],
30600:[278, 491, 661, 802],
30700:[279, 493, 663, 804],
30800:[280, 494, 665, 806],
30900:[281, 496, 668, 809],
31000:[282, 498, 670, 811],
31100:[283, 500, 672, 813],
31200:[284, 501, 674, 816],
31300:[285, 503, 676, 818],
31400:[286, 505, 678, 821],
31500:[287, 506, 680, 823],
31600:[288, 508, 683, 826],
31700:[289, 509, 685, 828],
31800:[290, 511, 687, 831],
31900:[291, 513, 689, 833],
32000:[292, 514, 691, 836],
32100:[293, 516, 693, 839],
32200:[294, 517, 695, 841],
32300:[295, 519, 697, 844],
32400:[296, 520, 699, 846],
32500:[297, 522, 702, 849],
32600:[298, 524, 704, 851],
32700:[299, 525, 706, 854],
32800:[301, 527, 708, 856],
32900:[302, 529, 710, 859],
33000:[303, 530, 712, 861],
33100:[304, 532, 714, 863],
33200:[305, 533, 716, 866],
33300:[306, 535, 718, 868],
33400:[307, 536, 720, 871],
33500:[308, 538, 723, 873],
33600:[309, 540, 725, 876],
33700:[310, 541, 727, 878],
33800:[311, 543, 729, 881],
33900:[312, 544, 731, 883],
34000:[313, 546, 733, 885],
34100:[314, 548, 735, 887],
34200:[315, 549, 737, 890],
34300:[316, 551, 739, 892],
34400:[317, 552, 741, 895],
34500:[318, 554, 743, 897],
34600:[320, 555, 745, 900],
34700:[321, 557, 747, 902],
34800:[322, 559, 749, 905],
34900:[323, 560, 751, 907],
35000:[324, 562, 753, 910],
35100:[325, 564, 755, 912],
35200:[326, 565, 757, 915],
35300:[327, 567, 759, 917],
35400:[328, 568, 761, 920],
35500:[329, 570, 763, 922],
35600:[330, 571, 765, 925],
35700:[331, 573, 767, 927],
35800:[332, 574, 769, 929],
35900:[333, 576, 772, 932],
36000:[334, 578, 774, 934],
36100:[335, 579, 776, 936],
36200:[336, 581, 778, 939],
36300:[337, 582, 780, 941],
36400:[338, 584, 782, 943],
36500:[339, 585, 784, 946],
36600:[340, 587, 785, 948],
36700:[340, 588, 787, 950],
36800:[341, 590, 789, 953],
36900:[342, 591, 791, 955],
37000:[343, 593, 793, 957],
37100:[344, 594, 795, 959],
37200:[345, 596, 797, 962],
37300:[346, 597, 799, 964],
37400:[347, 599, 801, 966],
37500:[348, 600, 803, 969],
37600:[349, 602, 805, 971],
37700:[350, 603, 807, 973],
37800:[351, 605, 809, 976],
37900:[352, 606, 811, 978],
38000:[353, 608, 813, 980],
38100:[354, 610, 815, 982],
38200:[355, 611, 817, 985],
38300:[356, 613, 819, 987],
38400:[357, 614, 821, 989],
38500:[358, 616, 823, 992],
38600:[359, 617, 825, 994],
38700:[360, 619, 827, 996],
38800:[361, 620, 828, 999],
38900:[362, 622, 830, 1001],
39000:[363, 624, 832, 1003],
39100:[364, 626, 834, 1005],
39200:[365, 627, 836, 1008],
39300:[366, 629, 838, 1010],
39400:[367, 630, 840, 1012],
39500:[368, 632, 842, 1015],
39600:[369, 633, 844, 1017],
39700:[370, 635, 846, 1019],
39800:[371, 636, 848, 1022],
39900:[372, 638, 850, 1024],
40000:[373, 639, 852, 1026],
40100:[374, 641, 854, 1028],
40200:[375, 642, 856, 1031],
40300:[376, 644, 858, 1033],
40400:[377, 645, 860, 1035],
40500:[378, 647, 862, 1038],
40600:[379, 648, 864, 1040],
40700:[380, 650, 866, 1042],
40800:[381, 651, 868, 1045],
40900:[381, 653, 870, 1047],
41000:[382, 654, 871, 1049],
41100:[383, 655, 873, 1051],
41200:[384, 657, 875, 1053],
41300:[385, 658, 877, 1056],
41400:[386, 660, 879, 1058],
41500:[387, 661, 881, 1060],
41600:[388, 663, 882, 1062],
41700:[389, 664, 884, 1065],
41800:[390, 665, 886, 1067],
41900:[391, 667, 888, 1069],
42000:[392, 668, 890, 1071],
42100:[393, 669, 892, 1073],
42200:[394, 671, 894, 1075],
42300:[395, 672, 896, 1078],
42400:[396, 674, 897, 1080],
42500:[397, 675, 899, 1082],
42600:[398, 677, 901, 1084],
42700:[399, 678, 903, 1087],
42800:[399, 680, 905, 1089],
42900:[400, 681, 907, 1091],
43000:[401, 683, 908, 1093],
43100:[402, 685, 910, 1095],
43200:[403, 686, 912, 1097],
43300:[404, 688, 914, 1100],
43400:[405, 689, 915, 1102],
43500:[405, 691, 917, 1104],
43600:[406, 692, 919, 1106],
43700:[407, 694, 921, 1109],
43800:[408, 695, 923, 1111],
43900:[409, 697, 925, 1113],
44000:[410, 698, 927, 1115],
44100:[411, 700, 929, 1117],
44200:[412, 701, 931, 1120],
44300:[413, 703, 933, 1122],
44400:[414, 704, 935, 1124],
44500:[415, 706, 937, 1126],
44600:[416, 707, 939, 1129],
44700:[417, 709, 941, 1131],
44800:[418, 710, 943, 1133],
44900:[419, 712, 945, 1136],
45000:[420, 713, 947, 1138],
45100:[421, 715, 949, 1140],
45200:[422, 716, 951, 1143],
45300:[423, 718, 953, 1145],
45400:[424, 719, 955, 1147],
45500:[425, 721, 957, 1149],
45600:[426, 722, 958, 1152],
45700:[427, 724, 960, 1154],
45800:[428, 725, 962, 1156],
45900:[429, 727, 964, 1158],
46000:[430, 728, 966, 1161],
46100:[431, 729, 968, 1163],
46200:[432, 731, 970, 1165],
46300:[433, 732, 972, 1168],
46400:[434, 734, 974, 1170],
46500:[435, 735, 976, 1172],
46600:[436, 737, 977, 1174],
46700:[436, 738, 979, 1176],
46800:[437, 739, 981, 1179],
46900:[438, 741, 983, 1181],
47000:[439, 742, 985, 1183],
47100:[440, 743, 987, 1185],
47200:[441, 745, 989, 1187],
47300:[442, 746, 991, 1190],
47400:[443, 748, 992, 1192],
47500:[443, 749, 994, 1194],
47600:[444, 751, 996, 1196],
47700:[445, 752, 998, 1199],
47800:[446, 754, 1000, 1201],
47900:[447, 755, 1002, 1203],
48000:[448, 757, 1003, 1205],
48100:[449, 758, 1005, 1207],
48200:[450, 760, 1007, 1209],
48300:[451, 761, 1009, 1212],
48400:[452, 763, 1011, 1214],
48500:[453, 764, 1012, 1216],
48600:[454, 766, 1014, 1218],
48700:[455, 767, 1016, 1221],
48800:[456, 769, 1018, 1223],
48900:[457, 770, 1020, 1225],
49000:[458, 771, 1022, 1227],
49100:[459, 772, 1024, 1229],
49200:[460, 774, 1026, 1231],
49300:[461, 775, 1028, 1233],
49400:[462, 777, 1029, 1236],
49500:[463, 778, 1031, 1238],
49600:[464, 779, 1033, 1240],
49700:[465, 781, 1035, 1242],
49800:[466, 782, 1037, 1244],
49900:[466, 784, 1039, 1246],
50000:[467, 785, 1040, 1248],
50100:[468, 786, 1042, 1250],
50200:[469, 788, 1044, 1252],
50300:[470, 789, 1046, 1254],
50400:[471, 791, 1048, 1257],
50500:[472, 792, 1050, 1259],
50600:[473, 794, 1051, 1261],
50700:[473, 795, 1053, 1263],
50800:[474, 797, 1055, 1265],
50900:[475, 798, 1057, 1267],
51000:[476, 800, 1059, 1270],
51100:[477, 801, 1061, 1272],
51200:[478, 803, 1063, 1275],
51300:[479, 804, 1065, 1277],
51400:[480, 806, 1066, 1279],
51500:[481, 807, 1068, 1281],
51600:[482, 809, 1070, 1284],
51700:[483, 810, 1072, 1286],
51800:[484, 811, 1074, 1288],
51900:[485, 813, 1076, 1290],
52000:[486, 814, 1077, 1293],
52100:[487, 815, 1079, 1295],
52200:[488, 817, 1081, 1297],
52300:[489, 818, 1083, 1300],
52400:[490, 820, 1084, 1302],
52500:[491, 821, 1086, 1304],
52600:[492, 823, 1088, 1306],
52700:[493, 824, 1090, 1309],
52800:[494, 826, 1092, 1311],
52900:[495, 827, 1094, 1313],
53000:[495, 829, 1096, 1315],
53100:[496, 830, 1098, 1317],
53200:[497, 832, 1100, 1319],
53300:[498, 833, 1102, 1322],
53400:[499, 835, 1103, 1324],
53500:[500, 836, 1105, 1326],
53600:[500, 838, 1107, 1328],
53700:[501, 839, 1109, 1330],
53800:[502, 841, 1111, 1333],
53900:[503, 842, 1113, 1335],
54000:[504, 844, 1115, 1337],
54100:[505, 846, 1117, 1339],
54200:[506, 847, 1119, 1342],
54300:[507, 849, 1121, 1344],
54400:[508, 850, 1123, 1346],
54500:[509, 852, 1124, 1348],
54600:[510, 853, 1126, 1351],
54700:[511, 855, 1128, 1353],
54800:[512, 856, 1130, 1355],
54900:[513, 858, 1132, 1357],
55000:[514, 859, 1134, 1360],
55100:[515, 861, 1136, 1362],
55200:[516, 862, 1138, 1365],
55300:[517, 864, 1140, 1367],
55400:[518, 865, 1142, 1369],
55500:[519, 867, 1144, 1372],
55600:[520, 868, 1146, 1374],
55700:[521, 870, 1148, 1376],
55800:[522, 871, 1150, 1379],
55900:[523, 873, 1152, 1381],
56000:[524, 874, 1154, 1383],
56100:[525, 876, 1156, 1385],
56200:[526, 877, 1158, 1388],
56300:[527, 879, 1160, 1390],
56400:[528, 880, 1162, 1392],
56500:[529, 882, 1164, 1395],
56600:[530, 884, 1166, 1397],
56700:[531, 885, 1168, 1400],
56800:[532, 887, 1170, 1402],
56900:[533, 888, 1172, 1404],
57000:[534, 890, 1174, 1407],
57100:[535, 892, 1176, 1409],
57200:[536, 893, 1178, 1412],
57300:[537, 895, 1180, 1414],
57400:[538, 896, 1182, 1417],
57500:[539, 898, 1184, 1419],
57600:[540, 899, 1186, 1421],
57700:[541, 901, 1188, 1424],
57800:[542, 902, 1190, 1426],
57900:[543, 904, 1192, 1429],
58000:[544, 905, 1194, 1431],
58100:[545, 907, 1196, 1433],
58200:[546, 908, 1198, 1436],
58300:[547, 910, 1200, 1438],
58400:[548, 911, 1202, 1440],
58500:[549, 913, 1204, 1443],
58600:[550, 915, 1206, 1445],
58700:[551, 916, 1208, 1447],
58800:[552, 918, 1210, 1450],
58900:[553, 919, 1212, 1452],
59000:[554, 921, 1214, 1454],
59100:[555, 923, 1216, 1456],
59200:[556, 924, 1218, 1459],
59300:[557, 926, 1220, 1461],
59400:[558, 927, 1222, 1464],
59500:[559, 929, 1224, 1466],
59600:[560, 930, 1226, 1468],
59700:[561, 932, 1228, 1471],
59800:[562, 933, 1230, 1473],
59900:[563, 935, 1232, 1475],
60000:[564, 936, 1234, 1478],
60100:[565, 938, 1236, 1480],
60200:[566, 939, 1238, 1483],
60300:[567, 941, 1240, 1485],
60400:[568, 942, 1242, 1487],
60500:[569, 944, 1244, 1490],
60600:[570, 945, 1246, 1492],
60700:[571, 947, 1248, 1494],
60800:[572, 949, 1250, 1497],
60900:[573, 950, 1252, 1499],
61000:[574, 952, 1254, 1501],
61100:[575, 954, 1256, 1503],
61200:[576, 955, 1258, 1506],
61300:[577, 957, 1260, 1508],
61400:[578, 958, 1262, 1510],
61500:[579, 960, 1264, 1513],
61600:[580, 961, 1266, 1515],
61700:[581, 963, 1268, 1518],
61800:[582, 964, 1270, 1520],
61900:[583, 966, 1272, 1522],
62000:[584, 967, 1274, 1525],
62100:[585, 969, 1276, 1527],
62200:[586, 970, 1278, 1530],
62300:[587, 972, 1280, 1532],
62400:[588, 973, 1282, 1535],
62500:[589, 975, 1284, 1537],
62600:[590, 976, 1286, 1539],
62700:[591, 978, 1288, 1542],
62800:[592, 980, 1290, 1544],
62900:[593, 981, 1292, 1547],
63000:[594, 983, 1294, 1549],
63100:[595, 985, 1296, 1551],
63200:[596, 986, 1298, 1554],
63300:[597, 988, 1300, 1556],
63400:[598, 989, 1302, 1558],
63500:[599, 991, 1304, 1561],
63600:[600, 992, 1306, 1563],
63700:[601, 994, 1308, 1565],
63800:[602, 995, 1310, 1568],
63900:[603, 997, 1312, 1570],
64000:[604, 998, 1314, 1572],
64100:[605, 1000, 1316, 1574],
64200:[606, 1001, 1318, 1577],
64300:[607, 1003, 1320, 1579],
64400:[608, 1004, 1322, 1582],
64500:[609, 1006, 1324, 1584],
64600:[610, 1007, 1326, 1586],
64700:[611, 1009, 1328, 1589],
64800:[612, 1011, 1330, 1591],
64900:[613, 1012, 1332, 1593],
65000:[614, 1014, 1334, 1596],
65100:[615, 1016, 1336, 1598],
65200:[616, 1017, 1338, 1601],
65300:[617, 1019, 1340, 1603],
65400:[618, 1020, 1342, 1605],
65500:[619, 1022, 1344, 1608],
65600:[620, 1023, 1346, 1610],
65700:[621, 1025, 1348, 1612],
65800:[622, 1026, 1350, 1615],
65900:[623, 1028, 1352, 1617],
66000:[624, 1029, 1354, 1619],
66100:[625, 1031, 1356, 1621],
66200:[626, 1032, 1358, 1624],
66300:[627, 1034, 1360, 1626],
66400:[628, 1035, 1362, 1628],
66500:[629, 1037, 1364, 1631],
66600:[630, 1038, 1366, 1633],
66700:[631, 1040, 1368, 1636],
66800:[632, 1041, 1370, 1638],
66900:[633, 1043, 1372, 1640],
67000:[634, 1045, 1374, 1643],
67100:[635, 1047, 1376, 1645],
67200:[636, 1048, 1378, 1648],
67300:[637, 1050, 1380, 1650],
67400:[638, 1051, 1382, 1652],
67500:[639, 1053, 1384, 1655],
67600:[640, 1054, 1386, 1657],
67700:[641, 1056, 1388, 1659],
67800:[641, 1057, 1390, 1662],
67900:[642, 1059, 1391, 1664],
68000:[643, 1060, 1393, 1666],
68100:[644, 1061, 1395, 1668],
68200:[645, 1063, 1397, 1671],
68300:[646, 1064, 1399, 1673],
68400:[647, 1066, 1401, 1675],
68500:[648, 1067, 1403, 1678],
68600:[649, 1069, 1405, 1680],
68700:[650, 1070, 1407, 1682],
68800:[651, 1072, 1409, 1684],
68900:[652, 1073, 1411, 1687],
69000:[653, 1075, 1413, 1689],
69100:[654, 1077, 1415, 1691],
69200:[655, 1078, 1417, 1694],
69300:[656, 1080, 1419, 1696],
69400:[657, 1081, 1421, 1698],
69500:[658, 1083, 1423, 1700],
69600:[659, 1084, 1425, 1703],
69700:[660, 1086, 1427, 1705],
69800:[661, 1088, 1429, 1707],
69900:[662, 1089, 1431, 1710],
70000:[663, 1091, 1433, 1712],
70100:[664, 1093, 1435, 1714],
70200:[665, 1094, 1437, 1717],
70300:[666, 1096, 1439, 1719],
70400:[667, 1097, 1441, 1721],
70500:[668, 1099, 1443, 1724],
70600:[669, 1100, 1445, 1726],
70700:[670, 1102, 1447, 1728],
70800:[671, 1103, 1448, 1731],
70900:[672, 1105, 1450, 1733],
71000:[673, 1106, 1452, 1736],
71100:[674, 1108, 1454, 1738],
71200:[675, 1109, 1456, 1741],
71300:[676, 1111, 1458, 1743],
71400:[677, 1112, 1460, 1745],
71500:[678, 1114, 1462, 1748],
71600:[679, 1115, 1464, 1750],
71700:[680, 1117, 1466, 1752],
71800:[681, 1118, 1468, 1755],
71900:[682, 1120, 1470, 1757],
72000:[683, 1121, 1472, 1759],
72100:[684, 1123, 1474, 1761],
72200:[685, 1124, 1476, 1764],
72300:[686, 1126, 1478, 1766],
72400:[687, 1127, 1480, 1768],
72500:[688, 1129, 1482, 1770],
72600:[689, 1130, 1484, 1773],
72700:[690, 1132, 1486, 1775],
72800:[691, 1134, 1488, 1777],
72900:[692, 1135, 1490, 1780],
73000:[693, 1137, 1492, 1782],
73100:[694, 1139, 1494, 1784],
73200:[695, 1140, 1496, 1787],
73300:[696, 1142, 1498, 1789],
73400:[697, 1143, 1500, 1791],
73500:[698, 1145, 1502, 1794],
73600:[699, 1146, 1504, 1796],
73700:[700, 1148, 1505, 1799],
73800:[701, 1149, 1507, 1801],
73900:[702, 1151, 1509, 1803],
74000:[703, 1152, 1511, 1806],
74100:[704, 1154, 1513, 1808],
74200:[705, 1155, 1515, 1811],
74300:[706, 1157, 1517, 1813],
74400:[707, 1158, 1519, 1815],
74500:[708, 1160, 1521, 1818],
74600:[709, 1161, 1523, 1820],
74700:[710, 1163, 1525, 1822],
74800:[711, 1164, 1527, 1825],
74900:[711, 1166, 1529, 1827],
75000:[712, 1167, 1531, 1829],
75100:[713, 1169, 1533, 1831],
75200:[714, 1170, 1535, 1834],
75300:[715, 1172, 1537, 1836],
75400:[716, 1173, 1539, 1838],
75500:[717, 1175, 1541, 1841],
75600:[718, 1176, 1543, 1843],
75700:[719, 1178, 1545, 1845],
75800:[720, 1180, 1547, 1848],
75900:[721, 1181, 1549, 1850],
76000:[722, 1183, 1551, 1852],
76100:[723, 1185, 1553, 1854],
76200:[724, 1186, 1555, 1857],
76300:[725, 1188, 1557, 1859],
76400:[726, 1189, 1559, 1861],
76500:[727, 1191, 1561, 1863],
76600:[728, 1192, 1563, 1866],
76700:[729, 1194, 1565, 1868],
76800:[730, 1195, 1567, 1870],
76900:[731, 1197, 1569, 1873],
77000:[732, 1198, 1571, 1875],
77100:[733, 1200, 1573, 1877],
77200:[734, 1201, 1575, 1880],
77300:[735, 1203, 1577, 1882],
77400:[736, 1204, 1579, 1884],
77500:[737, 1206, 1581, 1887],
77600:[738, 1207, 1583, 1889],
77700:[739, 1209, 1585, 1892],
77800:[740, 1210, 1587, 1894],
77900:[741, 1212, 1589, 1896],
78000:[742, 1213, 1590, 1899],
78100:[743, 1215, 1592, 1901],
78200:[744, 1216, 1594, 1904],
78300:[745, 1218, 1596, 1906],
78400:[746, 1219, 1598, 1908],
78500:[747, 1221, 1600, 1911],
78600:[748, 1222, 1602, 1913],
78700:[749, 1224, 1604, 1915],
78800:[750, 1226, 1606, 1918],
78900:[751, 1227, 1608, 1920],
79000:[752, 1229, 1610, 1922],
79100:[753, 1231, 1612, 1924],
79200:[754, 1232, 1614, 1927],
79300:[755, 1234, 1616, 1929],
79400:[756, 1235, 1618, 1931],
79500:[757, 1237, 1620, 1934],
79600:[758, 1238, 1622, 1936],
79700:[759, 1240, 1624, 1938],
79800:[760, 1241, 1626, 1940],
79900:[761, 1243, 1628, 1943],
80000:[762, 1244, 1630, 1945],
80100:[763, 1246, 1632, 1947],
80200:[764, 1247, 1634, 1950],
80300:[765, 1249, 1636, 1952],
80400:[766, 1250, 1638, 1955],
80500:[767, 1252, 1640, 1957],
80600:[768, 1253, 1642, 1959],
80700:[769, 1255, 1644, 1962],
80800:[769, 1256, 1646, 1964],
80900:[770, 1258, 1647, 1966],
81000:[771, 1259, 1649, 1969],
81100:[772, 1260, 1651, 1971],
81200:[773, 1262, 1653, 1974],
81300:[774, 1263, 1655, 1976],
81400:[775, 1265, 1657, 1978],
81500:[776, 1266, 1659, 1981],
81600:[777, 1268, 1661, 1983],
81700:[778, 1269, 1663, 1985],
81800:[779, 1271, 1665, 1988],
81900:[780, 1272, 1667, 1990],
82000:[781, 1274, 1669, 1992],
82100:[782, 1275, 1671, 1994],
82200:[783, 1277, 1673, 1996],
82300:[784, 1278, 1675, 1999],
82400:[785, 1280, 1677, 2001],
82500:[786, 1281, 1679, 2003],
82600:[787, 1283, 1680, 2005],
82700:[788, 1284, 1682, 2008],
82800:[789, 1286, 1684, 2010],
82900:[790, 1287, 1686, 2012],
83000:[791, 1289, 1688, 2014],
83100:[792, 1290, 1690, 2016],
83200:[793, 1292, 1692, 2018],
83300:[794, 1293, 1693, 2021],
83400:[795, 1295, 1695, 2023],
83500:[796, 1296, 1697, 2025],
83600:[797, 1298, 1699, 2027],
83700:[798, 1299, 1701, 2029],
83800:[798, 1301, 1703, 2032],
83900:[799, 1302, 1704, 2034],
84000:[800, 1304, 1706, 2036],
84100:[801, 1305, 1708, 2038],
84200:[802, 1307, 1710, 2040],
84300:[803, 1308, 1712, 2043],
84400:[804, 1310, 1713, 2045],
84500:[804, 1311, 1715, 2047],
84600:[805, 1313, 1717, 2049],
84700:[806, 1314, 1719, 2051],
84800:[807, 1316, 1721, 2054],
84900:[808, 1317, 1723, 2056],
85000:[809, 1318, 1725, 2058],
85100:[810, 1319, 1727, 2060],
85200:[811, 1321, 1729, 2062],
85300:[812, 1322, 1731, 2065],
85400:[813, 1324, 1733, 2067],
85500:[814, 1325, 1734, 2069],
85600:[815, 1327, 1736, 2071],
85700:[816, 1328, 1738, 2073],
85800:[817, 1330, 1740, 2076],
85900:[818, 1331, 1742, 2078],
86000:[819, 1333, 1744, 2080],
86100:[820, 1334, 1746, 2082],
86200:[821, 1336, 1748, 2084],
86300:[822, 1337, 1749, 2087],
86400:[823, 1339, 1751, 2089],
86500:[824, 1340, 1753, 2091],
86600:[825, 1342, 1755, 2093],
86700:[825, 1343, 1757, 2095],
86800:[826, 1344, 1759, 2097],
86900:[827, 1346, 1760, 2100],
87000:[828, 1347, 1762, 2102],
87100:[829, 1348, 1764, 2104],
87200:[830, 1350, 1766, 2106],
87300:[831, 1351, 1768, 2109],
87400:[832, 1353, 1769, 2111],
87500:[832, 1354, 1771, 2113],
87600:[833, 1356, 1773, 2115],
87700:[834, 1357, 1775, 2117],
87800:[835, 1359, 1777, 2119],
87900:[836, 1360, 1779, 2122],
88000:[837, 1362, 1781, 2124],
88100:[838, 1363, 1783, 2126],
88200:[839, 1365, 1785, 2128],
88300:[840, 1366, 1787, 2130],
88400:[841, 1368, 1789, 2133],
88500:[842, 1369, 1790, 2135],
88600:[843, 1371, 1792, 2137],
88700:[844, 1372, 1794, 2139],
88800:[845, 1373, 1796, 2141],
88900:[846, 1375, 1798, 2143],
89000:[847, 1376, 1800, 2146],
89100:[848, 1377, 1802, 2148],
89200:[849, 1379, 1804, 2151],
89300:[850, 1380, 1806, 2153],
89400:[851, 1382, 1808, 2155],
89500:[852, 1383, 1810, 2157],
89600:[853, 1385, 1811, 2160],
89700:[853, 1386, 1813, 2162],
89800:[854, 1388, 1815, 2164],
89900:[855, 1389, 1817, 2166],
90000:[856, 1391, 1819, 2169],
90100:[857, 1392, 1821, 2171],
90200:[858, 1394, 1823, 2173],
90300:[859, 1395, 1825, 2175],
90400:[860, 1397, 1826, 2178],
90500:[860, 1398, 1828, 2180],
90600:[861, 1400, 1830, 2182],
90700:[862, 1401, 1832, 2184],
90800:[863, 1402, 1834, 2186],
90900:[864, 1404, 1836, 2188],
91000:[865, 1405, 1837, 2190],
91100:[866, 1406, 1839, 2192],
91200:[867, 1408, 1840, 2194],
91300:[868, 1409, 1842, 2196],
91400:[869, 1410, 1844, 2198],
91500:[869, 1412, 1846, 2200],
91600:[870, 1413, 1847, 2202],
91700:[871, 1414, 1849, 2204],
91800:[872, 1416, 1851, 2206],
91900:[873, 1417, 1853, 2208],
92000:[874, 1418, 1854, 2210],
92100:[875, 1419, 1856, 2212],
92200:[876, 1421, 1857, 2214],
92300:[876, 1422, 1859, 2216],
92400:[877, 1424, 1861, 2218],
92500:[878, 1425, 1863, 2220],
92600:[879, 1426, 1864, 2222],
92700:[880, 1428, 1866, 2224],
92800:[881, 1429, 1868, 2226],
92900:[881, 1430, 1870, 2228],
93000:[882, 1432, 1871, 2230],
93100:[883, 1433, 1873, 2232],
93200:[884, 1435, 1874, 2234],
93300:[885, 1436, 1876, 2236],
93400:[885, 1437, 1878, 2238],
93500:[886, 1439, 1880, 2240],
93600:[887, 1440, 1881, 2242],
93700:[888, 1441, 1883, 2244],
93800:[889, 1443, 1885, 2246],
93900:[890, 1444, 1886, 2249],
94000:[891, 1445, 1888, 2251],
94100:[892, 1446, 1890, 2253],
94200:[893, 1448, 1891, 2255],
94300:[893, 1449, 1893, 2257],
94400:[894, 1450, 1895, 2259],
94500:[895, 1452, 1896, 2261],
94600:[896, 1453, 1898, 2263],
94700:[897, 1454, 1900, 2265],
94800:[897, 1455, 1902, 2267],
94900:[898, 1457, 1903, 2269],
95000:[899, 1458, 1905, 2271],
95100:[900, 1459, 1907, 2273],
95200:[901, 1461, 1908, 2275],
95300:[902, 1462, 1910, 2277],
95400:[902, 1464, 1912, 2279],
95500:[903, 1465, 1913, 2281],
95600:[904, 1466, 1915, 2283],
95700:[905, 1468, 1917, 2285],
95800:[906, 1469, 1918, 2287],
95900:[907, 1470, 1920, 2289],
96000:[908, 1472, 1922, 2291],
96100:[909, 1473, 1924, 2293],
96200:[910, 1475, 1926, 2295],
96300:[911, 1476, 1927, 2297],
96400:[912, 1477, 1929, 2299],
96500:[912, 1479, 1931, 2301],
96600:[913, 1480, 1933, 2303],
96700:[914, 1481, 1934, 2305],
96800:[915, 1483, 1936, 2308],
96900:[916, 1484, 1938, 2310],
97000:[917, 1485, 1940, 2312],
97100:[918, 1486, 1942, 2314],
97200:[919, 1488, 1943, 2316],
97300:[920, 1489, 1945, 2318],
97400:[920, 1490, 1947, 2320],
97500:[921, 1492, 1949, 2322],
97600:[922, 1493, 1950, 2324],
97700:[923, 1494, 1952, 2326],
97800:[924, 1495, 1954, 2328],
97900:[925, 1497, 1956, 2330],
98000:[925, 1498, 1957, 2332],
98100:[926, 1499, 1959, 2334],
98200:[927, 1501, 1960, 2336],
98300:[928, 1502, 1962, 2338],
98400:[929, 1503, 1964, 2340],
98500:[929, 1505, 1966, 2342],
98600:[930, 1506, 1967, 2344],
98700:[931, 1508, 1969, 2346],
98800:[932, 1509, 1971, 2348],
98900:[933, 1510, 1973, 2350],
99000:[934, 1512, 1974, 2352],
99100:[935, 1513, 1976, 2354],
99200:[936, 1515, 1977, 2356],
99300:[936, 1516, 1979, 2358],
99400:[937, 1517, 1981, 2360],
99500:[938, 1519, 1983, 2362],
99600:[939, 1520, 1984, 2364],
99700:[940, 1521, 1986, 2366],
99800:[941, 1523, 1988, 2368],
99900:[941, 1524, 1989, 2370],
};
const OR17_NT=[0.76, 1.26, 1.6, 1.84];

// Nunavut — 2017 Federal Child Support Guidelines Table
const T17_NU={
100000:[973, 1571, 2049, 2441],
100100:[974, 1572, 2051, 2443],
100200:[975, 1574, 2053, 2445],
100300:[976, 1575, 2054, 2447],
100400:[977, 1577, 2056, 2449],
100500:[978, 1578, 2058, 2452],
100600:[979, 1579, 2060, 2454],
100700:[979, 1581, 2061, 2456],
100800:[980, 1582, 2063, 2458],
100900:[981, 1584, 2065, 2460],
101000:[982, 1585, 2067, 2462],
101100:[983, 1586, 2069, 2464],
101200:[984, 1588, 2071, 2466],
101300:[985, 1589, 2073, 2469],
101400:[986, 1591, 2074, 2471],
101500:[987, 1592, 2076, 2473],
101600:[988, 1593, 2078, 2475],
101700:[988, 1595, 2080, 2477],
101800:[989, 1596, 2082, 2479],
101900:[990, 1598, 2084, 2482],
102000:[991, 1599, 2086, 2484],
102100:[992, 1600, 2088, 2486],
102200:[993, 1602, 2090, 2488],
102300:[994, 1603, 2092, 2490],
102400:[995, 1605, 2093, 2493],
102500:[996, 1606, 2095, 2495],
102600:[997, 1607, 2097, 2497],
102700:[997, 1609, 2099, 2499],
102800:[998, 1610, 2101, 2501],
102900:[999, 1612, 2103, 2503],
103000:[1000, 1613, 2104, 2505],
103100:[1001, 1614, 2106, 2507],
103200:[1002, 1616, 2108, 2509],
103300:[1003, 1617, 2110, 2511],
103400:[1004, 1619, 2111, 2513],
103500:[1005, 1620, 2113, 2516],
103600:[1006, 1621, 2115, 2518],
103700:[1006, 1623, 2117, 2520],
103800:[1007, 1624, 2119, 2522],
103900:[1008, 1626, 2121, 2524],
104000:[1009, 1627, 2122, 2526],
104100:[1010, 1628, 2124, 2528],
104200:[1011, 1630, 2126, 2530],
104300:[1012, 1631, 2128, 2533],
104400:[1013, 1633, 2129, 2535],
104500:[1014, 1634, 2131, 2537],
104600:[1014, 1635, 2133, 2539],
104700:[1015, 1637, 2135, 2541],
104800:[1016, 1638, 2137, 2543],
104900:[1017, 1640, 2139, 2546],
105000:[1018, 1641, 2140, 2548],
105100:[1019, 1642, 2142, 2550],
105200:[1020, 1644, 2144, 2552],
105300:[1021, 1645, 2145, 2554],
105400:[1022, 1647, 2147, 2557],
105500:[1023, 1648, 2149, 2559],
105600:[1023, 1649, 2151, 2561],
105700:[1024, 1651, 2153, 2563],
105800:[1025, 1652, 2155, 2565],
105900:[1026, 1654, 2156, 2567],
106000:[1027, 1655, 2158, 2569],
106100:[1028, 1656, 2160, 2571],
106200:[1029, 1658, 2162, 2573],
106300:[1030, 1659, 2163, 2575],
106400:[1031, 1661, 2165, 2577],
106500:[1032, 1662, 2167, 2580],
106600:[1032, 1663, 2169, 2582],
106700:[1033, 1665, 2171, 2584],
106800:[1034, 1666, 2173, 2586],
106900:[1035, 1667, 2174, 2588],
107000:[1036, 1669, 2176, 2590],
107100:[1037, 1670, 2178, 2592],
107200:[1038, 1672, 2180, 2594],
107300:[1039, 1673, 2181, 2597],
107400:[1040, 1675, 2183, 2599],
107500:[1041, 1676, 2185, 2601],
107600:[1041, 1677, 2187, 2603],
107700:[1042, 1679, 2189, 2605],
107800:[1043, 1680, 2191, 2607],
107900:[1044, 1681, 2192, 2610],
108000:[1045, 1683, 2194, 2612],
108100:[1046, 1684, 2196, 2614],
108200:[1047, 1686, 2198, 2616],
108300:[1048, 1687, 2199, 2618],
108400:[1049, 1689, 2201, 2621],
108500:[1050, 1690, 2203, 2623],
108600:[1050, 1691, 2205, 2625],
108700:[1051, 1693, 2207, 2627],
108800:[1052, 1694, 2209, 2629],
108900:[1053, 1695, 2210, 2631],
109000:[1054, 1697, 2212, 2633],
109100:[1055, 1698, 2214, 2635],
109200:[1056, 1700, 2216, 2637],
109300:[1057, 1701, 2217, 2639],
109400:[1058, 1702, 2219, 2641],
109500:[1059, 1704, 2221, 2644],
109600:[1059, 1705, 2223, 2646],
109700:[1060, 1707, 2225, 2648],
109800:[1061, 1708, 2226, 2650],
109900:[1062, 1709, 2228, 2652],
110000:[1063, 1711, 2230, 2654],
110100:[1064, 1712, 2232, 2656],
110200:[1065, 1714, 2234, 2658],
110300:[1066, 1715, 2235, 2661],
110400:[1067, 1716, 2237, 2663],
110500:[1067, 1718, 2239, 2665],
110600:[1068, 1719, 2241, 2667],
110700:[1069, 1721, 2243, 2669],
110800:[1070, 1722, 2244, 2671],
110900:[1071, 1723, 2246, 2674],
111000:[1072, 1725, 2248, 2676],
111100:[1073, 1726, 2250, 2678],
111200:[1074, 1728, 2252, 2680],
111300:[1075, 1729, 2253, 2682],
111400:[1076, 1730, 2255, 2685],
111500:[1076, 1732, 2257, 2687],
111600:[1077, 1733, 2259, 2689],
111700:[1078, 1735, 2261, 2691],
111800:[1079, 1736, 2262, 2693],
111900:[1080, 1737, 2264, 2695],
112000:[1081, 1739, 2266, 2697],
112100:[1082, 1740, 2268, 2699],
112200:[1083, 1742, 2270, 2701],
112300:[1084, 1743, 2271, 2703],
112400:[1085, 1744, 2273, 2705],
112500:[1085, 1746, 2275, 2708],
112600:[1086, 1747, 2277, 2710],
112700:[1087, 1749, 2279, 2712],
112800:[1088, 1750, 2280, 2714],
112900:[1089, 1751, 2282, 2716],
113000:[1090, 1753, 2284, 2718],
113100:[1091, 1754, 2286, 2720],
113200:[1092, 1756, 2288, 2722],
113300:[1093, 1757, 2289, 2725],
113400:[1094, 1758, 2291, 2727],
113500:[1094, 1760, 2293, 2729],
113600:[1095, 1761, 2295, 2731],
113700:[1096, 1762, 2297, 2733],
113800:[1097, 1764, 2298, 2735],
113900:[1098, 1765, 2300, 2738],
114000:[1099, 1767, 2302, 2740],
114100:[1100, 1768, 2304, 2742],
114200:[1101, 1770, 2306, 2744],
114300:[1102, 1771, 2307, 2746],
114400:[1103, 1773, 2309, 2749],
114500:[1103, 1774, 2311, 2751],
114600:[1104, 1776, 2313, 2753],
114700:[1105, 1777, 2314, 2755],
114800:[1106, 1779, 2316, 2757],
114900:[1107, 1780, 2318, 2759],
115000:[1108, 1782, 2320, 2761],
115100:[1109, 1783, 2322, 2763],
115200:[1110, 1785, 2324, 2765],
115300:[1111, 1786, 2325, 2767],
115400:[1112, 1788, 2327, 2769],
115500:[1112, 1789, 2329, 2772],
115600:[1113, 1791, 2331, 2774],
115700:[1114, 1792, 2332, 2776],
115800:[1115, 1794, 2334, 2778],
115900:[1116, 1795, 2336, 2780],
116000:[1117, 1796, 2338, 2782],
116100:[1118, 1797, 2340, 2784],
116200:[1119, 1799, 2342, 2786],
116300:[1120, 1800, 2343, 2789],
116400:[1121, 1802, 2345, 2791],
116500:[1121, 1803, 2347, 2793],
116600:[1122, 1805, 2349, 2795],
116700:[1123, 1806, 2350, 2797],
116800:[1124, 1808, 2352, 2799],
116900:[1125, 1809, 2354, 2802],
117000:[1126, 1810, 2356, 2804],
117100:[1127, 1811, 2358, 2806],
117200:[1128, 1813, 2360, 2808],
117300:[1129, 1814, 2361, 2810],
117400:[1130, 1816, 2363, 2813],
117500:[1130, 1817, 2365, 2815],
117600:[1131, 1819, 2367, 2817],
117700:[1132, 1820, 2368, 2819],
117800:[1133, 1822, 2370, 2821],
117900:[1134, 1823, 2372, 2823],
118000:[1135, 1824, 2374, 2825],
118100:[1136, 1825, 2376, 2827],
118200:[1137, 1827, 2378, 2829],
118300:[1138, 1828, 2379, 2831],
118400:[1139, 1830, 2381, 2833],
118500:[1139, 1831, 2383, 2835],
118600:[1140, 1833, 2385, 2838],
118700:[1141, 1834, 2386, 2840],
118800:[1142, 1835, 2388, 2842],
118900:[1143, 1837, 2390, 2844],
119000:[1144, 1838, 2392, 2846],
119100:[1145, 1839, 2394, 2848],
119200:[1146, 1841, 2396, 2850],
119300:[1147, 1842, 2398, 2852],
119400:[1147, 1844, 2399, 2855],
119500:[1148, 1845, 2401, 2857],
119600:[1149, 1847, 2403, 2859],
119700:[1150, 1848, 2405, 2861],
119800:[1151, 1849, 2407, 2863],
119900:[1152, 1851, 2409, 2865],
12000:[0, 0, 0, 0],
120000:[1153, 1852, 2411, 2868],
120100:[1154, 1853, 2413, 2870],
120200:[1155, 1855, 2415, 2872],
120300:[1156, 1856, 2417, 2874],
120400:[1156, 1858, 2418, 2877],
120500:[1157, 1859, 2420, 2879],
120600:[1158, 1861, 2422, 2881],
120700:[1159, 1862, 2424, 2883],
120800:[1160, 1863, 2426, 2885],
120900:[1161, 1865, 2428, 2887],
12100:[6, 7, 7, 8],
121000:[1162, 1866, 2429, 2889],
121100:[1163, 1867, 2431, 2891],
121200:[1164, 1869, 2433, 2893],
121300:[1165, 1870, 2435, 2895],
121400:[1165, 1872, 2436, 2897],
121500:[1166, 1873, 2438, 2899],
121600:[1167, 1875, 2440, 2902],
121700:[1168, 1876, 2442, 2904],
121800:[1169, 1877, 2444, 2906],
121900:[1170, 1879, 2446, 2908],
12200:[13, 14, 15, 16],
122000:[1171, 1880, 2447, 2910],
122100:[1172, 1881, 2449, 2912],
122200:[1173, 1883, 2451, 2914],
122300:[1174, 1884, 2453, 2916],
122400:[1174, 1886, 2454, 2919],
122500:[1175, 1887, 2456, 2921],
122600:[1176, 1888, 2458, 2923],
122700:[1177, 1890, 2460, 2925],
122800:[1178, 1891, 2462, 2927],
122900:[1179, 1893, 2464, 2929],
12300:[19, 20, 22, 24],
123000:[1180, 1894, 2465, 2932],
123100:[1181, 1895, 2467, 2934],
123200:[1182, 1897, 2469, 2936],
123300:[1183, 1898, 2470, 2938],
123400:[1183, 1900, 2472, 2941],
123500:[1184, 1901, 2474, 2943],
123600:[1185, 1902, 2476, 2945],
123700:[1186, 1904, 2478, 2947],
123800:[1187, 1905, 2480, 2949],
123900:[1188, 1907, 2481, 2951],
12400:[25, 27, 29, 32],
124000:[1189, 1908, 2483, 2953],
124100:[1190, 1909, 2485, 2955],
124200:[1191, 1911, 2487, 2957],
124300:[1192, 1912, 2488, 2959],
124400:[1192, 1914, 2490, 2961],
124500:[1193, 1915, 2492, 2963],
124600:[1194, 1916, 2494, 2966],
124700:[1195, 1918, 2496, 2968],
124800:[1196, 1919, 2498, 2970],
124900:[1197, 1921, 2499, 2972],
12500:[32, 34, 37, 40],
125000:[1198, 1922, 2501, 2974],
125100:[1199, 1923, 2503, 2976],
125200:[1200, 1925, 2505, 2978],
125300:[1201, 1926, 2506, 2980],
125400:[1201, 1928, 2508, 2983],
125500:[1202, 1929, 2510, 2985],
125600:[1203, 1930, 2512, 2987],
125700:[1204, 1932, 2514, 2989],
125800:[1205, 1933, 2516, 2991],
125900:[1206, 1935, 2517, 2993],
12600:[38, 41, 44, 47],
126000:[1207, 1936, 2519, 2996],
126100:[1208, 1937, 2521, 2998],
126200:[1209, 1939, 2523, 3000],
126300:[1210, 1940, 2524, 3002],
126400:[1210, 1942, 2526, 3005],
126500:[1211, 1943, 2528, 3007],
126600:[1212, 1944, 2530, 3009],
126700:[1213, 1946, 2532, 3011],
126800:[1214, 1947, 2534, 3013],
126900:[1215, 1949, 2535, 3015],
12700:[44, 48, 51, 55],
127000:[1216, 1950, 2537, 3017],
127100:[1217, 1951, 2539, 3019],
127200:[1218, 1953, 2541, 3021],
127300:[1219, 1954, 2542, 3023],
127400:[1220, 1956, 2544, 3025],
127500:[1221, 1957, 2546, 3027],
127600:[1222, 1958, 2548, 3030],
127700:[1223, 1960, 2550, 3032],
127800:[1224, 1961, 2551, 3034],
127900:[1225, 1963, 2553, 3036],
12800:[50, 54, 58, 63],
128000:[1226, 1964, 2555, 3038],
128100:[1227, 1965, 2557, 3040],
128200:[1228, 1967, 2559, 3042],
128300:[1229, 1968, 2560, 3044],
128400:[1230, 1970, 2562, 3047],
128500:[1231, 1971, 2564, 3049],
128600:[1232, 1972, 2566, 3051],
128700:[1233, 1974, 2568, 3053],
128800:[1234, 1975, 2569, 3055],
128900:[1235, 1977, 2571, 3057],
12900:[57, 61, 66, 71],
129000:[1235, 1978, 2573, 3060],
129100:[1236, 1979, 2575, 3062],
129200:[1237, 1981, 2577, 3064],
129300:[1238, 1982, 2578, 3066],
129400:[1239, 1984, 2580, 3069],
129500:[1240, 1985, 2582, 3071],
129600:[1241, 1986, 2584, 3073],
129700:[1242, 1988, 2586, 3075],
129800:[1243, 1989, 2587, 3077],
129900:[1244, 1990, 2589, 3079],
13000:[63, 68, 73, 79],
130000:[1244, 1992, 2591, 3081],
130100:[1245, 1993, 2593, 3083],
130200:[1246, 1995, 2595, 3085],
130300:[1247, 1996, 2596, 3087],
130400:[1248, 1998, 2598, 3089],
130500:[1249, 1999, 2600, 3091],
130600:[1250, 2000, 2602, 3094],
130700:[1251, 2002, 2604, 3096],
130800:[1252, 2003, 2605, 3098],
130900:[1252, 2004, 2607, 3100],
13100:[68, 73, 78, 85],
131000:[1253, 2006, 2609, 3102],
131100:[1254, 2007, 2611, 3104],
131200:[1255, 2009, 2613, 3106],
131300:[1256, 2010, 2614, 3108],
131400:[1257, 2012, 2616, 3111],
131500:[1258, 2013, 2618, 3113],
131600:[1259, 2014, 2620, 3115],
131700:[1260, 2016, 2622, 3117],
131800:[1261, 2017, 2623, 3119],
131900:[1261, 2018, 2625, 3121],
13200:[72, 78, 84, 91],
132000:[1262, 2020, 2627, 3124],
132100:[1263, 2021, 2629, 3126],
132200:[1264, 2023, 2631, 3128],
132300:[1265, 2024, 2632, 3130],
132400:[1266, 2025, 2634, 3133],
132500:[1267, 2027, 2636, 3135],
132600:[1268, 2028, 2638, 3137],
132700:[1269, 2030, 2639, 3139],
132800:[1269, 2031, 2641, 3141],
132900:[1270, 2032, 2643, 3143],
13300:[77, 83, 89, 96],
133000:[1271, 2034, 2645, 3145],
133100:[1272, 2035, 2647, 3147],
133200:[1273, 2037, 2649, 3149],
133300:[1274, 2038, 2650, 3151],
133400:[1275, 2039, 2652, 3153],
133500:[1276, 2041, 2654, 3155],
133600:[1277, 2042, 2656, 3158],
133700:[1278, 2044, 2657, 3160],
133800:[1278, 2045, 2659, 3162],
133900:[1279, 2046, 2661, 3164],
13400:[81, 88, 94, 102],
134000:[1280, 2048, 2663, 3166],
134100:[1281, 2049, 2665, 3168],
134200:[1282, 2051, 2667, 3170],
134300:[1283, 2052, 2668, 3172],
134400:[1284, 2053, 2670, 3175],
134500:[1285, 2055, 2672, 3177],
134600:[1286, 2056, 2674, 3179],
134700:[1287, 2058, 2675, 3181],
134800:[1287, 2059, 2677, 3183],
134900:[1288, 2060, 2679, 3185],
13500:[86, 93, 100, 108],
135000:[1289, 2062, 2681, 3188],
135100:[1290, 2063, 2683, 3190],
135200:[1291, 2065, 2685, 3192],
135300:[1292, 2066, 2686, 3194],
135400:[1293, 2067, 2688, 3196],
135500:[1294, 2069, 2690, 3199],
135600:[1295, 2070, 2692, 3201],
135700:[1296, 2072, 2693, 3203],
135800:[1296, 2073, 2695, 3205],
135900:[1297, 2074, 2697, 3207],
13600:[91, 98, 105, 114],
136000:[1298, 2076, 2699, 3209],
136100:[1299, 2077, 2701, 3211],
136200:[1300, 2079, 2703, 3213],
136300:[1301, 2080, 2704, 3215],
136400:[1302, 2081, 2706, 3217],
136500:[1303, 2083, 2708, 3219],
136600:[1304, 2084, 2710, 3222],
136700:[1304, 2085, 2711, 3224],
136800:[1305, 2087, 2713, 3226],
136900:[1306, 2088, 2715, 3228],
13700:[95, 103, 110, 120],
137000:[1307, 2090, 2717, 3230],
137100:[1308, 2091, 2719, 3232],
137200:[1309, 2093, 2721, 3234],
137300:[1310, 2094, 2723, 3236],
137400:[1311, 2096, 2724, 3239],
137500:[1312, 2097, 2726, 3241],
137600:[1313, 2099, 2728, 3243],
137700:[1313, 2100, 2730, 3245],
137800:[1314, 2102, 2732, 3247],
137900:[1315, 2103, 2734, 3249],
13800:[100, 108, 116, 126],
138000:[1316, 2105, 2736, 3252],
138100:[1317, 2106, 2738, 3254],
138200:[1318, 2108, 2740, 3256],
138300:[1319, 2109, 2742, 3258],
138400:[1320, 2111, 2743, 3260],
138500:[1321, 2112, 2745, 3263],
138600:[1322, 2114, 2747, 3265],
138700:[1322, 2115, 2749, 3267],
138800:[1323, 2117, 2751, 3269],
138900:[1324, 2118, 2753, 3271],
13900:[104, 113, 121, 131],
139000:[1325, 2119, 2754, 3273],
139100:[1326, 2120, 2756, 3275],
139200:[1327, 2122, 2758, 3277],
139300:[1328, 2123, 2760, 3279],
139400:[1329, 2125, 2761, 3281],
139500:[1330, 2126, 2763, 3283],
139600:[1331, 2128, 2765, 3286],
139700:[1331, 2129, 2767, 3288],
139800:[1332, 2131, 2769, 3290],
139900:[1333, 2132, 2771, 3292],
14000:[109, 118, 127, 137],
140000:[1334, 2133, 2772, 3294],
140100:[1335, 2134, 2774, 3296],
140200:[1336, 2136, 2775, 3298],
140300:[1336, 2137, 2777, 3300],
140400:[1337, 2138, 2779, 3302],
140500:[1338, 2140, 2781, 3304],
140600:[1339, 2141, 2782, 3306],
140700:[1340, 2142, 2784, 3308],
140800:[1341, 2144, 2786, 3310],
140900:[1341, 2145, 2788, 3312],
14100:[113, 123, 132, 142],
141000:[1342, 2146, 2789, 3315],
141100:[1343, 2147, 2791, 3317],
141200:[1344, 2149, 2792, 3319],
141300:[1345, 2150, 2794, 3321],
141400:[1345, 2151, 2796, 3323],
141500:[1346, 2153, 2797, 3325],
141600:[1347, 2154, 2799, 3327],
141700:[1348, 2155, 2800, 3329],
141800:[1349, 2156, 2802, 3330],
141900:[1350, 2158, 2804, 3332],
14200:[117, 127, 137, 147],
142000:[1351, 2159, 2805, 3334],
142100:[1352, 2160, 2807, 3336],
142200:[1353, 2162, 2808, 3338],
142300:[1353, 2163, 2810, 3340],
142400:[1354, 2164, 2812, 3342],
142500:[1355, 2166, 2813, 3344],
142600:[1356, 2167, 2815, 3346],
142700:[1357, 2168, 2817, 3348],
142800:[1358, 2170, 2818, 3350],
142900:[1358, 2171, 2820, 3352],
14300:[122, 132, 142, 153],
143000:[1359, 2172, 2822, 3354],
143100:[1360, 2173, 2824, 3356],
143200:[1361, 2174, 2825, 3358],
143300:[1361, 2176, 2827, 3360],
143400:[1362, 2177, 2828, 3362],
143500:[1363, 2178, 2830, 3364],
143600:[1364, 2179, 2832, 3366],
143700:[1365, 2181, 2833, 3367],
143800:[1365, 2182, 2835, 3369],
143900:[1366, 2183, 2837, 3371],
14400:[126, 136, 147, 158],
144000:[1367, 2184, 2838, 3373],
144100:[1368, 2185, 2840, 3375],
144200:[1369, 2187, 2841, 3377],
144300:[1369, 2188, 2843, 3379],
144400:[1370, 2189, 2845, 3381],
144500:[1371, 2190, 2846, 3383],
144600:[1372, 2192, 2848, 3385],
144700:[1372, 2193, 2850, 3387],
144800:[1373, 2194, 2851, 3389],
144900:[1374, 2195, 2853, 3391],
14500:[130, 141, 152, 163],
145000:[1375, 2197, 2855, 3393],
145100:[1376, 2198, 2857, 3395],
145200:[1377, 2200, 2858, 3397],
145300:[1378, 2201, 2860, 3399],
145400:[1378, 2202, 2861, 3401],
145500:[1379, 2203, 2863, 3403],
145600:[1380, 2205, 2865, 3405],
145700:[1381, 2206, 2866, 3406],
145800:[1382, 2207, 2868, 3408],
145900:[1383, 2208, 2870, 3410],
14600:[134, 145, 157, 168],
146000:[1384, 2210, 2871, 3412],
146100:[1385, 2211, 2873, 3414],
146200:[1386, 2213, 2874, 3416],
146300:[1386, 2214, 2876, 3418],
146400:[1387, 2215, 2878, 3420],
146500:[1388, 2216, 2879, 3422],
146600:[1389, 2218, 2881, 3424],
146700:[1390, 2219, 2883, 3426],
146800:[1391, 2220, 2884, 3428],
146900:[1391, 2222, 2886, 3430],
14700:[138, 150, 162, 174],
147000:[1392, 2223, 2888, 3432],
147100:[1393, 2224, 2890, 3434],
147200:[1394, 2226, 2891, 3436],
147300:[1394, 2227, 2893, 3438],
147400:[1395, 2228, 2894, 3440],
147500:[1396, 2229, 2896, 3442],
147600:[1397, 2231, 2898, 3443],
147700:[1398, 2232, 2899, 3445],
147800:[1398, 2233, 2901, 3447],
147900:[1399, 2235, 2902, 3449],
14800:[142, 155, 167, 179],
148000:[1400, 2236, 2904, 3451],
148100:[1401, 2237, 2906, 3453],
148200:[1402, 2239, 2907, 3455],
148300:[1403, 2240, 2909, 3457],
148400:[1403, 2241, 2911, 3459],
148500:[1404, 2243, 2912, 3461],
148600:[1405, 2244, 2914, 3463],
148700:[1406, 2245, 2916, 3465],
148800:[1407, 2246, 2917, 3467],
148900:[1408, 2248, 2919, 3469],
14900:[147, 159, 172, 184],
149000:[1409, 2249, 2921, 3471],
149100:[1410, 2250, 2923, 3473],
149200:[1411, 2252, 2924, 3475],
149300:[1412, 2253, 2926, 3477],
149400:[1412, 2254, 2927, 3479],
149500:[1413, 2256, 2929, 3481],
149600:[1414, 2257, 2931, 3482],
149700:[1415, 2258, 2932, 3484],
149800:[1416, 2260, 2934, 3486],
149900:[1417, 2261, 2935, 3488],
15000:[151, 164, 177, 189],
150000:[1417, 2262, 2937, 3490],
15100:[155, 169, 182, 194],
15200:[158, 173, 187, 200],
15300:[162, 178, 192, 205],
15400:[165, 182, 197, 210],
15500:[169, 187, 202, 215],
15600:[172, 192, 207, 221],
15700:[176, 196, 211, 226],
15800:[179, 201, 216, 231],
15900:[183, 205, 221, 236],
16000:[187, 210, 226, 242],
16100:[187, 215, 231, 247],
16200:[188, 219, 236, 252],
16300:[188, 224, 240, 258],
16400:[189, 228, 245, 263],
16500:[189, 233, 250, 268],
16600:[189, 237, 255, 273],
16700:[190, 242, 260, 278],
16800:[190, 246, 264, 283],
16900:[191, 251, 269, 289],
17000:[191, 255, 274, 294],
17100:[191, 259, 279, 299],
17200:[192, 264, 284, 304],
17300:[192, 268, 289, 310],
17400:[192, 273, 293, 315],
17500:[193, 277, 298, 320],
17600:[193, 282, 303, 325],
17700:[193, 286, 308, 330],
17800:[194, 290, 313, 336],
17900:[194, 295, 318, 341],
18000:[194, 299, 323, 346],
18100:[194, 303, 328, 351],
18200:[195, 308, 332, 356],
18300:[195, 312, 337, 361],
18400:[196, 317, 342, 367],
18500:[196, 321, 347, 372],
18600:[196, 326, 351, 377],
18700:[197, 330, 356, 382],
18800:[197, 335, 361, 387],
18900:[197, 339, 366, 392],
19000:[198, 344, 370, 397],
19100:[198, 345, 375, 402],
19200:[199, 347, 379, 407],
19300:[199, 348, 384, 411],
19400:[200, 349, 388, 416],
19500:[200, 351, 393, 421],
19600:[201, 352, 397, 426],
19700:[201, 353, 402, 431],
19800:[201, 354, 406, 435],
19900:[202, 356, 411, 440],
20000:[202, 357, 416, 445],
20100:[202, 358, 421, 450],
20200:[203, 359, 425, 455],
20300:[203, 360, 430, 460],
20400:[204, 361, 434, 464],
20500:[204, 362, 439, 469],
20600:[205, 364, 443, 474],
20700:[205, 365, 448, 479],
20800:[206, 366, 452, 484],
20900:[206, 367, 457, 489],
21000:[207, 368, 461, 494],
21100:[207, 369, 466, 499],
21200:[208, 370, 470, 504],
21300:[208, 372, 475, 508],
21400:[209, 373, 479, 513],
21500:[209, 374, 484, 518],
21600:[210, 375, 488, 523],
21700:[210, 376, 493, 528],
21800:[211, 377, 497, 533],
21900:[211, 379, 502, 537],
22000:[212, 380, 506, 542],
22100:[212, 381, 508, 547],
22200:[213, 382, 511, 551],
22300:[213, 383, 513, 556],
22400:[213, 384, 515, 561],
22500:[214, 385, 517, 565],
22600:[214, 386, 520, 570],
22700:[214, 387, 522, 575],
22800:[215, 388, 524, 579],
22900:[215, 388, 527, 584],
23000:[215, 389, 529, 589],
23100:[215, 390, 530, 594],
23200:[215, 391, 532, 598],
23300:[216, 392, 533, 603],
23400:[216, 393, 535, 607],
23500:[216, 393, 536, 612],
23600:[216, 394, 538, 616],
23700:[217, 395, 539, 621],
23800:[217, 396, 540, 625],
23900:[217, 397, 542, 630],
24000:[217, 398, 543, 634],
24100:[217, 399, 544, 639],
24200:[218, 400, 546, 643],
24300:[218, 401, 547, 648],
24400:[218, 401, 549, 652],
24500:[218, 402, 550, 657],
24600:[219, 403, 551, 661],
24700:[219, 404, 553, 666],
24800:[219, 405, 554, 670],
24900:[219, 406, 556, 675],
25000:[220, 407, 557, 680],
25100:[220, 408, 559, 682],
25200:[221, 409, 560, 684],
25300:[221, 410, 562, 686],
25400:[222, 411, 563, 688],
25500:[222, 412, 565, 690],
25600:[222, 413, 566, 692],
25700:[223, 414, 568, 694],
25800:[223, 415, 569, 696],
25900:[224, 417, 571, 698],
26000:[224, 418, 573, 700],
26100:[225, 419, 575, 702],
26200:[226, 421, 577, 704],
26300:[226, 422, 578, 707],
26400:[227, 423, 580, 709],
26500:[228, 425, 582, 711],
26600:[229, 426, 584, 713],
26700:[230, 427, 586, 716],
26800:[230, 428, 587, 718],
26900:[231, 430, 589, 720],
27000:[232, 431, 591, 722],
27100:[233, 432, 593, 724],
27200:[234, 434, 595, 726],
27300:[235, 435, 597, 729],
27400:[235, 436, 599, 731],
27500:[236, 438, 600, 733],
27600:[237, 439, 602, 735],
27700:[238, 441, 604, 737],
27800:[239, 442, 606, 740],
27900:[240, 443, 608, 742],
28000:[240, 445, 610, 744],
28100:[241, 447, 612, 746],
28200:[242, 448, 614, 749],
28300:[243, 450, 616, 751],
28400:[244, 451, 618, 754],
28500:[245, 453, 620, 756],
28600:[246, 454, 622, 759],
28700:[247, 456, 624, 761],
28800:[248, 458, 626, 764],
28900:[249, 459, 628, 766],
29000:[250, 461, 630, 769],
29100:[251, 463, 632, 772],
29200:[252, 465, 634, 774],
29300:[254, 466, 636, 777],
29400:[255, 468, 639, 779],
29500:[256, 470, 641, 782],
29600:[257, 472, 643, 784],
29700:[258, 473, 645, 787],
29800:[259, 475, 647, 789],
29900:[261, 477, 649, 792],
30000:[262, 479, 652, 794],
30100:[263, 481, 654, 797],
30200:[264, 482, 656, 799],
30300:[265, 484, 659, 802],
30400:[266, 486, 661, 804],
30500:[268, 488, 663, 807],
30600:[269, 489, 665, 809],
30700:[270, 491, 667, 812],
30800:[271, 493, 670, 814],
30900:[272, 495, 672, 817],
31000:[273, 496, 674, 819],
31100:[274, 498, 676, 822],
31200:[275, 499, 678, 824],
31300:[276, 501, 680, 827],
31400:[278, 503, 683, 829],
31500:[279, 505, 685, 832],
31600:[280, 506, 687, 834],
31700:[281, 508, 689, 837],
31800:[282, 510, 691, 839],
31900:[283, 512, 693, 842],
32000:[285, 513, 695, 844],
32100:[286, 515, 697, 846],
32200:[287, 516, 699, 849],
32300:[289, 518, 702, 851],
32400:[290, 520, 704, 854],
32500:[291, 522, 706, 856],
32600:[292, 523, 708, 859],
32700:[293, 525, 710, 861],
32800:[295, 527, 713, 864],
32900:[296, 528, 715, 866],
33000:[297, 530, 717, 869],
33100:[298, 532, 719, 871],
33200:[299, 533, 721, 874],
33300:[300, 535, 723, 876],
33400:[302, 537, 726, 879],
33500:[303, 539, 728, 881],
33600:[304, 540, 730, 884],
33700:[305, 542, 732, 886],
33800:[306, 544, 734, 889],
33900:[307, 545, 736, 891],
34000:[308, 547, 738, 894],
34100:[309, 549, 740, 896],
34200:[310, 550, 742, 899],
34300:[312, 552, 745, 901],
34400:[313, 554, 747, 904],
34500:[314, 555, 749, 906],
34600:[315, 557, 751, 909],
34700:[316, 559, 753, 911],
34800:[317, 561, 756, 914],
34900:[319, 562, 758, 916],
35000:[320, 564, 760, 919],
35100:[321, 566, 762, 921],
35200:[322, 567, 764, 924],
35300:[323, 569, 766, 926],
35400:[324, 571, 769, 929],
35500:[326, 572, 771, 931],
35600:[327, 574, 773, 934],
35700:[328, 576, 775, 936],
35800:[329, 577, 777, 939],
35900:[330, 579, 779, 941],
36000:[331, 581, 781, 944],
36100:[332, 583, 783, 946],
36200:[333, 584, 785, 949],
36300:[334, 586, 787, 951],
36400:[335, 587, 789, 954],
36500:[336, 589, 791, 956],
36600:[337, 591, 793, 958],
36700:[339, 592, 795, 961],
36800:[340, 594, 797, 963],
36900:[341, 595, 799, 966],
37000:[342, 597, 801, 968],
37100:[343, 599, 803, 970],
37200:[344, 600, 805, 973],
37300:[345, 602, 807, 975],
37400:[346, 603, 809, 977],
37500:[347, 605, 811, 980],
37600:[348, 607, 813, 982],
37700:[350, 608, 815, 984],
37800:[351, 610, 817, 987],
37900:[352, 611, 819, 989],
38000:[353, 613, 821, 991],
38100:[354, 615, 823, 993],
38200:[355, 617, 825, 996],
38300:[357, 618, 828, 998],
38400:[358, 620, 830, 1001],
38500:[359, 622, 832, 1003],
38600:[360, 624, 834, 1006],
38700:[361, 626, 836, 1008],
38800:[363, 627, 839, 1011],
38900:[364, 629, 841, 1013],
39000:[365, 631, 843, 1016],
39100:[366, 633, 845, 1019],
39200:[368, 635, 847, 1021],
39300:[369, 637, 850, 1024],
39400:[370, 638, 852, 1026],
39500:[371, 640, 854, 1029],
39600:[373, 642, 856, 1031],
39700:[374, 644, 859, 1034],
39800:[375, 646, 861, 1037],
39900:[376, 648, 863, 1039],
40000:[378, 649, 865, 1042],
40100:[379, 651, 867, 1045],
40200:[381, 653, 869, 1047],
40300:[382, 654, 872, 1050],
40400:[383, 656, 874, 1052],
40500:[384, 658, 876, 1055],
40600:[386, 660, 878, 1058],
40700:[387, 662, 880, 1060],
40800:[388, 664, 883, 1063],
40900:[389, 665, 885, 1065],
41000:[391, 667, 887, 1068],
41100:[392, 669, 889, 1071],
41200:[394, 671, 892, 1073],
41300:[395, 672, 894, 1076],
41400:[396, 674, 896, 1078],
41500:[397, 676, 898, 1081],
41600:[399, 678, 901, 1084],
41700:[400, 680, 903, 1086],
41800:[401, 681, 905, 1089],
41900:[403, 683, 907, 1091],
42000:[404, 685, 910, 1094],
42100:[405, 687, 912, 1097],
42200:[407, 689, 914, 1099],
42300:[408, 690, 917, 1102],
42400:[409, 692, 919, 1104],
42500:[410, 694, 921, 1107],
42600:[412, 696, 923, 1110],
42700:[413, 698, 926, 1112],
42800:[414, 699, 928, 1115],
42900:[416, 701, 930, 1118],
43000:[417, 703, 932, 1120],
43100:[418, 705, 934, 1123],
43200:[420, 707, 936, 1125],
43300:[421, 708, 939, 1128],
43400:[422, 710, 941, 1130],
43500:[423, 712, 943, 1133],
43600:[425, 714, 945, 1135],
43700:[426, 715, 947, 1138],
43800:[427, 717, 949, 1140],
43900:[429, 719, 952, 1143],
44000:[430, 721, 954, 1145],
44100:[431, 723, 956, 1148],
44200:[432, 724, 958, 1150],
44300:[433, 726, 961, 1153],
44400:[435, 728, 963, 1155],
44500:[436, 729, 965, 1158],
44600:[437, 731, 967, 1160],
44700:[438, 733, 969, 1163],
44800:[439, 735, 971, 1165],
44900:[440, 736, 974, 1168],
45000:[441, 738, 976, 1170],
45100:[442, 739, 978, 1172],
45200:[443, 741, 980, 1175],
45300:[444, 742, 982, 1177],
45400:[445, 744, 984, 1179],
45500:[446, 745, 986, 1182],
45600:[447, 747, 988, 1184],
45700:[448, 748, 990, 1186],
45800:[449, 750, 992, 1188],
45900:[450, 751, 993, 1191],
46000:[451, 753, 995, 1193],
46100:[452, 754, 997, 1195],
46200:[453, 756, 999, 1198],
46300:[454, 757, 1001, 1200],
46400:[455, 759, 1003, 1202],
46500:[456, 760, 1004, 1204],
46600:[457, 762, 1006, 1207],
46700:[458, 763, 1008, 1209],
46800:[459, 765, 1010, 1211],
46900:[460, 766, 1012, 1214],
47000:[461, 768, 1014, 1216],
47100:[462, 769, 1016, 1218],
47200:[463, 771, 1018, 1220],
47300:[464, 772, 1020, 1223],
47400:[465, 774, 1021, 1225],
47500:[466, 775, 1023, 1227],
47600:[467, 777, 1025, 1229],
47700:[468, 778, 1027, 1232],
47800:[469, 780, 1029, 1234],
47900:[470, 781, 1031, 1236],
48000:[470, 783, 1033, 1238],
48100:[471, 784, 1035, 1240],
48200:[472, 786, 1037, 1243],
48300:[473, 787, 1039, 1245],
48400:[474, 789, 1041, 1247],
48500:[475, 790, 1043, 1249],
48600:[476, 792, 1045, 1252],
48700:[477, 793, 1047, 1254],
48800:[478, 795, 1049, 1256],
48900:[479, 796, 1051, 1258],
49000:[480, 798, 1053, 1261],
49100:[481, 800, 1055, 1263],
49200:[482, 801, 1057, 1266],
49300:[483, 803, 1059, 1268],
49400:[484, 804, 1061, 1270],
49500:[485, 806, 1063, 1273],
49600:[486, 807, 1065, 1275],
49700:[487, 809, 1067, 1277],
49800:[487, 810, 1068, 1279],
49900:[488, 812, 1070, 1282],
50000:[489, 813, 1072, 1284],
50100:[490, 815, 1074, 1286],
50200:[491, 816, 1076, 1288],
50300:[492, 818, 1078, 1291],
50400:[493, 819, 1080, 1293],
50500:[494, 821, 1082, 1295],
50600:[495, 822, 1084, 1297],
50700:[496, 824, 1085, 1300],
50800:[497, 825, 1087, 1302],
50900:[498, 827, 1089, 1304],
51000:[499, 828, 1091, 1306],
51100:[500, 830, 1093, 1308],
51200:[501, 831, 1095, 1311],
51300:[502, 833, 1097, 1313],
51400:[503, 834, 1099, 1315],
51500:[504, 836, 1101, 1318],
51600:[505, 837, 1103, 1320],
51700:[506, 839, 1105, 1323],
51800:[507, 840, 1107, 1325],
51900:[508, 842, 1109, 1327],
52000:[509, 843, 1111, 1330],
52100:[510, 844, 1113, 1332],
52200:[511, 846, 1115, 1335],
52300:[512, 847, 1117, 1337],
52400:[513, 849, 1119, 1339],
52500:[514, 850, 1121, 1342],
52600:[515, 852, 1123, 1344],
52700:[516, 853, 1125, 1346],
52800:[516, 855, 1127, 1349],
52900:[517, 856, 1128, 1351],
53000:[518, 858, 1130, 1353],
53100:[519, 860, 1132, 1355],
53200:[520, 861, 1134, 1358],
53300:[521, 863, 1136, 1360],
53400:[522, 864, 1138, 1362],
53500:[523, 866, 1140, 1365],
53600:[524, 867, 1142, 1367],
53700:[525, 869, 1144, 1369],
53800:[526, 871, 1146, 1372],
53900:[527, 872, 1148, 1374],
54000:[528, 874, 1150, 1376],
54100:[529, 876, 1152, 1378],
54200:[530, 877, 1154, 1381],
54300:[531, 879, 1156, 1383],
54400:[532, 880, 1158, 1385],
54500:[533, 882, 1160, 1388],
54600:[534, 883, 1162, 1390],
54700:[535, 885, 1163, 1392],
54800:[536, 886, 1165, 1395],
54900:[537, 888, 1167, 1397],
55000:[538, 889, 1169, 1399],
55100:[539, 891, 1171, 1401],
55200:[540, 892, 1173, 1404],
55300:[541, 894, 1175, 1406],
55400:[542, 895, 1177, 1409],
55500:[543, 897, 1179, 1411],
55600:[544, 899, 1181, 1414],
55700:[545, 900, 1183, 1416],
55800:[546, 902, 1185, 1419],
55900:[547, 904, 1187, 1421],
56000:[548, 905, 1190, 1424],
56100:[549, 907, 1192, 1426],
56200:[550, 908, 1194, 1429],
56300:[551, 910, 1196, 1431],
56400:[552, 911, 1198, 1434],
56500:[553, 913, 1200, 1436],
56600:[554, 915, 1203, 1439],
56700:[555, 916, 1205, 1441],
56800:[556, 918, 1207, 1444],
56900:[558, 919, 1209, 1446],
57000:[559, 921, 1211, 1448],
57100:[560, 923, 1213, 1450],
57200:[561, 924, 1215, 1453],
57300:[562, 926, 1217, 1455],
57400:[563, 927, 1219, 1458],
57500:[564, 929, 1222, 1460],
57600:[565, 931, 1224, 1462],
57700:[566, 932, 1226, 1465],
57800:[567, 934, 1228, 1467],
57900:[568, 935, 1230, 1470],
58000:[569, 937, 1232, 1472],
58100:[570, 939, 1234, 1474],
58200:[571, 940, 1236, 1477],
58300:[572, 942, 1238, 1479],
58400:[573, 943, 1240, 1482],
58500:[574, 945, 1242, 1484],
58600:[575, 947, 1244, 1487],
58700:[576, 948, 1246, 1489],
58800:[577, 950, 1248, 1492],
58900:[578, 951, 1250, 1494],
59000:[579, 953, 1252, 1497],
59100:[580, 955, 1254, 1499],
59200:[581, 956, 1256, 1502],
59300:[582, 958, 1258, 1504],
59400:[583, 959, 1260, 1507],
59500:[584, 961, 1262, 1509],
59600:[585, 962, 1264, 1511],
59700:[586, 964, 1267, 1514],
59800:[587, 966, 1269, 1516],
59900:[588, 967, 1271, 1519],
60000:[590, 969, 1273, 1521],
60100:[591, 970, 1275, 1523],
60200:[592, 972, 1277, 1526],
60300:[593, 973, 1279, 1528],
60400:[594, 975, 1281, 1530],
60500:[595, 976, 1283, 1533],
60600:[596, 978, 1285, 1535],
60700:[596, 979, 1287, 1538],
60800:[597, 981, 1289, 1540],
60900:[598, 982, 1291, 1542],
61000:[599, 984, 1293, 1545],
61100:[600, 985, 1295, 1547],
61200:[601, 987, 1297, 1550],
61300:[602, 988, 1299, 1552],
61400:[603, 990, 1301, 1554],
61500:[604, 991, 1303, 1557],
61600:[605, 993, 1305, 1559],
61700:[606, 994, 1307, 1561],
61800:[607, 996, 1309, 1564],
61900:[608, 997, 1311, 1566],
62000:[609, 999, 1312, 1568],
62100:[610, 1000, 1314, 1570],
62200:[611, 1002, 1316, 1573],
62300:[612, 1003, 1318, 1575],
62400:[613, 1005, 1320, 1577],
62500:[614, 1006, 1322, 1580],
62600:[615, 1008, 1324, 1582],
62700:[616, 1009, 1326, 1584],
62800:[617, 1011, 1328, 1586],
62900:[617, 1012, 1330, 1589],
63000:[618, 1014, 1332, 1591],
63100:[619, 1016, 1334, 1593],
63200:[620, 1017, 1336, 1596],
63300:[621, 1019, 1338, 1598],
63400:[622, 1020, 1340, 1601],
63500:[623, 1022, 1342, 1603],
63600:[623, 1023, 1344, 1605],
63700:[624, 1025, 1346, 1608],
63800:[625, 1026, 1347, 1610],
63900:[626, 1028, 1349, 1612],
64000:[627, 1030, 1351, 1615],
64100:[628, 1032, 1353, 1617],
64200:[629, 1033, 1355, 1620],
64300:[630, 1035, 1357, 1622],
64400:[631, 1036, 1359, 1624],
64500:[632, 1038, 1361, 1627],
64600:[633, 1039, 1363, 1629],
64700:[634, 1041, 1365, 1631],
64800:[635, 1042, 1367, 1634],
64900:[636, 1044, 1369, 1636],
65000:[637, 1045, 1371, 1638],
65100:[638, 1047, 1373, 1640],
65200:[639, 1048, 1375, 1643],
65300:[640, 1050, 1377, 1645],
65400:[641, 1051, 1379, 1647],
65500:[642, 1053, 1381, 1650],
65600:[643, 1054, 1382, 1652],
65700:[644, 1056, 1384, 1654],
65800:[644, 1057, 1386, 1657],
65900:[645, 1059, 1388, 1659],
66000:[646, 1060, 1390, 1661],
66100:[647, 1062, 1392, 1663],
66200:[648, 1063, 1394, 1666],
66300:[649, 1065, 1396, 1668],
66400:[650, 1066, 1398, 1670],
66500:[650, 1068, 1400, 1672],
66600:[651, 1069, 1402, 1675],
66700:[652, 1071, 1404, 1677],
66800:[653, 1072, 1406, 1679],
66900:[654, 1074, 1408, 1682],
67000:[655, 1075, 1410, 1684],
67100:[656, 1077, 1412, 1686],
67200:[657, 1078, 1414, 1689],
67300:[658, 1080, 1416, 1691],
67400:[659, 1081, 1418, 1693],
67500:[660, 1083, 1420, 1696],
67600:[661, 1084, 1422, 1698],
67700:[662, 1086, 1424, 1701],
67800:[663, 1087, 1426, 1703],
67900:[664, 1089, 1428, 1705],
68000:[665, 1090, 1430, 1708],
68100:[666, 1092, 1432, 1710],
68200:[667, 1093, 1434, 1713],
68300:[668, 1095, 1436, 1715],
68400:[669, 1096, 1438, 1717],
68500:[670, 1098, 1440, 1720],
68600:[671, 1099, 1442, 1722],
68700:[671, 1101, 1444, 1724],
68800:[672, 1102, 1446, 1727],
68900:[673, 1104, 1447, 1729],
69000:[674, 1105, 1449, 1731],
69100:[675, 1107, 1451, 1733],
69200:[676, 1108, 1453, 1736],
69300:[677, 1110, 1455, 1738],
69400:[678, 1111, 1457, 1740],
69500:[679, 1113, 1459, 1742],
69600:[680, 1114, 1461, 1745],
69700:[681, 1116, 1463, 1747],
69800:[682, 1117, 1465, 1749],
69900:[683, 1119, 1467, 1752],
70000:[684, 1120, 1469, 1754],
70100:[685, 1122, 1471, 1756],
70200:[686, 1123, 1473, 1759],
70300:[687, 1125, 1475, 1761],
70400:[688, 1126, 1477, 1763],
70500:[689, 1128, 1479, 1766],
70600:[690, 1129, 1481, 1768],
70700:[691, 1131, 1482, 1771],
70800:[692, 1132, 1484, 1773],
70900:[692, 1134, 1486, 1775],
71000:[693, 1135, 1488, 1778],
71100:[694, 1137, 1490, 1780],
71200:[695, 1138, 1492, 1783],
71300:[696, 1140, 1494, 1785],
71400:[697, 1141, 1496, 1787],
71500:[698, 1143, 1498, 1790],
71600:[698, 1144, 1500, 1792],
71700:[699, 1146, 1502, 1794],
71800:[700, 1147, 1504, 1797],
71900:[701, 1149, 1506, 1799],
72000:[702, 1150, 1508, 1801],
72100:[703, 1152, 1510, 1803],
72200:[704, 1153, 1512, 1806],
72300:[705, 1155, 1514, 1808],
72400:[706, 1156, 1516, 1810],
72500:[707, 1158, 1518, 1813],
72600:[708, 1159, 1520, 1815],
72700:[709, 1161, 1522, 1817],
72800:[710, 1162, 1524, 1819],
72900:[711, 1164, 1526, 1822],
73000:[712, 1165, 1528, 1824],
73100:[713, 1167, 1530, 1826],
73200:[714, 1168, 1532, 1829],
73300:[715, 1170, 1534, 1831],
73400:[716, 1171, 1536, 1833],
73500:[717, 1173, 1538, 1836],
73600:[718, 1175, 1540, 1838],
73700:[719, 1176, 1542, 1841],
73800:[720, 1178, 1544, 1843],
73900:[721, 1179, 1546, 1845],
74000:[722, 1181, 1548, 1848],
74100:[723, 1183, 1550, 1850],
74200:[724, 1184, 1552, 1853],
74300:[725, 1186, 1554, 1855],
74400:[726, 1187, 1556, 1858],
74500:[727, 1189, 1558, 1860],
74600:[728, 1190, 1560, 1862],
74700:[729, 1192, 1562, 1865],
74800:[730, 1193, 1564, 1867],
74900:[731, 1195, 1566, 1870],
75000:[732, 1196, 1568, 1872],
75100:[733, 1198, 1570, 1874],
75200:[734, 1199, 1572, 1877],
75300:[735, 1201, 1574, 1879],
75400:[736, 1202, 1576, 1882],
75500:[737, 1204, 1578, 1884],
75600:[738, 1205, 1580, 1886],
75700:[739, 1207, 1582, 1889],
75800:[740, 1208, 1584, 1891],
75900:[741, 1210, 1586, 1894],
76000:[742, 1212, 1588, 1896],
76100:[743, 1214, 1590, 1898],
76200:[744, 1215, 1592, 1901],
76300:[745, 1217, 1594, 1903],
76400:[746, 1218, 1596, 1906],
76500:[747, 1220, 1598, 1908],
76600:[748, 1222, 1600, 1911],
76700:[749, 1223, 1602, 1913],
76800:[750, 1225, 1604, 1915],
76900:[751, 1226, 1606, 1918],
77000:[752, 1228, 1608, 1920],
77100:[753, 1230, 1610, 1922],
77200:[754, 1231, 1612, 1925],
77300:[755, 1233, 1614, 1927],
77400:[756, 1234, 1616, 1929],
77500:[757, 1236, 1618, 1932],
77600:[758, 1237, 1620, 1934],
77700:[759, 1239, 1622, 1936],
77800:[760, 1240, 1624, 1939],
77900:[761, 1242, 1626, 1941],
78000:[762, 1243, 1628, 1943],
78100:[763, 1245, 1630, 1945],
78200:[764, 1246, 1632, 1948],
78300:[765, 1248, 1634, 1950],
78400:[766, 1249, 1636, 1952],
78500:[767, 1251, 1638, 1955],
78600:[768, 1252, 1640, 1957],
78700:[769, 1254, 1642, 1960],
78800:[770, 1255, 1644, 1962],
78900:[771, 1257, 1646, 1964],
79000:[772, 1259, 1648, 1967],
79100:[773, 1261, 1650, 1969],
79200:[774, 1262, 1652, 1972],
79300:[775, 1264, 1654, 1974],
79400:[776, 1265, 1656, 1977],
79500:[777, 1267, 1658, 1979],
79600:[778, 1269, 1660, 1981],
79700:[779, 1270, 1662, 1984],
79800:[780, 1272, 1664, 1986],
79900:[781, 1273, 1666, 1988],
80000:[782, 1275, 1669, 1991],
80100:[783, 1277, 1671, 1993],
80200:[784, 1278, 1673, 1996],
80300:[785, 1280, 1675, 1998],
80400:[786, 1281, 1677, 2001],
80500:[787, 1283, 1679, 2003],
80600:[788, 1284, 1681, 2005],
80700:[789, 1286, 1683, 2008],
80800:[790, 1287, 1685, 2010],
80900:[791, 1289, 1687, 2013],
81000:[792, 1290, 1689, 2015],
81100:[793, 1292, 1691, 2017],
81200:[794, 1293, 1693, 2020],
81300:[795, 1295, 1695, 2022],
81400:[796, 1296, 1697, 2025],
81500:[797, 1298, 1699, 2027],
81600:[798, 1299, 1701, 2030],
81700:[799, 1301, 1703, 2032],
81800:[800, 1302, 1705, 2034],
81900:[801, 1304, 1707, 2037],
82000:[802, 1306, 1709, 2039],
82100:[803, 1308, 1711, 2041],
82200:[804, 1309, 1713, 2044],
82300:[805, 1311, 1715, 2046],
82400:[806, 1312, 1717, 2048],
82500:[807, 1314, 1719, 2051],
82600:[808, 1316, 1721, 2053],
82700:[809, 1317, 1723, 2055],
82800:[810, 1319, 1725, 2058],
82900:[811, 1320, 1727, 2060],
83000:[813, 1322, 1729, 2062],
83100:[814, 1324, 1731, 2064],
83200:[815, 1325, 1733, 2067],
83300:[816, 1327, 1735, 2069],
83400:[817, 1328, 1737, 2071],
83500:[818, 1330, 1739, 2074],
83600:[819, 1331, 1741, 2076],
83700:[820, 1333, 1743, 2079],
83800:[821, 1334, 1745, 2081],
83900:[822, 1336, 1747, 2083],
84000:[823, 1337, 1749, 2086],
84100:[824, 1339, 1751, 2088],
84200:[825, 1340, 1753, 2091],
84300:[826, 1342, 1755, 2093],
84400:[827, 1343, 1757, 2096],
84500:[828, 1345, 1759, 2098],
84600:[829, 1346, 1761, 2100],
84700:[830, 1348, 1763, 2103],
84800:[831, 1349, 1765, 2105],
84900:[832, 1351, 1767, 2107],
85000:[833, 1353, 1769, 2110],
85100:[834, 1355, 1771, 2112],
85200:[835, 1356, 1773, 2115],
85300:[836, 1358, 1775, 2117],
85400:[837, 1359, 1777, 2120],
85500:[838, 1361, 1779, 2122],
85600:[839, 1363, 1781, 2124],
85700:[840, 1364, 1783, 2127],
85800:[841, 1366, 1785, 2129],
85900:[842, 1367, 1787, 2132],
86000:[843, 1369, 1789, 2134],
86100:[844, 1371, 1791, 2136],
86200:[845, 1372, 1793, 2139],
86300:[846, 1374, 1795, 2141],
86400:[847, 1375, 1797, 2143],
86500:[848, 1377, 1799, 2146],
86600:[849, 1378, 1801, 2148],
86700:[850, 1380, 1803, 2150],
86800:[851, 1381, 1805, 2153],
86900:[852, 1383, 1807, 2155],
87000:[853, 1384, 1809, 2157],
87100:[854, 1385, 1811, 2159],
87200:[855, 1387, 1813, 2162],
87300:[856, 1388, 1815, 2164],
87400:[857, 1390, 1817, 2166],
87500:[858, 1391, 1819, 2168],
87600:[859, 1393, 1821, 2171],
87700:[860, 1394, 1823, 2173],
87800:[860, 1396, 1825, 2175],
87900:[861, 1397, 1827, 2178],
88000:[862, 1399, 1829, 2180],
88100:[863, 1401, 1831, 2182],
88200:[864, 1402, 1833, 2185],
88300:[865, 1404, 1835, 2187],
88400:[866, 1405, 1837, 2189],
88500:[867, 1407, 1839, 2191],
88600:[868, 1408, 1841, 2194],
88700:[869, 1410, 1842, 2196],
88800:[870, 1412, 1844, 2198],
88900:[871, 1413, 1846, 2200],
89000:[872, 1415, 1848, 2203],
89100:[873, 1417, 1850, 2205],
89200:[874, 1418, 1852, 2208],
89300:[875, 1420, 1854, 2210],
89400:[876, 1421, 1856, 2212],
89500:[877, 1423, 1858, 2215],
89600:[878, 1424, 1860, 2217],
89700:[879, 1426, 1862, 2220],
89800:[880, 1427, 1864, 2222],
89900:[881, 1429, 1866, 2224],
90000:[882, 1430, 1868, 2227],
90100:[883, 1431, 1870, 2229],
90200:[884, 1433, 1872, 2231],
90300:[885, 1434, 1874, 2234],
90400:[886, 1436, 1876, 2236],
90500:[886, 1437, 1878, 2238],
90600:[887, 1439, 1879, 2240],
90700:[888, 1440, 1881, 2243],
90800:[889, 1441, 1883, 2245],
90900:[890, 1443, 1885, 2247],
91000:[891, 1444, 1887, 2249],
91100:[892, 1445, 1889, 2251],
91200:[893, 1447, 1891, 2253],
91300:[894, 1448, 1892, 2255],
91400:[895, 1450, 1894, 2257],
91500:[896, 1451, 1896, 2260],
91600:[897, 1453, 1898, 2262],
91700:[898, 1454, 1900, 2264],
91800:[899, 1456, 1901, 2266],
91900:[900, 1457, 1903, 2268],
92000:[901, 1459, 1905, 2270],
92100:[902, 1460, 1907, 2272],
92200:[903, 1462, 1909, 2274],
92300:[904, 1463, 1910, 2277],
92400:[905, 1465, 1912, 2279],
92500:[906, 1466, 1914, 2281],
92600:[907, 1468, 1916, 2283],
92700:[908, 1469, 1918, 2285],
92800:[909, 1471, 1919, 2287],
92900:[910, 1472, 1921, 2290],
93000:[910, 1473, 1923, 2292],
93100:[911, 1474, 1925, 2294],
93200:[912, 1476, 1927, 2296],
93300:[913, 1477, 1928, 2298],
93400:[914, 1479, 1930, 2301],
93500:[915, 1480, 1932, 2303],
93600:[916, 1482, 1934, 2305],
93700:[917, 1483, 1936, 2307],
93800:[918, 1485, 1937, 2309],
93900:[919, 1486, 1939, 2311],
94000:[919, 1487, 1941, 2313],
94100:[920, 1488, 1943, 2315],
94200:[921, 1490, 1945, 2317],
94300:[922, 1491, 1946, 2319],
94400:[923, 1493, 1948, 2321],
94500:[924, 1494, 1950, 2324],
94600:[925, 1496, 1952, 2326],
94700:[926, 1497, 1954, 2328],
94800:[927, 1498, 1955, 2330],
94900:[927, 1500, 1957, 2332],
95000:[928, 1501, 1959, 2334],
95100:[929, 1502, 1961, 2336],
95200:[930, 1504, 1963, 2338],
95300:[931, 1505, 1964, 2341],
95400:[932, 1507, 1966, 2343],
95500:[933, 1508, 1968, 2345],
95600:[934, 1510, 1970, 2347],
95700:[935, 1511, 1972, 2349],
95800:[936, 1512, 1973, 2351],
95900:[936, 1514, 1975, 2354],
96000:[937, 1515, 1977, 2356],
96100:[938, 1516, 1979, 2358],
96200:[939, 1518, 1981, 2360],
96300:[940, 1519, 1982, 2362],
96400:[941, 1521, 1984, 2365],
96500:[942, 1522, 1986, 2367],
96600:[943, 1524, 1988, 2369],
96700:[944, 1525, 1989, 2371],
96800:[944, 1526, 1991, 2373],
96900:[945, 1528, 1993, 2375],
97000:[946, 1529, 1995, 2377],
97100:[947, 1530, 1997, 2379],
97200:[948, 1532, 1999, 2381],
97300:[949, 1533, 2000, 2383],
97400:[950, 1535, 2002, 2385],
97500:[951, 1536, 2004, 2388],
97600:[952, 1538, 2006, 2390],
97700:[953, 1539, 2007, 2392],
97800:[953, 1540, 2009, 2394],
97900:[954, 1542, 2011, 2396],
98000:[955, 1543, 2013, 2398],
98100:[956, 1544, 2015, 2400],
98200:[957, 1546, 2017, 2402],
98300:[958, 1547, 2018, 2405],
98400:[959, 1549, 2020, 2407],
98500:[960, 1550, 2022, 2409],
98600:[961, 1552, 2024, 2411],
98700:[962, 1553, 2025, 2413],
98800:[962, 1554, 2027, 2415],
98900:[963, 1556, 2029, 2418],
99000:[964, 1557, 2031, 2420],
99100:[965, 1558, 2033, 2422],
99200:[966, 1560, 2035, 2424],
99300:[967, 1561, 2036, 2426],
99400:[968, 1563, 2038, 2429],
99500:[969, 1564, 2040, 2431],
99600:[970, 1565, 2042, 2433],
99700:[971, 1567, 2043, 2435],
99800:[971, 1568, 2045, 2437],
99900:[972, 1570, 2047, 2439],
};
const OR17_NU=[0.84, 1.32, 1.6, 1.9];

// Ontario — 2017 Federal Child Support Guidelines Table
const T17_ON={
100000:[910, 1471, 1920, 2288],
100100:[911, 1472, 1922, 2290],
100200:[912, 1474, 1923, 2292],
100300:[912, 1475, 1925, 2294],
100400:[913, 1476, 1926, 2295],
100500:[914, 1477, 1928, 2297],
100600:[915, 1479, 1929, 2299],
100700:[915, 1480, 1931, 2301],
100800:[916, 1481, 1933, 2303],
100900:[917, 1482, 1934, 2305],
101000:[918, 1484, 1936, 2306],
101100:[919, 1485, 1938, 2308],
101200:[920, 1486, 1939, 2310],
101300:[920, 1488, 1941, 2312],
101400:[921, 1489, 1942, 2314],
101500:[922, 1490, 1944, 2315],
101600:[923, 1491, 1946, 2317],
101700:[923, 1493, 1947, 2319],
101800:[924, 1494, 1949, 2321],
101900:[925, 1495, 1950, 2323],
102000:[926, 1496, 1952, 2325],
102100:[927, 1497, 1954, 2327],
102200:[928, 1498, 1955, 2329],
102300:[928, 1500, 1957, 2330],
102400:[929, 1501, 1958, 2332],
102500:[930, 1502, 1960, 2334],
102600:[931, 1503, 1961, 2336],
102700:[932, 1504, 1963, 2338],
102800:[932, 1506, 1964, 2340],
102900:[933, 1507, 1966, 2341],
103000:[934, 1508, 1967, 2343],
103100:[935, 1509, 1969, 2345],
103200:[936, 1510, 1970, 2347],
103300:[936, 1512, 1972, 2349],
103400:[937, 1513, 1973, 2350],
103500:[938, 1514, 1975, 2352],
103600:[939, 1515, 1976, 2354],
103700:[940, 1516, 1978, 2356],
103800:[940, 1518, 1979, 2358],
103900:[941, 1519, 1981, 2360],
104000:[942, 1520, 1983, 2362],
104100:[943, 1521, 1985, 2364],
104200:[944, 1523, 1986, 2366],
104300:[944, 1524, 1988, 2367],
104400:[945, 1525, 1989, 2369],
104500:[946, 1526, 1991, 2371],
104600:[947, 1528, 1992, 2373],
104700:[948, 1529, 1994, 2375],
104800:[949, 1530, 1996, 2376],
104900:[949, 1531, 1997, 2378],
105000:[950, 1533, 1999, 2380],
105100:[951, 1534, 2001, 2382],
105200:[952, 1535, 2002, 2384],
105300:[953, 1537, 2004, 2386],
105400:[953, 1538, 2005, 2387],
105500:[954, 1539, 2007, 2389],
105600:[955, 1540, 2009, 2391],
105700:[956, 1542, 2010, 2393],
105800:[957, 1543, 2012, 2395],
105900:[958, 1544, 2013, 2397],
106000:[958, 1545, 2015, 2399],
106100:[959, 1546, 2017, 2401],
106200:[959, 1547, 2018, 2403],
106300:[960, 1549, 2020, 2405],
106400:[961, 1550, 2021, 2407],
106500:[962, 1551, 2023, 2408],
106600:[962, 1552, 2024, 2410],
106700:[963, 1554, 2026, 2412],
106800:[964, 1555, 2027, 2414],
106900:[965, 1556, 2029, 2416],
107000:[965, 1557, 2030, 2418],
107100:[966, 1558, 2032, 2420],
107200:[967, 1559, 2033, 2422],
107300:[967, 1561, 2035, 2424],
107400:[968, 1562, 2036, 2425],
107500:[969, 1563, 2038, 2427],
107600:[970, 1564, 2039, 2429],
107700:[970, 1565, 2041, 2431],
107800:[971, 1567, 2043, 2433],
107900:[972, 1568, 2044, 2435],
108000:[973, 1569, 2046, 2436],
108100:[974, 1570, 2048, 2438],
108200:[975, 1571, 2049, 2440],
108300:[975, 1573, 2051, 2442],
108400:[976, 1574, 2052, 2444],
108500:[977, 1575, 2054, 2445],
108600:[978, 1576, 2056, 2447],
108700:[978, 1577, 2057, 2449],
108800:[979, 1578, 2059, 2451],
108900:[980, 1580, 2060, 2453],
109000:[981, 1581, 2062, 2455],
109100:[982, 1582, 2064, 2457],
109200:[983, 1584, 2065, 2459],
109300:[983, 1585, 2067, 2460],
109400:[984, 1586, 2068, 2462],
109500:[985, 1587, 2070, 2464],
109600:[986, 1589, 2072, 2466],
109700:[987, 1590, 2073, 2468],
109800:[987, 1591, 2075, 2470],
109900:[988, 1592, 2077, 2471],
110000:[989, 1594, 2078, 2473],
110100:[990, 1595, 2080, 2475],
110200:[991, 1596, 2081, 2477],
110300:[991, 1598, 2083, 2479],
110400:[992, 1599, 2084, 2480],
110500:[993, 1600, 2086, 2482],
110600:[994, 1601, 2087, 2484],
110700:[995, 1603, 2089, 2486],
110800:[995, 1604, 2090, 2488],
110900:[996, 1605, 2092, 2490],
111000:[997, 1606, 2093, 2492],
111100:[998, 1607, 2095, 2494],
111200:[999, 1608, 2096, 2496],
111300:[999, 1610, 2098, 2498],
111400:[1000, 1611, 2099, 2500],
111500:[1001, 1612, 2101, 2502],
111600:[1002, 1613, 2102, 2503],
111700:[1003, 1614, 2104, 2505],
111800:[1004, 1616, 2106, 2507],
111900:[1004, 1617, 2107, 2509],
112000:[1005, 1618, 2109, 2511],
112100:[1006, 1619, 2111, 2513],
112200:[1007, 1620, 2112, 2515],
112300:[1008, 1622, 2114, 2517],
112400:[1008, 1623, 2115, 2518],
112500:[1009, 1624, 2117, 2520],
112600:[1010, 1625, 2119, 2522],
112700:[1011, 1626, 2120, 2524],
112800:[1012, 1627, 2122, 2526],
112900:[1013, 1629, 2123, 2528],
113000:[1013, 1630, 2125, 2529],
113100:[1014, 1631, 2127, 2531],
113200:[1014, 1633, 2128, 2533],
113300:[1015, 1634, 2130, 2535],
113400:[1016, 1635, 2131, 2537],
113500:[1017, 1636, 2133, 2538],
113600:[1017, 1638, 2134, 2540],
113700:[1018, 1639, 2136, 2542],
113800:[1019, 1640, 2137, 2544],
113900:[1020, 1641, 2139, 2546],
114000:[1020, 1643, 2140, 2548],
114100:[1021, 1644, 2142, 2550],
114200:[1022, 1645, 2143, 2552],
114300:[1022, 1647, 2145, 2554],
114400:[1023, 1648, 2146, 2555],
114500:[1024, 1649, 2148, 2557],
114600:[1025, 1650, 2149, 2559],
114700:[1025, 1652, 2151, 2561],
114800:[1026, 1653, 2152, 2563],
114900:[1027, 1654, 2154, 2565],
115000:[1028, 1655, 2156, 2566],
115100:[1029, 1656, 2158, 2568],
115200:[1030, 1657, 2159, 2570],
115300:[1030, 1659, 2161, 2572],
115400:[1031, 1660, 2162, 2574],
115500:[1032, 1661, 2164, 2575],
115600:[1033, 1662, 2166, 2577],
115700:[1033, 1664, 2167, 2579],
115800:[1034, 1665, 2169, 2581],
115900:[1035, 1666, 2170, 2583],
116000:[1036, 1667, 2172, 2585],
116100:[1037, 1668, 2174, 2587],
116200:[1038, 1669, 2175, 2589],
116300:[1038, 1671, 2177, 2590],
116400:[1039, 1672, 2178, 2592],
116500:[1040, 1673, 2180, 2594],
116600:[1041, 1674, 2182, 2596],
116700:[1042, 1675, 2183, 2598],
116800:[1042, 1677, 2185, 2600],
116900:[1043, 1678, 2187, 2601],
117000:[1044, 1679, 2188, 2603],
117100:[1045, 1680, 2190, 2605],
117200:[1046, 1682, 2191, 2607],
117300:[1046, 1683, 2193, 2609],
117400:[1047, 1684, 2194, 2610],
117500:[1048, 1685, 2196, 2612],
117600:[1049, 1687, 2197, 2614],
117700:[1050, 1688, 2199, 2616],
117800:[1050, 1689, 2200, 2618],
117900:[1051, 1690, 2202, 2620],
118000:[1052, 1692, 2203, 2622],
118100:[1053, 1693, 2205, 2624],
118200:[1054, 1694, 2206, 2626],
118300:[1054, 1696, 2208, 2628],
118400:[1055, 1697, 2209, 2630],
118500:[1056, 1698, 2211, 2632],
118600:[1057, 1699, 2212, 2633],
118700:[1058, 1701, 2214, 2635],
118800:[1059, 1702, 2216, 2637],
118900:[1059, 1703, 2217, 2639],
119000:[1060, 1704, 2219, 2641],
119100:[1061, 1705, 2221, 2643],
119200:[1062, 1706, 2222, 2645],
119300:[1062, 1708, 2224, 2647],
119400:[1063, 1709, 2225, 2648],
119500:[1064, 1710, 2227, 2650],
119600:[1065, 1711, 2229, 2652],
119700:[1066, 1713, 2230, 2654],
119800:[1067, 1714, 2232, 2656],
119900:[1067, 1715, 2233, 2658],
12000:[0, 0, 0, 0],
120000:[1068, 1716, 2235, 2659],
120100:[1069, 1717, 2237, 2661],
120200:[1069, 1718, 2238, 2663],
120300:[1070, 1720, 2240, 2665],
120400:[1071, 1721, 2241, 2667],
120500:[1072, 1722, 2243, 2668],
120600:[1072, 1723, 2244, 2670],
120700:[1073, 1724, 2246, 2672],
120800:[1074, 1726, 2247, 2674],
120900:[1075, 1727, 2249, 2676],
12100:[4, 10, 10, 11],
121000:[1075, 1728, 2250, 2678],
121100:[1076, 1729, 2252, 2680],
121200:[1077, 1730, 2253, 2682],
121300:[1077, 1732, 2255, 2683],
121400:[1078, 1733, 2256, 2685],
121500:[1079, 1734, 2258, 2687],
121600:[1080, 1735, 2259, 2689],
121700:[1080, 1736, 2261, 2691],
121800:[1081, 1737, 2262, 2693],
121900:[1082, 1739, 2264, 2694],
12200:[8, 19, 21, 22],
122000:[1083, 1740, 2266, 2696],
122100:[1084, 1741, 2268, 2698],
122200:[1085, 1743, 2269, 2700],
122300:[1085, 1744, 2271, 2702],
122400:[1086, 1745, 2272, 2703],
122500:[1087, 1746, 2274, 2705],
122600:[1088, 1748, 2276, 2707],
122700:[1088, 1749, 2277, 2709],
122800:[1089, 1750, 2279, 2711],
122900:[1090, 1751, 2280, 2713],
12300:[12, 29, 31, 33],
123000:[1091, 1753, 2282, 2715],
123100:[1092, 1754, 2284, 2717],
123200:[1093, 1755, 2285, 2719],
123300:[1093, 1757, 2287, 2720],
123400:[1094, 1758, 2288, 2722],
123500:[1095, 1759, 2290, 2724],
123600:[1096, 1760, 2292, 2726],
123700:[1097, 1762, 2293, 2728],
123800:[1097, 1763, 2295, 2730],
123900:[1098, 1764, 2297, 2731],
12400:[16, 38, 41, 44],
124000:[1099, 1765, 2298, 2733],
124100:[1100, 1766, 2300, 2735],
124200:[1101, 1767, 2301, 2737],
124300:[1101, 1769, 2303, 2739],
124400:[1102, 1770, 2304, 2740],
124500:[1103, 1771, 2306, 2742],
124600:[1104, 1772, 2307, 2744],
124700:[1105, 1773, 2309, 2746],
124800:[1105, 1775, 2310, 2748],
124900:[1106, 1776, 2312, 2750],
12500:[21, 48, 52, 55],
125000:[1107, 1777, 2313, 2752],
125100:[1108, 1778, 2315, 2754],
125200:[1109, 1779, 2316, 2756],
125300:[1109, 1781, 2318, 2758],
125400:[1110, 1782, 2319, 2760],
125500:[1111, 1783, 2321, 2761],
125600:[1112, 1784, 2322, 2763],
125700:[1113, 1785, 2324, 2765],
125800:[1114, 1787, 2326, 2767],
125900:[1114, 1788, 2327, 2769],
12600:[25, 57, 62, 66],
126000:[1115, 1789, 2329, 2771],
126100:[1116, 1790, 2331, 2773],
126200:[1117, 1792, 2332, 2775],
126300:[1117, 1793, 2334, 2777],
126400:[1118, 1794, 2335, 2778],
126500:[1119, 1795, 2337, 2780],
126600:[1120, 1797, 2339, 2782],
126700:[1121, 1798, 2340, 2784],
126800:[1122, 1799, 2342, 2786],
126900:[1122, 1800, 2343, 2788],
12700:[29, 67, 72, 77],
127000:[1123, 1802, 2345, 2789],
127100:[1124, 1803, 2347, 2791],
127200:[1124, 1804, 2348, 2793],
127300:[1125, 1806, 2350, 2795],
127400:[1126, 1807, 2351, 2797],
127500:[1127, 1808, 2353, 2798],
127600:[1127, 1809, 2354, 2800],
127700:[1128, 1811, 2356, 2802],
127800:[1129, 1812, 2357, 2804],
127900:[1130, 1813, 2359, 2806],
12800:[33, 76, 82, 88],
128000:[1130, 1814, 2360, 2808],
128100:[1131, 1815, 2362, 2810],
128200:[1132, 1816, 2363, 2812],
128300:[1132, 1818, 2365, 2813],
128400:[1133, 1819, 2366, 2815],
128500:[1134, 1820, 2368, 2817],
128600:[1135, 1821, 2369, 2819],
128700:[1135, 1823, 2371, 2821],
128800:[1136, 1824, 2372, 2823],
128900:[1137, 1825, 2374, 2824],
12900:[37, 86, 93, 99],
129000:[1138, 1826, 2376, 2826],
129100:[1139, 1827, 2378, 2828],
129200:[1140, 1828, 2379, 2830],
129300:[1140, 1830, 2381, 2832],
129400:[1141, 1831, 2382, 2833],
129500:[1142, 1832, 2384, 2835],
129600:[1143, 1833, 2385, 2837],
129700:[1143, 1834, 2387, 2839],
129800:[1144, 1836, 2389, 2841],
129900:[1145, 1837, 2390, 2843],
13000:[41, 95, 103, 110],
130000:[1146, 1838, 2392, 2845],
130100:[1147, 1839, 2394, 2847],
130200:[1148, 1840, 2395, 2849],
130300:[1148, 1842, 2397, 2850],
130400:[1149, 1843, 2398, 2852],
130500:[1150, 1844, 2400, 2854],
130600:[1151, 1845, 2402, 2856],
130700:[1152, 1846, 2403, 2858],
130800:[1152, 1847, 2405, 2859],
130900:[1153, 1849, 2406, 2861],
13100:[43, 99, 107, 114],
131000:[1154, 1850, 2408, 2863],
131100:[1155, 1851, 2410, 2865],
131200:[1156, 1853, 2411, 2867],
131300:[1156, 1854, 2413, 2869],
131400:[1157, 1855, 2414, 2870],
131500:[1158, 1856, 2416, 2872],
131600:[1159, 1858, 2417, 2874],
131700:[1160, 1859, 2419, 2876],
131800:[1160, 1860, 2420, 2878],
131900:[1161, 1861, 2422, 2880],
13200:[45, 103, 111, 119],
132000:[1162, 1863, 2423, 2882],
132100:[1163, 1864, 2425, 2884],
132200:[1164, 1865, 2426, 2886],
132300:[1164, 1867, 2428, 2888],
132400:[1165, 1868, 2429, 2890],
132500:[1166, 1869, 2431, 2891],
132600:[1167, 1870, 2432, 2893],
132700:[1168, 1872, 2434, 2895],
132800:[1169, 1873, 2436, 2897],
132900:[1169, 1874, 2437, 2899],
13300:[47, 107, 115, 123],
133000:[1170, 1875, 2439, 2901],
133100:[1171, 1876, 2441, 2903],
133200:[1172, 1877, 2442, 2905],
133300:[1172, 1879, 2444, 2907],
133400:[1173, 1880, 2445, 2908],
133500:[1174, 1881, 2447, 2910],
133600:[1175, 1882, 2449, 2912],
133700:[1176, 1883, 2450, 2914],
133800:[1177, 1885, 2452, 2916],
133900:[1177, 1886, 2453, 2918],
13400:[49, 110, 120, 128],
134000:[1178, 1887, 2455, 2919],
134100:[1179, 1888, 2457, 2921],
134200:[1179, 1889, 2458, 2923],
134300:[1180, 1891, 2460, 2925],
134400:[1181, 1892, 2461, 2927],
134500:[1182, 1893, 2463, 2928],
134600:[1182, 1894, 2464, 2930],
134700:[1183, 1895, 2466, 2932],
134800:[1184, 1896, 2467, 2934],
134900:[1185, 1898, 2469, 2936],
13500:[51, 114, 124, 132],
135000:[1185, 1899, 2470, 2938],
135100:[1186, 1900, 2472, 2940],
135200:[1187, 1902, 2473, 2942],
135300:[1187, 1903, 2475, 2943],
135400:[1188, 1904, 2476, 2945],
135500:[1189, 1905, 2478, 2947],
135600:[1190, 1907, 2479, 2949],
135700:[1190, 1908, 2481, 2951],
135800:[1191, 1909, 2482, 2953],
135900:[1192, 1910, 2484, 2954],
13600:[53, 118, 128, 137],
136000:[1193, 1912, 2486, 2956],
136100:[1194, 1913, 2488, 2958],
136200:[1195, 1914, 2489, 2960],
136300:[1195, 1916, 2491, 2962],
136400:[1196, 1917, 2492, 2963],
136500:[1197, 1918, 2494, 2965],
136600:[1198, 1919, 2495, 2967],
136700:[1198, 1921, 2497, 2969],
136800:[1199, 1922, 2499, 2971],
136900:[1200, 1923, 2500, 2973],
13700:[55, 122, 132, 141],
137000:[1201, 1924, 2502, 2975],
137100:[1202, 1925, 2504, 2977],
137200:[1203, 1926, 2505, 2979],
137300:[1203, 1928, 2507, 2981],
137400:[1204, 1929, 2508, 2983],
137500:[1205, 1930, 2510, 2985],
137600:[1206, 1931, 2512, 2986],
137700:[1206, 1933, 2513, 2988],
137800:[1207, 1934, 2515, 2990],
137900:[1208, 1935, 2516, 2992],
13800:[57, 126, 136, 146],
138000:[1209, 1936, 2518, 2994],
138100:[1210, 1937, 2520, 2996],
138200:[1211, 1938, 2521, 2998],
138300:[1211, 1940, 2523, 3000],
138400:[1212, 1941, 2524, 3001],
138500:[1213, 1942, 2526, 3003],
138600:[1214, 1943, 2527, 3005],
138700:[1215, 1944, 2529, 3007],
138800:[1215, 1946, 2530, 3009],
138900:[1216, 1947, 2532, 3011],
13900:[59, 130, 140, 150],
139000:[1217, 1948, 2533, 3012],
139100:[1218, 1949, 2535, 3014],
139200:[1219, 1950, 2536, 3016],
139300:[1219, 1952, 2538, 3018],
139400:[1220, 1953, 2539, 3020],
139500:[1221, 1954, 2541, 3021],
139600:[1222, 1955, 2542, 3023],
139700:[1223, 1956, 2544, 3025],
139800:[1223, 1957, 2546, 3027],
139900:[1224, 1959, 2547, 3029],
14000:[60, 134, 144, 155],
140000:[1225, 1960, 2549, 3031],
140100:[1226, 1961, 2550, 3033],
140200:[1226, 1962, 2552, 3035],
140300:[1227, 1963, 2553, 3036],
140400:[1228, 1965, 2555, 3038],
140500:[1229, 1966, 2556, 3040],
140600:[1229, 1967, 2558, 3042],
140700:[1230, 1968, 2559, 3044],
140800:[1231, 1969, 2561, 3046],
140900:[1232, 1970, 2562, 3047],
14100:[62, 138, 148, 159],
141000:[1232, 1972, 2564, 3049],
141100:[1233, 1973, 2565, 3051],
141200:[1234, 1974, 2567, 3052],
141300:[1234, 1976, 2568, 3054],
141400:[1235, 1977, 2570, 3056],
141500:[1236, 1978, 2571, 3058],
141600:[1237, 1979, 2573, 3059],
141700:[1237, 1980, 2574, 3061],
141800:[1238, 1981, 2576, 3063],
141900:[1239, 1983, 2577, 3065],
14200:[64, 141, 152, 163],
142000:[1240, 1984, 2579, 3066],
142100:[1241, 1985, 2580, 3068],
142200:[1241, 1986, 2582, 3070],
142300:[1242, 1987, 2583, 3071],
142400:[1243, 1988, 2585, 3073],
142500:[1244, 1990, 2586, 3075],
142600:[1244, 1991, 2588, 3077],
142700:[1245, 1992, 2589, 3078],
142800:[1246, 1993, 2591, 3080],
142900:[1246, 1994, 2592, 3082],
14300:[66, 145, 156, 167],
143000:[1247, 1995, 2594, 3084],
143100:[1248, 1996, 2595, 3086],
143200:[1249, 1997, 2597, 3087],
143300:[1249, 1998, 2598, 3089],
143400:[1250, 2000, 2600, 3091],
143500:[1251, 2001, 2601, 3093],
143600:[1252, 2002, 2603, 3094],
143700:[1252, 2003, 2604, 3096],
143800:[1253, 2004, 2606, 3098],
143900:[1254, 2005, 2607, 3099],
14400:[68, 148, 159, 172],
144000:[1255, 2007, 2609, 3101],
144100:[1256, 2008, 2611, 3103],
144200:[1256, 2009, 2612, 3105],
144300:[1257, 2011, 2614, 3106],
144400:[1258, 2012, 2615, 3108],
144500:[1259, 2013, 2617, 3110],
144600:[1259, 2014, 2618, 3112],
144700:[1260, 2015, 2620, 3113],
144800:[1261, 2017, 2621, 3115],
144900:[1262, 2018, 2623, 3117],
14500:[70, 152, 163, 176],
145000:[1262, 2019, 2624, 3119],
145100:[1263, 2020, 2626, 3121],
145200:[1264, 2021, 2627, 3123],
145300:[1264, 2022, 2629, 3124],
145400:[1265, 2024, 2630, 3126],
145500:[1266, 2025, 2632, 3128],
145600:[1267, 2026, 2633, 3130],
145700:[1268, 2027, 2635, 3132],
145800:[1268, 2028, 2636, 3133],
145900:[1269, 2029, 2638, 3135],
14600:[71, 156, 167, 180],
146000:[1270, 2030, 2639, 3137],
146100:[1271, 2031, 2641, 3139],
146200:[1271, 2032, 2642, 3140],
146300:[1272, 2034, 2644, 3142],
146400:[1273, 2035, 2645, 3144],
146500:[1274, 2036, 2647, 3146],
146600:[1274, 2037, 2648, 3147],
146700:[1275, 2038, 2650, 3149],
146800:[1276, 2039, 2651, 3151],
146900:[1277, 2041, 2653, 3153],
14700:[73, 159, 171, 184],
147000:[1277, 2042, 2654, 3154],
147100:[1278, 2043, 2656, 3156],
147200:[1278, 2044, 2657, 3158],
147300:[1279, 2045, 2659, 3159],
147400:[1280, 2046, 2660, 3161],
147500:[1280, 2048, 2662, 3163],
147600:[1281, 2049, 2663, 3165],
147700:[1282, 2050, 2665, 3166],
147800:[1283, 2051, 2666, 3168],
147900:[1283, 2052, 2668, 3170],
14800:[75, 163, 175, 188],
148000:[1284, 2053, 2669, 3172],
148100:[1285, 2054, 2670, 3174],
148200:[1286, 2055, 2672, 3175],
148300:[1286, 2056, 2673, 3177],
148400:[1287, 2058, 2675, 3179],
148500:[1288, 2059, 2676, 3181],
148600:[1289, 2060, 2678, 3182],
148700:[1289, 2061, 2679, 3184],
148800:[1290, 2062, 2681, 3186],
148900:[1291, 2063, 2682, 3187],
14900:[77, 166, 179, 192],
149000:[1292, 2065, 2683, 3189],
149100:[1293, 2066, 2684, 3191],
149200:[1293, 2067, 2686, 3193],
149300:[1294, 2069, 2687, 3194],
149400:[1295, 2070, 2689, 3196],
149500:[1296, 2071, 2690, 3198],
149600:[1296, 2072, 2692, 3200],
149700:[1297, 2073, 2693, 3201],
149800:[1298, 2075, 2695, 3203],
149900:[1298, 2076, 2696, 3205],
15000:[79, 170, 183, 196],
150000:[1299, 2077, 2698, 3207],
15100:[81, 173, 187, 200],
15200:[83, 177, 190, 204],
15300:[85, 180, 194, 207],
15400:[87, 183, 197, 211],
15500:[88, 187, 201, 215],
15600:[90, 190, 205, 219],
15700:[92, 193, 208, 223],
15800:[94, 196, 212, 226],
15900:[96, 200, 215, 230],
16000:[98, 203, 219, 234],
16100:[100, 206, 222, 237],
16200:[102, 209, 225, 241],
16300:[104, 212, 229, 244],
16400:[106, 215, 232, 248],
16500:[108, 218, 235, 251],
16600:[110, 221, 238, 255],
16700:[112, 224, 242, 258],
16800:[114, 227, 245, 262],
16900:[116, 230, 248, 265],
17000:[118, 233, 251, 269],
17100:[120, 236, 254, 272],
17200:[122, 239, 257, 276],
17300:[124, 242, 261, 279],
17400:[126, 245, 264, 283],
17500:[128, 248, 267, 286],
17600:[130, 251, 270, 290],
17700:[131, 254, 274, 293],
17800:[133, 257, 277, 296],
17900:[135, 260, 280, 300],
18000:[137, 263, 283, 303],
18100:[139, 266, 287, 307],
18200:[140, 270, 290, 311],
18300:[142, 273, 294, 315],
18400:[144, 276, 298, 319],
18500:[145, 280, 301, 323],
18600:[147, 283, 305, 326],
18700:[149, 286, 308, 330],
18800:[151, 290, 312, 334],
18900:[152, 293, 316, 338],
19000:[154, 296, 319, 342],
19100:[155, 297, 323, 346],
19200:[155, 299, 327, 351],
19300:[156, 300, 331, 355],
19400:[157, 302, 335, 359],
19500:[158, 303, 340, 364],
19600:[158, 305, 344, 368],
19700:[159, 306, 348, 372],
19800:[160, 308, 352, 377],
19900:[160, 309, 356, 381],
20000:[161, 311, 360, 385],
20100:[162, 312, 364, 389],
20200:[162, 314, 368, 393],
20300:[163, 315, 372, 398],
20400:[164, 316, 375, 402],
20500:[165, 318, 379, 406],
20600:[165, 319, 383, 410],
20700:[166, 320, 387, 414],
20800:[167, 321, 391, 418],
20900:[168, 323, 395, 423],
21000:[168, 324, 398, 427],
21100:[169, 325, 402, 431],
21200:[170, 327, 406, 436],
21300:[170, 328, 410, 440],
21400:[171, 329, 414, 444],
21500:[172, 331, 418, 449],
21600:[173, 332, 422, 453],
21700:[174, 333, 426, 457],
21800:[174, 335, 430, 461],
21900:[175, 336, 434, 466],
22000:[176, 337, 438, 470],
22100:[177, 338, 442, 474],
22200:[178, 340, 446, 478],
22300:[178, 341, 450, 482],
22400:[179, 342, 453, 487],
22500:[180, 343, 457, 491],
22600:[181, 345, 461, 495],
22700:[181, 346, 465, 499],
22800:[182, 347, 469, 503],
22900:[183, 348, 473, 507],
23000:[184, 350, 477, 511],
23100:[185, 351, 479, 515],
23200:[186, 353, 482, 519],
23300:[186, 354, 484, 523],
23400:[187, 355, 486, 527],
23500:[188, 356, 489, 531],
23600:[189, 358, 491, 535],
23700:[190, 359, 493, 539],
23800:[190, 360, 496, 543],
23900:[191, 361, 498, 547],
24000:[192, 363, 500, 551],
24100:[193, 364, 502, 555],
24200:[193, 366, 503, 559],
24300:[194, 367, 505, 563],
24400:[195, 368, 507, 567],
24500:[196, 369, 508, 571],
24600:[196, 371, 510, 575],
24700:[197, 372, 512, 579],
24800:[198, 373, 513, 583],
24900:[199, 375, 515, 587],
25000:[199, 376, 517, 591],
25100:[200, 378, 519, 595],
25200:[201, 379, 521, 600],
25300:[202, 381, 523, 604],
25400:[203, 382, 525, 609],
25500:[204, 384, 527, 613],
25600:[205, 385, 529, 617],
25700:[206, 387, 531, 622],
25800:[207, 388, 533, 626],
25900:[208, 390, 535, 630],
26000:[209, 391, 537, 635],
26100:[210, 393, 539, 639],
26200:[212, 395, 541, 644],
26300:[213, 397, 544, 648],
26400:[214, 398, 546, 653],
26500:[216, 400, 548, 657],
26600:[217, 402, 550, 661],
26700:[219, 404, 552, 666],
26800:[220, 406, 555, 670],
26900:[221, 408, 557, 674],
27000:[223, 410, 559, 679],
27100:[224, 412, 561, 682],
27200:[226, 414, 564, 685],
27300:[227, 415, 566, 688],
27400:[228, 417, 568, 690],
27500:[230, 419, 570, 693],
27600:[231, 421, 573, 696],
27700:[232, 423, 575, 699],
27800:[234, 425, 577, 702],
27900:[235, 426, 579, 705],
28000:[236, 428, 582, 708],
28100:[237, 430, 584, 710],
28200:[238, 431, 586, 713],
28300:[239, 433, 588, 715],
28400:[240, 435, 590, 718],
28500:[241, 436, 592, 720],
28600:[243, 438, 594, 723],
28700:[244, 440, 596, 725],
28800:[245, 441, 598, 728],
28900:[246, 443, 600, 730],
29000:[247, 445, 602, 732],
29100:[248, 446, 604, 734],
29200:[249, 448, 606, 736],
29300:[250, 449, 608, 739],
29400:[250, 451, 609, 741],
29500:[251, 452, 611, 743],
29600:[252, 454, 613, 745],
29700:[253, 455, 615, 748],
29800:[254, 456, 617, 750],
29900:[255, 458, 619, 752],
30000:[256, 459, 621, 754],
30100:[257, 461, 623, 756],
30200:[258, 462, 625, 759],
30300:[258, 464, 627, 761],
30400:[259, 465, 629, 763],
30500:[260, 467, 631, 766],
30600:[261, 468, 633, 768],
30700:[262, 470, 635, 771],
30800:[263, 471, 637, 773],
30900:[263, 473, 639, 775],
31000:[264, 474, 641, 778],
31100:[265, 475, 643, 780],
31200:[266, 477, 645, 783],
31300:[267, 478, 647, 785],
31400:[267, 480, 649, 787],
31500:[268, 481, 651, 790],
31600:[269, 483, 653, 792],
31700:[270, 484, 654, 794],
31800:[271, 486, 656, 797],
31900:[272, 487, 658, 799],
32000:[273, 488, 660, 801],
32100:[274, 489, 662, 803],
32200:[275, 491, 664, 806],
32300:[276, 492, 666, 808],
32400:[277, 494, 668, 810],
32500:[277, 495, 670, 813],
32600:[278, 497, 672, 815],
32700:[279, 498, 674, 817],
32800:[280, 500, 676, 820],
32900:[281, 501, 678, 822],
33000:[282, 503, 680, 824],
33100:[283, 504, 682, 826],
33200:[284, 506, 684, 829],
33300:[285, 507, 686, 831],
33400:[286, 509, 688, 833],
33500:[287, 510, 690, 835],
33600:[288, 512, 692, 838],
33700:[289, 513, 694, 840],
33800:[290, 514, 696, 842],
33900:[291, 516, 698, 845],
34000:[292, 517, 699, 847],
34100:[293, 518, 701, 849],
34200:[294, 520, 703, 852],
34300:[296, 521, 705, 854],
34400:[297, 523, 707, 856],
34500:[298, 524, 709, 859],
34600:[299, 526, 710, 861],
34700:[301, 527, 712, 864],
34800:[302, 529, 714, 866],
34900:[303, 530, 716, 868],
35000:[304, 532, 718, 871],
35100:[305, 533, 720, 873],
35200:[306, 535, 722, 875],
35300:[307, 536, 724, 878],
35400:[309, 538, 725, 880],
35500:[310, 539, 727, 882],
35600:[311, 540, 729, 884],
35700:[312, 542, 731, 887],
35800:[313, 543, 733, 889],
35900:[314, 545, 735, 891],
36000:[315, 546, 737, 893],
36100:[316, 547, 739, 895],
36200:[317, 549, 740, 897],
36300:[318, 550, 742, 899],
36400:[319, 551, 744, 901],
36500:[320, 552, 745, 903],
36600:[321, 554, 747, 905],
36700:[322, 555, 749, 907],
36800:[323, 556, 750, 909],
36900:[324, 557, 752, 911],
37000:[326, 559, 754, 913],
37100:[327, 560, 756, 915],
37200:[328, 561, 757, 917],
37300:[329, 563, 759, 919],
37400:[330, 564, 761, 921],
37500:[331, 565, 762, 923],
37600:[332, 566, 764, 925],
37700:[333, 568, 765, 927],
37800:[334, 569, 767, 929],
37900:[335, 570, 769, 931],
38000:[336, 571, 770, 933],
38100:[337, 572, 772, 935],
38200:[338, 574, 773, 937],
38300:[339, 575, 775, 939],
38400:[340, 576, 777, 941],
38500:[341, 578, 779, 943],
38600:[342, 579, 780, 945],
38700:[343, 580, 782, 947],
38800:[345, 581, 784, 949],
38900:[346, 583, 785, 951],
39000:[347, 584, 787, 953],
39100:[348, 585, 789, 955],
39200:[349, 587, 791, 957],
39300:[351, 588, 792, 959],
39400:[352, 589, 794, 962],
39500:[353, 591, 796, 964],
39600:[354, 592, 798, 966],
39700:[355, 593, 800, 968],
39800:[356, 595, 801, 970],
39900:[358, 596, 803, 972],
40000:[359, 597, 805, 975],
40100:[360, 598, 807, 977],
40200:[361, 600, 809, 979],
40300:[362, 601, 810, 982],
40400:[364, 602, 812, 984],
40500:[365, 604, 814, 986],
40600:[366, 605, 816, 988],
40700:[367, 607, 818, 990],
40800:[368, 608, 819, 993],
40900:[369, 609, 821, 995],
41000:[370, 611, 823, 997],
41100:[371, 612, 825, 999],
41200:[372, 614, 826, 1001],
41300:[373, 615, 828, 1003],
41400:[374, 616, 830, 1005],
41500:[376, 618, 831, 1007],
41600:[377, 619, 833, 1009],
41700:[378, 620, 835, 1011],
41800:[379, 621, 837, 1013],
41900:[380, 623, 838, 1015],
42000:[381, 624, 840, 1017],
42100:[382, 626, 842, 1019],
42200:[384, 627, 843, 1021],
42300:[385, 629, 845, 1023],
42400:[386, 630, 846, 1025],
42500:[387, 632, 848, 1026],
42600:[389, 633, 850, 1028],
42700:[390, 635, 851, 1030],
42800:[391, 636, 853, 1032],
42900:[392, 638, 854, 1034],
43000:[394, 639, 856, 1036],
43100:[395, 641, 858, 1038],
43200:[396, 642, 859, 1040],
43300:[398, 644, 861, 1042],
43400:[399, 646, 863, 1044],
43500:[400, 647, 864, 1046],
43600:[401, 649, 866, 1048],
43700:[403, 651, 867, 1050],
43800:[404, 652, 869, 1052],
43900:[405, 654, 871, 1054],
44000:[406, 656, 872, 1056],
44100:[407, 658, 874, 1058],
44200:[408, 660, 875, 1060],
44300:[410, 661, 877, 1062],
44400:[411, 663, 879, 1064],
44500:[412, 665, 880, 1066],
44600:[413, 667, 882, 1068],
44700:[415, 668, 884, 1070],
44800:[416, 670, 885, 1072],
44900:[417, 672, 887, 1074],
45000:[418, 674, 888, 1076],
45100:[419, 676, 890, 1078],
45200:[420, 677, 891, 1080],
45300:[421, 679, 893, 1082],
45400:[422, 681, 894, 1084],
45500:[423, 682, 896, 1086],
45600:[423, 684, 897, 1088],
45700:[424, 686, 899, 1090],
45800:[425, 688, 900, 1092],
45900:[426, 689, 902, 1094],
46000:[427, 691, 904, 1096],
46100:[428, 693, 906, 1098],
46200:[429, 694, 907, 1100],
46300:[430, 696, 909, 1102],
46400:[431, 698, 910, 1104],
46500:[431, 699, 912, 1106],
46600:[432, 701, 913, 1107],
46700:[433, 703, 915, 1109],
46800:[434, 704, 916, 1111],
46900:[435, 706, 918, 1113],
47000:[436, 708, 920, 1115],
47100:[437, 710, 922, 1117],
47200:[438, 711, 924, 1119],
47300:[439, 713, 926, 1121],
47400:[440, 715, 928, 1123],
47500:[440, 717, 930, 1124],
47600:[441, 718, 932, 1126],
47700:[442, 720, 934, 1128],
47800:[443, 722, 936, 1130],
47900:[444, 723, 938, 1132],
48000:[445, 725, 940, 1134],
48100:[446, 726, 942, 1135],
48200:[446, 728, 943, 1137],
48300:[447, 729, 945, 1138],
48400:[448, 730, 947, 1140],
48500:[448, 732, 948, 1141],
48600:[449, 733, 950, 1142],
48700:[450, 734, 952, 1144],
48800:[450, 736, 953, 1145],
48900:[451, 737, 955, 1147],
49000:[452, 738, 957, 1148],
49100:[453, 740, 959, 1150],
49200:[454, 741, 961, 1152],
49300:[455, 743, 963, 1154],
49400:[456, 745, 965, 1155],
49500:[456, 746, 967, 1157],
49600:[457, 748, 969, 1159],
49700:[458, 750, 971, 1161],
49800:[459, 751, 973, 1163],
49900:[460, 753, 975, 1165],
50000:[461, 755, 977, 1167],
50100:[462, 757, 979, 1169],
50200:[463, 758, 981, 1171],
50300:[464, 760, 983, 1173],
50400:[465, 762, 985, 1175],
50500:[465, 764, 987, 1177],
50600:[466, 765, 990, 1179],
50700:[467, 767, 992, 1181],
50800:[468, 769, 994, 1183],
50900:[469, 770, 996, 1185],
51000:[470, 772, 998, 1187],
51100:[471, 774, 1000, 1189],
51200:[472, 775, 1002, 1191],
51300:[473, 777, 1004, 1193],
51400:[474, 779, 1007, 1195],
51500:[474, 781, 1009, 1197],
51600:[475, 782, 1011, 1199],
51700:[476, 784, 1013, 1201],
51800:[477, 786, 1015, 1203],
51900:[478, 788, 1017, 1205],
52000:[479, 789, 1019, 1207],
52100:[480, 791, 1021, 1209],
52200:[481, 792, 1023, 1212],
52300:[482, 794, 1025, 1214],
52400:[483, 796, 1028, 1217],
52500:[484, 798, 1030, 1219],
52600:[485, 799, 1032, 1222],
52700:[486, 801, 1034, 1224],
52800:[487, 803, 1036, 1226],
52900:[488, 805, 1038, 1229],
53000:[489, 806, 1040, 1231],
53100:[490, 808, 1042, 1233],
53200:[491, 809, 1044, 1236],
53300:[492, 811, 1046, 1238],
53400:[493, 813, 1048, 1241],
53500:[494, 815, 1050, 1243],
53600:[495, 816, 1052, 1246],
53700:[496, 818, 1054, 1248],
53800:[496, 820, 1056, 1250],
53900:[497, 821, 1058, 1253],
54000:[498, 823, 1060, 1255],
54100:[499, 825, 1062, 1257],
54200:[500, 826, 1064, 1260],
54300:[501, 828, 1066, 1262],
54400:[502, 829, 1068, 1265],
54500:[503, 831, 1070, 1267],
54600:[503, 833, 1072, 1270],
54700:[504, 834, 1074, 1272],
54800:[505, 836, 1076, 1274],
54900:[506, 837, 1079, 1277],
55000:[507, 839, 1081, 1279],
55100:[508, 841, 1083, 1282],
55200:[509, 842, 1086, 1284],
55300:[510, 844, 1088, 1287],
55400:[511, 845, 1090, 1289],
55500:[512, 847, 1092, 1292],
55600:[513, 848, 1095, 1294],
55700:[514, 850, 1097, 1297],
55800:[515, 851, 1099, 1299],
55900:[516, 853, 1101, 1302],
56000:[517, 854, 1104, 1304],
56100:[518, 856, 1106, 1307],
56200:[519, 857, 1108, 1309],
56300:[520, 859, 1111, 1312],
56400:[521, 860, 1113, 1314],
56500:[522, 862, 1115, 1317],
56600:[523, 863, 1117, 1319],
56700:[524, 865, 1120, 1322],
56800:[525, 866, 1122, 1325],
56900:[526, 868, 1124, 1327],
57000:[527, 869, 1126, 1330],
57100:[528, 870, 1128, 1333],
57200:[529, 872, 1130, 1335],
57300:[530, 873, 1133, 1338],
57400:[531, 875, 1135, 1340],
57500:[532, 876, 1137, 1343],
57600:[533, 878, 1139, 1345],
57700:[534, 879, 1142, 1348],
57800:[534, 881, 1144, 1350],
57900:[535, 882, 1146, 1353],
58000:[536, 884, 1148, 1355],
58100:[537, 885, 1150, 1358],
58200:[538, 887, 1152, 1360],
58300:[539, 888, 1155, 1363],
58400:[540, 890, 1157, 1365],
58500:[541, 891, 1159, 1368],
58600:[542, 893, 1161, 1371],
58700:[543, 894, 1164, 1373],
58800:[544, 896, 1166, 1376],
58900:[545, 897, 1168, 1378],
59000:[546, 899, 1170, 1381],
59100:[547, 901, 1172, 1384],
59200:[548, 902, 1174, 1386],
59300:[549, 904, 1177, 1389],
59400:[550, 905, 1179, 1391],
59500:[551, 907, 1181, 1394],
59600:[552, 908, 1183, 1396],
59700:[553, 910, 1186, 1399],
59800:[554, 911, 1188, 1401],
59900:[555, 913, 1190, 1404],
60000:[556, 915, 1192, 1406],
60100:[557, 917, 1194, 1409],
60200:[558, 918, 1196, 1411],
60300:[559, 920, 1199, 1414],
60400:[560, 921, 1201, 1416],
60500:[561, 923, 1203, 1419],
60600:[562, 924, 1205, 1421],
60700:[563, 926, 1207, 1424],
60800:[564, 927, 1210, 1426],
60900:[565, 929, 1212, 1429],
61000:[566, 930, 1214, 1431],
61100:[567, 932, 1216, 1434],
61200:[568, 933, 1218, 1436],
61300:[569, 935, 1221, 1439],
61400:[570, 936, 1223, 1441],
61500:[571, 938, 1225, 1444],
61600:[572, 939, 1227, 1446],
61700:[573, 941, 1229, 1449],
61800:[574, 942, 1232, 1452],
61900:[575, 944, 1234, 1454],
62000:[576, 945, 1236, 1457],
62100:[577, 946, 1238, 1460],
62200:[578, 948, 1240, 1462],
62300:[579, 949, 1243, 1465],
62400:[580, 951, 1245, 1467],
62500:[581, 952, 1247, 1470],
62600:[582, 954, 1249, 1472],
62700:[583, 955, 1251, 1475],
62800:[584, 957, 1254, 1477],
62900:[585, 958, 1256, 1480],
63000:[585, 960, 1258, 1482],
63100:[586, 961, 1260, 1485],
63200:[587, 963, 1262, 1487],
63300:[588, 964, 1265, 1490],
63400:[589, 966, 1267, 1492],
63500:[590, 967, 1269, 1495],
63600:[591, 969, 1271, 1497],
63700:[592, 970, 1273, 1500],
63800:[593, 972, 1275, 1503],
63900:[594, 973, 1278, 1505],
64000:[595, 975, 1280, 1508],
64100:[596, 977, 1282, 1511],
64200:[597, 978, 1284, 1513],
64300:[598, 980, 1286, 1516],
64400:[599, 981, 1288, 1518],
64500:[600, 983, 1290, 1521],
64600:[601, 984, 1292, 1523],
64700:[602, 986, 1293, 1526],
64800:[603, 987, 1295, 1528],
64900:[604, 989, 1297, 1531],
65000:[605, 991, 1299, 1533],
65100:[606, 993, 1301, 1536],
65200:[607, 994, 1303, 1538],
65300:[608, 996, 1305, 1541],
65400:[609, 997, 1307, 1543],
65500:[610, 999, 1309, 1546],
65600:[611, 1000, 1311, 1548],
65700:[612, 1002, 1313, 1551],
65800:[613, 1003, 1315, 1553],
65900:[614, 1005, 1317, 1556],
66000:[615, 1006, 1319, 1558],
66100:[616, 1008, 1321, 1561],
66200:[617, 1009, 1323, 1563],
66300:[618, 1011, 1325, 1566],
66400:[619, 1012, 1327, 1568],
66500:[620, 1014, 1329, 1571],
66600:[621, 1015, 1331, 1573],
66700:[622, 1017, 1332, 1576],
66800:[623, 1018, 1334, 1578],
66900:[623, 1020, 1336, 1581],
67000:[624, 1021, 1338, 1584],
67100:[625, 1022, 1340, 1587],
67200:[626, 1024, 1342, 1589],
67300:[627, 1025, 1344, 1592],
67400:[628, 1027, 1346, 1594],
67500:[629, 1028, 1348, 1597],
67600:[630, 1030, 1350, 1599],
67700:[631, 1031, 1352, 1602],
67800:[632, 1033, 1354, 1604],
67900:[633, 1034, 1356, 1607],
68000:[634, 1036, 1358, 1609],
68100:[635, 1037, 1360, 1612],
68200:[636, 1039, 1362, 1614],
68300:[637, 1040, 1364, 1617],
68400:[638, 1042, 1366, 1619],
68500:[639, 1043, 1368, 1622],
68600:[640, 1045, 1369, 1624],
68700:[641, 1046, 1371, 1627],
68800:[642, 1048, 1373, 1630],
68900:[643, 1049, 1375, 1632],
69000:[644, 1051, 1377, 1635],
69100:[645, 1053, 1379, 1638],
69200:[646, 1054, 1381, 1640],
69300:[647, 1056, 1383, 1643],
69400:[648, 1057, 1385, 1645],
69500:[649, 1059, 1387, 1648],
69600:[650, 1060, 1389, 1650],
69700:[651, 1062, 1391, 1653],
69800:[652, 1063, 1393, 1655],
69900:[653, 1065, 1395, 1658],
70000:[654, 1067, 1397, 1660],
70100:[655, 1069, 1399, 1662],
70200:[656, 1070, 1401, 1665],
70300:[657, 1072, 1403, 1667],
70400:[658, 1073, 1405, 1670],
70500:[659, 1075, 1407, 1672],
70600:[660, 1076, 1409, 1675],
70700:[661, 1078, 1411, 1677],
70800:[661, 1079, 1413, 1680],
70900:[662, 1081, 1415, 1682],
71000:[663, 1082, 1417, 1685],
71100:[664, 1084, 1419, 1688],
71200:[665, 1085, 1421, 1690],
71300:[666, 1087, 1423, 1693],
71400:[667, 1088, 1425, 1695],
71500:[668, 1090, 1427, 1698],
71600:[669, 1091, 1429, 1700],
71700:[670, 1093, 1431, 1703],
71800:[671, 1094, 1433, 1705],
71900:[672, 1096, 1435, 1708],
72000:[673, 1097, 1436, 1711],
72100:[674, 1098, 1437, 1713],
72200:[675, 1099, 1439, 1715],
72300:[675, 1101, 1440, 1717],
72400:[676, 1102, 1442, 1719],
72500:[677, 1103, 1443, 1721],
72600:[678, 1104, 1445, 1723],
72700:[678, 1105, 1446, 1725],
72800:[679, 1107, 1448, 1727],
72900:[680, 1108, 1449, 1729],
73000:[681, 1109, 1451, 1731],
73100:[682, 1111, 1453, 1733],
73200:[683, 1112, 1455, 1736],
73300:[684, 1114, 1457, 1738],
73400:[685, 1115, 1459, 1740],
73500:[686, 1117, 1461, 1743],
73600:[687, 1118, 1463, 1745],
73700:[688, 1120, 1465, 1748],
73800:[689, 1121, 1467, 1750],
73900:[690, 1123, 1469, 1752],
74000:[691, 1124, 1471, 1755],
74100:[692, 1125, 1473, 1757],
74200:[693, 1127, 1475, 1760],
74300:[694, 1128, 1477, 1762],
74400:[695, 1130, 1479, 1764],
74500:[696, 1131, 1481, 1767],
74600:[697, 1133, 1483, 1769],
74700:[698, 1134, 1485, 1771],
74800:[698, 1136, 1487, 1774],
74900:[699, 1137, 1489, 1776],
75000:[700, 1139, 1491, 1778],
75100:[701, 1140, 1493, 1780],
75200:[702, 1142, 1495, 1782],
75300:[703, 1143, 1497, 1785],
75400:[703, 1145, 1498, 1787],
75500:[704, 1146, 1500, 1789],
75600:[705, 1148, 1502, 1791],
75700:[706, 1149, 1504, 1794],
75800:[707, 1151, 1506, 1796],
75900:[708, 1152, 1508, 1798],
76000:[709, 1154, 1509, 1800],
76100:[710, 1155, 1511, 1802],
76200:[711, 1157, 1513, 1804],
76300:[712, 1158, 1515, 1807],
76400:[712, 1160, 1517, 1809],
76500:[713, 1161, 1518, 1811],
76600:[714, 1163, 1520, 1813],
76700:[715, 1164, 1522, 1815],
76800:[716, 1165, 1524, 1818],
76900:[717, 1167, 1526, 1820],
77000:[718, 1168, 1528, 1822],
77100:[719, 1169, 1530, 1824],
77200:[720, 1171, 1532, 1826],
77300:[721, 1172, 1534, 1829],
77400:[721, 1174, 1535, 1831],
77500:[722, 1175, 1537, 1833],
77600:[723, 1176, 1539, 1835],
77700:[724, 1178, 1541, 1837],
77800:[725, 1179, 1543, 1840],
77900:[726, 1181, 1545, 1842],
78000:[727, 1182, 1546, 1844],
78100:[728, 1183, 1548, 1846],
78200:[729, 1185, 1550, 1848],
78300:[730, 1186, 1552, 1851],
78400:[731, 1188, 1554, 1853],
78500:[731, 1189, 1555, 1855],
78600:[732, 1190, 1557, 1857],
78700:[733, 1192, 1559, 1859],
78800:[734, 1193, 1561, 1862],
78900:[735, 1194, 1563, 1864],
79000:[736, 1196, 1565, 1866],
79100:[737, 1197, 1567, 1868],
79200:[738, 1199, 1569, 1870],
79300:[739, 1200, 1570, 1873],
79400:[740, 1202, 1572, 1875],
79500:[740, 1203, 1574, 1877],
79600:[741, 1205, 1576, 1879],
79700:[742, 1206, 1578, 1881],
79800:[743, 1208, 1580, 1884],
79900:[744, 1209, 1581, 1886],
80000:[745, 1211, 1583, 1888],
80100:[746, 1213, 1585, 1890],
80200:[747, 1214, 1587, 1893],
80300:[748, 1216, 1589, 1895],
80400:[749, 1217, 1590, 1897],
80500:[750, 1219, 1592, 1899],
80600:[751, 1220, 1594, 1902],
80700:[752, 1222, 1596, 1904],
80800:[753, 1223, 1598, 1906],
80900:[754, 1225, 1600, 1909],
81000:[755, 1226, 1602, 1911],
81100:[756, 1227, 1604, 1913],
81200:[757, 1229, 1606, 1915],
81300:[758, 1230, 1608, 1918],
81400:[759, 1232, 1609, 1920],
81500:[760, 1233, 1611, 1922],
81600:[761, 1235, 1613, 1924],
81700:[762, 1236, 1615, 1927],
81800:[763, 1238, 1617, 1929],
81900:[763, 1239, 1619, 1931],
82000:[764, 1240, 1621, 1933],
82100:[765, 1241, 1623, 1935],
82200:[766, 1243, 1625, 1938],
82300:[767, 1244, 1627, 1940],
82400:[768, 1246, 1628, 1942],
82500:[769, 1247, 1630, 1944],
82600:[770, 1249, 1632, 1947],
82700:[771, 1250, 1634, 1949],
82800:[772, 1252, 1636, 1951],
82900:[773, 1253, 1638, 1954],
83000:[774, 1255, 1640, 1956],
83100:[775, 1256, 1642, 1958],
83200:[776, 1258, 1644, 1960],
83300:[777, 1259, 1646, 1962],
83400:[778, 1261, 1647, 1965],
83500:[779, 1262, 1649, 1967],
83600:[780, 1264, 1651, 1969],
83700:[781, 1265, 1653, 1971],
83800:[781, 1267, 1655, 1973],
83900:[782, 1268, 1657, 1975],
84000:[783, 1270, 1659, 1977],
84100:[784, 1271, 1661, 1979],
84200:[785, 1273, 1663, 1981],
84300:[786, 1274, 1664, 1983],
84400:[787, 1276, 1666, 1986],
84500:[788, 1277, 1668, 1988],
84600:[788, 1279, 1670, 1990],
84700:[789, 1280, 1672, 1992],
84800:[790, 1282, 1674, 1994],
84900:[791, 1283, 1675, 1996],
85000:[792, 1284, 1677, 1999],
85100:[793, 1285, 1679, 2001],
85200:[794, 1287, 1681, 2003],
85300:[795, 1288, 1683, 2006],
85400:[796, 1290, 1685, 2008],
85500:[796, 1291, 1686, 2010],
85600:[797, 1293, 1688, 2012],
85700:[798, 1294, 1690, 2014],
85800:[799, 1295, 1692, 2016],
85900:[800, 1297, 1694, 2019],
86000:[801, 1298, 1696, 2021],
86100:[802, 1299, 1698, 2023],
86200:[803, 1301, 1700, 2025],
86300:[804, 1302, 1702, 2028],
86400:[805, 1304, 1703, 2030],
86500:[805, 1305, 1705, 2032],
86600:[806, 1306, 1707, 2034],
86700:[807, 1308, 1709, 2037],
86800:[808, 1309, 1711, 2039],
86900:[809, 1311, 1713, 2041],
87000:[810, 1312, 1714, 2043],
87100:[811, 1313, 1716, 2045],
87200:[812, 1315, 1718, 2047],
87300:[813, 1316, 1719, 2049],
87400:[813, 1317, 1721, 2052],
87500:[814, 1319, 1723, 2054],
87600:[815, 1320, 1725, 2056],
87700:[816, 1322, 1727, 2058],
87800:[817, 1323, 1728, 2060],
87900:[818, 1324, 1730, 2062],
88000:[819, 1326, 1732, 2064],
88100:[820, 1327, 1734, 2066],
88200:[820, 1328, 1735, 2068],
88300:[821, 1330, 1737, 2070],
88400:[822, 1331, 1738, 2072],
88500:[822, 1332, 1740, 2074],
88600:[823, 1333, 1742, 2076],
88700:[824, 1334, 1743, 2078],
88800:[825, 1335, 1745, 2079],
88900:[825, 1337, 1747, 2081],
89000:[826, 1338, 1748, 2083],
89100:[827, 1339, 1750, 2085],
89200:[828, 1341, 1751, 2087],
89300:[828, 1342, 1753, 2089],
89400:[829, 1343, 1754, 2091],
89500:[830, 1344, 1756, 2092],
89600:[831, 1346, 1758, 2094],
89700:[831, 1347, 1759, 2096],
89800:[832, 1348, 1761, 2098],
89900:[833, 1349, 1762, 2100],
90000:[834, 1351, 1764, 2102],
90100:[835, 1352, 1766, 2104],
90200:[835, 1353, 1767, 2106],
90300:[836, 1354, 1769, 2108],
90400:[837, 1356, 1770, 2109],
90500:[837, 1357, 1772, 2111],
90600:[838, 1358, 1774, 2113],
90700:[838, 1359, 1775, 2115],
90800:[839, 1360, 1777, 2117],
90900:[840, 1361, 1778, 2119],
91000:[840, 1362, 1780, 2121],
91100:[841, 1363, 1782, 2123],
91200:[841, 1364, 1783, 2125],
91300:[842, 1366, 1785, 2126],
91400:[843, 1367, 1786, 2128],
91500:[843, 1368, 1788, 2130],
91600:[844, 1369, 1789, 2132],
91700:[845, 1370, 1791, 2134],
91800:[845, 1371, 1792, 2135],
91900:[846, 1373, 1794, 2137],
92000:[847, 1374, 1795, 2139],
92100:[848, 1375, 1797, 2141],
92200:[849, 1376, 1798, 2143],
92300:[849, 1378, 1800, 2145],
92400:[850, 1379, 1801, 2147],
92500:[851, 1380, 1803, 2149],
92600:[852, 1381, 1804, 2150],
92700:[852, 1383, 1806, 2152],
92800:[853, 1384, 1807, 2154],
92900:[854, 1385, 1809, 2156],
93000:[855, 1386, 1810, 2158],
93100:[856, 1387, 1812, 2160],
93200:[857, 1388, 1813, 2162],
93300:[857, 1390, 1815, 2164],
93400:[858, 1391, 1816, 2165],
93500:[859, 1392, 1818, 2167],
93600:[860, 1393, 1819, 2169],
93700:[860, 1395, 1821, 2171],
93800:[861, 1396, 1823, 2173],
93900:[862, 1397, 1824, 2175],
94000:[863, 1398, 1826, 2176],
94100:[864, 1399, 1828, 2178],
94200:[865, 1400, 1829, 2180],
94300:[865, 1402, 1831, 2182],
94400:[866, 1403, 1832, 2184],
94500:[867, 1404, 1834, 2185],
94600:[868, 1405, 1836, 2187],
94700:[868, 1406, 1837, 2189],
94800:[869, 1408, 1839, 2191],
94900:[870, 1409, 1840, 2193],
95000:[871, 1410, 1842, 2195],
95100:[872, 1411, 1844, 2197],
95200:[873, 1413, 1845, 2199],
95300:[873, 1414, 1847, 2200],
95400:[874, 1415, 1848, 2202],
95500:[875, 1416, 1850, 2204],
95600:[876, 1418, 1851, 2206],
95700:[877, 1419, 1853, 2208],
95800:[877, 1420, 1854, 2210],
95900:[878, 1421, 1856, 2211],
96000:[879, 1423, 1857, 2213],
96100:[880, 1424, 1859, 2215],
96200:[881, 1425, 1860, 2217],
96300:[881, 1427, 1862, 2219],
96400:[882, 1428, 1863, 2220],
96500:[883, 1429, 1865, 2222],
96600:[884, 1430, 1866, 2224],
96700:[885, 1432, 1868, 2226],
96800:[885, 1433, 1869, 2228],
96900:[886, 1434, 1871, 2230],
97000:[887, 1435, 1873, 2232],
97100:[888, 1436, 1875, 2234],
97200:[889, 1437, 1876, 2236],
97300:[889, 1439, 1878, 2237],
97400:[890, 1440, 1879, 2239],
97500:[891, 1441, 1881, 2241],
97600:[892, 1442, 1883, 2243],
97700:[893, 1444, 1884, 2245],
97800:[894, 1445, 1886, 2247],
97900:[894, 1446, 1887, 2248],
98000:[895, 1447, 1889, 2250],
98100:[896, 1448, 1891, 2252],
98200:[896, 1449, 1892, 2254],
98300:[897, 1451, 1894, 2256],
98400:[898, 1452, 1895, 2257],
98500:[899, 1453, 1897, 2259],
98600:[899, 1454, 1899, 2261],
98700:[900, 1455, 1900, 2263],
98800:[901, 1457, 1902, 2265],
98900:[902, 1458, 1904, 2267],
99000:[902, 1459, 1905, 2269],
99100:[903, 1460, 1907, 2271],
99200:[904, 1461, 1908, 2273],
99300:[904, 1463, 1910, 2275],
99400:[905, 1464, 1911, 2277],
99500:[906, 1465, 1913, 2279],
99600:[907, 1466, 1914, 2280],
99700:[907, 1467, 1916, 2282],
99800:[908, 1468, 1917, 2284],
99900:[909, 1470, 1919, 2286],
};
const OR17_ON=[0.72, 1.2, 1.46, 1.76];

// Prince Edward Island — 2017 Federal Child Support Guidelines Table
const T17_PE={
100000:[861, 1394, 1821, 2171],
100100:[862, 1395, 1823, 2173],
100200:[862, 1396, 1824, 2175],
100300:[863, 1397, 1826, 2177],
100400:[864, 1399, 1827, 2178],
100500:[865, 1400, 1829, 2180],
100600:[865, 1401, 1830, 2182],
100700:[866, 1402, 1832, 2184],
100800:[867, 1403, 1834, 2186],
100900:[867, 1404, 1835, 2188],
101000:[868, 1406, 1837, 2189],
101100:[869, 1407, 1839, 2191],
101200:[870, 1408, 1840, 2193],
101300:[870, 1410, 1842, 2194],
101400:[871, 1411, 1843, 2196],
101500:[872, 1412, 1845, 2198],
101600:[873, 1413, 1846, 2200],
101700:[873, 1414, 1848, 2202],
101800:[874, 1415, 1849, 2204],
101900:[875, 1417, 1851, 2205],
102000:[876, 1418, 1852, 2207],
102100:[877, 1419, 1854, 2209],
102200:[877, 1420, 1855, 2210],
102300:[878, 1421, 1857, 2212],
102400:[879, 1422, 1858, 2214],
102500:[880, 1424, 1860, 2216],
102600:[880, 1425, 1861, 2217],
102700:[881, 1426, 1863, 2219],
102800:[882, 1427, 1864, 2221],
102900:[883, 1428, 1866, 2223],
103000:[883, 1429, 1867, 2224],
103100:[884, 1430, 1869, 2226],
103200:[884, 1431, 1870, 2228],
103300:[885, 1433, 1872, 2229],
103400:[886, 1434, 1873, 2231],
103500:[887, 1435, 1875, 2233],
103600:[887, 1436, 1876, 2235],
103700:[888, 1437, 1878, 2236],
103800:[889, 1438, 1879, 2238],
103900:[890, 1440, 1881, 2240],
104000:[890, 1441, 1882, 2242],
104100:[891, 1442, 1884, 2244],
104200:[891, 1443, 1885, 2246],
104300:[892, 1445, 1887, 2247],
104400:[893, 1446, 1888, 2249],
104500:[894, 1447, 1890, 2251],
104600:[894, 1448, 1891, 2253],
104700:[895, 1450, 1893, 2254],
104800:[896, 1451, 1894, 2256],
104900:[896, 1452, 1896, 2258],
105000:[897, 1453, 1897, 2260],
105100:[898, 1454, 1899, 2262],
105200:[899, 1455, 1900, 2264],
105300:[899, 1457, 1902, 2266],
105400:[900, 1458, 1903, 2267],
105500:[901, 1459, 1905, 2269],
105600:[902, 1460, 1906, 2271],
105700:[902, 1462, 1908, 2273],
105800:[903, 1463, 1909, 2275],
105900:[904, 1464, 1911, 2277],
106000:[905, 1465, 1912, 2279],
106100:[906, 1466, 1914, 2281],
106200:[907, 1467, 1915, 2283],
106300:[907, 1469, 1917, 2285],
106400:[908, 1470, 1918, 2286],
106500:[909, 1471, 1920, 2288],
106600:[910, 1472, 1921, 2290],
106700:[911, 1474, 1923, 2292],
106800:[911, 1475, 1925, 2294],
106900:[912, 1476, 1926, 2296],
107000:[913, 1477, 1928, 2297],
107100:[914, 1478, 1930, 2299],
107200:[915, 1479, 1931, 2301],
107300:[915, 1481, 1933, 2302],
107400:[916, 1482, 1934, 2304],
107500:[917, 1483, 1936, 2306],
107600:[918, 1484, 1937, 2308],
107700:[919, 1486, 1939, 2310],
107800:[920, 1487, 1940, 2311],
107900:[920, 1488, 1942, 2313],
108000:[921, 1489, 1943, 2315],
108100:[922, 1490, 1945, 2317],
108200:[922, 1491, 1946, 2319],
108300:[923, 1493, 1948, 2320],
108400:[924, 1494, 1949, 2322],
108500:[925, 1495, 1951, 2324],
108600:[925, 1496, 1952, 2326],
108700:[926, 1498, 1954, 2327],
108800:[927, 1499, 1956, 2329],
108900:[928, 1500, 1957, 2331],
109000:[928, 1501, 1959, 2333],
109100:[929, 1502, 1961, 2335],
109200:[930, 1503, 1962, 2337],
109300:[930, 1505, 1964, 2339],
109400:[931, 1506, 1965, 2340],
109500:[932, 1507, 1967, 2342],
109600:[933, 1508, 1968, 2344],
109700:[933, 1510, 1970, 2346],
109800:[934, 1511, 1971, 2348],
109900:[935, 1512, 1973, 2350],
110000:[936, 1513, 1974, 2352],
110100:[937, 1514, 1976, 2354],
110200:[938, 1515, 1977, 2356],
110300:[938, 1517, 1979, 2357],
110400:[939, 1518, 1980, 2359],
110500:[940, 1519, 1982, 2361],
110600:[941, 1520, 1984, 2363],
110700:[942, 1522, 1985, 2365],
110800:[942, 1523, 1987, 2367],
110900:[943, 1524, 1988, 2368],
111000:[944, 1525, 1990, 2370],
111100:[945, 1526, 1992, 2372],
111200:[945, 1527, 1993, 2374],
111300:[946, 1529, 1995, 2375],
111400:[947, 1530, 1996, 2377],
111500:[948, 1531, 1998, 2379],
111600:[948, 1532, 1999, 2381],
111700:[949, 1534, 2001, 2383],
111800:[950, 1535, 2002, 2384],
111900:[951, 1536, 2004, 2386],
112000:[951, 1537, 2005, 2388],
112100:[952, 1538, 2007, 2390],
112200:[953, 1539, 2008, 2392],
112300:[953, 1541, 2010, 2393],
112400:[954, 1542, 2011, 2395],
112500:[955, 1543, 2013, 2397],
112600:[956, 1544, 2015, 2399],
112700:[956, 1546, 2016, 2400],
112800:[957, 1547, 2018, 2402],
112900:[958, 1548, 2019, 2404],
113000:[959, 1549, 2021, 2406],
113100:[960, 1550, 2023, 2408],
113200:[961, 1551, 2024, 2410],
113300:[961, 1553, 2026, 2412],
113400:[962, 1554, 2027, 2413],
113500:[963, 1555, 2029, 2415],
113600:[964, 1556, 2030, 2417],
113700:[965, 1558, 2032, 2419],
113800:[965, 1559, 2033, 2421],
113900:[966, 1560, 2035, 2423],
114000:[967, 1561, 2036, 2425],
114100:[968, 1562, 2038, 2427],
114200:[969, 1563, 2039, 2429],
114300:[969, 1565, 2041, 2430],
114400:[970, 1566, 2042, 2432],
114500:[971, 1567, 2044, 2434],
114600:[972, 1568, 2045, 2436],
114700:[973, 1570, 2047, 2438],
114800:[974, 1571, 2048, 2440],
114900:[974, 1572, 2050, 2441],
115000:[975, 1573, 2051, 2443],
115100:[976, 1574, 2053, 2445],
115200:[976, 1575, 2054, 2447],
115300:[977, 1577, 2056, 2448],
115400:[978, 1578, 2057, 2450],
115500:[979, 1579, 2059, 2452],
115600:[979, 1580, 2060, 2454],
115700:[980, 1582, 2062, 2456],
115800:[981, 1583, 2063, 2457],
115900:[982, 1584, 2065, 2459],
116000:[982, 1585, 2067, 2461],
116100:[983, 1586, 2069, 2463],
116200:[984, 1587, 2070, 2465],
116300:[984, 1589, 2072, 2467],
116400:[985, 1590, 2073, 2468],
116500:[986, 1591, 2075, 2470],
116600:[987, 1592, 2076, 2472],
116700:[987, 1594, 2078, 2474],
116800:[988, 1595, 2079, 2476],
116900:[989, 1596, 2081, 2478],
117000:[990, 1597, 2082, 2480],
117100:[991, 1598, 2084, 2482],
117200:[992, 1599, 2085, 2484],
117300:[992, 1601, 2087, 2486],
117400:[993, 1602, 2088, 2487],
117500:[994, 1603, 2090, 2489],
117600:[995, 1604, 2091, 2491],
117700:[996, 1605, 2093, 2493],
117800:[996, 1607, 2095, 2495],
117900:[997, 1608, 2096, 2497],
118000:[998, 1609, 2098, 2498],
118100:[999, 1610, 2100, 2500],
118200:[999, 1611, 2101, 2502],
118300:[1000, 1613, 2103, 2503],
118400:[1001, 1614, 2104, 2505],
118500:[1002, 1615, 2106, 2507],
118600:[1002, 1616, 2107, 2509],
118700:[1003, 1617, 2109, 2511],
118800:[1004, 1619, 2110, 2513],
118900:[1005, 1620, 2112, 2514],
119000:[1005, 1621, 2113, 2516],
119100:[1006, 1622, 2115, 2518],
119200:[1007, 1623, 2116, 2520],
119300:[1007, 1625, 2118, 2521],
119400:[1008, 1626, 2119, 2523],
119500:[1009, 1627, 2121, 2525],
119600:[1010, 1628, 2122, 2527],
119700:[1010, 1629, 2124, 2529],
119800:[1011, 1631, 2126, 2530],
119900:[1012, 1632, 2127, 2532],
12000:[0, 0, 0, 0],
120000:[1013, 1633, 2129, 2534],
120100:[1014, 1634, 2131, 2536],
120200:[1015, 1635, 2132, 2538],
120300:[1015, 1637, 2134, 2540],
120400:[1016, 1638, 2135, 2541],
120500:[1017, 1639, 2137, 2543],
120600:[1018, 1640, 2138, 2545],
120700:[1018, 1641, 2140, 2547],
120800:[1019, 1643, 2141, 2549],
120900:[1020, 1644, 2143, 2551],
12100:[8, 8, 9, 9],
121000:[1021, 1645, 2144, 2553],
121100:[1022, 1646, 2146, 2555],
121200:[1023, 1647, 2147, 2557],
121300:[1023, 1649, 2149, 2559],
121400:[1024, 1650, 2150, 2560],
121500:[1025, 1651, 2152, 2562],
121600:[1026, 1652, 2154, 2564],
121700:[1027, 1653, 2155, 2566],
121800:[1027, 1655, 2157, 2568],
121900:[1028, 1656, 2158, 2570],
12200:[15, 16, 18, 19],
122000:[1029, 1657, 2160, 2571],
122100:[1030, 1658, 2162, 2573],
122200:[1030, 1659, 2163, 2575],
122300:[1031, 1661, 2165, 2576],
122400:[1032, 1662, 2166, 2578],
122500:[1033, 1663, 2168, 2580],
122600:[1033, 1664, 2169, 2582],
122700:[1034, 1665, 2171, 2584],
122800:[1035, 1667, 2172, 2586],
122900:[1036, 1668, 2174, 2587],
12300:[23, 24, 26, 28],
123000:[1036, 1669, 2175, 2589],
123100:[1037, 1670, 2176, 2591],
123200:[1038, 1671, 2178, 2593],
123300:[1038, 1673, 2179, 2594],
123400:[1039, 1674, 2181, 2596],
123500:[1040, 1675, 2182, 2598],
123600:[1041, 1676, 2184, 2600],
123700:[1041, 1677, 2185, 2602],
123800:[1042, 1679, 2187, 2603],
123900:[1043, 1680, 2188, 2605],
12400:[30, 32, 35, 38],
124000:[1044, 1681, 2190, 2607],
124100:[1045, 1682, 2192, 2609],
124200:[1046, 1683, 2193, 2611],
124300:[1046, 1685, 2195, 2613],
124400:[1047, 1686, 2196, 2614],
124500:[1048, 1687, 2198, 2616],
124600:[1049, 1688, 2199, 2618],
124700:[1050, 1689, 2201, 2620],
124800:[1050, 1691, 2202, 2622],
124900:[1051, 1692, 2204, 2624],
12500:[38, 41, 44, 47],
125000:[1052, 1693, 2206, 2626],
125100:[1053, 1694, 2208, 2628],
125200:[1054, 1695, 2209, 2630],
125300:[1054, 1697, 2211, 2632],
125400:[1055, 1698, 2212, 2633],
125500:[1056, 1699, 2214, 2635],
125600:[1057, 1700, 2215, 2637],
125700:[1058, 1701, 2217, 2639],
125800:[1059, 1703, 2218, 2641],
125900:[1059, 1704, 2220, 2643],
12600:[45, 49, 53, 56],
126000:[1060, 1705, 2221, 2644],
126100:[1061, 1706, 2223, 2646],
126200:[1061, 1707, 2224, 2648],
126300:[1062, 1709, 2226, 2649],
126400:[1063, 1710, 2227, 2651],
126500:[1064, 1711, 2229, 2653],
126600:[1064, 1712, 2230, 2655],
126700:[1065, 1713, 2232, 2657],
126800:[1066, 1715, 2233, 2658],
126900:[1067, 1716, 2235, 2660],
12700:[53, 57, 62, 66],
127000:[1067, 1717, 2237, 2662],
127100:[1068, 1718, 2239, 2664],
127200:[1069, 1719, 2240, 2666],
127300:[1069, 1721, 2242, 2667],
127400:[1070, 1722, 2243, 2669],
127500:[1071, 1723, 2245, 2671],
127600:[1072, 1724, 2246, 2673],
127700:[1072, 1725, 2248, 2675],
127800:[1073, 1727, 2249, 2676],
127900:[1074, 1728, 2251, 2678],
12800:[60, 65, 70, 75],
128000:[1075, 1729, 2252, 2680],
128100:[1076, 1730, 2254, 2682],
128200:[1077, 1731, 2255, 2684],
128300:[1077, 1733, 2257, 2686],
128400:[1078, 1734, 2258, 2687],
128500:[1079, 1735, 2260, 2689],
128600:[1080, 1736, 2261, 2691],
128700:[1081, 1737, 2263, 2693],
128800:[1081, 1739, 2265, 2695],
128900:[1082, 1740, 2266, 2697],
12900:[68, 73, 79, 85],
129000:[1083, 1741, 2268, 2699],
129100:[1084, 1742, 2270, 2701],
129200:[1084, 1743, 2271, 2703],
129300:[1085, 1745, 2273, 2705],
129400:[1086, 1746, 2274, 2706],
129500:[1087, 1747, 2276, 2708],
129600:[1087, 1748, 2277, 2710],
129700:[1088, 1749, 2279, 2712],
129800:[1089, 1751, 2280, 2714],
129900:[1090, 1752, 2282, 2716],
13000:[75, 81, 88, 94],
130000:[1090, 1753, 2283, 2717],
130100:[1091, 1754, 2285, 2719],
130200:[1092, 1755, 2286, 2721],
130300:[1092, 1757, 2288, 2722],
130400:[1093, 1758, 2289, 2724],
130500:[1094, 1759, 2291, 2726],
130600:[1095, 1760, 2292, 2728],
130700:[1095, 1761, 2294, 2730],
130800:[1096, 1763, 2296, 2731],
130900:[1097, 1764, 2297, 2733],
13100:[78, 84, 92, 98],
131000:[1098, 1765, 2299, 2735],
131100:[1099, 1766, 2301, 2737],
131200:[1100, 1767, 2302, 2739],
131300:[1100, 1769, 2304, 2740],
131400:[1101, 1770, 2305, 2742],
131500:[1102, 1771, 2307, 2744],
131600:[1103, 1772, 2308, 2746],
131700:[1103, 1773, 2310, 2747],
131800:[1104, 1774, 2311, 2749],
131900:[1105, 1776, 2313, 2751],
13200:[81, 88, 95, 102],
132000:[1106, 1777, 2314, 2753],
132100:[1107, 1778, 2316, 2755],
132200:[1108, 1779, 2317, 2757],
132300:[1108, 1781, 2319, 2759],
132400:[1109, 1782, 2320, 2760],
132500:[1110, 1783, 2322, 2762],
132600:[1111, 1784, 2324, 2764],
132700:[1112, 1785, 2325, 2766],
132800:[1112, 1786, 2327, 2768],
132900:[1113, 1788, 2328, 2770],
13300:[84, 91, 99, 106],
133000:[1114, 1789, 2330, 2772],
133100:[1115, 1790, 2332, 2774],
133200:[1115, 1791, 2333, 2776],
133300:[1116, 1793, 2335, 2777],
133400:[1117, 1794, 2336, 2779],
133500:[1118, 1795, 2338, 2781],
133600:[1118, 1796, 2339, 2783],
133700:[1119, 1797, 2341, 2785],
133800:[1120, 1798, 2342, 2787],
133900:[1121, 1800, 2344, 2788],
13400:[87, 94, 103, 110],
134000:[1121, 1801, 2345, 2790],
134100:[1122, 1802, 2346, 2792],
134200:[1123, 1803, 2348, 2794],
134300:[1123, 1805, 2349, 2795],
134400:[1124, 1806, 2351, 2797],
134500:[1125, 1807, 2352, 2799],
134600:[1126, 1808, 2354, 2801],
134700:[1126, 1809, 2355, 2803],
134800:[1127, 1810, 2357, 2804],
134900:[1128, 1812, 2358, 2806],
13500:[90, 98, 106, 114],
135000:[1129, 1813, 2360, 2808],
135100:[1130, 1814, 2362, 2810],
135200:[1131, 1815, 2363, 2812],
135300:[1131, 1817, 2365, 2814],
135400:[1132, 1818, 2366, 2816],
135500:[1133, 1819, 2368, 2817],
135600:[1134, 1820, 2369, 2819],
135700:[1135, 1821, 2371, 2821],
135800:[1135, 1822, 2372, 2823],
135900:[1136, 1824, 2374, 2825],
13600:[94, 101, 110, 117],
136000:[1137, 1825, 2376, 2827],
136100:[1138, 1826, 2378, 2829],
136200:[1139, 1827, 2379, 2831],
136300:[1139, 1829, 2381, 2833],
136400:[1140, 1830, 2382, 2834],
136500:[1141, 1831, 2384, 2836],
136600:[1142, 1832, 2385, 2838],
136700:[1143, 1833, 2387, 2840],
136800:[1144, 1834, 2388, 2842],
136900:[1144, 1836, 2390, 2844],
13700:[97, 105, 113, 121],
137000:[1145, 1837, 2391, 2845],
137100:[1146, 1838, 2393, 2847],
137200:[1146, 1839, 2394, 2849],
137300:[1147, 1841, 2396, 2850],
137400:[1148, 1842, 2397, 2852],
137500:[1149, 1843, 2399, 2854],
137600:[1149, 1844, 2400, 2856],
137700:[1150, 1845, 2402, 2858],
137800:[1151, 1846, 2403, 2860],
137900:[1152, 1848, 2405, 2861],
13800:[100, 108, 117, 125],
138000:[1152, 1849, 2407, 2863],
138100:[1153, 1850, 2409, 2865],
138200:[1154, 1851, 2410, 2867],
138300:[1154, 1853, 2412, 2868],
138400:[1155, 1854, 2413, 2870],
138500:[1156, 1855, 2415, 2872],
138600:[1157, 1856, 2416, 2874],
138700:[1157, 1857, 2418, 2876],
138800:[1158, 1858, 2419, 2877],
138900:[1159, 1860, 2421, 2879],
13900:[103, 111, 121, 129],
139000:[1160, 1861, 2422, 2881],
139100:[1161, 1862, 2424, 2883],
139200:[1162, 1863, 2425, 2885],
139300:[1162, 1865, 2427, 2887],
139400:[1163, 1866, 2428, 2888],
139500:[1164, 1867, 2430, 2890],
139600:[1165, 1868, 2431, 2892],
139700:[1166, 1869, 2433, 2894],
139800:[1166, 1870, 2435, 2896],
139900:[1167, 1872, 2436, 2898],
14000:[106, 115, 124, 133],
140000:[1168, 1873, 2438, 2900],
140100:[1169, 1874, 2440, 2902],
140200:[1169, 1875, 2441, 2903],
140300:[1170, 1877, 2443, 2905],
140400:[1171, 1878, 2444, 2907],
140500:[1172, 1879, 2446, 2909],
140600:[1172, 1880, 2447, 2910],
140700:[1173, 1881, 2449, 2912],
140800:[1174, 1882, 2450, 2914],
140900:[1175, 1884, 2452, 2916],
14100:[107, 118, 127, 137],
141000:[1175, 1885, 2453, 2917],
141100:[1176, 1886, 2454, 2919],
141200:[1177, 1887, 2456, 2921],
141300:[1177, 1888, 2457, 2922],
141400:[1178, 1889, 2459, 2924],
141500:[1179, 1891, 2460, 2926],
141600:[1180, 1892, 2462, 2928],
141700:[1180, 1893, 2463, 2929],
141800:[1181, 1894, 2464, 2931],
141900:[1182, 1895, 2466, 2933],
14200:[107, 121, 131, 140],
142000:[1183, 1896, 2467, 2935],
142100:[1184, 1897, 2468, 2937],
142200:[1184, 1898, 2470, 2938],
142300:[1185, 1900, 2471, 2940],
142400:[1186, 1901, 2473, 2942],
142500:[1187, 1902, 2474, 2944],
142600:[1187, 1903, 2476, 2945],
142700:[1188, 1904, 2477, 2947],
142800:[1189, 1905, 2479, 2949],
142900:[1190, 1907, 2480, 2951],
14300:[108, 124, 134, 144],
143000:[1190, 1908, 2482, 2952],
143100:[1191, 1909, 2484, 2954],
143200:[1191, 1910, 2485, 2955],
143300:[1192, 1911, 2487, 2957],
143400:[1193, 1913, 2488, 2959],
143500:[1194, 1914, 2490, 2961],
143600:[1194, 1915, 2491, 2962],
143700:[1195, 1916, 2493, 2964],
143800:[1196, 1917, 2494, 2966],
143900:[1196, 1918, 2496, 2967],
14400:[108, 127, 137, 147],
144000:[1197, 1919, 2497, 2969],
144100:[1198, 1920, 2498, 2971],
144200:[1198, 1921, 2500, 2972],
144300:[1199, 1922, 2501, 2974],
144400:[1200, 1923, 2503, 2976],
144500:[1200, 1924, 2504, 2977],
144600:[1201, 1926, 2506, 2979],
144700:[1202, 1927, 2507, 2981],
144800:[1202, 1928, 2509, 2983],
144900:[1203, 1929, 2510, 2984],
14500:[109, 130, 141, 151],
145000:[1204, 1930, 2511, 2986],
145100:[1205, 1931, 2512, 2988],
145200:[1206, 1932, 2514, 2990],
145300:[1206, 1933, 2515, 2991],
145400:[1207, 1935, 2517, 2993],
145500:[1208, 1936, 2518, 2995],
145600:[1209, 1937, 2520, 2997],
145700:[1209, 1938, 2521, 2998],
145800:[1210, 1939, 2523, 3000],
145900:[1211, 1940, 2524, 3002],
14600:[109, 134, 144, 154],
146000:[1212, 1942, 2526, 3004],
146100:[1213, 1943, 2527, 3006],
146200:[1213, 1944, 2529, 3007],
146300:[1214, 1945, 2530, 3009],
146400:[1215, 1946, 2532, 3011],
146500:[1216, 1948, 2533, 3013],
146600:[1216, 1949, 2535, 3014],
146700:[1217, 1950, 2536, 3016],
146800:[1218, 1951, 2537, 3018],
146900:[1218, 1952, 2539, 3020],
14700:[110, 137, 147, 158],
147000:[1219, 1953, 2540, 3021],
147100:[1220, 1954, 2541, 3023],
147200:[1220, 1955, 2543, 3024],
147300:[1221, 1957, 2544, 3026],
147400:[1222, 1958, 2546, 3028],
147500:[1222, 1959, 2547, 3030],
147600:[1223, 1960, 2549, 3031],
147700:[1224, 1961, 2550, 3033],
147800:[1225, 1962, 2552, 3035],
147900:[1225, 1964, 2553, 3036],
14800:[111, 140, 150, 161],
148000:[1226, 1965, 2555, 3038],
148100:[1227, 1966, 2556, 3040],
148200:[1228, 1967, 2558, 3041],
148300:[1228, 1968, 2559, 3043],
148400:[1229, 1970, 2561, 3045],
148500:[1230, 1971, 2562, 3046],
148600:[1231, 1972, 2564, 3048],
148700:[1231, 1973, 2565, 3050],
148800:[1232, 1974, 2567, 3051],
148900:[1233, 1975, 2568, 3053],
14900:[111, 143, 154, 165],
149000:[1234, 1976, 2570, 3055],
149100:[1235, 1977, 2571, 3057],
149200:[1235, 1978, 2573, 3059],
149300:[1236, 1979, 2574, 3060],
149400:[1237, 1980, 2576, 3062],
149500:[1238, 1982, 2577, 3064],
149600:[1238, 1983, 2579, 3066],
149700:[1239, 1984, 2580, 3067],
149800:[1240, 1985, 2581, 3069],
149900:[1241, 1986, 2583, 3071],
15000:[112, 146, 157, 168],
150000:[1241, 1987, 2584, 3073],
15100:[113, 149, 160, 172],
15200:[113, 152, 164, 175],
15300:[114, 155, 167, 179],
15400:[114, 158, 171, 182],
15500:[115, 161, 174, 186],
15600:[115, 165, 177, 189],
15700:[116, 168, 181, 193],
15800:[116, 171, 184, 196],
15900:[117, 174, 187, 200],
16000:[117, 177, 191, 204],
16100:[118, 180, 194, 207],
16200:[118, 183, 197, 211],
16300:[119, 186, 201, 214],
16400:[119, 189, 204, 218],
16500:[120, 192, 207, 221],
16600:[120, 195, 210, 225],
16700:[121, 198, 214, 228],
16800:[121, 201, 217, 232],
16900:[122, 204, 220, 235],
17000:[122, 207, 223, 239],
17100:[122, 210, 226, 242],
17200:[123, 212, 229, 245],
17300:[123, 215, 232, 248],
17400:[124, 218, 235, 252],
17500:[124, 221, 238, 255],
17600:[125, 223, 241, 258],
17700:[125, 226, 243, 261],
17800:[126, 229, 246, 264],
17900:[126, 231, 249, 267],
18000:[127, 234, 252, 270],
18100:[128, 237, 255, 274],
18200:[128, 240, 259, 277],
18300:[129, 243, 262, 281],
18400:[129, 246, 265, 284],
18500:[130, 250, 269, 288],
18600:[130, 253, 272, 292],
18700:[131, 256, 275, 295],
18800:[131, 259, 278, 299],
18900:[132, 262, 282, 302],
19000:[133, 265, 285, 306],
19100:[133, 267, 289, 310],
19200:[134, 269, 293, 314],
19300:[134, 271, 296, 318],
19400:[135, 273, 300, 322],
19500:[135, 275, 304, 326],
19600:[136, 276, 308, 330],
19700:[136, 278, 311, 334],
19800:[137, 280, 315, 338],
19900:[137, 282, 319, 342],
20000:[137, 284, 323, 346],
20100:[137, 285, 327, 350],
20200:[138, 286, 331, 354],
20300:[138, 287, 334, 358],
20400:[139, 288, 338, 362],
20500:[139, 289, 342, 366],
20600:[139, 290, 346, 370],
20700:[140, 291, 349, 374],
20800:[140, 292, 353, 379],
20900:[141, 293, 357, 383],
21000:[141, 294, 361, 387],
21100:[142, 295, 365, 391],
21200:[143, 296, 369, 395],
21300:[144, 297, 372, 399],
21400:[144, 298, 376, 403],
21500:[145, 299, 380, 408],
21600:[146, 300, 384, 412],
21700:[147, 301, 387, 416],
21800:[148, 302, 391, 420],
21900:[149, 303, 395, 424],
22000:[150, 304, 399, 428],
22100:[151, 305, 403, 432],
22200:[152, 306, 407, 436],
22300:[153, 307, 410, 440],
22400:[154, 308, 414, 444],
22500:[155, 309, 418, 448],
22600:[156, 310, 422, 452],
22700:[157, 311, 425, 456],
22800:[158, 312, 429, 460],
22900:[159, 313, 433, 464],
23000:[160, 314, 437, 468],
23100:[161, 315, 439, 472],
23200:[162, 317, 442, 476],
23300:[163, 318, 444, 480],
23400:[164, 320, 446, 484],
23500:[165, 321, 448, 488],
23600:[166, 322, 451, 492],
23700:[166, 324, 453, 496],
23800:[167, 325, 455, 501],
23900:[168, 326, 458, 505],
24000:[169, 328, 460, 509],
24100:[170, 330, 462, 513],
24200:[171, 331, 463, 518],
24300:[173, 333, 465, 522],
24400:[174, 335, 467, 527],
24500:[175, 337, 469, 531],
24600:[176, 338, 470, 535],
24700:[177, 340, 472, 540],
24800:[179, 342, 474, 544],
24900:[180, 344, 476, 549],
25000:[181, 345, 477, 553],
25100:[182, 347, 479, 557],
25200:[184, 349, 481, 562],
25300:[185, 351, 483, 566],
25400:[186, 352, 485, 571],
25500:[188, 354, 488, 575],
25600:[189, 356, 490, 580],
25700:[190, 358, 492, 584],
25800:[191, 360, 494, 588],
25900:[193, 362, 496, 593],
26000:[194, 363, 498, 597],
26100:[196, 365, 501, 601],
26200:[197, 367, 503, 605],
26300:[199, 369, 506, 609],
26400:[201, 371, 508, 614],
26500:[202, 374, 511, 618],
26600:[204, 376, 513, 622],
26700:[206, 378, 516, 626],
26800:[207, 380, 518, 630],
26900:[209, 382, 521, 634],
27000:[211, 384, 523, 638],
27100:[213, 386, 526, 641],
27200:[214, 388, 528, 643],
27300:[216, 391, 531, 646],
27400:[218, 393, 533, 648],
27500:[220, 395, 536, 651],
27600:[221, 397, 538, 654],
27700:[223, 399, 541, 656],
27800:[225, 401, 543, 659],
27900:[226, 404, 546, 661],
28000:[228, 406, 548, 664],
28100:[229, 408, 550, 667],
28200:[231, 410, 553, 669],
28300:[232, 412, 555, 672],
28400:[234, 414, 557, 675],
28500:[235, 416, 560, 677],
28600:[237, 418, 562, 680],
28700:[238, 420, 564, 683],
28800:[240, 422, 567, 685],
28900:[241, 424, 569, 688],
29000:[242, 425, 571, 691],
29100:[243, 427, 573, 693],
29200:[244, 428, 575, 696],
29300:[246, 430, 577, 698],
29400:[247, 432, 579, 701],
29500:[248, 434, 581, 703],
29600:[249, 435, 584, 706],
29700:[250, 437, 586, 708],
29800:[252, 439, 588, 710],
29900:[253, 440, 590, 713],
30000:[254, 442, 592, 715],
30100:[255, 444, 594, 718],
30200:[256, 445, 596, 720],
30300:[258, 447, 599, 723],
30400:[259, 449, 601, 725],
30500:[260, 451, 603, 728],
30600:[261, 452, 605, 731],
30700:[263, 454, 607, 733],
30800:[264, 456, 610, 736],
30900:[265, 458, 612, 738],
31000:[266, 459, 614, 741],
31100:[267, 461, 616, 743],
31200:[268, 462, 618, 746],
31300:[269, 464, 620, 748],
31400:[270, 466, 622, 751],
31500:[271, 467, 624, 753],
31600:[272, 469, 626, 755],
31700:[273, 471, 629, 758],
31800:[273, 472, 631, 760],
31900:[274, 474, 633, 763],
32000:[275, 476, 635, 765],
32100:[276, 478, 637, 767],
32200:[277, 479, 639, 770],
32300:[278, 481, 641, 772],
32400:[279, 482, 643, 774],
32500:[280, 484, 645, 776],
32600:[281, 486, 647, 779],
32700:[282, 487, 649, 781],
32800:[283, 489, 651, 783],
32900:[284, 490, 653, 786],
33000:[285, 492, 655, 788],
33100:[286, 494, 657, 790],
33200:[287, 495, 659, 793],
33300:[288, 497, 661, 795],
33400:[289, 498, 663, 797],
33500:[290, 500, 665, 799],
33600:[291, 502, 667, 802],
33700:[292, 503, 669, 804],
33800:[293, 505, 671, 806],
33900:[293, 507, 673, 809],
34000:[294, 508, 675, 811],
34100:[295, 510, 677, 813],
34200:[296, 511, 679, 816],
34300:[297, 513, 681, 818],
34400:[298, 514, 683, 820],
34500:[299, 516, 685, 822],
34600:[300, 517, 687, 825],
34700:[300, 519, 689, 827],
34800:[301, 520, 691, 829],
34900:[302, 522, 693, 832],
35000:[303, 523, 694, 834],
35100:[304, 525, 696, 836],
35200:[305, 526, 698, 838],
35300:[306, 528, 700, 841],
35400:[307, 529, 702, 843],
35500:[308, 531, 704, 845],
35600:[308, 532, 706, 847],
35700:[309, 534, 708, 849],
35800:[310, 535, 710, 852],
35900:[311, 537, 712, 854],
36000:[312, 539, 714, 856],
36100:[313, 541, 716, 858],
36200:[314, 542, 718, 860],
36300:[314, 544, 720, 862],
36400:[315, 545, 721, 865],
36500:[316, 547, 723, 867],
36600:[317, 548, 725, 869],
36700:[318, 550, 727, 871],
36800:[318, 551, 729, 873],
36900:[319, 553, 731, 875],
37000:[320, 554, 732, 878],
37100:[321, 555, 734, 880],
37200:[322, 557, 736, 882],
37300:[323, 558, 737, 884],
37400:[323, 559, 739, 886],
37500:[324, 561, 741, 889],
37600:[325, 562, 743, 891],
37700:[326, 563, 745, 893],
37800:[327, 565, 746, 895],
37900:[328, 566, 748, 897],
38000:[329, 567, 750, 899],
38100:[330, 568, 752, 901],
38200:[331, 570, 754, 903],
38300:[331, 571, 756, 905],
38400:[332, 572, 757, 907],
38500:[333, 574, 759, 909],
38600:[334, 575, 761, 912],
38700:[335, 576, 763, 914],
38800:[335, 578, 765, 916],
38900:[336, 579, 767, 918],
39000:[337, 580, 769, 920],
39100:[338, 581, 771, 922],
39200:[339, 583, 773, 924],
39300:[340, 584, 775, 926],
39400:[340, 585, 776, 929],
39500:[341, 586, 778, 931],
39600:[342, 588, 780, 933],
39700:[343, 589, 782, 935],
39800:[344, 590, 784, 937],
39900:[345, 592, 786, 939],
40000:[346, 593, 787, 942],
40100:[347, 594, 789, 944],
40200:[348, 596, 791, 946],
40300:[348, 597, 792, 948],
40400:[349, 598, 794, 951],
40500:[350, 599, 796, 953],
40600:[351, 601, 798, 955],
40700:[352, 602, 800, 957],
40800:[353, 603, 801, 959],
40900:[353, 604, 803, 961],
41000:[354, 606, 805, 963],
41100:[355, 607, 807, 965],
41200:[356, 609, 809, 967],
41300:[357, 610, 811, 969],
41400:[357, 611, 812, 971],
41500:[358, 613, 814, 973],
41600:[359, 614, 816, 976],
41700:[360, 615, 818, 978],
41800:[361, 617, 820, 980],
41900:[362, 618, 822, 982],
42000:[363, 620, 824, 984],
42100:[364, 621, 826, 986],
42200:[365, 623, 828, 988],
42300:[365, 624, 829, 990],
42400:[366, 625, 831, 993],
42500:[367, 627, 833, 995],
42600:[368, 628, 835, 997],
42700:[369, 629, 837, 999],
42800:[370, 631, 839, 1001],
42900:[370, 632, 840, 1003],
43000:[371, 633, 842, 1006],
43100:[372, 634, 844, 1008],
43200:[373, 636, 845, 1010],
43300:[374, 637, 847, 1012],
43400:[374, 638, 849, 1015],
43500:[375, 640, 850, 1017],
43600:[376, 641, 852, 1019],
43700:[377, 642, 854, 1021],
43800:[378, 644, 856, 1023],
43900:[379, 645, 857, 1025],
44000:[380, 646, 859, 1027],
44100:[381, 647, 861, 1029],
44200:[382, 649, 863, 1032],
44300:[383, 650, 864, 1034],
44400:[384, 652, 866, 1036],
44500:[385, 653, 868, 1038],
44600:[385, 654, 870, 1041],
44700:[386, 656, 871, 1043],
44800:[387, 657, 873, 1045],
44900:[388, 658, 875, 1048],
45000:[389, 660, 877, 1050],
45100:[390, 661, 879, 1052],
45200:[391, 663, 881, 1054],
45300:[392, 664, 882, 1056],
45400:[393, 666, 884, 1058],
45500:[394, 667, 886, 1061],
45600:[394, 668, 888, 1063],
45700:[395, 670, 889, 1065],
45800:[396, 671, 891, 1067],
45900:[397, 672, 893, 1069],
46000:[398, 674, 895, 1071],
46100:[399, 675, 897, 1073],
46200:[400, 677, 898, 1075],
46300:[401, 678, 900, 1077],
46400:[401, 679, 902, 1080],
46500:[402, 681, 903, 1082],
46600:[403, 682, 905, 1084],
46700:[404, 683, 907, 1086],
46800:[405, 685, 908, 1088],
46900:[406, 686, 910, 1090],
47000:[406, 687, 911, 1093],
47100:[407, 688, 913, 1095],
47200:[408, 690, 914, 1097],
47300:[408, 691, 916, 1099],
47400:[409, 692, 918, 1102],
47500:[410, 694, 919, 1104],
47600:[411, 695, 921, 1106],
47700:[412, 696, 923, 1108],
47800:[412, 698, 924, 1110],
47900:[413, 699, 926, 1112],
48000:[414, 700, 928, 1114],
48100:[415, 701, 930, 1116],
48200:[416, 703, 931, 1118],
48300:[417, 704, 933, 1120],
48400:[417, 705, 935, 1123],
48500:[418, 707, 936, 1125],
48600:[419, 708, 938, 1127],
48700:[420, 709, 940, 1129],
48800:[421, 711, 941, 1131],
48900:[422, 712, 943, 1133],
49000:[423, 713, 945, 1135],
49100:[424, 714, 947, 1137],
49200:[425, 716, 948, 1139],
49300:[425, 717, 950, 1141],
49400:[426, 718, 952, 1143],
49500:[427, 720, 954, 1145],
49600:[428, 721, 955, 1147],
49700:[429, 722, 957, 1149],
49800:[430, 723, 959, 1151],
49900:[430, 725, 960, 1153],
50000:[431, 726, 962, 1155],
50100:[432, 727, 964, 1157],
50200:[433, 729, 965, 1159],
50300:[433, 730, 967, 1161],
50400:[434, 731, 968, 1163],
50500:[435, 733, 970, 1165],
50600:[436, 734, 972, 1167],
50700:[436, 735, 973, 1168],
50800:[437, 736, 975, 1170],
50900:[438, 738, 977, 1172],
51000:[439, 739, 978, 1174],
51100:[440, 740, 980, 1176],
51200:[441, 742, 981, 1178],
51300:[442, 743, 983, 1180],
51400:[442, 744, 985, 1182],
51500:[443, 746, 986, 1184],
51600:[444, 747, 988, 1186],
51700:[445, 748, 990, 1188],
51800:[446, 750, 991, 1190],
51900:[447, 751, 993, 1192],
52000:[448, 752, 995, 1194],
52100:[449, 753, 997, 1196],
52200:[450, 755, 998, 1198],
52300:[450, 756, 1000, 1200],
52400:[451, 757, 1001, 1202],
52500:[452, 759, 1003, 1204],
52600:[453, 760, 1005, 1206],
52700:[454, 761, 1006, 1207],
52800:[455, 763, 1008, 1209],
52900:[455, 764, 1010, 1211],
53000:[456, 765, 1011, 1213],
53100:[457, 766, 1013, 1215],
53200:[458, 768, 1014, 1217],
53300:[458, 769, 1016, 1219],
53400:[459, 770, 1018, 1221],
53500:[460, 772, 1019, 1223],
53600:[461, 773, 1021, 1225],
53700:[462, 774, 1023, 1227],
53800:[462, 776, 1024, 1229],
53900:[463, 777, 1026, 1231],
54000:[464, 778, 1028, 1233],
54100:[465, 779, 1030, 1235],
54200:[466, 781, 1031, 1237],
54300:[467, 782, 1033, 1239],
54400:[467, 783, 1035, 1241],
54500:[468, 785, 1036, 1243],
54600:[469, 786, 1038, 1245],
54700:[470, 787, 1040, 1247],
54800:[471, 789, 1041, 1249],
54900:[472, 790, 1043, 1251],
55000:[473, 791, 1045, 1253],
55100:[474, 792, 1047, 1255],
55200:[475, 794, 1049, 1257],
55300:[476, 795, 1050, 1259],
55400:[477, 796, 1052, 1261],
55500:[478, 798, 1054, 1264],
55600:[479, 799, 1056, 1266],
55700:[479, 800, 1058, 1268],
55800:[480, 802, 1059, 1270],
55900:[481, 803, 1061, 1272],
56000:[482, 804, 1063, 1274],
56100:[483, 805, 1065, 1276],
56200:[484, 807, 1066, 1278],
56300:[485, 808, 1068, 1280],
56400:[485, 809, 1070, 1282],
56500:[486, 811, 1072, 1285],
56600:[487, 812, 1073, 1287],
56700:[488, 814, 1075, 1289],
56800:[489, 815, 1077, 1291],
56900:[490, 816, 1079, 1293],
57000:[490, 818, 1080, 1295],
57100:[491, 819, 1082, 1297],
57200:[492, 821, 1084, 1299],
57300:[493, 822, 1085, 1301],
57400:[493, 824, 1087, 1303],
57500:[494, 825, 1089, 1306],
57600:[495, 826, 1091, 1308],
57700:[496, 828, 1092, 1310],
57800:[497, 829, 1094, 1312],
57900:[498, 830, 1096, 1314],
58000:[499, 832, 1098, 1316],
58100:[500, 833, 1100, 1318],
58200:[501, 835, 1102, 1320],
58300:[502, 836, 1104, 1323],
58400:[503, 838, 1105, 1325],
58500:[504, 839, 1107, 1327],
58600:[505, 840, 1109, 1329],
58700:[506, 842, 1111, 1331],
58800:[507, 843, 1113, 1334],
58900:[508, 845, 1115, 1336],
59000:[509, 846, 1117, 1338],
59100:[510, 847, 1119, 1340],
59200:[511, 849, 1121, 1342],
59300:[512, 850, 1123, 1344],
59400:[513, 851, 1124, 1347],
59500:[514, 853, 1126, 1349],
59600:[515, 854, 1128, 1351],
59700:[516, 856, 1130, 1353],
59800:[517, 857, 1132, 1355],
59900:[518, 858, 1134, 1357],
60000:[518, 860, 1135, 1359],
60100:[519, 861, 1137, 1361],
60200:[520, 863, 1139, 1363],
60300:[521, 864, 1140, 1366],
60400:[522, 866, 1142, 1368],
60500:[523, 867, 1144, 1370],
60600:[524, 869, 1146, 1372],
60700:[525, 870, 1148, 1374],
60800:[525, 872, 1150, 1376],
60900:[526, 873, 1151, 1379],
61000:[527, 875, 1153, 1381],
61100:[528, 876, 1155, 1383],
61200:[529, 878, 1157, 1385],
61300:[530, 879, 1158, 1387],
61400:[531, 881, 1160, 1390],
61500:[532, 882, 1162, 1392],
61600:[533, 884, 1164, 1394],
61700:[533, 885, 1166, 1396],
61800:[534, 886, 1167, 1398],
61900:[535, 888, 1169, 1400],
62000:[536, 889, 1171, 1402],
62100:[537, 890, 1173, 1404],
62200:[538, 892, 1175, 1406],
62300:[539, 893, 1177, 1409],
62400:[540, 895, 1178, 1411],
62500:[541, 896, 1180, 1413],
62600:[541, 897, 1182, 1415],
62700:[542, 899, 1184, 1417],
62800:[543, 900, 1186, 1419],
62900:[544, 902, 1188, 1422],
63000:[545, 903, 1190, 1424],
63100:[546, 904, 1192, 1426],
63200:[547, 906, 1194, 1428],
63300:[548, 907, 1196, 1430],
63400:[549, 909, 1197, 1432],
63500:[549, 910, 1199, 1435],
63600:[550, 911, 1201, 1437],
63700:[551, 913, 1203, 1439],
63800:[552, 914, 1205, 1441],
63900:[553, 916, 1207, 1443],
64000:[554, 917, 1208, 1445],
64100:[555, 918, 1210, 1447],
64200:[556, 920, 1211, 1449],
64300:[557, 921, 1213, 1451],
64400:[558, 923, 1215, 1453],
64500:[558, 924, 1217, 1455],
64600:[559, 925, 1218, 1457],
64700:[560, 927, 1220, 1459],
64800:[561, 928, 1222, 1461],
64900:[562, 929, 1224, 1464],
65000:[563, 931, 1225, 1466],
65100:[564, 932, 1227, 1468],
65200:[565, 934, 1229, 1470],
65300:[566, 935, 1230, 1472],
65400:[567, 936, 1232, 1474],
65500:[568, 938, 1234, 1476],
65600:[568, 939, 1236, 1479],
65700:[569, 940, 1237, 1481],
65800:[570, 942, 1239, 1483],
65900:[571, 943, 1241, 1485],
66000:[572, 944, 1243, 1487],
66100:[573, 945, 1245, 1489],
66200:[574, 947, 1246, 1491],
66300:[575, 948, 1248, 1493],
66400:[575, 949, 1250, 1495],
66500:[576, 951, 1252, 1497],
66600:[577, 952, 1253, 1499],
66700:[578, 954, 1255, 1501],
66800:[579, 955, 1257, 1503],
66900:[580, 956, 1259, 1505],
67000:[580, 958, 1260, 1507],
67100:[581, 959, 1262, 1509],
67200:[582, 961, 1264, 1511],
67300:[583, 962, 1265, 1513],
67400:[583, 964, 1267, 1515],
67500:[584, 965, 1269, 1517],
67600:[585, 966, 1271, 1519],
67700:[586, 968, 1273, 1522],
67800:[587, 969, 1274, 1524],
67900:[588, 971, 1276, 1526],
68000:[589, 972, 1278, 1528],
68100:[590, 973, 1280, 1530],
68200:[591, 975, 1281, 1532],
68300:[592, 976, 1283, 1534],
68400:[593, 977, 1285, 1536],
68500:[593, 979, 1287, 1538],
68600:[594, 980, 1288, 1540],
68700:[595, 981, 1290, 1542],
68800:[596, 983, 1292, 1544],
68900:[597, 984, 1294, 1546],
69000:[598, 985, 1295, 1548],
69100:[599, 986, 1297, 1550],
69200:[600, 988, 1298, 1552],
69300:[600, 989, 1300, 1554],
69400:[601, 991, 1302, 1556],
69500:[602, 992, 1304, 1558],
69600:[603, 993, 1305, 1560],
69700:[604, 995, 1307, 1562],
69800:[605, 996, 1309, 1564],
69900:[605, 998, 1310, 1566],
70000:[606, 999, 1312, 1569],
70100:[607, 1000, 1314, 1571],
70200:[608, 1002, 1316, 1573],
70300:[609, 1003, 1317, 1575],
70400:[609, 1004, 1319, 1577],
70500:[610, 1006, 1321, 1579],
70600:[611, 1007, 1323, 1582],
70700:[612, 1008, 1324, 1584],
70800:[613, 1010, 1326, 1586],
70900:[614, 1011, 1328, 1588],
71000:[615, 1012, 1330, 1590],
71100:[616, 1013, 1332, 1592],
71200:[617, 1015, 1333, 1594],
71300:[618, 1016, 1335, 1596],
71400:[619, 1018, 1337, 1598],
71500:[619, 1019, 1339, 1600],
71600:[620, 1020, 1340, 1602],
71700:[621, 1022, 1342, 1604],
71800:[622, 1023, 1344, 1606],
71900:[623, 1024, 1345, 1608],
72000:[624, 1026, 1347, 1610],
72100:[625, 1027, 1349, 1612],
72200:[626, 1029, 1351, 1614],
72300:[627, 1030, 1352, 1616],
72400:[628, 1031, 1354, 1618],
72500:[629, 1033, 1356, 1620],
72600:[629, 1034, 1358, 1622],
72700:[630, 1035, 1359, 1624],
72800:[631, 1037, 1361, 1627],
72900:[632, 1038, 1363, 1629],
73000:[633, 1039, 1365, 1631],
73100:[634, 1040, 1367, 1633],
73200:[635, 1042, 1368, 1635],
73300:[636, 1043, 1370, 1637],
73400:[636, 1044, 1372, 1639],
73500:[637, 1046, 1374, 1642],
73600:[638, 1047, 1375, 1644],
73700:[639, 1049, 1377, 1646],
73800:[640, 1050, 1379, 1648],
73900:[641, 1051, 1381, 1650],
74000:[641, 1053, 1382, 1652],
74100:[642, 1054, 1384, 1654],
74200:[643, 1056, 1386, 1656],
74300:[644, 1057, 1387, 1658],
74400:[644, 1058, 1389, 1660],
74500:[645, 1060, 1391, 1662],
74600:[646, 1061, 1393, 1664],
74700:[647, 1062, 1394, 1666],
74800:[648, 1063, 1396, 1668],
74900:[649, 1065, 1398, 1670],
75000:[650, 1066, 1400, 1672],
75100:[651, 1067, 1402, 1674],
75200:[652, 1069, 1403, 1676],
75300:[653, 1070, 1405, 1678],
75400:[654, 1071, 1407, 1680],
75500:[654, 1073, 1409, 1682],
75600:[655, 1074, 1410, 1684],
75700:[656, 1075, 1412, 1687],
75800:[657, 1077, 1414, 1689],
75900:[658, 1078, 1416, 1691],
76000:[659, 1080, 1417, 1693],
76100:[660, 1081, 1419, 1695],
76200:[661, 1083, 1421, 1697],
76300:[662, 1084, 1422, 1699],
76400:[663, 1086, 1424, 1701],
76500:[664, 1087, 1426, 1703],
76600:[665, 1088, 1428, 1705],
76700:[665, 1090, 1430, 1707],
76800:[666, 1091, 1431, 1709],
76900:[667, 1093, 1433, 1711],
77000:[668, 1094, 1435, 1713],
77100:[669, 1095, 1437, 1715],
77200:[670, 1097, 1438, 1717],
77300:[671, 1098, 1440, 1719],
77400:[671, 1099, 1442, 1721],
77500:[672, 1101, 1444, 1723],
77600:[673, 1102, 1445, 1725],
77700:[674, 1103, 1447, 1727],
77800:[675, 1105, 1449, 1729],
77900:[676, 1106, 1451, 1732],
78000:[676, 1107, 1452, 1734],
78100:[677, 1108, 1454, 1736],
78200:[678, 1110, 1455, 1738],
78300:[679, 1111, 1457, 1740],
78400:[680, 1113, 1459, 1742],
78500:[680, 1114, 1461, 1744],
78600:[681, 1115, 1462, 1747],
78700:[682, 1117, 1464, 1749],
78800:[683, 1118, 1466, 1751],
78900:[684, 1119, 1467, 1753],
79000:[685, 1121, 1469, 1755],
79100:[686, 1122, 1471, 1757],
79200:[687, 1124, 1473, 1759],
79300:[688, 1125, 1474, 1761],
79400:[689, 1126, 1476, 1763],
79500:[690, 1128, 1478, 1765],
79600:[690, 1129, 1480, 1767],
79700:[691, 1130, 1481, 1769],
79800:[692, 1132, 1483, 1771],
79900:[693, 1133, 1485, 1773],
80000:[694, 1134, 1487, 1775],
80100:[695, 1135, 1489, 1777],
80200:[696, 1137, 1490, 1779],
80300:[696, 1138, 1492, 1781],
80400:[697, 1139, 1494, 1783],
80500:[698, 1141, 1496, 1785],
80600:[699, 1142, 1497, 1787],
80700:[700, 1144, 1499, 1790],
80800:[701, 1145, 1501, 1792],
80900:[701, 1146, 1502, 1794],
81000:[702, 1148, 1504, 1796],
81100:[703, 1149, 1506, 1798],
81200:[704, 1151, 1508, 1800],
81300:[705, 1152, 1509, 1802],
81400:[705, 1153, 1511, 1804],
81500:[706, 1155, 1513, 1806],
81600:[707, 1156, 1515, 1808],
81700:[708, 1157, 1516, 1810],
81800:[709, 1158, 1518, 1812],
81900:[710, 1160, 1520, 1814],
82000:[711, 1161, 1522, 1816],
82100:[712, 1162, 1524, 1818],
82200:[713, 1164, 1525, 1820],
82300:[714, 1165, 1527, 1822],
82400:[715, 1166, 1529, 1824],
82500:[715, 1168, 1531, 1826],
82600:[716, 1169, 1532, 1828],
82700:[717, 1170, 1534, 1830],
82800:[718, 1172, 1536, 1832],
82900:[719, 1173, 1538, 1834],
83000:[720, 1175, 1539, 1837],
83100:[721, 1176, 1541, 1839],
83200:[722, 1178, 1543, 1841],
83300:[723, 1179, 1544, 1843],
83400:[724, 1181, 1546, 1845],
83500:[725, 1182, 1548, 1847],
83600:[725, 1183, 1550, 1850],
83700:[726, 1185, 1551, 1852],
83800:[727, 1186, 1553, 1854],
83900:[728, 1188, 1555, 1856],
84000:[729, 1189, 1557, 1858],
84100:[730, 1190, 1559, 1860],
84200:[731, 1192, 1560, 1862],
84300:[732, 1193, 1562, 1864],
84400:[732, 1194, 1564, 1866],
84500:[733, 1196, 1566, 1868],
84600:[734, 1197, 1567, 1870],
84700:[735, 1198, 1569, 1872],
84800:[736, 1200, 1571, 1874],
84900:[737, 1201, 1573, 1876],
85000:[737, 1202, 1574, 1878],
85100:[738, 1203, 1576, 1880],
85200:[739, 1205, 1578, 1882],
85300:[740, 1206, 1579, 1884],
85400:[740, 1208, 1581, 1886],
85500:[741, 1209, 1583, 1888],
85600:[742, 1210, 1585, 1890],
85700:[743, 1212, 1587, 1892],
85800:[744, 1213, 1588, 1895],
85900:[745, 1214, 1590, 1897],
86000:[746, 1216, 1592, 1899],
86100:[747, 1217, 1594, 1901],
86200:[748, 1219, 1595, 1903],
86300:[749, 1220, 1597, 1905],
86400:[750, 1221, 1599, 1907],
86500:[750, 1223, 1601, 1910],
86600:[751, 1224, 1602, 1912],
86700:[752, 1225, 1604, 1914],
86800:[753, 1227, 1606, 1916],
86900:[754, 1228, 1608, 1918],
87000:[755, 1229, 1609, 1920],
87100:[756, 1230, 1611, 1922],
87200:[757, 1232, 1612, 1924],
87300:[757, 1233, 1614, 1926],
87400:[758, 1234, 1616, 1928],
87500:[759, 1236, 1618, 1930],
87600:[760, 1237, 1619, 1932],
87700:[761, 1239, 1621, 1934],
87800:[762, 1240, 1623, 1936],
87900:[762, 1241, 1624, 1938],
88000:[763, 1243, 1626, 1940],
88100:[764, 1244, 1628, 1942],
88200:[765, 1246, 1630, 1944],
88300:[766, 1247, 1631, 1946],
88400:[766, 1248, 1633, 1948],
88500:[767, 1250, 1635, 1950],
88600:[768, 1251, 1637, 1952],
88700:[769, 1252, 1638, 1955],
88800:[770, 1253, 1640, 1957],
88900:[771, 1255, 1642, 1959],
89000:[772, 1256, 1644, 1961],
89100:[773, 1257, 1646, 1963],
89200:[774, 1259, 1647, 1965],
89300:[775, 1260, 1649, 1967],
89400:[776, 1261, 1651, 1969],
89500:[776, 1263, 1653, 1971],
89600:[777, 1264, 1654, 1973],
89700:[778, 1265, 1656, 1975],
89800:[779, 1267, 1658, 1977],
89900:[780, 1268, 1659, 1979],
90000:[781, 1270, 1661, 1981],
90100:[782, 1271, 1663, 1983],
90200:[783, 1273, 1664, 1985],
90300:[783, 1274, 1666, 1987],
90400:[784, 1275, 1668, 1989],
90500:[785, 1276, 1669, 1991],
90600:[786, 1278, 1671, 1993],
90700:[787, 1279, 1673, 1995],
90800:[787, 1280, 1674, 1997],
90900:[788, 1282, 1676, 1999],
91000:[789, 1283, 1678, 2001],
91100:[790, 1284, 1680, 2003],
91200:[791, 1285, 1681, 2005],
91300:[791, 1287, 1683, 2007],
91400:[792, 1288, 1684, 2009],
91500:[793, 1289, 1686, 2010],
91600:[794, 1290, 1688, 2012],
91700:[794, 1291, 1689, 2014],
91800:[795, 1293, 1691, 2016],
91900:[796, 1294, 1692, 2018],
92000:[797, 1295, 1694, 2020],
92100:[798, 1296, 1696, 2022],
92200:[799, 1298, 1697, 2024],
92300:[799, 1299, 1699, 2026],
92400:[800, 1300, 1700, 2028],
92500:[801, 1301, 1702, 2029],
92600:[802, 1303, 1704, 2031],
92700:[802, 1304, 1705, 2033],
92800:[803, 1305, 1707, 2035],
92900:[804, 1306, 1708, 2037],
93000:[805, 1308, 1710, 2039],
93100:[806, 1309, 1712, 2041],
93200:[807, 1310, 1713, 2043],
93300:[807, 1312, 1715, 2045],
93400:[808, 1313, 1716, 2047],
93500:[809, 1314, 1718, 2049],
93600:[810, 1315, 1720, 2050],
93700:[810, 1317, 1721, 2052],
93800:[811, 1318, 1723, 2054],
93900:[812, 1319, 1725, 2056],
94000:[813, 1320, 1726, 2058],
94100:[814, 1321, 1728, 2060],
94200:[815, 1323, 1729, 2062],
94300:[815, 1324, 1731, 2063],
94400:[816, 1325, 1732, 2065],
94500:[817, 1326, 1734, 2067],
94600:[818, 1328, 1736, 2069],
94700:[818, 1329, 1737, 2071],
94800:[819, 1330, 1739, 2073],
94900:[820, 1332, 1741, 2074],
95000:[821, 1333, 1742, 2076],
95100:[822, 1334, 1744, 2078],
95200:[823, 1335, 1745, 2080],
95300:[823, 1337, 1747, 2082],
95400:[824, 1338, 1749, 2083],
95500:[825, 1339, 1750, 2085],
95600:[826, 1340, 1752, 2087],
95700:[827, 1342, 1753, 2089],
95800:[827, 1343, 1755, 2091],
95900:[828, 1344, 1757, 2093],
96000:[829, 1345, 1758, 2095],
96100:[830, 1346, 1760, 2097],
96200:[831, 1347, 1761, 2099],
96300:[831, 1349, 1763, 2101],
96400:[832, 1350, 1765, 2102],
96500:[833, 1351, 1766, 2104],
96600:[834, 1352, 1768, 2106],
96700:[835, 1353, 1769, 2108],
96800:[835, 1355, 1771, 2110],
96900:[836, 1356, 1773, 2112],
97000:[837, 1357, 1774, 2114],
97100:[838, 1358, 1776, 2116],
97200:[839, 1360, 1777, 2118],
97300:[839, 1361, 1779, 2120],
97400:[840, 1362, 1780, 2122],
97500:[841, 1363, 1782, 2123],
97600:[842, 1365, 1783, 2125],
97700:[843, 1366, 1785, 2127],
97800:[843, 1367, 1786, 2129],
97900:[844, 1368, 1788, 2131],
98000:[845, 1370, 1789, 2133],
98100:[846, 1371, 1791, 2135],
98200:[847, 1372, 1792, 2137],
98300:[847, 1374, 1794, 2139],
98400:[848, 1375, 1795, 2141],
98500:[849, 1376, 1797, 2143],
98600:[850, 1377, 1798, 2144],
98700:[851, 1379, 1800, 2146],
98800:[851, 1380, 1801, 2148],
98900:[852, 1381, 1803, 2150],
99000:[853, 1382, 1805, 2152],
99100:[854, 1383, 1807, 2154],
99200:[855, 1384, 1808, 2156],
99300:[855, 1386, 1810, 2158],
99400:[856, 1387, 1811, 2160],
99500:[857, 1388, 1813, 2162],
99600:[858, 1389, 1814, 2164],
99700:[859, 1390, 1816, 2165],
99800:[859, 1392, 1817, 2167],
99900:[860, 1393, 1819, 2169],
};
const OR17_PE=[0.72, 1.12, 1.44, 1.76];

// Saskatchewan — 2017 Federal Child Support Guidelines Table
const T17_SK={
100000:[858, 1394, 1823, 2174],
100100:[859, 1395, 1825, 2176],
100200:[860, 1397, 1826, 2178],
100300:[860, 1398, 1828, 2180],
100400:[861, 1399, 1830, 2182],
100500:[862, 1401, 1832, 2184],
100600:[863, 1402, 1833, 2186],
100700:[864, 1403, 1835, 2188],
100800:[865, 1404, 1837, 2190],
100900:[865, 1406, 1838, 2192],
101000:[866, 1407, 1840, 2194],
101100:[867, 1408, 1842, 2196],
101200:[868, 1410, 1843, 2198],
101300:[869, 1411, 1845, 2200],
101400:[870, 1412, 1847, 2202],
101500:[870, 1413, 1849, 2204],
101600:[871, 1415, 1850, 2206],
101700:[872, 1416, 1852, 2208],
101800:[873, 1417, 1854, 2210],
101900:[874, 1419, 1855, 2212],
102000:[875, 1420, 1857, 2214],
102100:[876, 1421, 1859, 2216],
102200:[877, 1423, 1860, 2218],
102300:[878, 1424, 1862, 2220],
102400:[878, 1425, 1864, 2222],
102500:[879, 1426, 1866, 2224],
102600:[880, 1428, 1867, 2226],
102700:[881, 1429, 1869, 2228],
102800:[882, 1430, 1871, 2230],
102900:[883, 1431, 1872, 2232],
103000:[883, 1433, 1874, 2234],
103100:[884, 1434, 1876, 2236],
103200:[885, 1436, 1877, 2238],
103300:[886, 1437, 1879, 2240],
103400:[887, 1438, 1881, 2242],
103500:[887, 1440, 1883, 2244],
103600:[888, 1441, 1884, 2246],
103700:[889, 1442, 1886, 2248],
103800:[890, 1444, 1888, 2250],
103900:[891, 1445, 1890, 2252],
104000:[892, 1447, 1891, 2254],
104100:[893, 1448, 1893, 2256],
104200:[894, 1450, 1894, 2258],
104300:[895, 1451, 1896, 2260],
104400:[895, 1452, 1898, 2262],
104500:[896, 1454, 1900, 2264],
104600:[897, 1455, 1901, 2266],
104700:[898, 1456, 1903, 2268],
104800:[899, 1458, 1905, 2270],
104900:[900, 1459, 1907, 2272],
105000:[900, 1460, 1908, 2274],
105100:[901, 1461, 1910, 2276],
105200:[902, 1463, 1911, 2278],
105300:[903, 1464, 1913, 2280],
105400:[904, 1465, 1915, 2282],
105500:[904, 1467, 1917, 2284],
105600:[905, 1468, 1918, 2286],
105700:[906, 1469, 1920, 2288],
105800:[907, 1471, 1922, 2290],
105900:[908, 1472, 1924, 2292],
106000:[909, 1473, 1925, 2294],
106100:[910, 1474, 1927, 2296],
106200:[911, 1476, 1928, 2298],
106300:[912, 1477, 1930, 2300],
106400:[912, 1478, 1932, 2302],
106500:[913, 1479, 1934, 2304],
106600:[914, 1481, 1935, 2306],
106700:[915, 1482, 1937, 2308],
106800:[916, 1483, 1939, 2310],
106900:[917, 1485, 1941, 2312],
107000:[917, 1486, 1942, 2314],
107100:[918, 1487, 1944, 2316],
107200:[919, 1489, 1945, 2318],
107300:[919, 1490, 1947, 2320],
107400:[920, 1491, 1949, 2322],
107500:[921, 1492, 1950, 2324],
107600:[922, 1494, 1952, 2326],
107700:[923, 1495, 1954, 2328],
107800:[923, 1496, 1955, 2330],
107900:[924, 1498, 1957, 2332],
108000:[925, 1499, 1958, 2334],
108100:[926, 1500, 1960, 2336],
108200:[927, 1502, 1961, 2338],
108300:[928, 1503, 1963, 2340],
108400:[928, 1504, 1965, 2342],
108500:[929, 1506, 1966, 2344],
108600:[930, 1507, 1968, 2346],
108700:[931, 1509, 1970, 2348],
108800:[932, 1510, 1971, 2350],
108900:[933, 1511, 1973, 2352],
109000:[934, 1513, 1975, 2354],
109100:[935, 1514, 1977, 2356],
109200:[936, 1516, 1978, 2358],
109300:[936, 1517, 1980, 2360],
109400:[937, 1518, 1982, 2362],
109500:[938, 1520, 1983, 2364],
109600:[939, 1521, 1985, 2366],
109700:[940, 1522, 1987, 2368],
109800:[940, 1524, 1988, 2370],
109900:[941, 1525, 1990, 2372],
110000:[942, 1526, 1992, 2374],
110100:[943, 1527, 1994, 2376],
110200:[944, 1529, 1995, 2378],
110300:[945, 1530, 1997, 2380],
110400:[945, 1531, 1999, 2382],
110500:[946, 1533, 2000, 2384],
110600:[947, 1534, 2002, 2386],
110700:[948, 1535, 2004, 2388],
110800:[949, 1537, 2005, 2390],
110900:[950, 1538, 2007, 2392],
111000:[951, 1539, 2009, 2394],
111100:[952, 1540, 2011, 2396],
111200:[953, 1542, 2012, 2398],
111300:[953, 1543, 2014, 2400],
111400:[954, 1544, 2016, 2402],
111500:[955, 1546, 2017, 2404],
111600:[956, 1547, 2019, 2406],
111700:[957, 1548, 2021, 2408],
111800:[958, 1549, 2022, 2410],
111900:[958, 1551, 2024, 2412],
112000:[959, 1552, 2026, 2414],
112100:[960, 1553, 2028, 2416],
112200:[961, 1555, 2029, 2418],
112300:[962, 1556, 2031, 2420],
112400:[962, 1557, 2033, 2422],
112500:[963, 1558, 2034, 2424],
112600:[964, 1560, 2036, 2426],
112700:[965, 1561, 2038, 2428],
112800:[966, 1562, 2039, 2430],
112900:[967, 1564, 2041, 2432],
113000:[968, 1565, 2043, 2434],
113100:[969, 1566, 2045, 2436],
113200:[970, 1568, 2046, 2438],
113300:[970, 1569, 2048, 2440],
113400:[971, 1570, 2050, 2442],
113500:[972, 1571, 2051, 2444],
113600:[973, 1573, 2053, 2446],
113700:[974, 1574, 2055, 2448],
113800:[975, 1575, 2056, 2450],
113900:[975, 1576, 2058, 2452],
114000:[976, 1578, 2060, 2454],
114100:[977, 1579, 2062, 2456],
114200:[978, 1581, 2063, 2458],
114300:[979, 1582, 2065, 2460],
114400:[979, 1583, 2067, 2462],
114500:[980, 1585, 2068, 2464],
114600:[981, 1586, 2070, 2466],
114700:[982, 1587, 2072, 2468],
114800:[983, 1589, 2073, 2470],
114900:[984, 1590, 2075, 2472],
115000:[985, 1592, 2077, 2474],
115100:[986, 1593, 2079, 2476],
115200:[987, 1595, 2080, 2478],
115300:[987, 1596, 2082, 2480],
115400:[988, 1597, 2084, 2482],
115500:[989, 1599, 2085, 2484],
115600:[990, 1600, 2087, 2486],
115700:[991, 1601, 2089, 2488],
115800:[992, 1603, 2091, 2490],
115900:[992, 1604, 2092, 2492],
116000:[993, 1605, 2094, 2494],
116100:[994, 1606, 2096, 2496],
116200:[995, 1608, 2097, 2498],
116300:[996, 1609, 2099, 2500],
116400:[997, 1610, 2101, 2502],
116500:[997, 1612, 2102, 2504],
116600:[998, 1613, 2104, 2506],
116700:[999, 1614, 2106, 2508],
116800:[1000, 1616, 2108, 2510],
116900:[1001, 1617, 2109, 2512],
117000:[1002, 1618, 2111, 2514],
117100:[1003, 1619, 2113, 2516],
117200:[1004, 1621, 2114, 2518],
117300:[1004, 1622, 2116, 2520],
117400:[1005, 1623, 2118, 2522],
117500:[1006, 1625, 2120, 2524],
117600:[1007, 1626, 2121, 2526],
117700:[1008, 1627, 2123, 2528],
117800:[1009, 1628, 2125, 2530],
117900:[1009, 1630, 2126, 2532],
118000:[1010, 1631, 2128, 2534],
118100:[1011, 1632, 2130, 2536],
118200:[1012, 1634, 2131, 2538],
118300:[1013, 1635, 2133, 2540],
118400:[1014, 1636, 2135, 2542],
118500:[1014, 1637, 2137, 2544],
118600:[1015, 1639, 2138, 2546],
118700:[1016, 1640, 2140, 2548],
118800:[1017, 1641, 2142, 2550],
118900:[1018, 1643, 2143, 2552],
119000:[1019, 1644, 2145, 2554],
119100:[1020, 1645, 2147, 2556],
119200:[1021, 1647, 2148, 2558],
119300:[1022, 1648, 2150, 2560],
119400:[1022, 1649, 2152, 2562],
119500:[1023, 1651, 2154, 2564],
119600:[1024, 1652, 2155, 2566],
119700:[1025, 1654, 2157, 2568],
119800:[1026, 1655, 2159, 2570],
119900:[1027, 1656, 2160, 2572],
12000:[0, 0, 0, 0],
120000:[1027, 1658, 2162, 2574],
120100:[1028, 1659, 2164, 2576],
120200:[1029, 1661, 2165, 2578],
120300:[1030, 1662, 2167, 2580],
120400:[1031, 1663, 2169, 2582],
120500:[1031, 1665, 2171, 2584],
120600:[1032, 1666, 2172, 2586],
120700:[1033, 1667, 2174, 2588],
120800:[1034, 1669, 2176, 2590],
120900:[1035, 1670, 2177, 2592],
12100:[4, 9, 10, 11],
121000:[1036, 1671, 2179, 2594],
121100:[1037, 1672, 2181, 2596],
121200:[1038, 1674, 2182, 2598],
121300:[1039, 1675, 2184, 2600],
121400:[1039, 1676, 2186, 2602],
121500:[1040, 1678, 2188, 2604],
121600:[1041, 1679, 2189, 2606],
121700:[1042, 1680, 2191, 2608],
121800:[1043, 1682, 2193, 2610],
121900:[1044, 1683, 2195, 2612],
12200:[8, 19, 20, 21],
122000:[1044, 1684, 2196, 2615],
122100:[1045, 1685, 2198, 2617],
122200:[1046, 1687, 2199, 2619],
122300:[1047, 1688, 2201, 2621],
122400:[1048, 1689, 2203, 2623],
122500:[1048, 1691, 2205, 2625],
122600:[1049, 1692, 2206, 2627],
122700:[1050, 1693, 2208, 2629],
122800:[1051, 1695, 2210, 2631],
122900:[1052, 1696, 2212, 2633],
12300:[13, 28, 30, 32],
123000:[1053, 1697, 2213, 2635],
123100:[1054, 1698, 2215, 2637],
123200:[1055, 1700, 2216, 2639],
123300:[1056, 1701, 2218, 2641],
123400:[1056, 1702, 2220, 2643],
123500:[1057, 1703, 2222, 2645],
123600:[1058, 1705, 2223, 2647],
123700:[1059, 1706, 2225, 2649],
123800:[1060, 1707, 2227, 2651],
123900:[1061, 1709, 2229, 2653],
12400:[17, 37, 40, 43],
124000:[1061, 1710, 2230, 2655],
124100:[1062, 1711, 2232, 2657],
124200:[1063, 1713, 2233, 2659],
124300:[1063, 1714, 2235, 2661],
124400:[1064, 1715, 2237, 2663],
124500:[1065, 1716, 2239, 2665],
124600:[1066, 1718, 2240, 2667],
124700:[1067, 1719, 2242, 2669],
124800:[1067, 1720, 2244, 2671],
124900:[1068, 1721, 2246, 2673],
12500:[21, 47, 50, 54],
125000:[1069, 1723, 2247, 2675],
125100:[1070, 1724, 2249, 2677],
125200:[1071, 1726, 2250, 2679],
125300:[1072, 1727, 2252, 2681],
125400:[1072, 1728, 2254, 2683],
125500:[1073, 1730, 2255, 2685],
125600:[1074, 1731, 2257, 2687],
125700:[1075, 1733, 2259, 2689],
125800:[1076, 1734, 2260, 2691],
125900:[1077, 1735, 2262, 2693],
12600:[25, 56, 60, 64],
126000:[1078, 1737, 2263, 2695],
126100:[1079, 1738, 2265, 2697],
126200:[1080, 1740, 2266, 2699],
126300:[1080, 1741, 2268, 2701],
126400:[1081, 1742, 2270, 2703],
126500:[1082, 1744, 2271, 2705],
126600:[1083, 1745, 2273, 2707],
126700:[1084, 1746, 2275, 2709],
126800:[1084, 1748, 2276, 2711],
126900:[1085, 1749, 2278, 2713],
12700:[29, 65, 70, 75],
127000:[1086, 1750, 2280, 2715],
127100:[1087, 1751, 2282, 2717],
127200:[1088, 1753, 2283, 2719],
127300:[1089, 1754, 2285, 2721],
127400:[1089, 1755, 2287, 2723],
127500:[1090, 1757, 2288, 2725],
127600:[1091, 1758, 2290, 2727],
127700:[1092, 1759, 2292, 2729],
127800:[1093, 1761, 2293, 2730],
127900:[1094, 1762, 2295, 2732],
12800:[34, 74, 80, 86],
128000:[1095, 1763, 2297, 2734],
128100:[1096, 1764, 2299, 2736],
128200:[1097, 1765, 2300, 2738],
128300:[1097, 1767, 2302, 2740],
128400:[1098, 1768, 2303, 2742],
128500:[1099, 1769, 2305, 2744],
128600:[1100, 1770, 2307, 2746],
128700:[1101, 1772, 2308, 2748],
128800:[1102, 1773, 2310, 2750],
128900:[1102, 1774, 2311, 2752],
12900:[38, 84, 90, 96],
129000:[1103, 1775, 2313, 2754],
129100:[1104, 1776, 2315, 2756],
129200:[1105, 1778, 2316, 2758],
129300:[1105, 1779, 2318, 2760],
129400:[1106, 1780, 2320, 2762],
129500:[1107, 1781, 2321, 2764],
129600:[1108, 1783, 2323, 2766],
129700:[1109, 1784, 2325, 2768],
129800:[1109, 1785, 2326, 2769],
129900:[1110, 1786, 2328, 2771],
13000:[42, 93, 100, 107],
130000:[1111, 1788, 2330, 2773],
130100:[1112, 1789, 2332, 2775],
130200:[1113, 1791, 2333, 2777],
130300:[1113, 1792, 2335, 2779],
130400:[1114, 1793, 2336, 2781],
130500:[1115, 1794, 2338, 2782],
130600:[1116, 1796, 2340, 2784],
130700:[1117, 1797, 2341, 2786],
130800:[1117, 1798, 2343, 2788],
130900:[1118, 1800, 2345, 2790],
13100:[44, 97, 104, 111],
131000:[1119, 1801, 2346, 2792],
131100:[1120, 1802, 2348, 2794],
131200:[1121, 1804, 2349, 2796],
131300:[1122, 1805, 2351, 2798],
131400:[1122, 1806, 2353, 2800],
131500:[1123, 1808, 2354, 2802],
131600:[1124, 1809, 2356, 2804],
131700:[1125, 1810, 2358, 2806],
131800:[1126, 1811, 2359, 2808],
131900:[1127, 1813, 2361, 2810],
13200:[46, 101, 108, 116],
132000:[1128, 1814, 2363, 2812],
132100:[1129, 1815, 2365, 2814],
132200:[1130, 1816, 2366, 2816],
132300:[1131, 1818, 2368, 2818],
132400:[1131, 1819, 2370, 2820],
132500:[1132, 1820, 2371, 2822],
132600:[1133, 1821, 2373, 2824],
132700:[1134, 1823, 2374, 2825],
132800:[1135, 1824, 2376, 2827],
132900:[1136, 1825, 2378, 2829],
13300:[48, 105, 113, 120],
133000:[1136, 1826, 2379, 2831],
133100:[1137, 1827, 2381, 2833],
133200:[1138, 1829, 2382, 2835],
133300:[1138, 1830, 2384, 2837],
133400:[1139, 1831, 2385, 2839],
133500:[1140, 1832, 2387, 2840],
133600:[1141, 1834, 2389, 2842],
133700:[1142, 1835, 2390, 2844],
133800:[1143, 1836, 2392, 2846],
133900:[1143, 1837, 2393, 2848],
13400:[50, 109, 117, 125],
134000:[1144, 1839, 2395, 2850],
134100:[1145, 1840, 2397, 2852],
134200:[1146, 1842, 2398, 2854],
134300:[1146, 1843, 2400, 2856],
134400:[1147, 1844, 2402, 2858],
134500:[1148, 1845, 2403, 2860],
134600:[1149, 1847, 2405, 2862],
134700:[1150, 1848, 2407, 2864],
134800:[1150, 1849, 2408, 2866],
134900:[1151, 1851, 2410, 2868],
13500:[52, 113, 121, 129],
135000:[1152, 1852, 2412, 2870],
135100:[1153, 1853, 2414, 2872],
135200:[1154, 1855, 2415, 2874],
135300:[1154, 1856, 2417, 2876],
135400:[1155, 1857, 2418, 2878],
135500:[1156, 1859, 2420, 2880],
135600:[1157, 1860, 2422, 2881],
135700:[1158, 1861, 2423, 2883],
135800:[1158, 1862, 2425, 2885],
135900:[1159, 1864, 2427, 2887],
13600:[54, 116, 125, 134],
136000:[1160, 1865, 2428, 2889],
136100:[1161, 1866, 2430, 2891],
136200:[1162, 1867, 2431, 2893],
136300:[1162, 1869, 2433, 2895],
136400:[1163, 1870, 2435, 2897],
136500:[1164, 1871, 2436, 2899],
136600:[1165, 1872, 2438, 2901],
136700:[1165, 1874, 2440, 2903],
136800:[1166, 1875, 2441, 2905],
136900:[1167, 1876, 2443, 2907],
13700:[56, 120, 129, 138],
137000:[1168, 1877, 2445, 2909],
137100:[1169, 1878, 2447, 2911],
137200:[1170, 1880, 2448, 2913],
137300:[1171, 1881, 2450, 2915],
137400:[1171, 1882, 2452, 2917],
137500:[1172, 1883, 2453, 2919],
137600:[1173, 1885, 2455, 2921],
137700:[1174, 1886, 2457, 2923],
137800:[1175, 1887, 2458, 2925],
137900:[1176, 1888, 2460, 2926],
13800:[58, 124, 134, 143],
138000:[1177, 1890, 2461, 2928],
138100:[1178, 1891, 2463, 2930],
138200:[1179, 1893, 2464, 2932],
138300:[1179, 1894, 2466, 2934],
138400:[1180, 1895, 2467, 2936],
138500:[1181, 1896, 2469, 2938],
138600:[1182, 1898, 2471, 2939],
138700:[1183, 1899, 2472, 2941],
138800:[1184, 1900, 2474, 2943],
138900:[1184, 1902, 2475, 2945],
13900:[60, 128, 138, 147],
139000:[1185, 1903, 2477, 2947],
139100:[1186, 1904, 2479, 2949],
139200:[1187, 1906, 2480, 2951],
139300:[1187, 1907, 2482, 2953],
139400:[1188, 1908, 2484, 2955],
139500:[1189, 1910, 2485, 2957],
139600:[1190, 1911, 2487, 2959],
139700:[1191, 1912, 2489, 2961],
139800:[1192, 1913, 2490, 2963],
139900:[1192, 1915, 2492, 2965],
14000:[62, 132, 142, 152],
140000:[1193, 1916, 2494, 2967],
140100:[1194, 1917, 2496, 2969],
140200:[1195, 1918, 2497, 2971],
140300:[1195, 1920, 2499, 2972],
140400:[1196, 1921, 2501, 2974],
140500:[1197, 1922, 2502, 2976],
140600:[1198, 1923, 2504, 2978],
140700:[1199, 1925, 2505, 2980],
140800:[1199, 1926, 2507, 2982],
140900:[1200, 1927, 2509, 2983],
14100:[64, 136, 146, 156],
141000:[1201, 1928, 2510, 2985],
141100:[1202, 1929, 2512, 2987],
141200:[1203, 1930, 2513, 2989],
141300:[1203, 1932, 2515, 2991],
141400:[1204, 1933, 2516, 2992],
141500:[1205, 1934, 2518, 2994],
141600:[1206, 1935, 2519, 2996],
141700:[1207, 1936, 2521, 2998],
141800:[1207, 1938, 2522, 3000],
141900:[1208, 1939, 2524, 3002],
14200:[66, 139, 150, 160],
142000:[1209, 1940, 2525, 3004],
142100:[1210, 1941, 2527, 3006],
142200:[1211, 1942, 2528, 3008],
142300:[1211, 1944, 2530, 3009],
142400:[1212, 1945, 2531, 3011],
142500:[1213, 1946, 2533, 3013],
142600:[1214, 1947, 2534, 3015],
142700:[1215, 1948, 2536, 3017],
142800:[1216, 1950, 2538, 3019],
142900:[1216, 1951, 2539, 3020],
14300:[68, 143, 153, 164],
143000:[1217, 1952, 2541, 3022],
143100:[1218, 1953, 2543, 3024],
143200:[1218, 1954, 2544, 3026],
143300:[1219, 1956, 2546, 3028],
143400:[1220, 1957, 2547, 3029],
143500:[1221, 1958, 2549, 3031],
143600:[1221, 1959, 2550, 3033],
143700:[1222, 1960, 2552, 3035],
143800:[1223, 1961, 2553, 3037],
143900:[1224, 1963, 2555, 3039],
14400:[70, 147, 157, 168],
144000:[1224, 1964, 2556, 3041],
144100:[1225, 1965, 2558, 3043],
144200:[1226, 1966, 2559, 3045],
144300:[1226, 1968, 2561, 3047],
144400:[1227, 1969, 2562, 3048],
144500:[1228, 1970, 2564, 3050],
144600:[1229, 1971, 2565, 3052],
144700:[1229, 1972, 2567, 3054],
144800:[1230, 1973, 2569, 3056],
144900:[1231, 1975, 2570, 3058],
14500:[72, 150, 161, 173],
145000:[1232, 1976, 2572, 3059],
145100:[1233, 1977, 2574, 3061],
145200:[1234, 1979, 2575, 3063],
145300:[1234, 1980, 2577, 3064],
145400:[1235, 1981, 2578, 3066],
145500:[1236, 1982, 2580, 3068],
145600:[1237, 1984, 2581, 3070],
145700:[1238, 1985, 2583, 3072],
145800:[1238, 1986, 2584, 3073],
145900:[1239, 1987, 2586, 3075],
14600:[74, 154, 165, 177],
146000:[1240, 1989, 2587, 3077],
146100:[1241, 1990, 2589, 3079],
146200:[1242, 1991, 2590, 3081],
146300:[1242, 1993, 2592, 3083],
146400:[1243, 1994, 2593, 3084],
146500:[1244, 1995, 2595, 3086],
146600:[1245, 1996, 2596, 3088],
146700:[1246, 1998, 2598, 3090],
146800:[1246, 1999, 2599, 3092],
146900:[1247, 2000, 2601, 3094],
14700:[76, 157, 169, 181],
147000:[1248, 2001, 2603, 3096],
147100:[1249, 2002, 2605, 3098],
147200:[1249, 2003, 2606, 3100],
147300:[1250, 2005, 2608, 3101],
147400:[1251, 2006, 2609, 3103],
147500:[1252, 2007, 2611, 3105],
147600:[1252, 2008, 2613, 3107],
147700:[1253, 2010, 2614, 3109],
147800:[1254, 2011, 2616, 3111],
147900:[1255, 2012, 2617, 3112],
14800:[78, 161, 173, 185],
148000:[1255, 2013, 2619, 3114],
148100:[1256, 2014, 2621, 3116],
148200:[1257, 2015, 2622, 3118],
148300:[1257, 2017, 2624, 3120],
148400:[1258, 2018, 2625, 3122],
148500:[1259, 2019, 2627, 3123],
148600:[1260, 2020, 2628, 3125],
148700:[1260, 2022, 2630, 3127],
148800:[1261, 2023, 2631, 3129],
148900:[1262, 2024, 2633, 3131],
14900:[80, 165, 176, 189],
149000:[1263, 2025, 2634, 3133],
149100:[1264, 2026, 2636, 3135],
149200:[1265, 2027, 2637, 3137],
149300:[1265, 2029, 2639, 3139],
149400:[1266, 2030, 2640, 3140],
149500:[1267, 2031, 2642, 3142],
149600:[1268, 2032, 2644, 3144],
149700:[1268, 2034, 2645, 3146],
149800:[1269, 2035, 2647, 3148],
149900:[1270, 2036, 2648, 3150],
15000:[82, 168, 180, 193],
150000:[1271, 2037, 2650, 3151],
15100:[84, 172, 184, 197],
15200:[86, 175, 188, 201],
15300:[88, 179, 192, 206],
15400:[90, 182, 195, 210],
15500:[92, 186, 199, 214],
15600:[94, 189, 203, 218],
15700:[96, 193, 207, 222],
15800:[98, 196, 211, 226],
15900:[100, 200, 215, 231],
16000:[102, 203, 219, 235],
16100:[104, 206, 223, 239],
16200:[106, 210, 226, 243],
16300:[108, 213, 230, 247],
16400:[110, 216, 233, 251],
16500:[112, 220, 237, 255],
16600:[114, 223, 241, 259],
16700:[116, 227, 244, 263],
16800:[118, 230, 248, 266],
16900:[120, 233, 251, 270],
17000:[121, 237, 255, 274],
17100:[123, 240, 258, 277],
17200:[125, 243, 261, 281],
17300:[127, 246, 264, 284],
17400:[129, 249, 268, 287],
17500:[131, 251, 271, 291],
17600:[133, 254, 274, 294],
17700:[135, 257, 277, 297],
17800:[137, 260, 280, 301],
17900:[139, 263, 283, 304],
18000:[141, 266, 287, 307],
18100:[143, 269, 291, 311],
18200:[145, 273, 294, 315],
18300:[146, 276, 298, 319],
18400:[148, 279, 301, 322],
18500:[150, 283, 305, 326],
18600:[152, 286, 309, 330],
18700:[153, 289, 312, 334],
18800:[155, 293, 316, 338],
18900:[157, 296, 319, 342],
19000:[159, 300, 323, 346],
19100:[160, 302, 327, 350],
19200:[160, 303, 331, 355],
19300:[161, 305, 335, 359],
19400:[162, 306, 339, 363],
19500:[162, 308, 343, 368],
19600:[163, 309, 347, 372],
19700:[164, 311, 351, 376],
19800:[164, 312, 355, 381],
19900:[165, 314, 359, 385],
20000:[165, 315, 363, 389],
20100:[166, 316, 367, 393],
20200:[166, 317, 371, 398],
20300:[167, 319, 375, 402],
20400:[167, 320, 379, 406],
20500:[168, 321, 383, 411],
20600:[169, 322, 387, 415],
20700:[169, 323, 391, 419],
20800:[170, 324, 395, 424],
20900:[170, 326, 399, 428],
21000:[171, 327, 403, 432],
21100:[172, 328, 407, 436],
21200:[172, 329, 411, 441],
21300:[173, 331, 415, 445],
21400:[174, 332, 419, 449],
21500:[174, 333, 423, 454],
21600:[175, 334, 427, 458],
21700:[176, 335, 431, 462],
21800:[176, 336, 435, 467],
21900:[177, 338, 439, 471],
22000:[178, 339, 443, 475],
22100:[179, 340, 447, 479],
22200:[179, 341, 451, 484],
22300:[180, 342, 455, 488],
22400:[181, 344, 459, 492],
22500:[181, 345, 463, 497],
22600:[182, 346, 467, 501],
22700:[182, 347, 471, 505],
22800:[183, 348, 475, 510],
22900:[184, 349, 479, 514],
23000:[184, 351, 483, 518],
23100:[185, 352, 485, 522],
23200:[185, 353, 487, 527],
23300:[186, 354, 489, 531],
23400:[186, 356, 490, 535],
23500:[187, 357, 492, 540],
23600:[188, 358, 494, 544],
23700:[188, 359, 496, 548],
23800:[189, 360, 498, 552],
23900:[189, 361, 500, 557],
24000:[190, 363, 502, 561],
24100:[191, 364, 504, 565],
24200:[191, 366, 505, 570],
24300:[192, 367, 507, 574],
24400:[193, 368, 509, 578],
24500:[193, 369, 511, 582],
24600:[194, 371, 512, 587],
24700:[195, 372, 514, 591],
24800:[195, 373, 516, 595],
24900:[196, 374, 517, 600],
25000:[197, 376, 519, 604],
25100:[198, 377, 521, 608],
25200:[199, 379, 522, 613],
25300:[199, 380, 524, 617],
25400:[200, 381, 526, 621],
25500:[201, 383, 528, 625],
25600:[202, 384, 529, 630],
25700:[203, 385, 531, 634],
25800:[204, 387, 533, 638],
25900:[204, 388, 535, 643],
26000:[205, 389, 536, 647],
26100:[206, 391, 538, 650],
26200:[207, 392, 540, 654],
26300:[208, 394, 542, 657],
26400:[210, 395, 544, 661],
26500:[211, 397, 546, 664],
26600:[212, 399, 548, 667],
26700:[213, 400, 550, 671],
26800:[214, 402, 553, 674],
26900:[215, 403, 555, 677],
27000:[216, 405, 557, 681],
27100:[217, 407, 559, 683],
27200:[218, 408, 561, 686],
27300:[219, 410, 563, 688],
27400:[220, 412, 565, 691],
27500:[222, 413, 567, 693],
27600:[223, 415, 569, 696],
27700:[224, 417, 571, 698],
27800:[225, 418, 573, 700],
27900:[226, 420, 575, 703],
28000:[227, 422, 577, 705],
28100:[228, 423, 579, 707],
28200:[229, 425, 581, 709],
28300:[230, 426, 583, 712],
28400:[231, 428, 584, 714],
28500:[231, 429, 586, 716],
28600:[232, 431, 588, 718],
28700:[233, 432, 590, 721],
28800:[234, 433, 592, 723],
28900:[235, 435, 594, 725],
29000:[236, 436, 596, 727],
29100:[237, 437, 598, 729],
29200:[237, 438, 599, 731],
29300:[238, 440, 601, 733],
29400:[238, 441, 602, 735],
29500:[239, 442, 604, 737],
29600:[240, 443, 606, 739],
29700:[240, 444, 607, 741],
29800:[241, 446, 609, 743],
29900:[241, 447, 610, 745],
30000:[242, 448, 612, 747],
30100:[243, 449, 614, 749],
30200:[243, 450, 615, 751],
30300:[244, 451, 617, 753],
30400:[244, 452, 619, 755],
30500:[245, 454, 620, 757],
30600:[246, 455, 622, 759],
30700:[246, 456, 624, 761],
30800:[247, 457, 625, 763],
30900:[247, 458, 627, 765],
31000:[248, 459, 629, 767],
31100:[249, 460, 631, 769],
31200:[249, 461, 632, 771],
31300:[250, 462, 634, 773],
31400:[250, 464, 636, 775],
31500:[251, 465, 637, 777],
31600:[252, 466, 639, 779],
31700:[252, 467, 641, 781],
31800:[253, 468, 642, 783],
31900:[253, 469, 644, 785],
32000:[254, 471, 645, 787],
32100:[255, 472, 647, 789],
32200:[255, 473, 648, 791],
32300:[256, 475, 650, 793],
32400:[256, 476, 651, 795],
32500:[257, 477, 653, 797],
32600:[258, 478, 655, 798],
32700:[258, 479, 656, 800],
32800:[259, 480, 658, 802],
32900:[259, 482, 660, 804],
33000:[260, 483, 661, 806],
33100:[261, 484, 663, 808],
33200:[261, 485, 664, 810],
33300:[262, 486, 666, 812],
33400:[262, 488, 667, 814],
33500:[263, 489, 669, 816],
33600:[264, 490, 670, 818],
33700:[264, 491, 672, 820],
33800:[265, 492, 673, 822],
33900:[265, 493, 675, 824],
34000:[266, 494, 676, 826],
34100:[267, 495, 678, 828],
34200:[268, 496, 679, 830],
34300:[269, 497, 681, 832],
34400:[270, 498, 682, 834],
34500:[271, 500, 684, 836],
34600:[272, 501, 685, 838],
34700:[273, 502, 687, 839],
34800:[274, 503, 688, 841],
34900:[275, 504, 690, 843],
35000:[276, 505, 692, 845],
35100:[277, 506, 693, 847],
35200:[278, 507, 695, 849],
35300:[279, 508, 696, 851],
35400:[280, 509, 698, 853],
35500:[281, 510, 699, 854],
35600:[282, 512, 701, 856],
35700:[283, 513, 702, 858],
35800:[284, 514, 704, 860],
35900:[284, 515, 705, 862],
36000:[285, 516, 707, 864],
36100:[286, 517, 708, 866],
36200:[287, 518, 710, 868],
36300:[287, 519, 711, 869],
36400:[288, 520, 713, 871],
36500:[289, 521, 714, 873],
36600:[290, 522, 716, 875],
36700:[291, 523, 717, 877],
36800:[292, 524, 719, 878],
36900:[292, 525, 720, 880],
37000:[293, 526, 722, 882],
37100:[294, 527, 723, 884],
37200:[295, 528, 725, 886],
37300:[296, 529, 726, 887],
37400:[296, 530, 728, 889],
37500:[297, 531, 729, 891],
37600:[298, 532, 730, 893],
37700:[299, 533, 732, 895],
37800:[300, 535, 733, 897],
37900:[301, 536, 735, 898],
38000:[302, 537, 736, 900],
38100:[303, 538, 737, 902],
38200:[304, 539, 739, 903],
38300:[304, 540, 740, 905],
38400:[305, 541, 742, 907],
38500:[306, 542, 743, 909],
38600:[307, 543, 745, 910],
38700:[308, 544, 746, 912],
38800:[308, 545, 748, 914],
38900:[309, 546, 749, 916],
39000:[310, 547, 751, 917],
39100:[311, 548, 752, 919],
39200:[312, 549, 754, 921],
39300:[313, 550, 755, 922],
39400:[313, 551, 757, 924],
39500:[314, 552, 758, 926],
39600:[315, 553, 760, 928],
39700:[316, 554, 761, 929],
39800:[317, 555, 763, 931],
39900:[318, 556, 764, 933],
40000:[319, 557, 765, 935],
40100:[320, 558, 766, 937],
40200:[321, 560, 768, 939],
40300:[322, 561, 769, 940],
40400:[323, 562, 771, 942],
40500:[323, 563, 772, 944],
40600:[324, 565, 773, 946],
40700:[325, 566, 775, 948],
40800:[326, 567, 776, 949],
40900:[327, 569, 778, 951],
41000:[328, 570, 779, 953],
41100:[329, 571, 780, 955],
41200:[330, 573, 782, 957],
41300:[330, 574, 783, 958],
41400:[331, 575, 785, 960],
41500:[332, 577, 786, 962],
41600:[333, 578, 788, 964],
41700:[334, 579, 789, 966],
41800:[335, 581, 791, 968],
41900:[335, 582, 792, 969],
42000:[336, 583, 794, 971],
42100:[337, 584, 795, 973],
42200:[338, 586, 797, 974],
42300:[339, 587, 798, 976],
42400:[339, 588, 800, 978],
42500:[340, 590, 801, 980],
42600:[341, 591, 803, 981],
42700:[342, 592, 804, 983],
42800:[343, 593, 805, 985],
42900:[344, 595, 807, 987],
43000:[345, 596, 808, 988],
43100:[346, 597, 809, 990],
43200:[347, 599, 811, 992],
43300:[348, 600, 812, 993],
43400:[349, 601, 814, 995],
43500:[350, 603, 815, 997],
43600:[350, 604, 817, 999],
43700:[351, 606, 818, 1000],
43800:[352, 607, 820, 1002],
43900:[353, 608, 821, 1004],
44000:[354, 610, 823, 1006],
44100:[355, 611, 825, 1008],
44200:[356, 613, 826, 1010],
44300:[357, 614, 828, 1012],
44400:[358, 616, 829, 1014],
44500:[359, 617, 831, 1015],
44600:[360, 619, 832, 1017],
44700:[361, 620, 834, 1019],
44800:[362, 621, 835, 1021],
44900:[362, 623, 837, 1023],
45000:[363, 624, 838, 1025],
45100:[364, 625, 839, 1027],
45200:[365, 627, 841, 1029],
45300:[366, 628, 842, 1030],
45400:[367, 630, 844, 1032],
45500:[368, 631, 845, 1034],
45600:[368, 632, 846, 1036],
45700:[369, 634, 848, 1037],
45800:[370, 635, 849, 1039],
45900:[371, 636, 851, 1041],
46000:[372, 638, 852, 1043],
46100:[373, 639, 854, 1045],
46200:[374, 641, 855, 1046],
46300:[375, 642, 857, 1048],
46400:[375, 643, 858, 1050],
46500:[376, 645, 860, 1052],
46600:[377, 646, 862, 1053],
46700:[378, 647, 863, 1055],
46800:[379, 649, 865, 1057],
46900:[380, 650, 866, 1058],
47000:[380, 651, 868, 1060],
47100:[381, 652, 870, 1062],
47200:[382, 654, 871, 1063],
47300:[383, 655, 873, 1065],
47400:[384, 656, 875, 1067],
47500:[384, 657, 877, 1069],
47600:[385, 659, 878, 1070],
47700:[386, 660, 880, 1072],
47800:[387, 661, 882, 1074],
47900:[388, 663, 883, 1075],
48000:[389, 664, 885, 1077],
48100:[390, 665, 887, 1079],
48200:[391, 667, 888, 1080],
48300:[392, 668, 890, 1082],
48400:[392, 669, 892, 1084],
48500:[393, 671, 894, 1085],
48600:[394, 672, 895, 1087],
48700:[395, 674, 897, 1089],
48800:[396, 675, 899, 1091],
48900:[397, 676, 900, 1092],
49000:[397, 678, 902, 1094],
49100:[398, 679, 904, 1096],
49200:[399, 681, 905, 1097],
49300:[400, 682, 907, 1099],
49400:[401, 683, 909, 1101],
49500:[401, 685, 911, 1102],
49600:[402, 686, 912, 1104],
49700:[403, 687, 914, 1106],
49800:[404, 689, 916, 1107],
49900:[405, 690, 917, 1109],
50000:[406, 691, 919, 1111],
50100:[407, 692, 921, 1113],
50200:[408, 694, 922, 1114],
50300:[408, 695, 924, 1116],
50400:[409, 696, 926, 1118],
50500:[410, 698, 927, 1119],
50600:[411, 699, 929, 1121],
50700:[412, 700, 931, 1123],
50800:[413, 701, 933, 1124],
50900:[413, 703, 934, 1126],
51000:[414, 704, 936, 1128],
51100:[415, 705, 938, 1130],
51200:[416, 707, 940, 1132],
51300:[417, 708, 941, 1134],
51400:[417, 710, 943, 1135],
51500:[418, 711, 945, 1137],
51600:[419, 712, 947, 1139],
51700:[420, 714, 948, 1141],
51800:[421, 715, 950, 1143],
51900:[422, 716, 952, 1145],
52000:[423, 718, 954, 1147],
52100:[424, 719, 956, 1149],
52200:[425, 721, 957, 1151],
52300:[426, 722, 959, 1153],
52400:[427, 723, 961, 1155],
52500:[427, 725, 963, 1157],
52600:[428, 726, 964, 1159],
52700:[429, 727, 966, 1161],
52800:[430, 729, 968, 1163],
52900:[431, 730, 970, 1165],
53000:[432, 731, 971, 1167],
53100:[433, 732, 973, 1169],
53200:[434, 734, 975, 1171],
53300:[434, 735, 976, 1173],
53400:[435, 736, 978, 1175],
53500:[436, 738, 980, 1177],
53600:[437, 739, 982, 1179],
53700:[438, 741, 984, 1182],
53800:[439, 742, 985, 1184],
53900:[439, 743, 987, 1186],
54000:[440, 745, 989, 1188],
54100:[441, 746, 991, 1190],
54200:[442, 748, 992, 1192],
54300:[443, 749, 994, 1194],
54400:[443, 751, 996, 1196],
54500:[444, 752, 998, 1199],
54600:[445, 753, 999, 1201],
54700:[446, 755, 1001, 1203],
54800:[447, 756, 1003, 1205],
54900:[448, 758, 1005, 1207],
55000:[449, 759, 1006, 1209],
55100:[450, 760, 1008, 1211],
55200:[451, 762, 1010, 1213],
55300:[452, 763, 1012, 1215],
55400:[452, 765, 1014, 1218],
55500:[453, 766, 1015, 1220],
55600:[454, 768, 1017, 1222],
55700:[455, 769, 1019, 1224],
55800:[456, 770, 1021, 1226],
55900:[457, 772, 1023, 1228],
56000:[458, 773, 1025, 1230],
56100:[459, 774, 1027, 1232],
56200:[460, 776, 1029, 1234],
56300:[461, 777, 1031, 1236],
56400:[462, 779, 1032, 1239],
56500:[463, 780, 1034, 1241],
56600:[464, 781, 1036, 1243],
56700:[465, 783, 1038, 1245],
56800:[466, 784, 1040, 1247],
56900:[467, 786, 1042, 1249],
57000:[468, 787, 1043, 1252],
57100:[469, 788, 1045, 1254],
57200:[470, 790, 1047, 1256],
57300:[471, 791, 1049, 1259],
57400:[472, 793, 1051, 1261],
57500:[473, 794, 1052, 1263],
57600:[474, 796, 1054, 1265],
57700:[474, 797, 1056, 1267],
57800:[475, 799, 1058, 1269],
57900:[476, 800, 1060, 1272],
58000:[477, 802, 1062, 1274],
58100:[478, 803, 1064, 1276],
58200:[479, 805, 1066, 1278],
58300:[480, 806, 1068, 1281],
58400:[481, 808, 1069, 1283],
58500:[482, 809, 1071, 1285],
58600:[482, 811, 1073, 1287],
58700:[483, 812, 1075, 1289],
58800:[484, 813, 1077, 1292],
58900:[485, 815, 1079, 1294],
59000:[486, 816, 1080, 1296],
59100:[487, 817, 1082, 1298],
59200:[488, 819, 1084, 1300],
59300:[489, 820, 1085, 1303],
59400:[490, 822, 1087, 1305],
59500:[490, 823, 1089, 1307],
59600:[491, 824, 1091, 1309],
59700:[492, 826, 1093, 1311],
59800:[493, 827, 1094, 1314],
59900:[494, 829, 1096, 1316],
60000:[495, 830, 1098, 1318],
60100:[496, 831, 1100, 1320],
60200:[497, 833, 1102, 1322],
60300:[498, 834, 1104, 1325],
60400:[499, 836, 1105, 1327],
60500:[500, 837, 1107, 1329],
60600:[501, 839, 1109, 1331],
60700:[502, 840, 1111, 1334],
60800:[503, 842, 1113, 1336],
60900:[504, 843, 1115, 1338],
61000:[505, 845, 1117, 1340],
61100:[506, 846, 1119, 1342],
61200:[507, 848, 1121, 1344],
61300:[508, 849, 1122, 1346],
61400:[509, 851, 1124, 1349],
61500:[510, 852, 1126, 1351],
61600:[511, 854, 1128, 1353],
61700:[512, 855, 1130, 1355],
61800:[512, 856, 1131, 1357],
61900:[513, 858, 1133, 1359],
62000:[514, 859, 1135, 1361],
62100:[515, 860, 1137, 1363],
62200:[516, 862, 1139, 1365],
62300:[517, 863, 1141, 1367],
62400:[518, 865, 1142, 1370],
62500:[519, 866, 1144, 1372],
62600:[519, 868, 1146, 1374],
62700:[520, 869, 1148, 1376],
62800:[521, 871, 1150, 1378],
62900:[522, 872, 1152, 1380],
63000:[523, 874, 1154, 1383],
63100:[524, 875, 1156, 1385],
63200:[525, 877, 1158, 1387],
63300:[526, 878, 1159, 1390],
63400:[527, 880, 1161, 1392],
63500:[527, 881, 1163, 1394],
63600:[528, 883, 1165, 1396],
63700:[529, 884, 1167, 1398],
63800:[530, 886, 1168, 1400],
63900:[531, 887, 1170, 1403],
64000:[532, 888, 1172, 1405],
64100:[533, 889, 1174, 1407],
64200:[534, 891, 1176, 1409],
64300:[535, 892, 1178, 1412],
64400:[536, 894, 1179, 1414],
64500:[537, 895, 1181, 1416],
64600:[538, 896, 1183, 1418],
64700:[539, 898, 1185, 1420],
64800:[540, 899, 1187, 1423],
64900:[541, 901, 1189, 1425],
65000:[542, 902, 1191, 1427],
65100:[543, 903, 1193, 1429],
65200:[544, 905, 1195, 1431],
65300:[545, 906, 1196, 1434],
65400:[546, 908, 1198, 1436],
65500:[547, 909, 1200, 1438],
65600:[548, 911, 1202, 1440],
65700:[549, 912, 1204, 1442],
65800:[550, 914, 1206, 1445],
65900:[550, 915, 1207, 1447],
66000:[551, 917, 1209, 1449],
66100:[552, 918, 1211, 1451],
66200:[553, 920, 1213, 1453],
66300:[554, 921, 1215, 1456],
66400:[555, 923, 1216, 1458],
66500:[556, 924, 1218, 1460],
66600:[556, 926, 1220, 1462],
66700:[557, 927, 1222, 1465],
66800:[558, 928, 1224, 1467],
66900:[559, 930, 1226, 1469],
67000:[560, 931, 1228, 1471],
67100:[561, 932, 1230, 1473],
67200:[562, 934, 1232, 1475],
67300:[563, 935, 1233, 1477],
67400:[564, 937, 1235, 1480],
67500:[564, 938, 1237, 1482],
67600:[565, 939, 1239, 1484],
67700:[566, 941, 1241, 1486],
67800:[567, 942, 1243, 1488],
67900:[568, 944, 1244, 1490],
68000:[569, 945, 1246, 1492],
68100:[570, 946, 1248, 1494],
68200:[571, 948, 1250, 1496],
68300:[572, 949, 1252, 1498],
68400:[573, 951, 1253, 1501],
68500:[574, 952, 1255, 1503],
68600:[575, 954, 1257, 1505],
68700:[576, 955, 1259, 1507],
68800:[577, 957, 1261, 1509],
68900:[578, 958, 1263, 1511],
69000:[579, 960, 1265, 1514],
69100:[580, 961, 1267, 1516],
69200:[581, 963, 1269, 1518],
69300:[582, 964, 1270, 1521],
69400:[583, 966, 1272, 1523],
69500:[584, 967, 1274, 1525],
69600:[585, 969, 1276, 1527],
69700:[586, 970, 1278, 1529],
69800:[587, 971, 1280, 1531],
69900:[587, 973, 1281, 1534],
70000:[588, 974, 1283, 1536],
70100:[589, 975, 1285, 1538],
70200:[590, 977, 1287, 1540],
70300:[591, 978, 1289, 1543],
70400:[592, 980, 1291, 1545],
70500:[593, 981, 1292, 1547],
70600:[594, 983, 1294, 1549],
70700:[594, 984, 1296, 1551],
70800:[595, 986, 1298, 1554],
70900:[596, 987, 1300, 1556],
71000:[597, 989, 1302, 1558],
71100:[598, 990, 1304, 1560],
71200:[599, 992, 1306, 1562],
71300:[600, 993, 1307, 1565],
71400:[601, 995, 1309, 1567],
71500:[601, 996, 1311, 1569],
71600:[602, 998, 1313, 1571],
71700:[603, 999, 1315, 1573],
71800:[604, 1001, 1317, 1576],
71900:[605, 1002, 1318, 1578],
72000:[606, 1003, 1320, 1580],
72100:[607, 1004, 1322, 1582],
72200:[608, 1006, 1324, 1584],
72300:[609, 1007, 1326, 1587],
72400:[610, 1009, 1328, 1589],
72500:[611, 1010, 1329, 1591],
72600:[612, 1011, 1331, 1593],
72700:[613, 1013, 1333, 1596],
72800:[614, 1014, 1335, 1598],
72900:[615, 1016, 1337, 1600],
73000:[616, 1017, 1339, 1602],
73100:[617, 1018, 1341, 1604],
73200:[618, 1020, 1343, 1606],
73300:[619, 1021, 1345, 1608],
73400:[620, 1023, 1346, 1611],
73500:[621, 1024, 1348, 1613],
73600:[622, 1026, 1350, 1615],
73700:[623, 1027, 1352, 1617],
73800:[624, 1029, 1354, 1619],
73900:[625, 1030, 1356, 1621],
74000:[625, 1032, 1357, 1623],
74100:[626, 1033, 1359, 1625],
74200:[627, 1035, 1361, 1627],
74300:[628, 1036, 1363, 1629],
74400:[629, 1038, 1365, 1632],
74500:[630, 1039, 1366, 1634],
74600:[631, 1041, 1368, 1636],
74700:[631, 1042, 1370, 1638],
74800:[632, 1044, 1372, 1640],
74900:[633, 1045, 1374, 1642],
75000:[634, 1046, 1376, 1645],
75100:[635, 1047, 1378, 1647],
75200:[636, 1049, 1380, 1649],
75300:[637, 1050, 1382, 1652],
75400:[638, 1052, 1383, 1654],
75500:[639, 1053, 1385, 1656],
75600:[639, 1054, 1387, 1658],
75700:[640, 1056, 1389, 1660],
75800:[641, 1057, 1391, 1662],
75900:[642, 1059, 1393, 1665],
76000:[643, 1060, 1394, 1667],
76100:[644, 1061, 1396, 1669],
76200:[645, 1063, 1398, 1671],
76300:[646, 1064, 1400, 1674],
76400:[647, 1066, 1402, 1676],
76500:[647, 1067, 1403, 1678],
76600:[648, 1069, 1405, 1680],
76700:[649, 1070, 1407, 1682],
76800:[650, 1072, 1409, 1685],
76900:[651, 1073, 1411, 1687],
77000:[652, 1075, 1413, 1689],
77100:[653, 1076, 1415, 1691],
77200:[654, 1078, 1417, 1693],
77300:[655, 1079, 1419, 1696],
77400:[656, 1081, 1420, 1698],
77500:[657, 1082, 1422, 1700],
77600:[658, 1084, 1424, 1702],
77700:[659, 1085, 1426, 1704],
77800:[660, 1086, 1428, 1707],
77900:[661, 1088, 1430, 1709],
78000:[662, 1089, 1431, 1711],
78100:[663, 1090, 1433, 1713],
78200:[664, 1092, 1435, 1715],
78300:[665, 1093, 1436, 1718],
78400:[666, 1095, 1438, 1720],
78500:[667, 1096, 1440, 1722],
78600:[668, 1097, 1442, 1724],
78700:[669, 1099, 1444, 1727],
78800:[669, 1100, 1445, 1729],
78900:[670, 1102, 1447, 1731],
79000:[671, 1103, 1449, 1733],
79100:[672, 1104, 1451, 1735],
79200:[673, 1106, 1453, 1737],
79300:[674, 1107, 1455, 1739],
79400:[675, 1109, 1456, 1742],
79500:[676, 1110, 1458, 1744],
79600:[676, 1112, 1460, 1746],
79700:[677, 1113, 1462, 1748],
79800:[678, 1115, 1464, 1750],
79900:[679, 1116, 1466, 1752],
80000:[680, 1118, 1468, 1754],
80100:[681, 1119, 1470, 1756],
80200:[682, 1121, 1472, 1758],
80300:[683, 1122, 1473, 1760],
80400:[684, 1124, 1475, 1763],
80500:[684, 1125, 1477, 1765],
80600:[685, 1127, 1479, 1767],
80700:[686, 1128, 1481, 1769],
80800:[687, 1129, 1482, 1771],
80900:[688, 1131, 1484, 1773],
81000:[689, 1132, 1486, 1776],
81100:[690, 1133, 1488, 1778],
81200:[691, 1135, 1490, 1780],
81300:[692, 1136, 1492, 1783],
81400:[693, 1138, 1493, 1785],
81500:[694, 1139, 1495, 1787],
81600:[695, 1141, 1497, 1789],
81700:[696, 1142, 1499, 1791],
81800:[697, 1144, 1501, 1793],
81900:[698, 1145, 1503, 1796],
82000:[699, 1147, 1505, 1798],
82100:[700, 1148, 1507, 1800],
82200:[701, 1150, 1509, 1802],
82300:[702, 1151, 1510, 1805],
82400:[703, 1153, 1512, 1807],
82500:[704, 1154, 1514, 1809],
82600:[705, 1156, 1516, 1811],
82700:[706, 1157, 1518, 1813],
82800:[706, 1159, 1520, 1816],
82900:[707, 1160, 1521, 1818],
83000:[708, 1161, 1523, 1820],
83100:[709, 1162, 1525, 1822],
83200:[710, 1164, 1527, 1824],
83300:[711, 1165, 1529, 1827],
83400:[712, 1167, 1530, 1829],
83500:[713, 1168, 1532, 1831],
83600:[713, 1169, 1534, 1833],
83700:[714, 1171, 1536, 1835],
83800:[715, 1172, 1538, 1838],
83900:[716, 1174, 1540, 1840],
84000:[717, 1175, 1542, 1842],
84100:[718, 1176, 1544, 1844],
84200:[719, 1178, 1546, 1846],
84300:[720, 1179, 1547, 1849],
84400:[721, 1181, 1549, 1851],
84500:[721, 1182, 1551, 1853],
84600:[722, 1184, 1553, 1855],
84700:[723, 1185, 1555, 1858],
84800:[724, 1187, 1557, 1860],
84900:[725, 1188, 1558, 1862],
85000:[726, 1190, 1560, 1864],
85100:[727, 1191, 1562, 1866],
85200:[728, 1193, 1564, 1868],
85300:[729, 1194, 1566, 1870],
85400:[730, 1196, 1567, 1873],
85500:[731, 1197, 1569, 1875],
85600:[732, 1199, 1571, 1877],
85700:[733, 1200, 1573, 1879],
85800:[734, 1201, 1575, 1881],
85900:[735, 1203, 1577, 1883],
86000:[736, 1204, 1579, 1885],
86100:[737, 1205, 1581, 1887],
86200:[738, 1207, 1583, 1889],
86300:[739, 1208, 1584, 1891],
86400:[740, 1210, 1586, 1894],
86500:[741, 1211, 1588, 1896],
86600:[742, 1212, 1590, 1898],
86700:[743, 1214, 1592, 1900],
86800:[744, 1215, 1594, 1902],
86900:[744, 1217, 1595, 1904],
87000:[745, 1218, 1597, 1907],
87100:[746, 1219, 1599, 1909],
87200:[747, 1221, 1601, 1911],
87300:[748, 1222, 1603, 1914],
87400:[749, 1224, 1605, 1916],
87500:[750, 1225, 1606, 1918],
87600:[751, 1227, 1608, 1920],
87700:[751, 1228, 1610, 1922],
87800:[752, 1230, 1612, 1924],
87900:[753, 1231, 1614, 1927],
88000:[754, 1233, 1616, 1929],
88100:[755, 1234, 1618, 1931],
88200:[756, 1236, 1620, 1933],
88300:[757, 1237, 1621, 1936],
88400:[758, 1239, 1623, 1938],
88500:[758, 1240, 1625, 1940],
88600:[759, 1242, 1627, 1942],
88700:[760, 1243, 1629, 1944],
88800:[761, 1244, 1631, 1947],
88900:[762, 1246, 1632, 1949],
89000:[763, 1247, 1634, 1951],
89100:[764, 1248, 1636, 1953],
89200:[765, 1250, 1638, 1955],
89300:[766, 1251, 1640, 1958],
89400:[767, 1253, 1642, 1960],
89500:[768, 1254, 1643, 1962],
89600:[769, 1255, 1645, 1964],
89700:[770, 1257, 1647, 1966],
89800:[771, 1258, 1649, 1969],
89900:[772, 1259, 1651, 1971],
90000:[773, 1261, 1653, 1973],
90100:[774, 1262, 1655, 1975],
90200:[775, 1264, 1656, 1977],
90300:[776, 1265, 1658, 1979],
90400:[776, 1266, 1660, 1982],
90500:[777, 1268, 1662, 1984],
90600:[778, 1269, 1663, 1986],
90700:[779, 1270, 1665, 1988],
90800:[780, 1272, 1667, 1990],
90900:[781, 1273, 1669, 1992],
91000:[781, 1275, 1670, 1994],
91100:[782, 1276, 1672, 1996],
91200:[783, 1278, 1673, 1998],
91300:[784, 1279, 1675, 2000],
91400:[784, 1280, 1677, 2002],
91500:[785, 1282, 1678, 2004],
91600:[786, 1283, 1680, 2006],
91700:[787, 1285, 1682, 2008],
91800:[788, 1286, 1683, 2010],
91900:[789, 1287, 1685, 2012],
92000:[790, 1289, 1687, 2014],
92100:[791, 1290, 1689, 2016],
92200:[792, 1292, 1690, 2018],
92300:[792, 1293, 1692, 2020],
92400:[793, 1294, 1694, 2022],
92500:[794, 1296, 1695, 2024],
92600:[795, 1297, 1697, 2026],
92700:[796, 1298, 1699, 2028],
92800:[796, 1300, 1700, 2030],
92900:[797, 1301, 1702, 2032],
93000:[798, 1302, 1704, 2034],
93100:[799, 1303, 1706, 2036],
93200:[800, 1305, 1707, 2038],
93300:[801, 1306, 1709, 2040],
93400:[801, 1307, 1711, 2042],
93500:[802, 1309, 1712, 2044],
93600:[803, 1310, 1714, 2046],
93700:[804, 1311, 1716, 2048],
93800:[805, 1313, 1717, 2050],
93900:[806, 1314, 1719, 2052],
94000:[807, 1315, 1721, 2054],
94100:[808, 1316, 1723, 2056],
94200:[809, 1318, 1724, 2058],
94300:[809, 1319, 1726, 2060],
94400:[810, 1320, 1728, 2062],
94500:[811, 1322, 1729, 2064],
94600:[812, 1323, 1731, 2066],
94700:[813, 1324, 1733, 2068],
94800:[814, 1326, 1734, 2070],
94900:[814, 1327, 1736, 2072],
95000:[815, 1328, 1738, 2074],
95100:[816, 1329, 1740, 2076],
95200:[817, 1331, 1741, 2078],
95300:[818, 1332, 1743, 2080],
95400:[818, 1333, 1745, 2082],
95500:[819, 1334, 1746, 2084],
95600:[820, 1336, 1748, 2086],
95700:[821, 1337, 1750, 2088],
95800:[822, 1338, 1751, 2090],
95900:[823, 1340, 1753, 2092],
96000:[824, 1341, 1755, 2094],
96100:[825, 1342, 1757, 2096],
96200:[826, 1344, 1758, 2098],
96300:[826, 1345, 1760, 2100],
96400:[827, 1346, 1762, 2102],
96500:[828, 1347, 1763, 2104],
96600:[829, 1349, 1765, 2106],
96700:[830, 1350, 1767, 2108],
96800:[831, 1351, 1768, 2110],
96900:[831, 1353, 1770, 2112],
97000:[832, 1354, 1772, 2114],
97100:[833, 1355, 1774, 2116],
97200:[834, 1357, 1775, 2118],
97300:[835, 1358, 1777, 2120],
97400:[835, 1359, 1779, 2122],
97500:[836, 1361, 1780, 2124],
97600:[837, 1362, 1782, 2126],
97700:[838, 1364, 1784, 2128],
97800:[839, 1365, 1786, 2130],
97900:[840, 1366, 1787, 2132],
98000:[841, 1368, 1789, 2134],
98100:[842, 1369, 1791, 2136],
98200:[843, 1371, 1792, 2138],
98300:[843, 1372, 1794, 2140],
98400:[844, 1373, 1796, 2142],
98500:[845, 1375, 1797, 2144],
98600:[846, 1376, 1799, 2146],
98700:[847, 1377, 1801, 2148],
98800:[848, 1379, 1803, 2150],
98900:[848, 1380, 1804, 2152],
99000:[849, 1381, 1806, 2154],
99100:[850, 1382, 1808, 2156],
99200:[851, 1384, 1809, 2158],
99300:[852, 1385, 1811, 2160],
99400:[853, 1386, 1813, 2162],
99500:[853, 1388, 1815, 2164],
99600:[854, 1389, 1816, 2166],
99700:[855, 1390, 1818, 2168],
99800:[856, 1392, 1820, 2170],
99900:[857, 1393, 1821, 2172],
};
const OR17_SK=[0.78, 1.22, 1.6, 1.84];

// Yukon — 2017 Federal Child Support Guidelines Table
const T17_YT={
100000:[935, 1511, 1971, 2348],
100100:[936, 1512, 1973, 2350],
100200:[937, 1514, 1975, 2352],
100300:[938, 1515, 1976, 2354],
100400:[938, 1516, 1978, 2356],
100500:[939, 1518, 1980, 2358],
100600:[940, 1519, 1982, 2360],
100700:[941, 1520, 1983, 2362],
100800:[942, 1522, 1985, 2365],
100900:[943, 1523, 1987, 2367],
101000:[943, 1524, 1989, 2369],
101100:[944, 1525, 1991, 2371],
101200:[945, 1527, 1992, 2373],
101300:[946, 1528, 1994, 2375],
101400:[946, 1530, 1996, 2377],
101500:[947, 1531, 1998, 2379],
101600:[948, 1532, 1999, 2382],
101700:[949, 1534, 2001, 2384],
101800:[950, 1535, 2003, 2386],
101900:[951, 1536, 2004, 2388],
102000:[952, 1538, 2006, 2390],
102100:[953, 1539, 2008, 2392],
102200:[954, 1541, 2010, 2394],
102300:[955, 1542, 2011, 2396],
102400:[956, 1543, 2013, 2398],
102500:[956, 1545, 2015, 2400],
102600:[957, 1546, 2017, 2402],
102700:[958, 1547, 2018, 2404],
102800:[959, 1549, 2020, 2406],
102900:[960, 1550, 2022, 2408],
103000:[961, 1551, 2024, 2410],
103100:[962, 1552, 2026, 2412],
103200:[963, 1554, 2027, 2414],
103300:[964, 1555, 2029, 2416],
103400:[965, 1556, 2031, 2418],
103500:[966, 1558, 2033, 2420],
103600:[967, 1559, 2034, 2422],
103700:[967, 1561, 2036, 2424],
103800:[968, 1562, 2038, 2426],
103900:[969, 1563, 2039, 2428],
104000:[970, 1565, 2041, 2431],
104100:[971, 1566, 2043, 2433],
104200:[972, 1568, 2045, 2435],
104300:[973, 1569, 2046, 2437],
104400:[973, 1571, 2048, 2439],
104500:[974, 1572, 2050, 2441],
104600:[975, 1573, 2052, 2443],
104700:[976, 1575, 2053, 2446],
104800:[977, 1576, 2055, 2448],
104900:[978, 1578, 2057, 2450],
105000:[978, 1579, 2059, 2452],
105100:[979, 1580, 2061, 2454],
105200:[980, 1582, 2062, 2456],
105300:[981, 1583, 2064, 2458],
105400:[981, 1584, 2066, 2460],
105500:[982, 1586, 2068, 2463],
105600:[983, 1587, 2069, 2465],
105700:[984, 1588, 2071, 2467],
105800:[985, 1590, 2073, 2469],
105900:[986, 1591, 2074, 2471],
106000:[987, 1592, 2076, 2473],
106100:[988, 1593, 2078, 2475],
106200:[989, 1595, 2080, 2477],
106300:[990, 1596, 2081, 2479],
106400:[991, 1597, 2083, 2481],
106500:[991, 1599, 2085, 2483],
106600:[992, 1600, 2087, 2485],
106700:[993, 1602, 2088, 2487],
106800:[994, 1603, 2090, 2489],
106900:[995, 1604, 2092, 2491],
107000:[996, 1606, 2094, 2493],
107100:[997, 1607, 2096, 2495],
107200:[998, 1609, 2098, 2497],
107300:[999, 1610, 2099, 2499],
107400:[1000, 1612, 2101, 2501],
107500:[1001, 1613, 2103, 2503],
107600:[1001, 1614, 2105, 2505],
107700:[1002, 1616, 2107, 2507],
107800:[1003, 1617, 2108, 2510],
107900:[1004, 1619, 2110, 2512],
108000:[1005, 1620, 2112, 2514],
108100:[1006, 1621, 2114, 2516],
108200:[1007, 1623, 2115, 2518],
108300:[1008, 1624, 2117, 2520],
108400:[1008, 1625, 2119, 2522],
108500:[1009, 1627, 2121, 2524],
108600:[1010, 1628, 2122, 2527],
108700:[1011, 1629, 2124, 2529],
108800:[1012, 1631, 2126, 2531],
108900:[1013, 1632, 2128, 2533],
109000:[1013, 1633, 2129, 2535],
109100:[1014, 1634, 2131, 2537],
109200:[1015, 1636, 2133, 2539],
109300:[1016, 1637, 2134, 2541],
109400:[1016, 1639, 2136, 2543],
109500:[1017, 1640, 2138, 2545],
109600:[1018, 1641, 2140, 2547],
109700:[1019, 1643, 2142, 2549],
109800:[1020, 1644, 2143, 2551],
109900:[1021, 1645, 2145, 2553],
110000:[1022, 1647, 2147, 2555],
110100:[1023, 1648, 2149, 2557],
110200:[1024, 1650, 2150, 2559],
110300:[1025, 1651, 2152, 2561],
110400:[1026, 1652, 2154, 2563],
110500:[1026, 1654, 2156, 2565],
110600:[1027, 1655, 2157, 2567],
110700:[1028, 1656, 2159, 2569],
110800:[1029, 1658, 2161, 2571],
110900:[1030, 1659, 2163, 2573],
111000:[1031, 1660, 2164, 2576],
111100:[1032, 1661, 2166, 2578],
111200:[1033, 1663, 2168, 2580],
111300:[1034, 1664, 2169, 2582],
111400:[1035, 1665, 2171, 2584],
111500:[1036, 1667, 2173, 2586],
111600:[1036, 1668, 2175, 2588],
111700:[1037, 1669, 2177, 2591],
111800:[1038, 1671, 2178, 2593],
111900:[1039, 1672, 2180, 2595],
112000:[1040, 1674, 2182, 2597],
112100:[1041, 1675, 2184, 2599],
112200:[1042, 1677, 2185, 2601],
112300:[1042, 1678, 2187, 2603],
112400:[1043, 1680, 2189, 2605],
112500:[1044, 1681, 2191, 2608],
112600:[1045, 1682, 2192, 2610],
112700:[1046, 1684, 2194, 2612],
112800:[1047, 1685, 2196, 2614],
112900:[1047, 1687, 2198, 2616],
113000:[1048, 1688, 2199, 2618],
113100:[1049, 1689, 2201, 2620],
113200:[1050, 1691, 2203, 2622],
113300:[1051, 1692, 2204, 2624],
113400:[1051, 1693, 2206, 2626],
113500:[1052, 1695, 2208, 2628],
113600:[1053, 1696, 2210, 2630],
113700:[1054, 1697, 2211, 2632],
113800:[1055, 1699, 2213, 2634],
113900:[1056, 1700, 2215, 2636],
114000:[1057, 1701, 2217, 2638],
114100:[1058, 1702, 2219, 2640],
114200:[1059, 1704, 2220, 2642],
114300:[1060, 1705, 2222, 2644],
114400:[1061, 1706, 2224, 2646],
114500:[1061, 1708, 2226, 2648],
114600:[1062, 1709, 2227, 2650],
114700:[1063, 1711, 2229, 2652],
114800:[1064, 1712, 2231, 2655],
114900:[1065, 1713, 2233, 2657],
115000:[1066, 1715, 2234, 2659],
115100:[1067, 1716, 2236, 2661],
115200:[1068, 1718, 2238, 2663],
115300:[1069, 1719, 2239, 2665],
115400:[1070, 1721, 2241, 2667],
115500:[1071, 1722, 2243, 2669],
115600:[1071, 1723, 2245, 2672],
115700:[1072, 1725, 2246, 2674],
115800:[1073, 1726, 2248, 2676],
115900:[1074, 1728, 2250, 2678],
116000:[1075, 1729, 2252, 2680],
116100:[1076, 1730, 2254, 2682],
116200:[1077, 1732, 2255, 2684],
116300:[1077, 1733, 2257, 2686],
116400:[1078, 1734, 2259, 2688],
116500:[1079, 1736, 2261, 2690],
116600:[1080, 1737, 2262, 2692],
116700:[1081, 1738, 2264, 2694],
116800:[1082, 1740, 2266, 2696],
116900:[1082, 1741, 2268, 2698],
117000:[1083, 1742, 2269, 2700],
117100:[1084, 1743, 2271, 2702],
117200:[1085, 1745, 2273, 2704],
117300:[1086, 1746, 2274, 2706],
117400:[1086, 1747, 2276, 2708],
117500:[1087, 1749, 2278, 2710],
117600:[1088, 1750, 2280, 2712],
117700:[1089, 1752, 2281, 2714],
117800:[1090, 1753, 2283, 2716],
117900:[1091, 1754, 2285, 2718],
118000:[1092, 1756, 2287, 2721],
118100:[1093, 1757, 2289, 2723],
118200:[1094, 1759, 2290, 2725],
118300:[1095, 1760, 2292, 2727],
118400:[1095, 1762, 2294, 2729],
118500:[1096, 1763, 2296, 2731],
118600:[1097, 1764, 2297, 2733],
118700:[1098, 1766, 2299, 2736],
118800:[1099, 1767, 2301, 2738],
118900:[1100, 1769, 2302, 2740],
119000:[1101, 1770, 2304, 2742],
119100:[1102, 1771, 2306, 2744],
119200:[1103, 1773, 2308, 2746],
119300:[1104, 1774, 2309, 2748],
119400:[1105, 1775, 2311, 2750],
119500:[1105, 1777, 2313, 2753],
119600:[1106, 1778, 2315, 2755],
119700:[1107, 1779, 2316, 2757],
119800:[1108, 1781, 2318, 2759],
119900:[1109, 1782, 2320, 2761],
12000:[0, 0, 0, 0],
120000:[1110, 1783, 2322, 2763],
120100:[1111, 1784, 2324, 2765],
120200:[1112, 1786, 2325, 2767],
120300:[1113, 1787, 2327, 2769],
120400:[1114, 1789, 2329, 2771],
120500:[1115, 1790, 2331, 2773],
120600:[1116, 1791, 2332, 2775],
120700:[1116, 1793, 2334, 2777],
120800:[1117, 1794, 2336, 2779],
120900:[1118, 1795, 2337, 2781],
12100:[7, 8, 9, 9],
121000:[1119, 1797, 2339, 2783],
121100:[1120, 1798, 2341, 2785],
121200:[1121, 1800, 2343, 2787],
121300:[1122, 1801, 2344, 2789],
121400:[1122, 1802, 2346, 2791],
121500:[1123, 1804, 2348, 2793],
121600:[1124, 1805, 2350, 2795],
121700:[1125, 1806, 2351, 2797],
121800:[1126, 1808, 2353, 2800],
121900:[1127, 1809, 2355, 2802],
12200:[15, 16, 17, 18],
122000:[1127, 1810, 2357, 2804],
122100:[1128, 1811, 2359, 2806],
122200:[1129, 1813, 2360, 2808],
122300:[1130, 1814, 2362, 2810],
122400:[1130, 1815, 2364, 2812],
122500:[1131, 1817, 2366, 2814],
122600:[1132, 1818, 2367, 2817],
122700:[1133, 1819, 2369, 2819],
122800:[1134, 1821, 2371, 2821],
122900:[1135, 1822, 2372, 2823],
12300:[22, 24, 26, 28],
123000:[1136, 1824, 2374, 2825],
123100:[1137, 1825, 2376, 2827],
123200:[1138, 1827, 2378, 2829],
123300:[1139, 1828, 2379, 2831],
123400:[1140, 1830, 2381, 2833],
123500:[1140, 1831, 2383, 2836],
123600:[1141, 1832, 2385, 2838],
123700:[1142, 1834, 2386, 2840],
123800:[1143, 1835, 2388, 2842],
123900:[1144, 1837, 2390, 2844],
12400:[30, 32, 34, 37],
124000:[1145, 1838, 2392, 2846],
124100:[1146, 1839, 2394, 2848],
124200:[1147, 1841, 2396, 2850],
124300:[1148, 1842, 2397, 2852],
124400:[1149, 1843, 2399, 2854],
124500:[1150, 1845, 2401, 2856],
124600:[1150, 1846, 2403, 2858],
124700:[1151, 1847, 2405, 2860],
124800:[1152, 1849, 2406, 2862],
124900:[1153, 1850, 2408, 2864],
12500:[37, 40, 43, 46],
125000:[1154, 1851, 2410, 2866],
125100:[1155, 1852, 2412, 2868],
125200:[1156, 1854, 2413, 2870],
125300:[1157, 1855, 2415, 2872],
125400:[1157, 1856, 2417, 2874],
125500:[1158, 1858, 2419, 2876],
125600:[1159, 1859, 2420, 2878],
125700:[1160, 1861, 2422, 2881],
125800:[1161, 1862, 2424, 2883],
125900:[1162, 1863, 2426, 2885],
12600:[44, 48, 52, 55],
126000:[1162, 1865, 2427, 2887],
126100:[1163, 1866, 2429, 2889],
126200:[1164, 1868, 2431, 2891],
126300:[1165, 1869, 2432, 2893],
126400:[1165, 1871, 2434, 2895],
126500:[1166, 1872, 2436, 2898],
126600:[1167, 1873, 2438, 2900],
126700:[1168, 1875, 2440, 2902],
126800:[1169, 1876, 2441, 2904],
126900:[1170, 1878, 2443, 2906],
12700:[52, 56, 60, 64],
127000:[1171, 1879, 2445, 2908],
127100:[1172, 1880, 2447, 2910],
127200:[1173, 1882, 2448, 2912],
127300:[1174, 1883, 2450, 2914],
127400:[1175, 1884, 2452, 2916],
127500:[1175, 1886, 2454, 2918],
127600:[1176, 1887, 2455, 2920],
127700:[1177, 1888, 2457, 2922],
127800:[1178, 1890, 2459, 2924],
127900:[1179, 1891, 2461, 2926],
12800:[59, 64, 69, 74],
128000:[1180, 1892, 2462, 2928],
128100:[1181, 1893, 2464, 2930],
128200:[1182, 1895, 2466, 2932],
128300:[1183, 1896, 2467, 2934],
128400:[1184, 1898, 2469, 2936],
128500:[1185, 1899, 2471, 2938],
128600:[1185, 1900, 2473, 2940],
128700:[1186, 1902, 2475, 2942],
128800:[1187, 1903, 2476, 2945],
128900:[1188, 1904, 2478, 2947],
12900:[67, 72, 77, 83],
129000:[1189, 1906, 2480, 2949],
129100:[1190, 1907, 2482, 2951],
129200:[1191, 1909, 2483, 2953],
129300:[1192, 1910, 2485, 2955],
129400:[1192, 1911, 2487, 2957],
129500:[1193, 1913, 2489, 2959],
129600:[1194, 1914, 2490, 2962],
129700:[1195, 1915, 2492, 2964],
129800:[1196, 1917, 2494, 2966],
129900:[1197, 1918, 2496, 2968],
13000:[74, 80, 86, 92],
130000:[1197, 1919, 2497, 2970],
130100:[1198, 1920, 2499, 2972],
130200:[1199, 1922, 2501, 2974],
130300:[1200, 1923, 2502, 2976],
130400:[1200, 1924, 2504, 2978],
130500:[1201, 1926, 2506, 2981],
130600:[1202, 1927, 2508, 2983],
130700:[1203, 1928, 2509, 2985],
130800:[1204, 1930, 2511, 2987],
130900:[1205, 1931, 2513, 2989],
13100:[77, 84, 90, 96],
131000:[1206, 1933, 2515, 2991],
131100:[1207, 1934, 2517, 2993],
131200:[1208, 1936, 2518, 2995],
131300:[1209, 1937, 2520, 2997],
131400:[1210, 1939, 2522, 2999],
131500:[1210, 1940, 2524, 3001],
131600:[1211, 1941, 2525, 3003],
131700:[1212, 1943, 2527, 3005],
131800:[1213, 1944, 2529, 3007],
131900:[1214, 1945, 2531, 3009],
13200:[81, 87, 94, 100],
132000:[1215, 1947, 2532, 3011],
132100:[1216, 1948, 2534, 3013],
132200:[1217, 1950, 2536, 3015],
132300:[1218, 1951, 2537, 3017],
132400:[1219, 1952, 2539, 3019],
132500:[1220, 1954, 2541, 3021],
132600:[1220, 1955, 2543, 3023],
132700:[1221, 1956, 2544, 3026],
132800:[1222, 1958, 2546, 3028],
132900:[1223, 1959, 2548, 3030],
13300:[84, 91, 98, 105],
133000:[1224, 1960, 2550, 3032],
133100:[1225, 1961, 2552, 3034],
133200:[1226, 1963, 2553, 3036],
133300:[1226, 1964, 2555, 3038],
133400:[1227, 1965, 2557, 3040],
133500:[1228, 1967, 2559, 3043],
133600:[1229, 1968, 2560, 3045],
133700:[1230, 1970, 2562, 3047],
133800:[1231, 1971, 2564, 3049],
133900:[1231, 1972, 2566, 3051],
13400:[87, 95, 102, 109],
134000:[1232, 1974, 2567, 3053],
134100:[1233, 1975, 2569, 3055],
134200:[1234, 1977, 2571, 3057],
134300:[1235, 1978, 2572, 3059],
134400:[1235, 1980, 2574, 3061],
134500:[1236, 1981, 2576, 3063],
134600:[1237, 1982, 2578, 3065],
134700:[1238, 1984, 2579, 3067],
134800:[1239, 1985, 2581, 3069],
134900:[1240, 1987, 2583, 3071],
13500:[91, 98, 106, 113],
135000:[1241, 1988, 2585, 3073],
135100:[1242, 1989, 2587, 3075],
135200:[1243, 1991, 2588, 3077],
135300:[1244, 1992, 2590, 3079],
135400:[1245, 1993, 2592, 3081],
135500:[1245, 1995, 2594, 3083],
135600:[1246, 1996, 2595, 3085],
135700:[1247, 1997, 2597, 3087],
135800:[1248, 1999, 2599, 3090],
135900:[1249, 2000, 2600, 3092],
13600:[94, 102, 109, 117],
136000:[1250, 2001, 2602, 3094],
136100:[1251, 2002, 2604, 3096],
136200:[1252, 2004, 2606, 3098],
136300:[1253, 2005, 2607, 3100],
136400:[1254, 2006, 2609, 3102],
136500:[1254, 2008, 2611, 3104],
136600:[1255, 2009, 2613, 3107],
136700:[1256, 2011, 2614, 3109],
136800:[1257, 2012, 2616, 3111],
136900:[1258, 2013, 2618, 3113],
13700:[97, 105, 113, 121],
137000:[1259, 2015, 2620, 3115],
137100:[1260, 2016, 2622, 3117],
137200:[1261, 2018, 2623, 3119],
137300:[1262, 2019, 2625, 3121],
137400:[1263, 2021, 2627, 3123],
137500:[1264, 2022, 2629, 3126],
137600:[1265, 2023, 2630, 3128],
137700:[1265, 2025, 2632, 3130],
137800:[1266, 2026, 2634, 3132],
137900:[1267, 2028, 2635, 3134],
13800:[101, 109, 117, 126],
138000:[1268, 2029, 2637, 3136],
138100:[1269, 2030, 2639, 3138],
138200:[1270, 2032, 2641, 3140],
138300:[1271, 2033, 2642, 3142],
138400:[1271, 2034, 2644, 3144],
138500:[1272, 2036, 2646, 3146],
138600:[1273, 2037, 2648, 3148],
138700:[1274, 2038, 2649, 3150],
138800:[1275, 2040, 2651, 3152],
138900:[1276, 2041, 2653, 3154],
13900:[104, 113, 121, 130],
139000:[1276, 2042, 2655, 3156],
139100:[1277, 2043, 2657, 3158],
139200:[1278, 2045, 2658, 3160],
139300:[1279, 2046, 2660, 3162],
139400:[1279, 2048, 2662, 3164],
139500:[1280, 2049, 2664, 3166],
139600:[1281, 2050, 2665, 3168],
139700:[1282, 2052, 2667, 3171],
139800:[1283, 2053, 2669, 3173],
139900:[1284, 2054, 2670, 3175],
14000:[107, 116, 125, 134],
140000:[1285, 2056, 2672, 3177],
140100:[1286, 2057, 2674, 3179],
140200:[1287, 2059, 2675, 3181],
140300:[1287, 2060, 2677, 3183],
140400:[1288, 2061, 2679, 3185],
140500:[1289, 2063, 2680, 3187],
140600:[1290, 2064, 2682, 3189],
140700:[1291, 2065, 2684, 3191],
140800:[1291, 2067, 2685, 3193],
140900:[1292, 2068, 2687, 3195],
14100:[108, 119, 128, 138],
141000:[1293, 2069, 2689, 3197],
141100:[1294, 2070, 2691, 3199],
141200:[1295, 2071, 2692, 3201],
141300:[1296, 2073, 2694, 3203],
141400:[1296, 2074, 2695, 3205],
141500:[1297, 2075, 2697, 3207],
141600:[1298, 2076, 2699, 3209],
141700:[1299, 2078, 2700, 3211],
141800:[1300, 2079, 2702, 3212],
141900:[1301, 2080, 2703, 3214],
14200:[109, 123, 132, 142],
142000:[1302, 2081, 2705, 3216],
142100:[1303, 2082, 2707, 3218],
142200:[1304, 2084, 2708, 3220],
142300:[1305, 2085, 2710, 3222],
142400:[1305, 2086, 2711, 3224],
142500:[1306, 2087, 2713, 3226],
142600:[1307, 2089, 2714, 3228],
142700:[1308, 2090, 2716, 3229],
142800:[1309, 2091, 2718, 3231],
142900:[1310, 2092, 2719, 3233],
14300:[110, 126, 135, 145],
143000:[1310, 2094, 2721, 3235],
143100:[1311, 2095, 2723, 3237],
143200:[1312, 2097, 2724, 3239],
143300:[1313, 2098, 2726, 3241],
143400:[1313, 2099, 2728, 3243],
143500:[1314, 2101, 2729, 3245],
143600:[1315, 2102, 2731, 3246],
143700:[1316, 2103, 2733, 3248],
143800:[1317, 2104, 2734, 3250],
143900:[1318, 2106, 2736, 3252],
14400:[110, 129, 139, 149],
144000:[1318, 2107, 2738, 3254],
144100:[1319, 2108, 2740, 3256],
144200:[1320, 2109, 2741, 3258],
144300:[1320, 2111, 2743, 3260],
144400:[1321, 2112, 2745, 3262],
144500:[1322, 2113, 2746, 3264],
144600:[1323, 2114, 2748, 3265],
144700:[1324, 2116, 2749, 3267],
144800:[1325, 2117, 2751, 3269],
144900:[1325, 2118, 2753, 3271],
14500:[111, 132, 142, 153],
145000:[1326, 2119, 2754, 3273],
145100:[1327, 2120, 2756, 3275],
145200:[1328, 2122, 2757, 3277],
145300:[1328, 2123, 2759, 3279],
145400:[1329, 2124, 2760, 3281],
145500:[1330, 2125, 2762, 3282],
145600:[1331, 2127, 2764, 3284],
145700:[1332, 2128, 2765, 3286],
145800:[1333, 2129, 2767, 3288],
145900:[1333, 2131, 2769, 3290],
14600:[112, 136, 146, 157],
146000:[1334, 2132, 2770, 3292],
146100:[1335, 2133, 2772, 3294],
146200:[1336, 2134, 2773, 3296],
146300:[1336, 2136, 2775, 3298],
146400:[1337, 2137, 2776, 3300],
146500:[1338, 2138, 2778, 3301],
146600:[1339, 2139, 2780, 3303],
146700:[1340, 2141, 2781, 3305],
146800:[1341, 2142, 2783, 3307],
146900:[1341, 2143, 2784, 3309],
14700:[113, 139, 149, 160],
147000:[1342, 2144, 2786, 3311],
147100:[1343, 2145, 2788, 3313],
147200:[1344, 2147, 2789, 3315],
147300:[1344, 2148, 2791, 3317],
147400:[1345, 2149, 2792, 3318],
147500:[1346, 2150, 2794, 3320],
147600:[1347, 2152, 2796, 3322],
147700:[1348, 2153, 2797, 3324],
147800:[1348, 2154, 2799, 3326],
147900:[1349, 2155, 2800, 3328],
14800:[114, 142, 153, 164],
148000:[1350, 2157, 2802, 3330],
148100:[1351, 2158, 2804, 3332],
148200:[1352, 2159, 2805, 3334],
148300:[1352, 2161, 2807, 3336],
148400:[1353, 2162, 2808, 3338],
148500:[1354, 2163, 2810, 3340],
148600:[1355, 2164, 2811, 3342],
148700:[1356, 2166, 2813, 3344],
148800:[1356, 2167, 2815, 3346],
148900:[1357, 2168, 2816, 3348],
14900:[115, 145, 156, 168],
149000:[1358, 2169, 2818, 3350],
149100:[1359, 2170, 2820, 3352],
149200:[1360, 2172, 2821, 3354],
149300:[1360, 2173, 2823, 3356],
149400:[1361, 2174, 2825, 3358],
149500:[1362, 2175, 2826, 3360],
149600:[1363, 2177, 2828, 3362],
149700:[1364, 2178, 2830, 3364],
149800:[1364, 2179, 2831, 3366],
149900:[1365, 2180, 2833, 3368],
15000:[116, 149, 160, 172],
150000:[1366, 2182, 2835, 3369],
15100:[117, 152, 164, 176],
15200:[118, 156, 167, 180],
15300:[118, 159, 171, 183],
15400:[119, 162, 174, 187],
15500:[120, 165, 178, 191],
15600:[121, 169, 181, 195],
15700:[122, 172, 185, 199],
15800:[122, 175, 188, 202],
15900:[123, 179, 192, 206],
16000:[124, 182, 196, 210],
16100:[125, 185, 199, 214],
16200:[126, 188, 203, 217],
16300:[127, 191, 206, 221],
16400:[127, 195, 210, 225],
16500:[128, 198, 213, 228],
16600:[129, 201, 217, 232],
16700:[130, 204, 220, 235],
16800:[131, 207, 224, 239],
16900:[132, 210, 227, 243],
17000:[133, 213, 230, 246],
17100:[134, 216, 233, 250],
17200:[135, 219, 237, 253],
17300:[135, 223, 240, 257],
17400:[136, 226, 244, 261],
17500:[137, 229, 247, 264],
17600:[138, 232, 251, 268],
17700:[139, 235, 254, 272],
17800:[140, 238, 257, 276],
17900:[140, 242, 261, 279],
18000:[141, 245, 264, 283],
18100:[142, 249, 268, 287],
18200:[143, 252, 272, 291],
18300:[144, 256, 275, 295],
18400:[144, 259, 279, 299],
18500:[145, 263, 283, 303],
18600:[146, 266, 287, 307],
18700:[147, 270, 291, 311],
18800:[148, 273, 295, 315],
18900:[149, 277, 298, 319],
19000:[150, 280, 302, 323],
19100:[151, 283, 306, 328],
19200:[152, 285, 310, 332],
19300:[152, 288, 315, 337],
19400:[153, 290, 319, 341],
19500:[154, 293, 323, 346],
19600:[155, 295, 327, 350],
19700:[156, 298, 332, 355],
19800:[157, 301, 336, 360],
19900:[157, 303, 340, 364],
20000:[158, 306, 344, 369],
20100:[159, 307, 348, 374],
20200:[160, 309, 353, 378],
20300:[161, 310, 357, 383],
20400:[162, 312, 361, 387],
20500:[162, 313, 365, 392],
20600:[163, 315, 370, 397],
20700:[164, 316, 374, 401],
20800:[165, 318, 378, 406],
20900:[166, 319, 382, 410],
21000:[167, 321, 387, 415],
21100:[168, 322, 391, 420],
21200:[169, 324, 396, 424],
21300:[170, 325, 400, 429],
21400:[170, 327, 404, 433],
21500:[171, 328, 408, 438],
21600:[172, 330, 413, 443],
21700:[173, 331, 417, 447],
21800:[174, 332, 421, 452],
21900:[175, 334, 426, 457],
22000:[175, 335, 430, 461],
22100:[176, 336, 434, 466],
22200:[177, 338, 439, 470],
22300:[178, 339, 443, 475],
22400:[179, 341, 447, 479],
22500:[179, 342, 452, 484],
22600:[180, 343, 456, 488],
22700:[181, 345, 460, 493],
22800:[182, 346, 464, 497],
22900:[183, 348, 469, 502],
23000:[184, 349, 473, 506],
23100:[185, 350, 476, 511],
23200:[186, 352, 479, 515],
23300:[187, 353, 482, 520],
23400:[187, 355, 484, 524],
23500:[188, 356, 487, 529],
23600:[189, 358, 490, 533],
23700:[190, 359, 493, 538],
23800:[191, 361, 496, 542],
23900:[192, 362, 499, 547],
24000:[192, 364, 501, 552],
24100:[193, 365, 503, 557],
24200:[194, 367, 505, 561],
24300:[194, 368, 507, 566],
24400:[195, 370, 509, 570],
24500:[196, 371, 511, 575],
24600:[197, 373, 513, 580],
24700:[198, 374, 514, 584],
24800:[198, 376, 516, 589],
24900:[199, 377, 518, 593],
25000:[200, 378, 520, 598],
25100:[201, 380, 522, 603],
25200:[202, 381, 524, 607],
25300:[203, 383, 526, 612],
25400:[204, 384, 528, 616],
25500:[205, 386, 530, 621],
25600:[206, 388, 532, 626],
25700:[207, 389, 534, 630],
25800:[208, 391, 536, 635],
25900:[210, 393, 538, 639],
26000:[211, 394, 540, 644],
26100:[212, 396, 542, 648],
26200:[214, 398, 545, 653],
26300:[215, 400, 547, 657],
26400:[217, 402, 550, 662],
26500:[218, 404, 552, 666],
26600:[220, 407, 555, 671],
26700:[221, 409, 557, 675],
26800:[223, 411, 560, 679],
26900:[224, 413, 562, 684],
27000:[226, 415, 565, 688],
27100:[228, 417, 568, 691],
27200:[229, 419, 570, 694],
27300:[231, 421, 573, 696],
27400:[232, 423, 575, 699],
27500:[234, 425, 578, 702],
27600:[235, 427, 580, 705],
27700:[237, 429, 583, 708],
27800:[238, 431, 585, 710],
27900:[240, 433, 588, 713],
28000:[242, 435, 590, 716],
28100:[243, 437, 592, 719],
28200:[245, 439, 594, 721],
28300:[246, 440, 597, 724],
28400:[247, 442, 599, 726],
28500:[249, 444, 601, 729],
28600:[250, 446, 603, 732],
28700:[251, 448, 606, 734],
28800:[253, 449, 608, 737],
28900:[254, 451, 610, 739],
29000:[255, 453, 612, 742],
29100:[256, 455, 614, 744],
29200:[257, 456, 616, 747],
29300:[258, 458, 618, 749],
29400:[259, 459, 620, 752],
29500:[260, 461, 622, 754],
29600:[261, 462, 624, 756],
29700:[262, 464, 627, 759],
29800:[263, 465, 629, 761],
29900:[264, 467, 631, 763],
30000:[265, 469, 633, 766],
30100:[266, 471, 635, 768],
30200:[267, 472, 637, 771],
30300:[268, 474, 639, 773],
30400:[269, 475, 641, 776],
30500:[270, 477, 643, 778],
30600:[271, 478, 645, 780],
30700:[272, 480, 647, 783],
30800:[273, 482, 649, 785],
30900:[274, 483, 651, 787],
31000:[275, 485, 653, 790],
31100:[276, 487, 655, 792],
31200:[277, 488, 657, 795],
31300:[278, 490, 659, 797],
31400:[279, 491, 661, 800],
31500:[280, 493, 663, 802],
31600:[281, 495, 665, 804],
31700:[282, 496, 667, 807],
31800:[283, 498, 669, 809],
31900:[284, 499, 671, 811],
32000:[285, 501, 673, 814],
32100:[286, 503, 675, 816],
32200:[287, 504, 677, 819],
32300:[288, 506, 679, 821],
32400:[289, 507, 681, 823],
32500:[290, 509, 683, 826],
32600:[291, 511, 685, 828],
32700:[292, 512, 688, 831],
32800:[293, 514, 690, 833],
32900:[294, 515, 692, 835],
33000:[296, 517, 694, 838],
33100:[297, 519, 696, 840],
33200:[298, 520, 698, 843],
33300:[299, 522, 700, 845],
33400:[300, 524, 702, 847],
33500:[301, 525, 704, 850],
33600:[302, 527, 706, 852],
33700:[303, 528, 708, 855],
33800:[304, 530, 710, 857],
33900:[305, 532, 712, 859],
34000:[306, 533, 714, 862],
34100:[307, 535, 716, 864],
34200:[308, 536, 718, 867],
34300:[309, 538, 720, 869],
34400:[310, 539, 722, 871],
34500:[311, 541, 724, 874],
34600:[312, 542, 726, 876],
34700:[313, 544, 728, 879],
34800:[314, 545, 730, 881],
34900:[315, 547, 732, 883],
35000:[316, 548, 734, 886],
35100:[317, 550, 736, 888],
35200:[318, 551, 738, 891],
35300:[319, 553, 740, 893],
35400:[320, 554, 742, 895],
35500:[321, 556, 744, 898],
35600:[322, 557, 746, 900],
35700:[323, 559, 748, 903],
35800:[324, 560, 750, 905],
35900:[325, 562, 752, 907],
36000:[326, 564, 754, 910],
36100:[327, 566, 756, 912],
36200:[328, 567, 758, 914],
36300:[329, 569, 760, 917],
36400:[330, 570, 762, 919],
36500:[331, 572, 763, 921],
36600:[331, 573, 765, 923],
36700:[332, 575, 767, 925],
36800:[333, 576, 769, 928],
36900:[334, 578, 771, 930],
37000:[335, 579, 773, 932],
37100:[336, 580, 775, 934],
37200:[337, 582, 777, 937],
37300:[338, 583, 779, 939],
37400:[339, 585, 781, 941],
37500:[340, 586, 782, 943],
37600:[341, 588, 784, 946],
37700:[342, 589, 786, 948],
37800:[343, 591, 788, 950],
37900:[344, 592, 790, 952],
38000:[345, 593, 792, 955],
38100:[346, 594, 794, 957],
38200:[347, 596, 796, 959],
38300:[348, 597, 798, 962],
38400:[349, 599, 800, 964],
38500:[350, 600, 801, 966],
38600:[350, 602, 803, 968],
38700:[351, 603, 805, 971],
38800:[352, 605, 807, 973],
38900:[353, 606, 809, 975],
39000:[354, 608, 811, 977],
39100:[355, 609, 813, 979],
39200:[356, 611, 815, 982],
39300:[357, 612, 817, 984],
39400:[358, 614, 819, 986],
39500:[359, 615, 820, 988],
39600:[360, 617, 822, 991],
39700:[361, 618, 824, 993],
39800:[362, 620, 826, 995],
39900:[363, 621, 828, 998],
40000:[364, 623, 830, 1000],
40100:[365, 625, 832, 1002],
40200:[366, 626, 834, 1004],
40300:[367, 628, 836, 1007],
40400:[368, 629, 838, 1009],
40500:[369, 631, 839, 1011],
40600:[369, 632, 841, 1013],
40700:[370, 634, 843, 1016],
40800:[371, 635, 845, 1018],
40900:[372, 637, 847, 1020],
41000:[373, 638, 849, 1022],
41100:[374, 639, 851, 1024],
41200:[375, 641, 853, 1026],
41300:[376, 642, 855, 1029],
41400:[377, 644, 857, 1031],
41500:[378, 645, 859, 1033],
41600:[379, 647, 860, 1035],
41700:[380, 648, 862, 1037],
41800:[381, 650, 864, 1040],
41900:[382, 651, 866, 1042],
42000:[383, 652, 868, 1044],
42100:[384, 653, 870, 1046],
42200:[385, 655, 872, 1049],
42300:[386, 656, 874, 1051],
42400:[387, 658, 876, 1053],
42500:[388, 659, 878, 1055],
42600:[389, 661, 879, 1058],
42700:[389, 662, 881, 1060],
42800:[390, 664, 883, 1062],
42900:[391, 665, 885, 1064],
43000:[392, 667, 887, 1067],
43100:[393, 668, 889, 1069],
43200:[394, 670, 891, 1071],
43300:[395, 671, 893, 1074],
43400:[396, 673, 895, 1076],
43500:[397, 674, 897, 1078],
43600:[398, 676, 898, 1080],
43700:[399, 677, 900, 1083],
43800:[400, 679, 902, 1085],
43900:[401, 680, 904, 1087],
44000:[402, 682, 906, 1089],
44100:[403, 684, 908, 1091],
44200:[404, 685, 910, 1094],
44300:[405, 687, 912, 1096],
44400:[406, 688, 914, 1098],
44500:[407, 690, 916, 1101],
44600:[408, 692, 918, 1103],
44700:[409, 693, 920, 1106],
44800:[410, 695, 922, 1108],
44900:[411, 696, 924, 1110],
45000:[412, 698, 926, 1113],
45100:[413, 699, 928, 1115],
45200:[414, 701, 930, 1117],
45300:[415, 702, 932, 1120],
45400:[416, 704, 934, 1122],
45500:[417, 705, 935, 1124],
45600:[417, 707, 937, 1126],
45700:[418, 708, 939, 1128],
45800:[419, 710, 941, 1131],
45900:[420, 711, 943, 1133],
46000:[421, 712, 945, 1135],
46100:[422, 713, 947, 1137],
46200:[423, 715, 949, 1139],
46300:[424, 716, 950, 1142],
46400:[424, 718, 952, 1144],
46500:[425, 719, 954, 1146],
46600:[426, 720, 956, 1148],
46700:[427, 722, 958, 1150],
46800:[428, 723, 960, 1152],
46900:[429, 724, 961, 1155],
47000:[430, 726, 963, 1157],
47100:[431, 727, 965, 1159],
47200:[432, 729, 967, 1161],
47300:[433, 730, 968, 1163],
47400:[433, 732, 970, 1166],
47500:[434, 733, 972, 1168],
47600:[435, 734, 974, 1170],
47700:[436, 736, 976, 1172],
47800:[437, 737, 977, 1174],
47900:[438, 738, 979, 1176],
48000:[439, 740, 981, 1178],
48100:[440, 741, 983, 1180],
48200:[441, 743, 985, 1182],
48300:[442, 744, 986, 1184],
48400:[442, 745, 988, 1186],
48500:[443, 747, 990, 1189],
48600:[444, 748, 992, 1191],
48700:[445, 750, 994, 1193],
48800:[446, 751, 995, 1195],
48900:[447, 752, 997, 1197],
49000:[448, 754, 999, 1199],
49100:[449, 755, 1001, 1201],
49200:[450, 757, 1003, 1203],
49300:[451, 758, 1004, 1205],
49400:[451, 759, 1006, 1208],
49500:[452, 761, 1008, 1210],
49600:[453, 762, 1010, 1212],
49700:[454, 764, 1012, 1214],
49800:[455, 765, 1013, 1216],
49900:[456, 766, 1015, 1218],
50000:[457, 768, 1017, 1221],
50100:[458, 769, 1019, 1223],
50200:[459, 771, 1021, 1225],
50300:[460, 772, 1022, 1227],
50400:[461, 774, 1024, 1230],
50500:[462, 775, 1026, 1232],
50600:[463, 777, 1028, 1234],
50700:[464, 778, 1029, 1236],
50800:[465, 780, 1031, 1238],
50900:[466, 781, 1033, 1240],
51000:[467, 783, 1035, 1242],
51100:[468, 784, 1037, 1244],
51200:[469, 786, 1039, 1246],
51300:[470, 787, 1041, 1249],
51400:[471, 789, 1042, 1251],
51500:[472, 790, 1044, 1253],
51600:[473, 792, 1046, 1255],
51700:[474, 793, 1048, 1257],
51800:[475, 795, 1050, 1259],
51900:[476, 796, 1052, 1262],
52000:[476, 797, 1054, 1264],
52100:[477, 798, 1056, 1266],
52200:[478, 800, 1058, 1268],
52300:[479, 801, 1059, 1271],
52400:[480, 803, 1061, 1273],
52500:[481, 804, 1063, 1275],
52600:[482, 805, 1065, 1277],
52700:[482, 807, 1067, 1279],
52800:[483, 808, 1069, 1282],
52900:[484, 810, 1070, 1284],
53000:[485, 811, 1072, 1286],
53100:[486, 812, 1074, 1288],
53200:[487, 814, 1076, 1290],
53300:[488, 815, 1078, 1293],
53400:[489, 817, 1079, 1295],
53500:[489, 818, 1081, 1297],
53600:[490, 820, 1083, 1299],
53700:[491, 821, 1085, 1301],
53800:[492, 823, 1087, 1304],
53900:[493, 824, 1089, 1306],
54000:[494, 826, 1091, 1308],
54100:[495, 827, 1093, 1310],
54200:[496, 829, 1095, 1312],
54300:[497, 830, 1096, 1315],
54400:[498, 832, 1098, 1317],
54500:[499, 833, 1100, 1319],
54600:[500, 835, 1102, 1321],
54700:[501, 836, 1104, 1324],
54800:[502, 837, 1106, 1326],
54900:[503, 839, 1107, 1328],
55000:[504, 840, 1109, 1330],
55100:[505, 841, 1111, 1332],
55200:[506, 843, 1113, 1335],
55300:[507, 844, 1115, 1337],
55400:[508, 846, 1117, 1339],
55500:[509, 847, 1119, 1342],
55600:[510, 849, 1121, 1344],
55700:[511, 850, 1123, 1346],
55800:[512, 852, 1125, 1349],
55900:[512, 853, 1127, 1351],
56000:[513, 855, 1129, 1353],
56100:[514, 857, 1131, 1355],
56200:[515, 858, 1133, 1358],
56300:[516, 860, 1135, 1360],
56400:[517, 861, 1137, 1362],
56500:[518, 863, 1139, 1365],
56600:[519, 864, 1141, 1367],
56700:[520, 866, 1143, 1369],
56800:[521, 867, 1145, 1371],
56900:[522, 869, 1147, 1374],
57000:[523, 871, 1149, 1376],
57100:[524, 873, 1151, 1378],
57200:[525, 874, 1153, 1381],
57300:[526, 876, 1155, 1383],
57400:[527, 877, 1157, 1385],
57500:[528, 879, 1159, 1387],
57600:[529, 880, 1161, 1390],
57700:[530, 882, 1163, 1392],
57800:[531, 883, 1164, 1394],
57900:[532, 885, 1166, 1397],
58000:[533, 886, 1168, 1399],
58100:[534, 888, 1170, 1401],
58200:[535, 889, 1172, 1404],
58300:[536, 891, 1174, 1406],
58400:[537, 892, 1176, 1408],
58500:[538, 894, 1178, 1410],
58600:[539, 895, 1180, 1413],
58700:[540, 897, 1182, 1415],
58800:[541, 898, 1184, 1417],
58900:[542, 900, 1186, 1419],
59000:[543, 901, 1188, 1422],
59100:[544, 902, 1190, 1424],
59200:[545, 904, 1192, 1427],
59300:[546, 905, 1194, 1429],
59400:[547, 907, 1196, 1431],
59500:[548, 908, 1198, 1434],
59600:[549, 910, 1200, 1436],
59700:[550, 911, 1201, 1439],
59800:[551, 913, 1203, 1441],
59900:[552, 914, 1205, 1443],
60000:[553, 916, 1207, 1446],
60100:[554, 918, 1209, 1448],
60200:[555, 919, 1211, 1451],
60300:[556, 921, 1213, 1453],
60400:[557, 922, 1215, 1455],
60500:[558, 924, 1217, 1458],
60600:[559, 925, 1219, 1460],
60700:[560, 927, 1221, 1462],
60800:[561, 929, 1223, 1465],
60900:[562, 930, 1225, 1467],
61000:[562, 932, 1227, 1469],
61100:[563, 934, 1229, 1471],
61200:[564, 935, 1231, 1474],
61300:[565, 937, 1233, 1476],
61400:[566, 938, 1235, 1478],
61500:[567, 940, 1237, 1481],
61600:[568, 941, 1239, 1483],
61700:[569, 943, 1241, 1485],
61800:[570, 944, 1243, 1488],
61900:[571, 946, 1245, 1490],
62000:[572, 947, 1247, 1492],
62100:[573, 949, 1249, 1494],
62200:[574, 950, 1251, 1497],
62300:[575, 952, 1253, 1499],
62400:[576, 953, 1255, 1501],
62500:[577, 955, 1257, 1504],
62600:[578, 956, 1259, 1506],
62700:[579, 958, 1261, 1508],
62800:[580, 959, 1263, 1511],
62900:[581, 961, 1264, 1513],
63000:[582, 962, 1266, 1515],
63100:[583, 963, 1268, 1517],
63200:[584, 965, 1270, 1520],
63300:[585, 966, 1272, 1522],
63400:[586, 968, 1274, 1524],
63500:[587, 969, 1276, 1527],
63600:[588, 971, 1278, 1529],
63700:[589, 972, 1280, 1531],
63800:[590, 974, 1282, 1533],
63900:[591, 975, 1284, 1536],
64000:[592, 977, 1286, 1538],
64100:[593, 979, 1288, 1540],
64200:[594, 980, 1290, 1543],
64300:[595, 982, 1292, 1545],
64400:[596, 983, 1294, 1547],
64500:[597, 985, 1296, 1549],
64600:[598, 986, 1298, 1552],
64700:[599, 988, 1299, 1554],
64800:[600, 990, 1301, 1556],
64900:[601, 991, 1303, 1559],
65000:[602, 993, 1305, 1561],
65100:[603, 995, 1307, 1563],
65200:[604, 996, 1309, 1566],
65300:[605, 998, 1311, 1568],
65400:[606, 999, 1313, 1570],
65500:[607, 1001, 1315, 1572],
65600:[608, 1002, 1317, 1575],
65700:[609, 1004, 1319, 1577],
65800:[610, 1005, 1321, 1579],
65900:[611, 1007, 1323, 1581],
66000:[611, 1008, 1325, 1584],
66100:[612, 1010, 1327, 1586],
66200:[613, 1011, 1329, 1589],
66300:[614, 1013, 1331, 1591],
66400:[615, 1014, 1333, 1593],
66500:[616, 1016, 1335, 1596],
66600:[617, 1017, 1336, 1598],
66700:[618, 1019, 1338, 1601],
66800:[619, 1020, 1340, 1603],
66900:[620, 1022, 1342, 1605],
67000:[621, 1023, 1344, 1608],
67100:[622, 1025, 1346, 1610],
67200:[623, 1026, 1348, 1613],
67300:[624, 1028, 1350, 1615],
67400:[625, 1029, 1352, 1617],
67500:[626, 1031, 1354, 1620],
67600:[627, 1032, 1356, 1622],
67700:[628, 1034, 1358, 1624],
67800:[629, 1035, 1360, 1627],
67900:[630, 1037, 1362, 1629],
68000:[631, 1038, 1364, 1631],
68100:[632, 1039, 1366, 1633],
68200:[633, 1041, 1368, 1636],
68300:[634, 1042, 1370, 1638],
68400:[635, 1044, 1372, 1640],
68500:[636, 1045, 1374, 1643],
68600:[637, 1047, 1376, 1645],
68700:[638, 1048, 1378, 1647],
68800:[639, 1050, 1380, 1650],
68900:[640, 1051, 1382, 1652],
69000:[641, 1053, 1384, 1654],
69100:[642, 1055, 1386, 1656],
69200:[643, 1056, 1388, 1659],
69300:[644, 1058, 1390, 1661],
69400:[645, 1059, 1392, 1663],
69500:[646, 1061, 1394, 1666],
69600:[647, 1062, 1396, 1668],
69700:[648, 1064, 1398, 1670],
69800:[648, 1065, 1399, 1673],
69900:[649, 1067, 1401, 1675],
70000:[650, 1069, 1403, 1677],
70100:[651, 1071, 1405, 1679],
70200:[652, 1072, 1407, 1682],
70300:[653, 1074, 1409, 1684],
70400:[654, 1075, 1411, 1686],
70500:[655, 1077, 1413, 1689],
70600:[656, 1078, 1415, 1691],
70700:[657, 1080, 1417, 1693],
70800:[658, 1081, 1419, 1695],
70900:[659, 1083, 1421, 1698],
71000:[660, 1084, 1423, 1700],
71100:[661, 1086, 1425, 1702],
71200:[662, 1087, 1427, 1705],
71300:[663, 1089, 1429, 1707],
71400:[664, 1090, 1431, 1709],
71500:[665, 1092, 1433, 1711],
71600:[666, 1093, 1435, 1714],
71700:[667, 1095, 1436, 1716],
71800:[668, 1096, 1438, 1718],
71900:[669, 1098, 1440, 1721],
72000:[670, 1099, 1442, 1723],
72100:[671, 1100, 1444, 1725],
72200:[672, 1102, 1446, 1728],
72300:[673, 1103, 1448, 1730],
72400:[674, 1105, 1450, 1732],
72500:[675, 1106, 1452, 1734],
72600:[676, 1108, 1454, 1737],
72700:[677, 1109, 1456, 1739],
72800:[678, 1111, 1458, 1741],
72900:[679, 1112, 1460, 1743],
73000:[680, 1114, 1462, 1746],
73100:[681, 1116, 1464, 1748],
73200:[682, 1117, 1466, 1751],
73300:[683, 1119, 1468, 1753],
73400:[684, 1120, 1470, 1755],
73500:[685, 1122, 1472, 1758],
73600:[686, 1123, 1474, 1760],
73700:[687, 1125, 1476, 1763],
73800:[688, 1127, 1478, 1765],
73900:[689, 1128, 1480, 1767],
74000:[690, 1130, 1482, 1770],
74100:[691, 1132, 1484, 1772],
74200:[692, 1133, 1486, 1775],
74300:[693, 1135, 1488, 1777],
74400:[694, 1136, 1490, 1779],
74500:[695, 1138, 1492, 1782],
74600:[696, 1139, 1494, 1784],
74700:[697, 1141, 1496, 1786],
74800:[697, 1142, 1498, 1789],
74900:[698, 1144, 1499, 1791],
75000:[699, 1145, 1501, 1793],
75100:[700, 1147, 1503, 1795],
75200:[701, 1148, 1505, 1798],
75300:[702, 1150, 1507, 1800],
75400:[703, 1151, 1509, 1802],
75500:[704, 1153, 1511, 1805],
75600:[705, 1154, 1513, 1807],
75700:[706, 1156, 1515, 1809],
75800:[707, 1157, 1517, 1812],
75900:[708, 1159, 1519, 1814],
76000:[709, 1160, 1521, 1816],
76100:[710, 1161, 1523, 1818],
76200:[711, 1163, 1525, 1821],
76300:[712, 1164, 1527, 1823],
76400:[713, 1166, 1529, 1825],
76500:[714, 1167, 1531, 1828],
76600:[715, 1169, 1533, 1830],
76700:[716, 1170, 1534, 1832],
76800:[717, 1172, 1536, 1835],
76900:[718, 1173, 1538, 1837],
77000:[719, 1175, 1540, 1839],
77100:[720, 1177, 1542, 1841],
77200:[721, 1178, 1544, 1844],
77300:[722, 1180, 1546, 1846],
77400:[723, 1181, 1548, 1848],
77500:[724, 1183, 1550, 1851],
77600:[725, 1184, 1552, 1853],
77700:[726, 1186, 1554, 1855],
77800:[727, 1188, 1556, 1857],
77900:[728, 1189, 1558, 1860],
78000:[729, 1191, 1560, 1862],
78100:[730, 1193, 1562, 1864],
78200:[731, 1194, 1564, 1867],
78300:[732, 1196, 1566, 1869],
78400:[733, 1197, 1568, 1871],
78500:[734, 1199, 1570, 1873],
78600:[735, 1200, 1571, 1876],
78700:[736, 1202, 1573, 1878],
78800:[737, 1203, 1575, 1880],
78900:[738, 1205, 1577, 1883],
79000:[739, 1206, 1579, 1885],
79100:[740, 1208, 1581, 1887],
79200:[741, 1209, 1583, 1890],
79300:[742, 1211, 1585, 1892],
79400:[743, 1212, 1587, 1894],
79500:[744, 1214, 1589, 1896],
79600:[745, 1215, 1591, 1899],
79700:[746, 1217, 1593, 1901],
79800:[747, 1218, 1595, 1903],
79900:[747, 1220, 1597, 1905],
80000:[748, 1221, 1599, 1908],
80100:[749, 1223, 1601, 1910],
80200:[750, 1224, 1603, 1913],
80300:[751, 1226, 1605, 1915],
80400:[752, 1227, 1607, 1917],
80500:[753, 1229, 1609, 1920],
80600:[754, 1230, 1611, 1922],
80700:[755, 1232, 1613, 1925],
80800:[756, 1233, 1615, 1927],
80900:[757, 1235, 1617, 1929],
81000:[758, 1236, 1619, 1932],
81100:[759, 1237, 1621, 1934],
81200:[760, 1239, 1623, 1937],
81300:[761, 1240, 1625, 1939],
81400:[762, 1242, 1627, 1941],
81500:[763, 1243, 1629, 1944],
81600:[764, 1245, 1631, 1946],
81700:[765, 1246, 1633, 1948],
81800:[766, 1248, 1634, 1951],
81900:[767, 1249, 1636, 1953],
82000:[768, 1251, 1638, 1955],
82100:[769, 1253, 1640, 1957],
82200:[770, 1254, 1642, 1960],
82300:[771, 1256, 1644, 1962],
82400:[772, 1257, 1646, 1964],
82500:[773, 1259, 1648, 1967],
82600:[774, 1260, 1650, 1969],
82700:[775, 1262, 1652, 1971],
82800:[776, 1263, 1654, 1974],
82900:[777, 1265, 1656, 1976],
83000:[778, 1267, 1658, 1978],
83100:[779, 1269, 1660, 1980],
83200:[780, 1270, 1662, 1983],
83300:[781, 1272, 1664, 1985],
83400:[782, 1273, 1666, 1987],
83500:[783, 1275, 1668, 1990],
83600:[784, 1276, 1670, 1992],
83700:[785, 1278, 1671, 1994],
83800:[786, 1279, 1673, 1997],
83900:[787, 1281, 1675, 1999],
84000:[788, 1282, 1677, 2001],
84100:[789, 1284, 1679, 2003],
84200:[790, 1285, 1681, 2006],
84300:[791, 1287, 1683, 2008],
84400:[792, 1288, 1685, 2010],
84500:[793, 1290, 1687, 2013],
84600:[794, 1291, 1689, 2015],
84700:[795, 1293, 1691, 2017],
84800:[796, 1294, 1693, 2019],
84900:[797, 1296, 1695, 2022],
85000:[797, 1297, 1697, 2024],
85100:[798, 1298, 1699, 2026],
85200:[799, 1300, 1701, 2029],
85300:[800, 1301, 1703, 2031],
85400:[801, 1303, 1705, 2033],
85500:[802, 1304, 1707, 2035],
85600:[803, 1306, 1709, 2038],
85700:[804, 1307, 1711, 2040],
85800:[805, 1309, 1713, 2042],
85900:[806, 1310, 1715, 2045],
86000:[807, 1312, 1717, 2047],
86100:[808, 1314, 1719, 2049],
86200:[809, 1315, 1721, 2052],
86300:[810, 1317, 1723, 2054],
86400:[811, 1318, 1725, 2056],
86500:[812, 1320, 1727, 2058],
86600:[813, 1321, 1729, 2061],
86700:[814, 1323, 1731, 2063],
86800:[815, 1325, 1733, 2065],
86900:[816, 1326, 1734, 2067],
87000:[817, 1328, 1736, 2070],
87100:[818, 1330, 1738, 2072],
87200:[819, 1331, 1740, 2075],
87300:[820, 1333, 1742, 2077],
87400:[821, 1334, 1744, 2079],
87500:[822, 1336, 1746, 2082],
87600:[823, 1337, 1748, 2084],
87700:[824, 1339, 1750, 2087],
87800:[825, 1340, 1752, 2089],
87900:[826, 1342, 1754, 2091],
88000:[827, 1343, 1756, 2094],
88100:[828, 1345, 1758, 2096],
88200:[829, 1346, 1760, 2099],
88300:[830, 1348, 1762, 2101],
88400:[831, 1349, 1764, 2103],
88500:[832, 1351, 1766, 2106],
88600:[833, 1352, 1768, 2108],
88700:[834, 1354, 1769, 2110],
88800:[835, 1355, 1771, 2113],
88900:[836, 1357, 1773, 2115],
89000:[837, 1358, 1775, 2117],
89100:[838, 1359, 1777, 2119],
89200:[839, 1361, 1779, 2122],
89300:[840, 1362, 1781, 2124],
89400:[841, 1364, 1783, 2126],
89500:[842, 1365, 1785, 2129],
89600:[843, 1367, 1787, 2131],
89700:[844, 1368, 1789, 2133],
89800:[845, 1370, 1791, 2136],
89900:[846, 1371, 1793, 2138],
90000:[846, 1373, 1795, 2140],
90100:[847, 1374, 1797, 2142],
90200:[848, 1376, 1799, 2144],
90300:[849, 1377, 1801, 2147],
90400:[850, 1379, 1803, 2149],
90500:[851, 1380, 1805, 2151],
90600:[852, 1382, 1806, 2153],
90700:[853, 1383, 1808, 2156],
90800:[854, 1385, 1810, 2158],
90900:[855, 1386, 1812, 2160],
91000:[856, 1388, 1814, 2162],
91100:[857, 1389, 1816, 2164],
91200:[858, 1391, 1817, 2166],
91300:[859, 1392, 1819, 2168],
91400:[859, 1393, 1821, 2170],
91500:[860, 1395, 1823, 2173],
91600:[861, 1396, 1824, 2175],
91700:[862, 1397, 1826, 2177],
91800:[863, 1399, 1828, 2179],
91900:[864, 1400, 1830, 2181],
92000:[864, 1401, 1831, 2183],
92100:[865, 1402, 1833, 2185],
92200:[866, 1404, 1835, 2187],
92300:[867, 1405, 1836, 2189],
92400:[867, 1406, 1838, 2191],
92500:[868, 1408, 1840, 2193],
92600:[869, 1409, 1842, 2195],
92700:[870, 1410, 1844, 2197],
92800:[871, 1412, 1845, 2199],
92900:[872, 1413, 1847, 2201],
93000:[873, 1415, 1849, 2203],
93100:[874, 1416, 1851, 2205],
93200:[875, 1418, 1852, 2207],
93300:[876, 1419, 1854, 2209],
93400:[877, 1421, 1856, 2211],
93500:[877, 1422, 1858, 2213],
93600:[878, 1423, 1859, 2215],
93700:[879, 1425, 1861, 2217],
93800:[880, 1426, 1863, 2220],
93900:[881, 1428, 1865, 2222],
94000:[882, 1429, 1866, 2224],
94100:[883, 1430, 1868, 2226],
94200:[884, 1432, 1870, 2228],
94300:[885, 1433, 1871, 2230],
94400:[886, 1434, 1873, 2232],
94500:[887, 1436, 1875, 2234],
94600:[887, 1437, 1877, 2237],
94700:[888, 1438, 1878, 2239],
94800:[889, 1440, 1880, 2241],
94900:[890, 1441, 1882, 2243],
95000:[891, 1442, 1884, 2245],
95100:[892, 1443, 1886, 2247],
95200:[893, 1445, 1887, 2249],
95300:[893, 1446, 1889, 2251],
95400:[894, 1447, 1891, 2253],
95500:[895, 1449, 1893, 2255],
95600:[896, 1450, 1894, 2257],
95700:[897, 1452, 1896, 2259],
95800:[898, 1453, 1898, 2261],
95900:[898, 1454, 1900, 2263],
96000:[899, 1456, 1901, 2265],
96100:[900, 1457, 1903, 2267],
96200:[901, 1459, 1905, 2269],
96300:[902, 1460, 1906, 2271],
96400:[902, 1462, 1908, 2273],
96500:[903, 1463, 1910, 2275],
96600:[904, 1464, 1912, 2277],
96700:[905, 1466, 1913, 2279],
96800:[906, 1467, 1915, 2281],
96900:[907, 1469, 1917, 2283],
97000:[908, 1470, 1919, 2286],
97100:[909, 1471, 1921, 2288],
97200:[910, 1473, 1922, 2290],
97300:[911, 1474, 1924, 2292],
97400:[912, 1475, 1926, 2294],
97500:[912, 1477, 1928, 2296],
97600:[913, 1478, 1929, 2298],
97700:[914, 1479, 1931, 2301],
97800:[915, 1481, 1933, 2303],
97900:[916, 1482, 1935, 2305],
98000:[917, 1483, 1936, 2307],
98100:[918, 1484, 1938, 2309],
98200:[919, 1486, 1940, 2311],
98300:[920, 1487, 1941, 2313],
98400:[921, 1488, 1943, 2315],
98500:[922, 1490, 1945, 2318],
98600:[922, 1491, 1947, 2320],
98700:[923, 1493, 1948, 2322],
98800:[924, 1494, 1950, 2324],
98900:[925, 1495, 1952, 2326],
99000:[926, 1497, 1954, 2328],
99100:[927, 1498, 1956, 2330],
99200:[928, 1500, 1957, 2332],
99300:[929, 1501, 1959, 2334],
99400:[930, 1503, 1961, 2336],
99500:[931, 1504, 1963, 2338],
99600:[932, 1505, 1964, 2340],
99700:[932, 1507, 1966, 2342],
99800:[933, 1508, 1968, 2344],
99900:[934, 1510, 1969, 2346],
};
const OR17_YT=[0.8, 1.26, 1.66, 1.94];

const TABLES_2017 = {
  AB: T17_AB,
  BC: T17_BC,
  MB: T17_MB,
  NB: T17_NB,
  NL: T17_NL,
  NS: T17_NS,
  NT: T17_NT,
  NU: T17_NU,
  ON: T17_ON,
  PE: T17_PE,
  SK: T17_SK,
  YT: T17_YT,
};

const OVER_RATES_2017 = {
  AB: OR17_AB,
  BC: OR17_BC,
  MB: OR17_MB,
  NB: OR17_NB,
  NL: OR17_NL,
  NS: OR17_NS,
  NT: OR17_NT,
  NU: OR17_NU,
  ON: OR17_ON,
  PE: OR17_PE,
  SK: OR17_SK,
  YT: OR17_YT,
};

function lookupCSG2017(prov, numChildren, annualIncome) {
  if(prov === "QC") return null;
  const table = TABLES_2017[prov];
  const overRates = OVER_RATES_2017[prov];
  if(!table || !overRates) return null;
  if(annualIncome < 12000) return 0;
  const idx = Math.min(numChildren - 1, 3);
  if(annualIncome <= 150000) {
    const bracket = Math.floor(annualIncome / 100) * 100;
    const row = table[bracket];
    const nextRow = table[bracket + 100];
    if(!row) return null;
    if(!nextRow) return row[idx];
    const frac = (annualIncome - bracket) / 100;
    const val = row[idx] + (nextRow[idx] - row[idx]) * frac;
    if(numChildren >= 5) {
      const inc34 = row[3] - row[2];
      return Math.round(val + inc34 * (numChildren - 4) * 0.85);
    }
    return Math.round(val);
  } else {
    // Over $150,000: base + rate% of excess (rate is monthly %, per official table note)
    const t150 = table[150000];
    if(!t150) return null;
    const base = t150[idx];
    const excess = annualIncome - 150000;
    const rate = overRates[Math.min(numChildren - 1, 3)];
    return Math.round(base + (rate / 100) * excess);
  }
}

export { lookupCSG2017, TABLES_2017, OVER_RATES_2017, T17_AB, T17_BC, T17_MB, T17_NB, T17_NL, T17_NS, T17_NT, T17_NU, T17_ON, T17_PE, T17_SK, T17_YT };